function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequire02ae"];
parcelRequire.register("3Q10N", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinbaseWalletProvider = module.exports.CoinbaseWalletSDK = void 0;

var $cG0Vq = parcelRequire("cG0Vq");

var $jQXdt = parcelRequire("jQXdt");

var $cG0Vq = parcelRequire("cG0Vq");
Object.defineProperty(module.exports, "CoinbaseWalletSDK", {
    enumerable: true,
    get: function() {
        return $cG0Vq.CoinbaseWalletSDK;
    }
});

var $jQXdt = parcelRequire("jQXdt");
Object.defineProperty(module.exports, "CoinbaseWalletProvider", {
    enumerable: true,
    get: function() {
        return $jQXdt.CoinbaseWalletProvider;
    }
});
module.exports.default = $cG0Vq.CoinbaseWalletSDK;
if (typeof window !== "undefined") {
    window.CoinbaseWalletSDK = $cG0Vq.CoinbaseWalletSDK;
    window.CoinbaseWalletProvider = $jQXdt.CoinbaseWalletProvider;
    /**
     * @deprecated Use `window.CoinbaseWalletSDK`
     */ window.WalletLink = $cG0Vq.CoinbaseWalletSDK;
    /**
     * @deprecated Use `window.CoinbaseWalletProvider`
     */ window.WalletLinkProvider = $jQXdt.CoinbaseWalletProvider;
}

});
parcelRequire.register("cG0Vq", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinbaseWalletSDK = void 0;

var $7Wlp2 = parcelRequire("7Wlp2");

var $gBFYx = parcelRequire("gBFYx");

var $8YRCQ = parcelRequire("8YRCQ");

var $jQXdt = parcelRequire("jQXdt");

var $jU9nd = parcelRequire("jU9nd");

var $kVwIQ = parcelRequire("kVwIQ");

var $frxtt = parcelRequire("frxtt");

var $1mY3j = parcelRequire("1mY3j");

var $ejuBv = parcelRequire("ejuBv");
class $93aa1ffe09e79edf$var$CoinbaseWalletSDK {
    /**
     * Constructor
     * @param options Coinbase Wallet SDK constructor options
     */ constructor(options){
        var _a, _b, _c;
        this._appName = "";
        this._appLogoUrl = null;
        this._relay = null;
        this._relayEventManager = null;
        const linkAPIUrl = options.linkAPIUrl || $gBFYx.LINK_API_URL;
        let uiConstructor;
        if (!options.uiConstructor) uiConstructor = (opts)=>new $jU9nd.WalletSDKUI(opts);
        else uiConstructor = options.uiConstructor;
        if (typeof options.overrideIsMetaMask === "undefined") this._overrideIsMetaMask = false;
        else this._overrideIsMetaMask = options.overrideIsMetaMask;
        this._overrideIsCoinbaseWallet = (_a = options.overrideIsCoinbaseWallet) !== null && _a !== void 0 ? _a : true;
        this._overrideIsCoinbaseBrowser = (_b = options.overrideIsCoinbaseBrowser) !== null && _b !== void 0 ? _b : false;
        if (options.diagnosticLogger && options.eventListener) throw new Error("Can't have both eventListener and diagnosticLogger options, use only diagnosticLogger");
        if (options.eventListener) this._diagnosticLogger = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            log: options.eventListener.onEvent
        };
        else this._diagnosticLogger = options.diagnosticLogger;
        this._reloadOnDisconnect = (_c = options.reloadOnDisconnect) !== null && _c !== void 0 ? _c : true;
        const url = new URL(linkAPIUrl);
        const origin = `${url.protocol}//${url.host}`;
        this._storage = new $8YRCQ.ScopedLocalStorage(`-walletlink:${origin}`); // needs migration to preserve local states
        this._storage.setItem("version", $93aa1ffe09e79edf$var$CoinbaseWalletSDK.VERSION);
        if (this.walletExtension || this.coinbaseBrowser) return;
        this._relayEventManager = new $frxtt.WalletSDKRelayEventManager();
        this._relay = new $kVwIQ.WalletSDKRelay({
            linkAPIUrl: linkAPIUrl,
            version: $ejuBv.LIB_VERSION,
            darkMode: !!options.darkMode,
            uiConstructor: uiConstructor,
            storage: this._storage,
            relayEventManager: this._relayEventManager,
            diagnosticLogger: this._diagnosticLogger,
            reloadOnDisconnect: this._reloadOnDisconnect
        });
        this.setAppInfo(options.appName, options.appLogoUrl);
        if (!!options.headlessMode) return;
        this._relay.attachUI();
    }
    /**
     * Create a Web3 Provider object
     * @param jsonRpcUrl Ethereum JSON RPC URL (Default: "")
     * @param chainId Ethereum Chain ID (Default: 1)
     * @returns A Web3 Provider
     */ makeWeb3Provider(jsonRpcUrl = "", chainId = 1) {
        const extension = this.walletExtension;
        if (extension) {
            if (!this.isCipherProvider(extension)) extension.setProviderInfo(jsonRpcUrl, chainId);
            if (this._reloadOnDisconnect === false && typeof extension.disableReloadOnDisconnect === "function") extension.disableReloadOnDisconnect();
            return extension;
        }
        const dappBrowser = this.coinbaseBrowser;
        if (dappBrowser) return dappBrowser;
        const relay = this._relay;
        if (!relay || !this._relayEventManager || !this._storage) throw new Error("Relay not initialized, should never happen");
        if (!jsonRpcUrl) relay.setConnectDisabled(true);
        return new $jQXdt.CoinbaseWalletProvider({
            relayProvider: ()=>Promise.resolve(relay),
            relayEventManager: this._relayEventManager,
            storage: this._storage,
            jsonRpcUrl: jsonRpcUrl,
            chainId: chainId,
            qrUrl: this.getQrUrl(),
            diagnosticLogger: this._diagnosticLogger,
            overrideIsMetaMask: this._overrideIsMetaMask,
            overrideIsCoinbaseWallet: this._overrideIsCoinbaseWallet,
            overrideIsCoinbaseBrowser: this._overrideIsCoinbaseBrowser
        });
    }
    /**
     * Set application information
     * @param appName Application name
     * @param appLogoUrl Application logo image URL
     */ setAppInfo(appName, appLogoUrl) {
        var _a;
        this._appName = appName || "DApp";
        this._appLogoUrl = appLogoUrl || (0, $1mY3j.getFavicon)();
        const extension = this.walletExtension;
        if (extension) {
            if (!this.isCipherProvider(extension)) extension.setAppInfo(this._appName, this._appLogoUrl);
        } else (_a = this._relay) === null || _a === void 0 || _a.setAppInfo(this._appName, this._appLogoUrl);
    }
    /**
     * Disconnect. After disconnecting, this will reload the web page to ensure
     * all potential stale state is cleared.
     */ disconnect() {
        var _a;
        const extension = this.walletExtension;
        if (extension) extension.close();
        else (_a = this._relay) === null || _a === void 0 || _a.resetAndReload();
    }
    /**
     * Return QR URL for mobile wallet connection, will return null if extension is installed
     */ getQrUrl() {
        var _a, _b;
        return (_b = (_a = this._relay) === null || _a === void 0 ? void 0 : _a.getQRCodeUrl()) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Official Coinbase Wallet logo for developers to use on their frontend
     * @param type Type of wallet logo: "standard" | "circle" | "text" | "textWithLogo" | "textLight" | "textWithLogoLight"
     * @param width Width of the logo (Optional)
     * @returns SVG Data URI
     */ getCoinbaseWalletLogo(type, width = 240) {
        return (0, $7Wlp2.walletLogo)(type, width);
    }
    get walletExtension() {
        var _a;
        return (_a = window.coinbaseWalletExtension) !== null && _a !== void 0 ? _a : window.walletLinkExtension;
    }
    get coinbaseBrowser() {
        var _a, _b;
        try {
            // Coinbase DApp browser does not inject into iframes so grab provider from top frame if it exists
            const ethereum = (_a = window.ethereum) !== null && _a !== void 0 ? _a : (_b = window.top) === null || _b === void 0 ? void 0 : _b.ethereum;
            if (!ethereum) return undefined;
            if ("isCoinbaseBrowser" in ethereum && ethereum.isCoinbaseBrowser) return ethereum;
            else return undefined;
        } catch (e) {
            return undefined;
        }
    }
    isCipherProvider(provider) {
        // @ts-expect-error isCipher walletlink property
        return typeof provider.isCipher === "boolean" && provider.isCipher;
    }
}
module.exports.CoinbaseWalletSDK = $93aa1ffe09e79edf$var$CoinbaseWalletSDK;
$93aa1ffe09e79edf$var$CoinbaseWalletSDK.VERSION = $ejuBv.LIB_VERSION;

});
parcelRequire.register("7Wlp2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.walletLogo = void 0;
const $5c7e8d5778a4910c$var$walletLogo = (type, width)=>{
    let height;
    switch(type){
        case "standard":
            height = width;
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
        case "circle":
            height = width;
            return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 999.81 999.81'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052fe;%7D.cls-2%7Bfill:%23fefefe;%7D.cls-3%7Bfill:%230152fe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M655-115.9h56c.83,1.59,2.36.88,3.56,1a478,478,0,0,1,75.06,10.42C891.4-81.76,978.33-32.58,1049.19,44q116.7,126,131.94,297.61c.38,4.14-.34,8.53,1.78,12.45v59c-1.58.84-.91,2.35-1,3.56a482.05,482.05,0,0,1-10.38,74.05c-24,106.72-76.64,196.76-158.83,268.93s-178.18,112.82-287.2,122.6c-4.83.43-9.86-.25-14.51,1.77H654c-1-1.68-2.69-.91-4.06-1a496.89,496.89,0,0,1-105.9-18.59c-93.54-27.42-172.78-77.59-236.91-150.94Q199.34,590.1,184.87,426.58c-.47-5.19.25-10.56-1.77-15.59V355c1.68-1,.91-2.7,1-4.06a498.12,498.12,0,0,1,18.58-105.9c26-88.75,72.64-164.9,140.6-227.57q126-116.27,297.21-131.61C645.32-114.57,650.35-113.88,655-115.9Zm377.92,500c0-192.44-156.31-349.49-347.56-350.15-194.13-.68-350.94,155.13-352.29,347.42-1.37,194.55,155.51,352.1,348.56,352.47C876.15,734.23,1032.93,577.84,1032.93,384.11Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-2' d='M1032.93,384.11c0,193.73-156.78,350.12-351.29,349.74-193-.37-349.93-157.92-348.56-352.47C334.43,189.09,491.24,33.28,685.37,34,876.62,34.62,1032.94,191.67,1032.93,384.11ZM683,496.81q43.74,0,87.48,0c15.55,0,25.32-9.72,25.33-25.21q0-87.48,0-175c0-15.83-9.68-25.46-25.59-25.46H595.77c-15.88,0-25.57,9.64-25.58,25.46q0,87.23,0,174.45c0,16.18,9.59,25.7,25.84,25.71Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-3' d='M683,496.81H596c-16.25,0-25.84-9.53-25.84-25.71q0-87.23,0-174.45c0-15.82,9.7-25.46,25.58-25.46H770.22c15.91,0,25.59,9.63,25.59,25.46q0,87.47,0,175c0,15.49-9.78,25.2-25.33,25.21Q726.74,496.84,683,496.81Z' transform='translate(-183.1 115.9)'/%3E%3C/svg%3E`;
        case "text":
            height = (0.1 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
        case "textWithLogo":
            height = (0.25 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
        case "textLight":
            height = (0.1 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
        case "textWithLogoLight":
            height = (0.25 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
        default:
            height = width;
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
    }
};
module.exports.walletLogo = $5c7e8d5778a4910c$var$walletLogo;

});

parcelRequire.register("gBFYx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LINK_API_URL = void 0;
module.exports.LINK_API_URL = "https://www.walletlink.org";

});

parcelRequire.register("8YRCQ", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ScopedLocalStorage = void 0;
class $689d863a641782ff$var$ScopedLocalStorage {
    constructor(scope){
        this.scope = scope;
    }
    setItem(key, value) {
        localStorage.setItem(this.scopedKey(key), value);
    }
    getItem(key) {
        return localStorage.getItem(this.scopedKey(key));
    }
    removeItem(key) {
        localStorage.removeItem(this.scopedKey(key));
    }
    clear() {
        const prefix = this.scopedKey("");
        const keysToRemove = [];
        for(let i = 0; i < localStorage.length; i++){
            const key = localStorage.key(i);
            if (typeof key === "string" && key.startsWith(prefix)) keysToRemove.push(key);
        }
        keysToRemove.forEach((key)=>localStorage.removeItem(key));
    }
    scopedKey(key) {
        return `${this.scope}:${key}`;
    }
}
module.exports.ScopedLocalStorage = $689d863a641782ff$var$ScopedLocalStorage;

});

parcelRequire.register("jQXdt", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e740cecc1735163c$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $e740cecc1735163c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinbaseWalletProvider = void 0;

const $e740cecc1735163c$var$safe_event_emitter_1 = $e740cecc1735163c$var$__importDefault((parcelRequire("e5MJz")));

const $e740cecc1735163c$var$bn_js_1 = $e740cecc1735163c$var$__importDefault((parcelRequire("dEXSZ")));

var $6W6hh = parcelRequire("6W6hh");

var $iGxB3 = parcelRequire("iGxB3");

var $gPotL = parcelRequire("gPotL");

var $iF8HB = parcelRequire("iF8HB");

var $6Hvzc = parcelRequire("6Hvzc");

var $7jLgc = parcelRequire("7jLgc");

var $1mY3j = parcelRequire("1mY3j");

const $e740cecc1735163c$var$eth_eip712_util_1 = $e740cecc1735163c$var$__importDefault((parcelRequire("gx2Ud")));

var $fEUWi = parcelRequire("fEUWi");

var $fpSI4 = parcelRequire("fpSI4");

var $jUU2a = parcelRequire("jUU2a");
const $e740cecc1735163c$var$DEFAULT_CHAIN_ID_KEY = "DefaultChainId";
const $e740cecc1735163c$var$DEFAULT_JSON_RPC_URL = "DefaultJsonRpcUrl";
class $e740cecc1735163c$var$CoinbaseWalletProvider extends $e740cecc1735163c$var$safe_event_emitter_1.default {
    constructor(options){
        var _a, _b;
        super();
        this._filterPolyfill = new $fEUWi.FilterPolyfill(this);
        this._subscriptionManager = new $jUU2a.SubscriptionManager(this);
        this._relay = null;
        this._addresses = [];
        this.hasMadeFirstChainChangedEmission = false;
        this.setProviderInfo = this.setProviderInfo.bind(this);
        this.updateProviderInfo = this.updateProviderInfo.bind(this);
        this.getChainId = this.getChainId.bind(this);
        this.setAppInfo = this.setAppInfo.bind(this);
        this.enable = this.enable.bind(this);
        this.close = this.close.bind(this);
        this.send = this.send.bind(this);
        this.sendAsync = this.sendAsync.bind(this);
        this.request = this.request.bind(this);
        this._setAddresses = this._setAddresses.bind(this);
        this.scanQRCode = this.scanQRCode.bind(this);
        this.genericRequest = this.genericRequest.bind(this);
        this._chainIdFromOpts = options.chainId;
        this._jsonRpcUrlFromOpts = options.jsonRpcUrl;
        this._overrideIsMetaMask = options.overrideIsMetaMask;
        this._relayProvider = options.relayProvider;
        this._storage = options.storage;
        this._relayEventManager = options.relayEventManager;
        this.diagnostic = options.diagnosticLogger;
        this.reloadOnDisconnect = true;
        this.isCoinbaseWallet = (_a = options.overrideIsCoinbaseWallet) !== null && _a !== void 0 ? _a : true;
        this.isCoinbaseBrowser = (_b = options.overrideIsCoinbaseBrowser) !== null && _b !== void 0 ? _b : false;
        this.qrUrl = options.qrUrl;
        const chainId = this.getChainId();
        const chainIdStr = (0, $1mY3j.prepend0x)(chainId.toString(16));
        // indicate that we've connected, for EIP-1193 compliance
        this.emit("connect", {
            chainIdStr: chainIdStr
        });
        const cachedAddresses = this._storage.getItem($iF8HB.LOCAL_STORAGE_ADDRESSES_KEY);
        if (cachedAddresses) {
            const addresses = cachedAddresses.split(" ");
            if (addresses[0] !== "") {
                this._addresses = addresses.map((address)=>(0, $1mY3j.ensureAddressString)(address));
                this.emit("accountsChanged", addresses);
            }
        }
        this._subscriptionManager.events.on("notification", (notification)=>{
            this.emit("message", {
                type: notification.method,
                data: notification.params
            });
        });
        if (this._isAuthorized()) this.initializeRelay();
        window.addEventListener("message", (event)=>{
            var _a;
            // Used to verify the source and window are correct before proceeding
            if (event.origin !== location.origin || event.source !== window) return;
            if (event.data.type !== "walletLinkMessage") return; // compatibility with CBW extension
            if (event.data.data.action === "dappChainSwitched") {
                const _chainId = event.data.data.chainId;
                const jsonRpcUrl = (_a = event.data.data.jsonRpcUrl) !== null && _a !== void 0 ? _a : this.jsonRpcUrl;
                this.updateProviderInfo(jsonRpcUrl, Number(_chainId));
            }
            if (event.data.data.action === "addressChanged") this._setAddresses([
                event.data.data.address
            ]);
        });
    }
    /** @deprecated Use `.request({ method: 'eth_accounts' })` instead. */ get selectedAddress() {
        return this._addresses[0] || undefined;
    }
    /** @deprecated Use the chain ID. If you still need the network ID, use `.request({ method: 'net_version' })`. */ get networkVersion() {
        return this.getChainId().toString(10);
    }
    /** @deprecated Use `.request({ method: 'eth_chainId' })` instead. */ get chainId() {
        return (0, $1mY3j.prepend0x)(this.getChainId().toString(16));
    }
    get isWalletLink() {
        // backward compatibility
        return true;
    }
    /**
     * Some DApps (i.e. Alpha Homora) seem to require the window.ethereum object return
     * true for this method.
     */ get isMetaMask() {
        return this._overrideIsMetaMask;
    }
    get host() {
        return this.jsonRpcUrl;
    }
    get connected() {
        return true;
    }
    isConnected() {
        return true;
    }
    get jsonRpcUrl() {
        var _a;
        return (_a = this._storage.getItem($e740cecc1735163c$var$DEFAULT_JSON_RPC_URL)) !== null && _a !== void 0 ? _a : this._jsonRpcUrlFromOpts;
    }
    set jsonRpcUrl(value) {
        this._storage.setItem($e740cecc1735163c$var$DEFAULT_JSON_RPC_URL, value);
    }
    disableReloadOnDisconnect() {
        this.reloadOnDisconnect = false;
    }
    setProviderInfo(jsonRpcUrl, chainId) {
        if (!this.isCoinbaseBrowser) {
            this._chainIdFromOpts = chainId;
            this._jsonRpcUrlFromOpts = jsonRpcUrl;
        }
        this.updateProviderInfo(this.jsonRpcUrl, this.getChainId());
    }
    updateProviderInfo(jsonRpcUrl, chainId) {
        this.jsonRpcUrl = jsonRpcUrl;
        // emit chainChanged event if necessary
        const originalChainId = this.getChainId();
        this._storage.setItem($e740cecc1735163c$var$DEFAULT_CHAIN_ID_KEY, chainId.toString(10));
        const chainChanged = (0, $1mY3j.ensureIntNumber)(chainId) !== originalChainId;
        if (chainChanged || !this.hasMadeFirstChainChangedEmission) {
            this.emit("chainChanged", this.getChainId());
            this.hasMadeFirstChainChangedEmission = true;
        }
    }
    async watchAsset(type, address, symbol, decimals, image, chainId) {
        const relay = await this.initializeRelay();
        const result = await relay.watchAsset(type, address, symbol, decimals, image, chainId === null || chainId === void 0 ? void 0 : chainId.toString()).promise;
        return !!result.result;
    }
    async addEthereumChain(chainId, rpcUrls, blockExplorerUrls, chainName, iconUrls, nativeCurrency) {
        var _a, _b;
        if ((0, $1mY3j.ensureIntNumber)(chainId) === this.getChainId()) return false;
        const relay = await this.initializeRelay();
        const isWhitelistedNetworkOrStandalone = relay.inlineAddEthereumChain(chainId.toString());
        if (!this._isAuthorized() && !isWhitelistedNetworkOrStandalone) await relay.requestEthereumAccounts().promise;
        const res = await relay.addEthereumChain(chainId.toString(), rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency).promise;
        if (((_a = res.result) === null || _a === void 0 ? void 0 : _a.isApproved) === true) this.updateProviderInfo(rpcUrls[0], chainId);
        return ((_b = res.result) === null || _b === void 0 ? void 0 : _b.isApproved) === true;
    }
    async switchEthereumChain(chainId) {
        const relay = await this.initializeRelay();
        const res = await relay.switchEthereumChain(chainId.toString(10), this.selectedAddress || undefined).promise;
        // backward compatibility
        if ((0, $7jLgc.isErrorResponse)(res) && res.errorCode) {
            if (res.errorCode === $iGxB3.standardErrorCodes.provider.unsupportedChain) throw $iGxB3.standardErrors.provider.unsupportedChain(chainId);
            else throw $iGxB3.standardErrors.provider.custom({
                message: res.errorMessage,
                code: res.errorCode
            });
        }
        const switchResponse = res.result;
        if (switchResponse.isApproved && switchResponse.rpcUrl.length > 0) this.updateProviderInfo(switchResponse.rpcUrl, chainId);
    }
    setAppInfo(appName, appLogoUrl) {
        this.initializeRelay().then((relay)=>relay.setAppInfo(appName, appLogoUrl));
    }
    /** @deprecated Use `.request({ method: 'eth_requestAccounts' })` instead. */ async enable() {
        var _a;
        (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.ETH_ACCOUNTS_STATE, {
            method: "provider::enable",
            addresses_length: this._addresses.length,
            sessionIdHash: this._relay ? $gPotL.Session.hash(this._relay.session.id) : undefined
        });
        if (this._isAuthorized()) return [
            ...this._addresses
        ];
        return await this.send($fpSI4.JSONRPCMethod.eth_requestAccounts);
    }
    async close() {
        const relay = await this.initializeRelay();
        relay.resetAndReload();
    }
    send(requestOrMethod, callbackOrParams) {
        // send<T>(method, params): Promise<T>
        try {
            const result = this._send(requestOrMethod, callbackOrParams);
            if (result instanceof Promise) return result.catch((error)=>{
                throw (0, $iGxB3.serializeError)(error, requestOrMethod);
            });
        } catch (error) {
            throw (0, $iGxB3.serializeError)(error, requestOrMethod);
        }
    }
    _send(requestOrMethod, callbackOrParams) {
        if (typeof requestOrMethod === "string") {
            const method = requestOrMethod;
            const params = Array.isArray(callbackOrParams) ? callbackOrParams : callbackOrParams !== undefined ? [
                callbackOrParams
            ] : [];
            const request = {
                jsonrpc: "2.0",
                id: 0,
                method: method,
                params: params
            };
            return this._sendRequestAsync(request).then((res)=>res.result);
        }
        // send(JSONRPCRequest | JSONRPCRequest[], callback): void
        if (typeof callbackOrParams === "function") {
            const request = requestOrMethod;
            const callback = callbackOrParams;
            return this._sendAsync(request, callback);
        }
        // send(JSONRPCRequest[]): JSONRPCResponse[]
        if (Array.isArray(requestOrMethod)) {
            const requests = requestOrMethod;
            return requests.map((r)=>this._sendRequest(r));
        }
        // send(JSONRPCRequest): JSONRPCResponse
        const req = requestOrMethod;
        return this._sendRequest(req);
    }
    async sendAsync(request, callback) {
        try {
            return this._sendAsync(request, callback).catch((error)=>{
                throw (0, $iGxB3.serializeError)(error, request);
            });
        } catch (error) {
            return Promise.reject((0, $iGxB3.serializeError)(error, request));
        }
    }
    async _sendAsync(request, callback) {
        if (typeof callback !== "function") throw new Error("callback is required");
        // send(JSONRPCRequest[], callback): void
        if (Array.isArray(request)) {
            const arrayCb = callback;
            this._sendMultipleRequestsAsync(request).then((responses)=>arrayCb(null, responses)).catch((err)=>arrayCb(err, null));
            return;
        }
        // send(JSONRPCRequest, callback): void
        const cb = callback;
        return this._sendRequestAsync(request).then((response)=>cb(null, response)).catch((err)=>cb(err, null));
    }
    async request(args) {
        try {
            return this._request(args).catch((error)=>{
                throw (0, $iGxB3.serializeError)(error, args.method);
            });
        } catch (error) {
            return Promise.reject((0, $iGxB3.serializeError)(error, args.method));
        }
    }
    async _request(args) {
        if (!args || typeof args !== "object" || Array.isArray(args)) throw $iGxB3.standardErrors.rpc.invalidRequest({
            message: "Expected a single, non-array, object argument.",
            data: args
        });
        const { method: method, params: params } = args;
        if (typeof method !== "string" || method.length === 0) throw $iGxB3.standardErrors.rpc.invalidRequest({
            message: "'args.method' must be a non-empty string.",
            data: args
        });
        if (params !== undefined && !Array.isArray(params) && (typeof params !== "object" || params === null)) throw $iGxB3.standardErrors.rpc.invalidRequest({
            message: "'args.params' must be an object or array if provided.",
            data: args
        });
        const newParams = params === undefined ? [] : params;
        // Coinbase Wallet Requests
        const id = this._relayEventManager.makeRequestId();
        const result = await this._sendRequestAsync({
            method: method,
            params: newParams,
            jsonrpc: "2.0",
            id: id
        });
        return result.result;
    }
    async scanQRCode(match) {
        var _a;
        const relay = await this.initializeRelay();
        const res = await relay.scanQRCode((0, $1mY3j.ensureRegExpString)(match)).promise;
        if (typeof res.result !== "string") throw (0, $iGxB3.serializeError)((_a = res.errorMessage) !== null && _a !== void 0 ? _a : "result was not a string", $6Hvzc.Web3Method.scanQRCode);
        return res.result;
    }
    async genericRequest(data, action) {
        var _a;
        const relay = await this.initializeRelay();
        const res = await relay.genericRequest(data, action).promise;
        if (typeof res.result !== "string") throw (0, $iGxB3.serializeError)((_a = res.errorMessage) !== null && _a !== void 0 ? _a : "result was not a string", $6Hvzc.Web3Method.generic);
        return res.result;
    }
    async selectProvider(providerOptions) {
        var _a;
        const relay = await this.initializeRelay();
        const res = await relay.selectProvider(providerOptions).promise;
        if (typeof res.result !== "string") throw (0, $iGxB3.serializeError)((_a = res.errorMessage) !== null && _a !== void 0 ? _a : "result was not a string", $6Hvzc.Web3Method.selectProvider);
        return res.result;
    }
    supportsSubscriptions() {
        return false;
    }
    subscribe() {
        throw new Error("Subscriptions are not supported");
    }
    unsubscribe() {
        throw new Error("Subscriptions are not supported");
    }
    disconnect() {
        return true;
    }
    _sendRequest(request) {
        const response = {
            jsonrpc: "2.0",
            id: request.id
        };
        const { method: method } = request;
        response.result = this._handleSynchronousMethods(request);
        if (response.result === undefined) throw new Error(`Coinbase Wallet does not support calling ${method} synchronously without ` + `a callback. Please provide a callback parameter to call ${method} ` + `asynchronously.`);
        return response;
    }
    _setAddresses(addresses, _) {
        if (!Array.isArray(addresses)) throw new Error("addresses is not an array");
        const newAddresses = addresses.map((address)=>(0, $1mY3j.ensureAddressString)(address));
        if (JSON.stringify(newAddresses) === JSON.stringify(this._addresses)) return;
        this._addresses = newAddresses;
        this.emit("accountsChanged", this._addresses);
        this._storage.setItem($iF8HB.LOCAL_STORAGE_ADDRESSES_KEY, newAddresses.join(" "));
    }
    _sendRequestAsync(request) {
        return new Promise((resolve, reject)=>{
            try {
                const syncResult = this._handleSynchronousMethods(request);
                if (syncResult !== undefined) return resolve({
                    jsonrpc: "2.0",
                    id: request.id,
                    result: syncResult
                });
                const filterPromise = this._handleAsynchronousFilterMethods(request);
                if (filterPromise !== undefined) {
                    filterPromise.then((res)=>resolve(Object.assign(Object.assign({}, res), {
                            id: request.id
                        }))).catch((err)=>reject(err));
                    return;
                }
                const subscriptionPromise = this._handleSubscriptionMethods(request);
                if (subscriptionPromise !== undefined) {
                    subscriptionPromise.then((res)=>resolve({
                            jsonrpc: "2.0",
                            id: request.id,
                            result: res.result
                        })).catch((err)=>reject(err));
                    return;
                }
            } catch (err) {
                return reject(err);
            }
            this._handleAsynchronousMethods(request).then((res)=>res && resolve(Object.assign(Object.assign({}, res), {
                    id: request.id
                }))).catch((err)=>reject(err));
        });
    }
    _sendMultipleRequestsAsync(requests) {
        return Promise.all(requests.map((r)=>this._sendRequestAsync(r)));
    }
    _handleSynchronousMethods(request) {
        const { method: method } = request;
        const params = request.params || [];
        switch(method){
            case $fpSI4.JSONRPCMethod.eth_accounts:
                return this._eth_accounts();
            case $fpSI4.JSONRPCMethod.eth_coinbase:
                return this._eth_coinbase();
            case $fpSI4.JSONRPCMethod.eth_uninstallFilter:
                return this._eth_uninstallFilter(params);
            case $fpSI4.JSONRPCMethod.net_version:
                return this._net_version();
            case $fpSI4.JSONRPCMethod.eth_chainId:
                return this._eth_chainId();
            default:
                return undefined;
        }
    }
    async _handleAsynchronousMethods(request) {
        const { method: method } = request;
        const params = request.params || [];
        switch(method){
            case $fpSI4.JSONRPCMethod.eth_requestAccounts:
                return this._eth_requestAccounts();
            case $fpSI4.JSONRPCMethod.eth_sign:
                return this._eth_sign(params);
            case $fpSI4.JSONRPCMethod.eth_ecRecover:
                return this._eth_ecRecover(params);
            case $fpSI4.JSONRPCMethod.personal_sign:
                return this._personal_sign(params);
            case $fpSI4.JSONRPCMethod.personal_ecRecover:
                return this._personal_ecRecover(params);
            case $fpSI4.JSONRPCMethod.eth_signTransaction:
                return this._eth_signTransaction(params);
            case $fpSI4.JSONRPCMethod.eth_sendRawTransaction:
                return this._eth_sendRawTransaction(params);
            case $fpSI4.JSONRPCMethod.eth_sendTransaction:
                return this._eth_sendTransaction(params);
            case $fpSI4.JSONRPCMethod.eth_signTypedData_v1:
                return this._eth_signTypedData_v1(params);
            case $fpSI4.JSONRPCMethod.eth_signTypedData_v2:
                return this._throwUnsupportedMethodError();
            case $fpSI4.JSONRPCMethod.eth_signTypedData_v3:
                return this._eth_signTypedData_v3(params);
            case $fpSI4.JSONRPCMethod.eth_signTypedData_v4:
            case $fpSI4.JSONRPCMethod.eth_signTypedData:
                return this._eth_signTypedData_v4(params);
            case $fpSI4.JSONRPCMethod.cbWallet_arbitrary:
                return this._cbwallet_arbitrary(params);
            case $fpSI4.JSONRPCMethod.wallet_addEthereumChain:
                return this._wallet_addEthereumChain(params);
            case $fpSI4.JSONRPCMethod.wallet_switchEthereumChain:
                return this._wallet_switchEthereumChain(params);
            case $fpSI4.JSONRPCMethod.wallet_watchAsset:
                return this._wallet_watchAsset(params);
        }
        const relay = await this.initializeRelay();
        return relay.makeEthereumJSONRPCRequest(request, this.jsonRpcUrl);
    }
    _handleAsynchronousFilterMethods(request) {
        const { method: method } = request;
        const params = request.params || [];
        switch(method){
            case $fpSI4.JSONRPCMethod.eth_newFilter:
                return this._eth_newFilter(params);
            case $fpSI4.JSONRPCMethod.eth_newBlockFilter:
                return this._eth_newBlockFilter();
            case $fpSI4.JSONRPCMethod.eth_newPendingTransactionFilter:
                return this._eth_newPendingTransactionFilter();
            case $fpSI4.JSONRPCMethod.eth_getFilterChanges:
                return this._eth_getFilterChanges(params);
            case $fpSI4.JSONRPCMethod.eth_getFilterLogs:
                return this._eth_getFilterLogs(params);
        }
        return undefined;
    }
    _handleSubscriptionMethods(request) {
        switch(request.method){
            case $fpSI4.JSONRPCMethod.eth_subscribe:
            case $fpSI4.JSONRPCMethod.eth_unsubscribe:
                return this._subscriptionManager.handleRequest(request);
        }
        return undefined;
    }
    _isKnownAddress(addressString) {
        try {
            const addressStr = (0, $1mY3j.ensureAddressString)(addressString);
            const lowercaseAddresses = this._addresses.map((address)=>(0, $1mY3j.ensureAddressString)(address));
            return lowercaseAddresses.includes(addressStr);
        } catch (_a) {}
        return false;
    }
    _ensureKnownAddress(addressString) {
        var _a;
        if (!this._isKnownAddress(addressString)) {
            (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.UNKNOWN_ADDRESS_ENCOUNTERED);
            throw new Error("Unknown Ethereum address");
        }
    }
    _prepareTransactionParams(tx) {
        const fromAddress = tx.from ? (0, $1mY3j.ensureAddressString)(tx.from) : this.selectedAddress;
        if (!fromAddress) throw new Error("Ethereum address is unavailable");
        this._ensureKnownAddress(fromAddress);
        const toAddress = tx.to ? (0, $1mY3j.ensureAddressString)(tx.to) : null;
        const weiValue = tx.value != null ? (0, $1mY3j.ensureBN)(tx.value) : new $e740cecc1735163c$var$bn_js_1.default(0);
        const data = tx.data ? (0, $1mY3j.ensureBuffer)(tx.data) : $e740cecc1735163c$require$Buffer.alloc(0);
        const nonce = tx.nonce != null ? (0, $1mY3j.ensureIntNumber)(tx.nonce) : null;
        const gasPriceInWei = tx.gasPrice != null ? (0, $1mY3j.ensureBN)(tx.gasPrice) : null;
        const maxFeePerGas = tx.maxFeePerGas != null ? (0, $1mY3j.ensureBN)(tx.maxFeePerGas) : null;
        const maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? (0, $1mY3j.ensureBN)(tx.maxPriorityFeePerGas) : null;
        const gasLimit = tx.gas != null ? (0, $1mY3j.ensureBN)(tx.gas) : null;
        const chainId = this.getChainId();
        return {
            fromAddress: fromAddress,
            toAddress: toAddress,
            weiValue: weiValue,
            data: data,
            nonce: nonce,
            gasPriceInWei: gasPriceInWei,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            gasLimit: gasLimit,
            chainId: chainId
        };
    }
    _isAuthorized() {
        return this._addresses.length > 0;
    }
    _requireAuthorization() {
        if (!this._isAuthorized()) throw $iGxB3.standardErrors.provider.unauthorized({});
    }
    _throwUnsupportedMethodError() {
        throw $iGxB3.standardErrors.provider.unsupportedMethod({});
    }
    async _signEthereumMessage(message, address, addPrefix, typedDataJson) {
        this._ensureKnownAddress(address);
        try {
            const relay = await this.initializeRelay();
            const res = await relay.signEthereumMessage(message, address, addPrefix, typedDataJson).promise;
            return {
                jsonrpc: "2.0",
                id: 0,
                result: res.result
            };
        } catch (err) {
            if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw $iGxB3.standardErrors.provider.userRejectedRequest("User denied message signature");
            throw err;
        }
    }
    async _ethereumAddressFromSignedMessage(message, signature, addPrefix) {
        const relay = await this.initializeRelay();
        const res = await relay.ethereumAddressFromSignedMessage(message, signature, addPrefix).promise;
        return {
            jsonrpc: "2.0",
            id: 0,
            result: res.result
        };
    }
    _eth_accounts() {
        return [
            ...this._addresses
        ];
    }
    _eth_coinbase() {
        return this.selectedAddress || null;
    }
    _net_version() {
        return this.getChainId().toString(10);
    }
    _eth_chainId() {
        return (0, $1mY3j.hexStringFromIntNumber)(this.getChainId());
    }
    getChainId() {
        const chainIdStr = this._storage.getItem($e740cecc1735163c$var$DEFAULT_CHAIN_ID_KEY);
        if (!chainIdStr) return (0, $1mY3j.ensureIntNumber)(this._chainIdFromOpts);
        const chainId = parseInt(chainIdStr, 10);
        return (0, $1mY3j.ensureIntNumber)(chainId);
    }
    async _eth_requestAccounts() {
        var _a;
        (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.ETH_ACCOUNTS_STATE, {
            method: "provider::_eth_requestAccounts",
            addresses_length: this._addresses.length,
            sessionIdHash: this._relay ? $gPotL.Session.hash(this._relay.session.id) : undefined
        });
        if (this._isAuthorized()) return Promise.resolve({
            jsonrpc: "2.0",
            id: 0,
            result: this._addresses
        });
        let res;
        try {
            const relay = await this.initializeRelay();
            res = await relay.requestEthereumAccounts().promise;
        } catch (err) {
            if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw $iGxB3.standardErrors.provider.userRejectedRequest("User denied account authorization");
            throw err;
        }
        if (!res.result) throw new Error("accounts received is empty");
        this._setAddresses(res.result);
        if (!this.isCoinbaseBrowser) await this.switchEthereumChain(this.getChainId());
        return {
            jsonrpc: "2.0",
            id: 0,
            result: this._addresses
        };
    }
    _eth_sign(params) {
        this._requireAuthorization();
        const address = (0, $1mY3j.ensureAddressString)(params[0]);
        const message = (0, $1mY3j.ensureBuffer)(params[1]);
        return this._signEthereumMessage(message, address, false);
    }
    _eth_ecRecover(params) {
        const message = (0, $1mY3j.ensureBuffer)(params[0]);
        const signature = (0, $1mY3j.ensureBuffer)(params[1]);
        return this._ethereumAddressFromSignedMessage(message, signature, false);
    }
    _personal_sign(params) {
        this._requireAuthorization();
        const message = (0, $1mY3j.ensureBuffer)(params[0]);
        const address = (0, $1mY3j.ensureAddressString)(params[1]);
        return this._signEthereumMessage(message, address, true);
    }
    _personal_ecRecover(params) {
        const message = (0, $1mY3j.ensureBuffer)(params[0]);
        const signature = (0, $1mY3j.ensureBuffer)(params[1]);
        return this._ethereumAddressFromSignedMessage(message, signature, true);
    }
    async _eth_signTransaction(params) {
        this._requireAuthorization();
        const tx = this._prepareTransactionParams(params[0] || {});
        try {
            const relay = await this.initializeRelay();
            const res = await relay.signEthereumTransaction(tx).promise;
            return {
                jsonrpc: "2.0",
                id: 0,
                result: res.result
            };
        } catch (err) {
            if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw $iGxB3.standardErrors.provider.userRejectedRequest("User denied transaction signature");
            throw err;
        }
    }
    async _eth_sendRawTransaction(params) {
        const signedTransaction = (0, $1mY3j.ensureBuffer)(params[0]);
        const relay = await this.initializeRelay();
        const res = await relay.submitEthereumTransaction(signedTransaction, this.getChainId()).promise;
        return {
            jsonrpc: "2.0",
            id: 0,
            result: res.result
        };
    }
    async _eth_sendTransaction(params) {
        this._requireAuthorization();
        const tx = this._prepareTransactionParams(params[0] || {});
        try {
            const relay = await this.initializeRelay();
            const res = await relay.signAndSubmitEthereumTransaction(tx).promise;
            return {
                jsonrpc: "2.0",
                id: 0,
                result: res.result
            };
        } catch (err) {
            if (typeof err.message === "string" && err.message.match(/(denied|rejected)/i)) throw $iGxB3.standardErrors.provider.userRejectedRequest("User denied transaction signature");
            throw err;
        }
    }
    async _eth_signTypedData_v1(params) {
        this._requireAuthorization();
        const typedData = (0, $1mY3j.ensureParsedJSONObject)(params[0]);
        const address = (0, $1mY3j.ensureAddressString)(params[1]);
        this._ensureKnownAddress(address);
        const message = $e740cecc1735163c$var$eth_eip712_util_1.default.hashForSignTypedDataLegacy({
            data: typedData
        });
        const typedDataJSON = JSON.stringify(typedData, null, 2);
        return this._signEthereumMessage(message, address, false, typedDataJSON);
    }
    async _eth_signTypedData_v3(params) {
        this._requireAuthorization();
        const address = (0, $1mY3j.ensureAddressString)(params[0]);
        const typedData = (0, $1mY3j.ensureParsedJSONObject)(params[1]);
        this._ensureKnownAddress(address);
        const message = $e740cecc1735163c$var$eth_eip712_util_1.default.hashForSignTypedData_v3({
            data: typedData
        });
        const typedDataJSON = JSON.stringify(typedData, null, 2);
        return this._signEthereumMessage(message, address, false, typedDataJSON);
    }
    async _eth_signTypedData_v4(params) {
        this._requireAuthorization();
        const address = (0, $1mY3j.ensureAddressString)(params[0]);
        const typedData = (0, $1mY3j.ensureParsedJSONObject)(params[1]);
        this._ensureKnownAddress(address);
        const message = $e740cecc1735163c$var$eth_eip712_util_1.default.hashForSignTypedData_v4({
            data: typedData
        });
        const typedDataJSON = JSON.stringify(typedData, null, 2);
        return this._signEthereumMessage(message, address, false, typedDataJSON);
    }
    /** @deprecated */ async _cbwallet_arbitrary(params) {
        const action = params[0];
        const data = params[1];
        if (typeof data !== "string") throw new Error("parameter must be a string");
        if (typeof action !== "object" || action === null) throw new Error("parameter must be an object");
        const result = await this.genericRequest(action, data);
        return {
            jsonrpc: "2.0",
            id: 0,
            result: result
        };
    }
    async _wallet_addEthereumChain(params) {
        var _a, _b, _c, _d;
        const request = params[0];
        if (((_a = request.rpcUrls) === null || _a === void 0 ? void 0 : _a.length) === 0) return {
            jsonrpc: "2.0",
            id: 0,
            error: {
                code: 2,
                message: `please pass in at least 1 rpcUrl`
            }
        };
        if (!request.chainName || request.chainName.trim() === "") throw $iGxB3.standardErrors.rpc.invalidParams("chainName is a required field");
        if (!request.nativeCurrency) throw $iGxB3.standardErrors.rpc.invalidParams("nativeCurrency is a required field");
        const chainIdNumber = parseInt(request.chainId, 16);
        const success = await this.addEthereumChain(chainIdNumber, (_b = request.rpcUrls) !== null && _b !== void 0 ? _b : [], (_c = request.blockExplorerUrls) !== null && _c !== void 0 ? _c : [], request.chainName, (_d = request.iconUrls) !== null && _d !== void 0 ? _d : [], request.nativeCurrency);
        if (success) return {
            jsonrpc: "2.0",
            id: 0,
            result: null
        };
        else return {
            jsonrpc: "2.0",
            id: 0,
            error: {
                code: 2,
                message: `unable to add ethereum chain`
            }
        };
    }
    async _wallet_switchEthereumChain(params) {
        const request = params[0];
        await this.switchEthereumChain(parseInt(request.chainId, 16));
        return {
            jsonrpc: "2.0",
            id: 0,
            result: null
        };
    }
    async _wallet_watchAsset(params) {
        const request = Array.isArray(params) ? params[0] : params;
        if (!request.type) throw $iGxB3.standardErrors.rpc.invalidParams("Type is required");
        if ((request === null || request === void 0 ? void 0 : request.type) !== "ERC20") throw $iGxB3.standardErrors.rpc.invalidParams(`Asset of type '${request.type}' is not supported`);
        if (!(request === null || request === void 0 ? void 0 : request.options)) throw $iGxB3.standardErrors.rpc.invalidParams("Options are required");
        if (!(request === null || request === void 0 ? void 0 : request.options.address)) throw $iGxB3.standardErrors.rpc.invalidParams("Address is required");
        const chainId = this.getChainId();
        const { address: address, symbol: symbol, image: image, decimals: decimals } = request.options;
        const res = await this.watchAsset(request.type, address, symbol, decimals, image, chainId);
        return {
            jsonrpc: "2.0",
            id: 0,
            result: res
        };
    }
    _eth_uninstallFilter(params) {
        const filterId = (0, $1mY3j.ensureHexString)(params[0]);
        return this._filterPolyfill.uninstallFilter(filterId);
    }
    async _eth_newFilter(params) {
        const param = params[0];
        const filterId = await this._filterPolyfill.newFilter(param);
        return {
            jsonrpc: "2.0",
            id: 0,
            result: filterId
        };
    }
    async _eth_newBlockFilter() {
        const filterId = await this._filterPolyfill.newBlockFilter();
        return {
            jsonrpc: "2.0",
            id: 0,
            result: filterId
        };
    }
    async _eth_newPendingTransactionFilter() {
        const filterId = await this._filterPolyfill.newPendingTransactionFilter();
        return {
            jsonrpc: "2.0",
            id: 0,
            result: filterId
        };
    }
    _eth_getFilterChanges(params) {
        const filterId = (0, $1mY3j.ensureHexString)(params[0]);
        return this._filterPolyfill.getFilterChanges(filterId);
    }
    _eth_getFilterLogs(params) {
        const filterId = (0, $1mY3j.ensureHexString)(params[0]);
        return this._filterPolyfill.getFilterLogs(filterId);
    }
    initializeRelay() {
        if (this._relay) return Promise.resolve(this._relay);
        return this._relayProvider().then((relay)=>{
            relay.setAccountsCallback((accounts, isDisconnect)=>this._setAddresses(accounts, isDisconnect));
            relay.setChainCallback((chainId, jsonRpcUrl)=>{
                this.updateProviderInfo(jsonRpcUrl, parseInt(chainId, 10));
            });
            relay.setDappDefaultChainCallback(this._chainIdFromOpts);
            this._relay = relay;
            return relay;
        });
    }
}
module.exports.CoinbaseWalletProvider = $e740cecc1735163c$var$CoinbaseWalletProvider;

});
parcelRequire.register("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("e5MJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7etJZ = parcelRequire("7etJZ");
function $a42755dee99d5dab$var$safeApply(handler, context, args) {
    try {
        Reflect.apply(handler, context, args);
    } catch (err) {
        // Throw error after timeout so as not to interrupt the stack
        setTimeout(()=>{
            throw err;
        });
    }
}
function $a42755dee99d5dab$var$arrayClone(arr) {
    const n = arr.length;
    const copy = new Array(n);
    for(let i = 0; i < n; i += 1)copy[i] = arr[i];
    return copy;
}
class $a42755dee99d5dab$var$SafeEventEmitter extends $7etJZ.EventEmitter {
    emit(type, ...args) {
        let doError = type === "error";
        const events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        // If there is no 'error' event listener then throw.
        if (doError) {
            let er;
            if (args.length > 0) [er] = args;
            if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
            // up in Node's output if this results in an unhandled exception.
            throw er; // Unhandled 'error' event
            // At least give some kind of context to the user
            const err = new Error(`Unhandled error.${er ? ` (${er.message})` : ""}`);
            err.context = er;
            throw err; // Unhandled 'error' event
        }
        const handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === "function") $a42755dee99d5dab$var$safeApply(handler, this, args);
        else {
            const len = handler.length;
            const listeners = $a42755dee99d5dab$var$arrayClone(handler);
            for(let i = 0; i < len; i += 1)$a42755dee99d5dab$var$safeApply(listeners[i], this, args);
        }
        return true;
    }
}
module.exports.default = $a42755dee99d5dab$var$SafeEventEmitter;

});
parcelRequire.register("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRequire.register("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("6W6hh", function(module, exports) {
"use strict";
// DiagnosticLogger for debugging purposes only
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EVENTS = void 0;
module.exports.EVENTS = {
    STARTED_CONNECTING: "walletlink_sdk.started.connecting",
    CONNECTED_STATE_CHANGE: "walletlink_sdk.connected",
    DISCONNECTED: "walletlink_sdk.disconnected",
    METADATA_DESTROYED: "walletlink_sdk_metadata_destroyed",
    LINKED: "walletlink_sdk.linked",
    FAILURE: "walletlink_sdk.generic_failure",
    SESSION_CONFIG_RECEIVED: "walletlink_sdk.session_config_event_received",
    ETH_ACCOUNTS_STATE: "walletlink_sdk.eth_accounts_state",
    SESSION_STATE_CHANGE: "walletlink_sdk.session_state_change",
    UNLINKED_ERROR_STATE: "walletlink_sdk.unlinked_error_state",
    SKIPPED_CLEARING_SESSION: "walletlink_sdk.skipped_clearing_session",
    GENERAL_ERROR: "walletlink_sdk.general_error",
    WEB3_REQUEST: "walletlink_sdk.web3.request",
    WEB3_REQUEST_PUBLISHED: "walletlink_sdk.web3.request_published",
    WEB3_RESPONSE: "walletlink_sdk.web3.response",
    UNKNOWN_ADDRESS_ENCOUNTERED: "walletlink_sdk.unknown_address_encountered"
};

});

parcelRequire.register("iGxB3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getErrorCode = module.exports.serializeError = module.exports.standardErrors = module.exports.standardErrorMessage = module.exports.standardErrorCodes = void 0;

var $5Who5 = parcelRequire("5Who5");

var $7jLgc = parcelRequire("7jLgc");

var $ejuBv = parcelRequire("ejuBv");
module.exports.standardErrorCodes = Object.freeze(Object.assign(Object.assign({}, $5Who5.errorCodes), {
    provider: Object.freeze(Object.assign(Object.assign({}, $5Who5.errorCodes.provider), {
        unsupportedChain: 4902
    }))
}));
function $d9a635d08a8ba922$var$standardErrorMessage(code) {
    return code !== undefined ? (0, $5Who5.getMessageFromCode)(code) : "Unknown error";
}
module.exports.standardErrorMessage = $d9a635d08a8ba922$var$standardErrorMessage;
module.exports.standardErrors = Object.freeze(Object.assign(Object.assign({}, $5Who5.ethErrors), {
    provider: Object.freeze(Object.assign(Object.assign({}, $5Who5.ethErrors.provider), {
        unsupportedChain: (chainId = "")=>$5Who5.ethErrors.provider.custom({
                code: module.exports.standardErrorCodes.provider.unsupportedChain,
                message: `Unrecognized chain ID ${chainId}. Try adding the chain using wallet_addEthereumChain first.`
            })
    }))
}));
/**
 * Serializes an error to a format that is compatible with the Ethereum JSON RPC error format.
 * See https://docs.cloud.coinbase.com/wallet-sdk/docs/errors
 * for more information.
 */ function $d9a635d08a8ba922$var$serializeError(error, requestOrMethod) {
    const serialized = (0, $5Who5.serializeError)($d9a635d08a8ba922$var$getErrorObject(error), {
        shouldIncludeStack: true
    });
    const docUrl = new URL("https://docs.cloud.coinbase.com/wallet-sdk/docs/errors");
    docUrl.searchParams.set("version", $ejuBv.LIB_VERSION);
    docUrl.searchParams.set("code", serialized.code.toString());
    const method = $d9a635d08a8ba922$var$getMethod(serialized.data, requestOrMethod);
    if (method) docUrl.searchParams.set("method", method);
    docUrl.searchParams.set("message", serialized.message);
    return Object.assign(Object.assign({}, serialized), {
        docUrl: docUrl.href
    });
}
module.exports.serializeError = $d9a635d08a8ba922$var$serializeError;
/**
 * Converts an error to a serializable object.
 */ function $d9a635d08a8ba922$var$getErrorObject(error) {
    if (typeof error === "string") return {
        message: error,
        code: module.exports.standardErrorCodes.rpc.internal
    };
    else if ((0, $7jLgc.isErrorResponse)(error)) return Object.assign(Object.assign({}, error), {
        message: error.errorMessage,
        code: error.errorCode,
        data: {
            method: error.method,
            result: error.result
        }
    });
    else return error;
}
/**
 * Gets the method name from the serialized data or the request.
 */ function $d9a635d08a8ba922$var$getMethod(serializedData, request) {
    var _a;
    const methodInData = (_a = serializedData) === null || _a === void 0 ? void 0 : _a.method;
    if (methodInData) return methodInData;
    if (request === undefined) return undefined;
    else if (typeof request === "string") return request;
    else if (!Array.isArray(request)) return request.method;
    else if (request.length > 0) return request[0].method;
    else return undefined;
}
// ----------------- getErrorCode -----------------
/**
 * Returns the error code from an error object.
 */ function $d9a635d08a8ba922$var$getErrorCode(error) {
    var _a;
    if (typeof error === "number") return error;
    else if ($d9a635d08a8ba922$var$isErrorWithCode(error)) return (_a = error.code) !== null && _a !== void 0 ? _a : error.errorCode;
    return undefined;
}
module.exports.getErrorCode = $d9a635d08a8ba922$var$getErrorCode;
function $d9a635d08a8ba922$var$isErrorWithCode(error) {
    return typeof error === "object" && error !== null && (typeof error.code === "number" || typeof error.errorCode === "number");
}

});
parcelRequire.register("5Who5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMessageFromCode = module.exports.serializeError = module.exports.EthereumProviderError = module.exports.EthereumRpcError = module.exports.ethErrors = module.exports.errorCodes = void 0;

var $5LJgD = parcelRequire("5LJgD");
Object.defineProperty(module.exports, "EthereumRpcError", {
    enumerable: true,
    get: function() {
        return $5LJgD.EthereumRpcError;
    }
});
Object.defineProperty(module.exports, "EthereumProviderError", {
    enumerable: true,
    get: function() {
        return $5LJgD.EthereumProviderError;
    }
});

var $6OOIJ = parcelRequire("6OOIJ");
Object.defineProperty(module.exports, "serializeError", {
    enumerable: true,
    get: function() {
        return $6OOIJ.serializeError;
    }
});
Object.defineProperty(module.exports, "getMessageFromCode", {
    enumerable: true,
    get: function() {
        return $6OOIJ.getMessageFromCode;
    }
});

var $cRqWI = parcelRequire("cRqWI");
Object.defineProperty(module.exports, "ethErrors", {
    enumerable: true,
    get: function() {
        return $cRqWI.ethErrors;
    }
});

var $6s3bz = parcelRequire("6s3bz");
Object.defineProperty(module.exports, "errorCodes", {
    enumerable: true,
    get: function() {
        return $6s3bz.errorCodes;
    }
});

});
parcelRequire.register("5LJgD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EthereumProviderError = module.exports.EthereumRpcError = void 0;

var $hgGe6 = parcelRequire("hgGe6");
/**
 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors
 * per EIP-1474.
 * Permits any integer error code.
 */ class $433474b2b6271325$var$EthereumRpcError extends Error {
    constructor(code, message, data){
        if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
        if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string.');
        super(message);
        this.code = code;
        if (data !== undefined) this.data = data;
    }
    /**
     * Returns a plain object with all public class properties.
     */ serialize() {
        const serialized = {
            code: this.code,
            message: this.message
        };
        if (this.data !== undefined) serialized.data = this.data;
        if (this.stack) serialized.stack = this.stack;
        return serialized;
    }
    /**
     * Return a string representation of the serialized error, omitting
     * any circular references.
     */ toString() {
        return $hgGe6.default(this.serialize(), $433474b2b6271325$var$stringifyReplacer, 2);
    }
}
module.exports.EthereumRpcError = $433474b2b6271325$var$EthereumRpcError;
/**
 * Error subclass implementing Ethereum Provider errors per EIP-1193.
 * Permits integer error codes in the [ 1000 <= 4999 ] range.
 */ class $433474b2b6271325$var$EthereumProviderError extends $433474b2b6271325$var$EthereumRpcError {
    /**
     * Create an Ethereum Provider JSON-RPC error.
     * `code` must be an integer in the 1000 <= 4999 range.
     */ constructor(code, message, data){
        if (!$433474b2b6271325$var$isValidEthProviderCode(code)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
        super(code, message, data);
    }
}
module.exports.EthereumProviderError = $433474b2b6271325$var$EthereumProviderError;
// Internal
function $433474b2b6271325$var$isValidEthProviderCode(code) {
    return Number.isInteger(code) && code >= 1000 && code <= 4999;
}
function $433474b2b6271325$var$stringifyReplacer(_, value) {
    if (value === "[Circular]") return undefined;
    return value;
}

});
parcelRequire.register("hgGe6", function(module, exports) {
module.exports = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.default = $c924af90aa582a4d$var$stringify;
$c924af90aa582a4d$var$stringify.stable = $c924af90aa582a4d$var$deterministicStringify;
$c924af90aa582a4d$var$stringify.stableStringify = $c924af90aa582a4d$var$deterministicStringify;
var $c924af90aa582a4d$var$LIMIT_REPLACE_NODE = "[...]";
var $c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE = "[Circular]";
var $c924af90aa582a4d$var$arr = [];
var $c924af90aa582a4d$var$replacerStack = [];
function $c924af90aa582a4d$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $c924af90aa582a4d$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $c924af90aa582a4d$var$defaultOptions();
    $c924af90aa582a4d$var$decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $c924af90aa582a4d$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $c924af90aa582a4d$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $c924af90aa582a4d$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $c924af90aa582a4d$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $c924af90aa582a4d$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $c924af90aa582a4d$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $c924af90aa582a4d$var$defaultOptions();
    var tmp = $c924af90aa582a4d$var$deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($c924af90aa582a4d$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $c924af90aa582a4d$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while($c924af90aa582a4d$var$arr.length !== 0){
            var part = $c924af90aa582a4d$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $c924af90aa582a4d$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $c924af90aa582a4d$var$setReplace($c924af90aa582a4d$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$c924af90aa582a4d$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($c924af90aa582a4d$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $c924af90aa582a4d$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                $c924af90aa582a4d$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $c924af90aa582a4d$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($c924af90aa582a4d$var$replacerStack.length > 0) for(var i = 0; i < $c924af90aa582a4d$var$replacerStack.length; i++){
            var part = $c924af90aa582a4d$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $c924af90aa582a4d$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

});


parcelRequire.register("6OOIJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeError = module.exports.isValidCode = module.exports.getMessageFromCode = module.exports.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;

var $6s3bz = parcelRequire("6s3bz");

var $5LJgD = parcelRequire("5LJgD");
const $4f6ec1a1004f858d$var$FALLBACK_ERROR_CODE = $6s3bz.errorCodes.rpc.internal;
const $4f6ec1a1004f858d$var$FALLBACK_MESSAGE = "Unspecified error message. This is a bug, please report it.";
const $4f6ec1a1004f858d$var$FALLBACK_ERROR = {
    code: $4f6ec1a1004f858d$var$FALLBACK_ERROR_CODE,
    message: $4f6ec1a1004f858d$var$getMessageFromCode($4f6ec1a1004f858d$var$FALLBACK_ERROR_CODE)
};
module.exports.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
/**
 * Gets the message for a given code, or a fallback message if the code has
 * no corresponding message.
 */ function $4f6ec1a1004f858d$var$getMessageFromCode(code, fallbackMessage = $4f6ec1a1004f858d$var$FALLBACK_MESSAGE) {
    if (Number.isInteger(code)) {
        const codeString = code.toString();
        if ($4f6ec1a1004f858d$var$hasKey($6s3bz.errorValues, codeString)) return $6s3bz.errorValues[codeString].message;
        if ($4f6ec1a1004f858d$var$isJsonRpcServerError(code)) return module.exports.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return fallbackMessage;
}
module.exports.getMessageFromCode = $4f6ec1a1004f858d$var$getMessageFromCode;
/**
 * Returns whether the given code is valid.
 * A code is only valid if it has a message.
 */ function $4f6ec1a1004f858d$var$isValidCode(code) {
    if (!Number.isInteger(code)) return false;
    const codeString = code.toString();
    if ($6s3bz.errorValues[codeString]) return true;
    if ($4f6ec1a1004f858d$var$isJsonRpcServerError(code)) return true;
    return false;
}
module.exports.isValidCode = $4f6ec1a1004f858d$var$isValidCode;
/**
 * Serializes the given error to an Ethereum JSON RPC-compatible error object.
 * Merely copies the given error's values if it is already compatible.
 * If the given error is not fully compatible, it will be preserved on the
 * returned object's data.originalError property.
 */ function $4f6ec1a1004f858d$var$serializeError(error, { fallbackError: fallbackError = $4f6ec1a1004f858d$var$FALLBACK_ERROR, shouldIncludeStack: shouldIncludeStack = false } = {}) {
    var _a, _b;
    if (!fallbackError || !Number.isInteger(fallbackError.code) || typeof fallbackError.message !== "string") throw new Error("Must provide fallback error with integer number code and string message.");
    if (error instanceof $5LJgD.EthereumRpcError) return error.serialize();
    const serialized = {};
    if (error && typeof error === "object" && !Array.isArray(error) && $4f6ec1a1004f858d$var$hasKey(error, "code") && $4f6ec1a1004f858d$var$isValidCode(error.code)) {
        const _error = error;
        serialized.code = _error.code;
        if (_error.message && typeof _error.message === "string") {
            serialized.message = _error.message;
            if ($4f6ec1a1004f858d$var$hasKey(_error, "data")) serialized.data = _error.data;
        } else {
            serialized.message = $4f6ec1a1004f858d$var$getMessageFromCode(serialized.code);
            serialized.data = {
                originalError: $4f6ec1a1004f858d$var$assignOriginalError(error)
            };
        }
    } else {
        serialized.code = fallbackError.code;
        const message = (_a = error) === null || _a === void 0 ? void 0 : _a.message;
        serialized.message = message && typeof message === "string" ? message : fallbackError.message;
        serialized.data = {
            originalError: $4f6ec1a1004f858d$var$assignOriginalError(error)
        };
    }
    const stack = (_b = error) === null || _b === void 0 ? void 0 : _b.stack;
    if (shouldIncludeStack && error && stack && typeof stack === "string") serialized.stack = stack;
    return serialized;
}
module.exports.serializeError = $4f6ec1a1004f858d$var$serializeError;
// Internal
function $4f6ec1a1004f858d$var$isJsonRpcServerError(code) {
    return code >= -32099 && code <= -32000;
}
function $4f6ec1a1004f858d$var$assignOriginalError(error) {
    if (error && typeof error === "object" && !Array.isArray(error)) return Object.assign({}, error);
    return error;
}
function $4f6ec1a1004f858d$var$hasKey(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}

});
parcelRequire.register("6s3bz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorValues = module.exports.errorCodes = void 0;
module.exports.errorCodes = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901
    }
};
module.exports.errorValues = {
    "-32700": {
        standard: "JSON RPC 2.0",
        message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    },
    "-32600": {
        standard: "JSON RPC 2.0",
        message: "The JSON sent is not a valid Request object."
    },
    "-32601": {
        standard: "JSON RPC 2.0",
        message: "The method does not exist / is not available."
    },
    "-32602": {
        standard: "JSON RPC 2.0",
        message: "Invalid method parameter(s)."
    },
    "-32603": {
        standard: "JSON RPC 2.0",
        message: "Internal JSON-RPC error."
    },
    "-32000": {
        standard: "EIP-1474",
        message: "Invalid input."
    },
    "-32001": {
        standard: "EIP-1474",
        message: "Resource not found."
    },
    "-32002": {
        standard: "EIP-1474",
        message: "Resource unavailable."
    },
    "-32003": {
        standard: "EIP-1474",
        message: "Transaction rejected."
    },
    "-32004": {
        standard: "EIP-1474",
        message: "Method not supported."
    },
    "-32005": {
        standard: "EIP-1474",
        message: "Request limit exceeded."
    },
    "4001": {
        standard: "EIP-1193",
        message: "User rejected the request."
    },
    "4100": {
        standard: "EIP-1193",
        message: "The requested account and/or method has not been authorized by the user."
    },
    "4200": {
        standard: "EIP-1193",
        message: "The requested method is not supported by this Ethereum provider."
    },
    "4900": {
        standard: "EIP-1193",
        message: "The provider is disconnected from all chains."
    },
    "4901": {
        standard: "EIP-1193",
        message: "The provider is disconnected from the specified chain."
    }
};

});


parcelRequire.register("cRqWI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ethErrors = void 0;

var $5LJgD = parcelRequire("5LJgD");

var $6OOIJ = parcelRequire("6OOIJ");

var $6s3bz = parcelRequire("6s3bz");
module.exports.ethErrors = {
    rpc: {
        /**
         * Get a JSON RPC 2.0 Parse (-32700) error.
         */ parse: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.parse, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Request (-32600) error.
         */ invalidRequest: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.invalidRequest, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Params (-32602) error.
         */ invalidParams: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.invalidParams, arg),
        /**
         * Get a JSON RPC 2.0 Method Not Found (-32601) error.
         */ methodNotFound: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.methodNotFound, arg),
        /**
         * Get a JSON RPC 2.0 Internal (-32603) error.
         */ internal: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.internal, arg),
        /**
         * Get a JSON RPC 2.0 Server error.
         * Permits integer error codes in the [ -32099 <= -32005 ] range.
         * Codes -32000 through -32004 are reserved by EIP-1474.
         */ server: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum RPC Server errors must provide single object argument.");
            const { code: code } = opts;
            if (!Number.isInteger(code) || code > -32005 || code < -32099) throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
            return $95cf563110ff7237$var$getEthJsonRpcError(code, opts);
        },
        /**
         * Get an Ethereum JSON RPC Invalid Input (-32000) error.
         */ invalidInput: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.invalidInput, arg),
        /**
         * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
         */ resourceNotFound: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.resourceNotFound, arg),
        /**
         * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
         */ resourceUnavailable: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.resourceUnavailable, arg),
        /**
         * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
         */ transactionRejected: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.transactionRejected, arg),
        /**
         * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
         */ methodNotSupported: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.methodNotSupported, arg),
        /**
         * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
         */ limitExceeded: (arg)=>$95cf563110ff7237$var$getEthJsonRpcError($6s3bz.errorCodes.rpc.limitExceeded, arg)
    },
    provider: {
        /**
         * Get an Ethereum Provider User Rejected Request (4001) error.
         */ userRejectedRequest: (arg)=>{
            return $95cf563110ff7237$var$getEthProviderError($6s3bz.errorCodes.provider.userRejectedRequest, arg);
        },
        /**
         * Get an Ethereum Provider Unauthorized (4100) error.
         */ unauthorized: (arg)=>{
            return $95cf563110ff7237$var$getEthProviderError($6s3bz.errorCodes.provider.unauthorized, arg);
        },
        /**
         * Get an Ethereum Provider Unsupported Method (4200) error.
         */ unsupportedMethod: (arg)=>{
            return $95cf563110ff7237$var$getEthProviderError($6s3bz.errorCodes.provider.unsupportedMethod, arg);
        },
        /**
         * Get an Ethereum Provider Not Connected (4900) error.
         */ disconnected: (arg)=>{
            return $95cf563110ff7237$var$getEthProviderError($6s3bz.errorCodes.provider.disconnected, arg);
        },
        /**
         * Get an Ethereum Provider Chain Not Connected (4901) error.
         */ chainDisconnected: (arg)=>{
            return $95cf563110ff7237$var$getEthProviderError($6s3bz.errorCodes.provider.chainDisconnected, arg);
        },
        /**
         * Get a custom Ethereum Provider error.
         */ custom: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum Provider custom errors must provide single object argument.");
            const { code: code, message: message, data: data } = opts;
            if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string');
            return new $5LJgD.EthereumProviderError(code, message, data);
        }
    }
};
// Internal
function $95cf563110ff7237$var$getEthJsonRpcError(code, arg) {
    const [message, data] = $95cf563110ff7237$var$parseOpts(arg);
    return new $5LJgD.EthereumRpcError(code, message || $6OOIJ.getMessageFromCode(code), data);
}
function $95cf563110ff7237$var$getEthProviderError(code, arg) {
    const [message, data] = $95cf563110ff7237$var$parseOpts(arg);
    return new $5LJgD.EthereumProviderError(code, message || $6OOIJ.getMessageFromCode(code), data);
}
function $95cf563110ff7237$var$parseOpts(arg) {
    if (arg) {
        if (typeof arg === "string") return [
            arg
        ];
        else if (typeof arg === "object" && !Array.isArray(arg)) {
            const { message: message, data: data } = arg;
            if (message && typeof message !== "string") throw new Error("Must specify string message.");
            return [
                message || undefined,
                data
            ];
        }
    }
    return [];
}

});


parcelRequire.register("7jLgc", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EthereumAddressFromSignedMessageResponse = module.exports.SubmitEthereumTransactionResponse = module.exports.SignEthereumTransactionResponse = module.exports.SignEthereumMessageResponse = module.exports.isRequestEthereumAccountsResponse = module.exports.SelectProviderResponse = module.exports.WatchAssetReponse = module.exports.RequestEthereumAccountsResponse = module.exports.SwitchEthereumChainResponse = module.exports.AddEthereumChainResponse = module.exports.isErrorResponse = void 0;

var $6Hvzc = parcelRequire("6Hvzc");
function $553ef7a2e83b0b69$var$isErrorResponse(response) {
    var _a, _b;
    return ((_a = response) === null || _a === void 0 ? void 0 : _a.method) !== undefined && ((_b = response) === null || _b === void 0 ? void 0 : _b.errorMessage) !== undefined;
}
module.exports.isErrorResponse = $553ef7a2e83b0b69$var$isErrorResponse;
function $553ef7a2e83b0b69$var$AddEthereumChainResponse(addResponse) {
    return {
        method: $6Hvzc.Web3Method.addEthereumChain,
        result: addResponse
    };
}
module.exports.AddEthereumChainResponse = $553ef7a2e83b0b69$var$AddEthereumChainResponse;
function $553ef7a2e83b0b69$var$SwitchEthereumChainResponse(switchResponse) {
    return {
        method: $6Hvzc.Web3Method.switchEthereumChain,
        result: switchResponse
    };
}
module.exports.SwitchEthereumChainResponse = $553ef7a2e83b0b69$var$SwitchEthereumChainResponse;
function $553ef7a2e83b0b69$var$RequestEthereumAccountsResponse(addresses) {
    return {
        method: $6Hvzc.Web3Method.requestEthereumAccounts,
        result: addresses
    };
}
module.exports.RequestEthereumAccountsResponse = $553ef7a2e83b0b69$var$RequestEthereumAccountsResponse;
function $553ef7a2e83b0b69$var$WatchAssetReponse(success) {
    return {
        method: $6Hvzc.Web3Method.watchAsset,
        result: success
    };
}
module.exports.WatchAssetReponse = $553ef7a2e83b0b69$var$WatchAssetReponse;
function $553ef7a2e83b0b69$var$SelectProviderResponse(selectedProviderKey) {
    return {
        method: $6Hvzc.Web3Method.selectProvider,
        result: selectedProviderKey
    };
}
module.exports.SelectProviderResponse = $553ef7a2e83b0b69$var$SelectProviderResponse;
function $553ef7a2e83b0b69$var$isRequestEthereumAccountsResponse(res) {
    return res && res.method === $6Hvzc.Web3Method.requestEthereumAccounts;
}
module.exports.isRequestEthereumAccountsResponse = $553ef7a2e83b0b69$var$isRequestEthereumAccountsResponse;
function $553ef7a2e83b0b69$var$SignEthereumMessageResponse(signature) {
    return {
        method: $6Hvzc.Web3Method.signEthereumMessage,
        result: signature
    };
}
module.exports.SignEthereumMessageResponse = $553ef7a2e83b0b69$var$SignEthereumMessageResponse;
function $553ef7a2e83b0b69$var$SignEthereumTransactionResponse(signedData) {
    return {
        method: $6Hvzc.Web3Method.signEthereumTransaction,
        result: signedData
    };
}
module.exports.SignEthereumTransactionResponse = $553ef7a2e83b0b69$var$SignEthereumTransactionResponse;
function $553ef7a2e83b0b69$var$SubmitEthereumTransactionResponse(txHash) {
    return {
        method: $6Hvzc.Web3Method.submitEthereumTransaction,
        result: txHash
    };
}
module.exports.SubmitEthereumTransactionResponse = $553ef7a2e83b0b69$var$SubmitEthereumTransactionResponse;
function $553ef7a2e83b0b69$var$EthereumAddressFromSignedMessageResponse(address) {
    return {
        method: $6Hvzc.Web3Method.ethereumAddressFromSignedMessage,
        result: address
    };
}
module.exports.EthereumAddressFromSignedMessageResponse = $553ef7a2e83b0b69$var$EthereumAddressFromSignedMessageResponse;

});
parcelRequire.register("6Hvzc", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Web3Method = void 0;
var $4e0f3eb8c8e86717$var$Web3Method;
(function(Web3Method) {
    Web3Method["requestEthereumAccounts"] = "requestEthereumAccounts";
    Web3Method["signEthereumMessage"] = "signEthereumMessage";
    Web3Method["signEthereumTransaction"] = "signEthereumTransaction";
    Web3Method["submitEthereumTransaction"] = "submitEthereumTransaction";
    Web3Method["ethereumAddressFromSignedMessage"] = "ethereumAddressFromSignedMessage";
    Web3Method["scanQRCode"] = "scanQRCode";
    Web3Method["generic"] = "generic";
    Web3Method["childRequestEthereumAccounts"] = "childRequestEthereumAccounts";
    Web3Method["addEthereumChain"] = "addEthereumChain";
    Web3Method["switchEthereumChain"] = "switchEthereumChain";
    Web3Method["makeEthereumJSONRPCRequest"] = "makeEthereumJSONRPCRequest";
    Web3Method["watchAsset"] = "watchAsset";
    Web3Method["selectProvider"] = "selectProvider";
})($4e0f3eb8c8e86717$var$Web3Method = module.exports.Web3Method || (module.exports.Web3Method = {}));

});


parcelRequire.register("ejuBv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LIB_VERSION = void 0;
module.exports.LIB_VERSION = "3.7.2";

});


parcelRequire.register("gPotL", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Session = void 0;

var $5Z1sR = parcelRequire("5Z1sR");

var $1mY3j = parcelRequire("1mY3j");
const $c40465cd8fff0e4e$var$STORAGE_KEY_SESSION_ID = "session:id";
const $c40465cd8fff0e4e$var$STORAGE_KEY_SESSION_SECRET = "session:secret";
const $c40465cd8fff0e4e$var$STORAGE_KEY_SESSION_LINKED = "session:linked";
class $c40465cd8fff0e4e$var$Session {
    constructor(storage, id, secret, linked){
        this._storage = storage;
        this._id = id || (0, $1mY3j.randomBytesHex)(16);
        this._secret = secret || (0, $1mY3j.randomBytesHex)(32);
        this._key = new $5Z1sR.sha256().update(`${this._id}, ${this._secret} WalletLink`) // ensure old sessions stay connected
        .digest("hex");
        this._linked = !!linked;
    }
    static load(storage) {
        const id = storage.getItem($c40465cd8fff0e4e$var$STORAGE_KEY_SESSION_ID);
        const linked = storage.getItem($c40465cd8fff0e4e$var$STORAGE_KEY_SESSION_LINKED);
        const secret = storage.getItem($c40465cd8fff0e4e$var$STORAGE_KEY_SESSION_SECRET);
        if (id && secret) return new $c40465cd8fff0e4e$var$Session(storage, id, secret, linked === "1");
        return null;
    }
    /**
     * Takes in a session ID and returns the sha256 hash of it.
     * @param sessionId session ID
     */ static hash(sessionId) {
        return new $5Z1sR.sha256().update(sessionId).digest("hex");
    }
    get id() {
        return this._id;
    }
    get secret() {
        return this._secret;
    }
    get key() {
        return this._key;
    }
    get linked() {
        return this._linked;
    }
    set linked(val) {
        this._linked = val;
        this.persistLinked();
    }
    save() {
        this._storage.setItem($c40465cd8fff0e4e$var$STORAGE_KEY_SESSION_ID, this._id);
        this._storage.setItem($c40465cd8fff0e4e$var$STORAGE_KEY_SESSION_SECRET, this._secret);
        this.persistLinked();
        return this;
    }
    persistLinked() {
        this._storage.setItem($c40465cd8fff0e4e$var$STORAGE_KEY_SESSION_LINKED, this._linked ? "1" : "0");
    }
}
module.exports.Session = $c40465cd8fff0e4e$var$Session;

});
parcelRequire.register("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRequire.register("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRequire.register("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRequire.register("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});
parcelRequire.register("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});



parcelRequire.register("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRequire.register("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRequire.register("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRequire.register("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRequire.register("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRequire.register("1mY3j", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $0ff66db27ee16df1$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $0ff66db27ee16df1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInIFrame = module.exports.createQrUrl = module.exports.getFavicon = module.exports.range = module.exports.isBigNumber = module.exports.ensureParsedJSONObject = module.exports.ensureBN = module.exports.ensureRegExpString = module.exports.ensureIntNumber = module.exports.ensureBuffer = module.exports.ensureAddressString = module.exports.ensureEvenLengthHexString = module.exports.ensureHexString = module.exports.isHexString = module.exports.prepend0x = module.exports.strip0x = module.exports.has0xPrefix = module.exports.hexStringFromIntNumber = module.exports.intNumberFromHexString = module.exports.bigIntStringFromBN = module.exports.hexStringFromBuffer = module.exports.hexStringToUint8Array = module.exports.uint8ArrayToHex = module.exports.randomBytesHex = void 0;

const $0ff66db27ee16df1$var$bn_js_1 = $0ff66db27ee16df1$var$__importDefault((parcelRequire("dEXSZ")));

var $2rasJ = parcelRequire("2rasJ");

var $iGxB3 = parcelRequire("iGxB3");

var $iJH0e = parcelRequire("iJH0e");
const $0ff66db27ee16df1$var$INT_STRING_REGEX = /^[0-9]*$/;
const $0ff66db27ee16df1$var$HEXADECIMAL_STRING_REGEX = /^[a-f0-9]*$/;
/**
 * @param length number of bytes
 */ function $0ff66db27ee16df1$var$randomBytesHex(length) {
    return $0ff66db27ee16df1$var$uint8ArrayToHex(crypto.getRandomValues(new Uint8Array(length)));
}
module.exports.randomBytesHex = $0ff66db27ee16df1$var$randomBytesHex;
function $0ff66db27ee16df1$var$uint8ArrayToHex(value) {
    return [
        ...value
    ].map((b)=>b.toString(16).padStart(2, "0")).join("");
}
module.exports.uint8ArrayToHex = $0ff66db27ee16df1$var$uint8ArrayToHex;
function $0ff66db27ee16df1$var$hexStringToUint8Array(hexString) {
    return new Uint8Array(hexString.match(/.{1,2}/g).map((byte)=>parseInt(byte, 16)));
}
module.exports.hexStringToUint8Array = $0ff66db27ee16df1$var$hexStringToUint8Array;
function $0ff66db27ee16df1$var$hexStringFromBuffer(buf, includePrefix = false) {
    const hex = buf.toString("hex");
    return (0, $iJH0e.HexString)(includePrefix ? "0x" + hex : hex);
}
module.exports.hexStringFromBuffer = $0ff66db27ee16df1$var$hexStringFromBuffer;
function $0ff66db27ee16df1$var$bigIntStringFromBN(bn) {
    return (0, $iJH0e.BigIntString)(bn.toString(10));
}
module.exports.bigIntStringFromBN = $0ff66db27ee16df1$var$bigIntStringFromBN;
function $0ff66db27ee16df1$var$intNumberFromHexString(hex) {
    return (0, $iJH0e.IntNumber)(new $0ff66db27ee16df1$var$bn_js_1.default($0ff66db27ee16df1$var$ensureEvenLengthHexString(hex, false), 16).toNumber());
}
module.exports.intNumberFromHexString = $0ff66db27ee16df1$var$intNumberFromHexString;
function $0ff66db27ee16df1$var$hexStringFromIntNumber(num) {
    return (0, $iJH0e.HexString)("0x" + new $0ff66db27ee16df1$var$bn_js_1.default(num).toString(16));
}
module.exports.hexStringFromIntNumber = $0ff66db27ee16df1$var$hexStringFromIntNumber;
function $0ff66db27ee16df1$var$has0xPrefix(str) {
    return str.startsWith("0x") || str.startsWith("0X");
}
module.exports.has0xPrefix = $0ff66db27ee16df1$var$has0xPrefix;
function $0ff66db27ee16df1$var$strip0x(hex) {
    if ($0ff66db27ee16df1$var$has0xPrefix(hex)) return hex.slice(2);
    return hex;
}
module.exports.strip0x = $0ff66db27ee16df1$var$strip0x;
function $0ff66db27ee16df1$var$prepend0x(hex) {
    if ($0ff66db27ee16df1$var$has0xPrefix(hex)) return "0x" + hex.slice(2);
    return "0x" + hex;
}
module.exports.prepend0x = $0ff66db27ee16df1$var$prepend0x;
function $0ff66db27ee16df1$var$isHexString(hex) {
    if (typeof hex !== "string") return false;
    const s = $0ff66db27ee16df1$var$strip0x(hex).toLowerCase();
    return $0ff66db27ee16df1$var$HEXADECIMAL_STRING_REGEX.test(s);
}
module.exports.isHexString = $0ff66db27ee16df1$var$isHexString;
function $0ff66db27ee16df1$var$ensureHexString(hex, includePrefix = false) {
    if (typeof hex === "string") {
        const s = $0ff66db27ee16df1$var$strip0x(hex).toLowerCase();
        if ($0ff66db27ee16df1$var$HEXADECIMAL_STRING_REGEX.test(s)) return (0, $iJH0e.HexString)(includePrefix ? "0x" + s : s);
    }
    throw $iGxB3.standardErrors.rpc.invalidParams(`"${String(hex)}" is not a hexadecimal string`);
}
module.exports.ensureHexString = $0ff66db27ee16df1$var$ensureHexString;
function $0ff66db27ee16df1$var$ensureEvenLengthHexString(hex, includePrefix = false) {
    let h = $0ff66db27ee16df1$var$ensureHexString(hex, false);
    if (h.length % 2 === 1) h = (0, $iJH0e.HexString)("0" + h);
    return includePrefix ? (0, $iJH0e.HexString)("0x" + h) : h;
}
module.exports.ensureEvenLengthHexString = $0ff66db27ee16df1$var$ensureEvenLengthHexString;
function $0ff66db27ee16df1$var$ensureAddressString(str) {
    if (typeof str === "string") {
        const s = $0ff66db27ee16df1$var$strip0x(str).toLowerCase();
        if ($0ff66db27ee16df1$var$isHexString(s) && s.length === 40) return (0, $iJH0e.AddressString)($0ff66db27ee16df1$var$prepend0x(s));
    }
    throw $iGxB3.standardErrors.rpc.invalidParams(`Invalid Ethereum address: ${String(str)}`);
}
module.exports.ensureAddressString = $0ff66db27ee16df1$var$ensureAddressString;
function $0ff66db27ee16df1$var$ensureBuffer(str) {
    if ($0ff66db27ee16df1$require$Buffer.isBuffer(str)) return str;
    if (typeof str === "string") {
        if ($0ff66db27ee16df1$var$isHexString(str)) {
            const s = $0ff66db27ee16df1$var$ensureEvenLengthHexString(str, false);
            return $0ff66db27ee16df1$require$Buffer.from(s, "hex");
        } else return $0ff66db27ee16df1$require$Buffer.from(str, "utf8");
    }
    throw $iGxB3.standardErrors.rpc.invalidParams(`Not binary data: ${String(str)}`);
}
module.exports.ensureBuffer = $0ff66db27ee16df1$var$ensureBuffer;
function $0ff66db27ee16df1$var$ensureIntNumber(num) {
    if (typeof num === "number" && Number.isInteger(num)) return (0, $iJH0e.IntNumber)(num);
    if (typeof num === "string") {
        if ($0ff66db27ee16df1$var$INT_STRING_REGEX.test(num)) return (0, $iJH0e.IntNumber)(Number(num));
        if ($0ff66db27ee16df1$var$isHexString(num)) return (0, $iJH0e.IntNumber)(new $0ff66db27ee16df1$var$bn_js_1.default($0ff66db27ee16df1$var$ensureEvenLengthHexString(num, false), 16).toNumber());
    }
    throw $iGxB3.standardErrors.rpc.invalidParams(`Not an integer: ${String(num)}`);
}
module.exports.ensureIntNumber = $0ff66db27ee16df1$var$ensureIntNumber;
function $0ff66db27ee16df1$var$ensureRegExpString(regExp) {
    if (regExp instanceof RegExp) return (0, $iJH0e.RegExpString)(regExp.toString());
    throw $iGxB3.standardErrors.rpc.invalidParams(`Not a RegExp: ${String(regExp)}`);
}
module.exports.ensureRegExpString = $0ff66db27ee16df1$var$ensureRegExpString;
function $0ff66db27ee16df1$var$ensureBN(val) {
    if (val !== null && ($0ff66db27ee16df1$var$bn_js_1.default.isBN(val) || $0ff66db27ee16df1$var$isBigNumber(val))) return new $0ff66db27ee16df1$var$bn_js_1.default(val.toString(10), 10);
    if (typeof val === "number") return new $0ff66db27ee16df1$var$bn_js_1.default($0ff66db27ee16df1$var$ensureIntNumber(val));
    if (typeof val === "string") {
        if ($0ff66db27ee16df1$var$INT_STRING_REGEX.test(val)) return new $0ff66db27ee16df1$var$bn_js_1.default(val, 10);
        if ($0ff66db27ee16df1$var$isHexString(val)) return new $0ff66db27ee16df1$var$bn_js_1.default($0ff66db27ee16df1$var$ensureEvenLengthHexString(val, false), 16);
    }
    throw $iGxB3.standardErrors.rpc.invalidParams(`Not an integer: ${String(val)}`);
}
module.exports.ensureBN = $0ff66db27ee16df1$var$ensureBN;
function $0ff66db27ee16df1$var$ensureParsedJSONObject(val) {
    if (typeof val === "string") return JSON.parse(val);
    if (typeof val === "object") return val;
    throw $iGxB3.standardErrors.rpc.invalidParams(`Not a JSON string or an object: ${String(val)}`);
}
module.exports.ensureParsedJSONObject = $0ff66db27ee16df1$var$ensureParsedJSONObject;
function $0ff66db27ee16df1$var$isBigNumber(val) {
    if (val == null || typeof val.constructor !== "function") return false;
    const { constructor: constructor } = val;
    return typeof constructor.config === "function" && typeof constructor.EUCLID === "number";
}
module.exports.isBigNumber = $0ff66db27ee16df1$var$isBigNumber;
function $0ff66db27ee16df1$var$range(start, stop) {
    return Array.from({
        length: stop - start
    }, (_, i)=>start + i);
}
module.exports.range = $0ff66db27ee16df1$var$range;
function $0ff66db27ee16df1$var$getFavicon() {
    const el = document.querySelector('link[sizes="192x192"]') || document.querySelector('link[sizes="180x180"]') || document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
    const { protocol: protocol, host: host } = document.location;
    const href = el ? el.getAttribute("href") : null;
    if (!href || href.startsWith("javascript:")) return null;
    if (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("data:")) return href;
    if (href.startsWith("//")) return protocol + href;
    return `${protocol}//${host}${href}`;
}
module.exports.getFavicon = $0ff66db27ee16df1$var$getFavicon;
function $0ff66db27ee16df1$var$createQrUrl(sessionId, sessionSecret, serverUrl, isParentConnection, version, chainId) {
    const sessionIdKey = isParentConnection ? "parent-id" : "id";
    const query = (0, $2rasJ.stringify)({
        [sessionIdKey]: sessionId,
        secret: sessionSecret,
        server: serverUrl,
        v: version,
        chainId: chainId
    });
    const qrUrl = `${serverUrl}/#/link?${query}`;
    return qrUrl;
}
module.exports.createQrUrl = $0ff66db27ee16df1$var$createQrUrl;
function $0ff66db27ee16df1$var$isInIFrame() {
    try {
        return window.frameElement !== null;
    } catch (e) {
        return false;
    }
}
module.exports.isInIFrame = $0ff66db27ee16df1$var$isInIFrame;

});
parcelRequire.register("2rasJ", function(module, exports) {
"use strict";

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRequire.register("jJyEy", function(module, exports) {
"use strict";

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$split = String.prototype.split;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = $e5dd19a945a45bbb$var$split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + (commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && valuesArray.length === 1 ? "[]" : "") + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $LlIML();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $i1Gbt.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $LlIML();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRequire.register("LlIML", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $hXu6F = parcelRequire("hXu6F");

var $e7DLx = parcelRequire("e7DLx");
var $08e53d4ef2e1f8ef$var$$TypeError = $1zENl("%TypeError%");
var $08e53d4ef2e1f8ef$var$$WeakMap = $1zENl("%WeakMap%", true);
var $08e53d4ef2e1f8ef$var$$Map = $1zENl("%Map%", true);
var $08e53d4ef2e1f8ef$var$$weakMapGet = $hXu6F("WeakMap.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$weakMapSet = $hXu6F("WeakMap.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$weakMapHas = $hXu6F("WeakMap.prototype.has", true);
var $08e53d4ef2e1f8ef$var$$mapGet = $hXu6F("Map.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$mapSet = $hXu6F("Map.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$mapHas = $hXu6F("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $08e53d4ef2e1f8ef$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $08e53d4ef2e1f8ef$var$listGet = function(objects, key) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    return node && node.value;
};
var $08e53d4ef2e1f8ef$var$listSet = function(objects, key, value) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $08e53d4ef2e1f8ef$var$listHas = function(objects, key) {
    return !!$08e53d4ef2e1f8ef$var$listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $08e53d4ef2e1f8ef$var$$TypeError("Side channel does not contain " + $e7DLx(key));
        },
        get: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapGet($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapGet($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapHas($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapHas($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $08e53d4ef2e1f8ef$var$$WeakMap();
                $08e53d4ef2e1f8ef$var$$weakMapSet($wm, key, value);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if (!$m) $m = new $08e53d4ef2e1f8ef$var$$Map();
                $08e53d4ef2e1f8ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $08e53d4ef2e1f8ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRequire.register("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined;
var $1258b452ecf218a1$var$$SyntaxError = SyntaxError;
var $1258b452ecf218a1$var$$Function = Function;
var $1258b452ecf218a1$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $1258b452ecf218a1$var$$TypeError();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $1258b452ecf218a1$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $1258b452ecf218a1$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : $1258b452ecf218a1$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $1258b452ecf218a1$var$undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $1258b452ecf218a1$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $1258b452ecf218a1$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $1258b452ecf218a1$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $1258b452ecf218a1$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $1258b452ecf218a1$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $1258b452ecf218a1$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $1258b452ecf218a1$var$undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : $1258b452ecf218a1$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $1258b452ecf218a1$var$undefined,
    "%Map%": typeof Map === "undefined" ? $1258b452ecf218a1$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $1258b452ecf218a1$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $1258b452ecf218a1$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $1258b452ecf218a1$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $1258b452ecf218a1$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $1258b452ecf218a1$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : $1258b452ecf218a1$var$undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : $1258b452ecf218a1$var$undefined,
    "%SyntaxError%": $1258b452ecf218a1$var$$SyntaxError,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $1258b452ecf218a1$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $1258b452ecf218a1$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $1258b452ecf218a1$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $1258b452ecf218a1$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $1258b452ecf218a1$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $1258b452ecf218a1$var$undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $8aKn2 = parcelRequire("8aKn2");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $1258b452ecf218a1$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8aKn2($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $1258b452ecf218a1$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1258b452ecf218a1$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $1258b452ecf218a1$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $1258b452ecf218a1$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1258b452ecf218a1$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $1258b452ecf218a1$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($8aKn2($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $1258b452ecf218a1$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8aKn2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});
parcelRequire.register("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !(({
        __proto__: null
    }) instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRequire.register("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRequire.register("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$slice = Array.prototype.slice;
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.call(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($efd80b1d7fbb2850$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("8aKn2", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");
module.exports = $gvair.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRequire.register("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRequire.register("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);
var $9546dce5bd4976bd$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
var $9546dce5bd4976bd$var$$defineProperty = $1zENl("%Object.defineProperty%", true);
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
if ($9546dce5bd4976bd$var$$defineProperty) try {
    $9546dce5bd4976bd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9546dce5bd4976bd$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    if ($9546dce5bd4976bd$var$$gOPD && $9546dce5bd4976bd$var$$defineProperty) {
        var desc = $9546dce5bd4976bd$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $9546dce5bd4976bd$var$$defineProperty(func, "length", {
            value: 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($9546dce5bd4976bd$var$$defineProperty) $9546dce5bd4976bd$var$$defineProperty(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});


parcelRequire.register("e7DLx", function(module, exports) {
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a48090c7c3dfd2b6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a48090c7c3dfd2b6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a48090c7c3dfd2b6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === "object" && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = "<" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return "[" + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a48090c7c3dfd2b6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Map", $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Set", $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakMap");
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakSet");
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakRef");
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a48090c7c3dfd2b6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Array]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Date]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object RegExp]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Error]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object String]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Number]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Boolean]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, "single", opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === "function" ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});


parcelRequire.register("iBfJ5", function(module, exports) {
"use strict";

var $i1Gbt = parcelRequire("i1Gbt");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $d8a7e190fdc9c6e7$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};

});
parcelRequire.register("i1Gbt", function(module, exports) {
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRequire.register("cfYIz", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $iBfJ5.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        if ($8ec5fc0fdc198ba4$var$has.call(obj, key)) obj[key] = $iBfJ5.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iBfJ5.compact(obj);
};

});


parcelRequire.register("iJH0e", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProviderType = module.exports.RegExpString = module.exports.IntNumber = module.exports.BigIntString = module.exports.AddressString = module.exports.HexString = module.exports.OpaqueType = void 0;
function $da3dc96df6aa7c01$var$OpaqueType() {
    return (value)=>value;
}
module.exports.OpaqueType = $da3dc96df6aa7c01$var$OpaqueType;
module.exports.HexString = $da3dc96df6aa7c01$var$OpaqueType();
module.exports.AddressString = $da3dc96df6aa7c01$var$OpaqueType();
module.exports.BigIntString = $da3dc96df6aa7c01$var$OpaqueType();
function $da3dc96df6aa7c01$var$IntNumber(num) {
    return Math.floor(num);
}
module.exports.IntNumber = $da3dc96df6aa7c01$var$IntNumber;
module.exports.RegExpString = $da3dc96df6aa7c01$var$OpaqueType();
var $da3dc96df6aa7c01$var$ProviderType;
(function(ProviderType) {
    ProviderType["CoinbaseWallet"] = "CoinbaseWallet";
    ProviderType["MetaMask"] = "MetaMask";
    ProviderType["Unselected"] = "";
})($da3dc96df6aa7c01$var$ProviderType = module.exports.ProviderType || (module.exports.ProviderType = {}));

});



parcelRequire.register("iF8HB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletSDKRelayAbstract = module.exports.APP_VERSION_KEY = module.exports.LOCAL_STORAGE_ADDRESSES_KEY = module.exports.WALLET_USER_NAME_KEY = void 0;

var $iGxB3 = parcelRequire("iGxB3");
module.exports.WALLET_USER_NAME_KEY = "walletUsername";
module.exports.LOCAL_STORAGE_ADDRESSES_KEY = "Addresses";
module.exports.APP_VERSION_KEY = "AppVersion";
class $d962ce7096963f21$var$WalletSDKRelayAbstract {
    async makeEthereumJSONRPCRequest(request, jsonRpcUrl) {
        if (!jsonRpcUrl) throw new Error("Error: No jsonRpcUrl provided");
        return window.fetch(jsonRpcUrl, {
            method: "POST",
            body: JSON.stringify(request),
            mode: "cors",
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res)=>res.json()).then((json)=>{
            if (!json) throw $iGxB3.standardErrors.rpc.parse({});
            const response = json;
            const { error: error } = response;
            if (error) throw (0, $iGxB3.serializeError)(error, request.method);
            return response;
        });
    }
}
module.exports.WalletSDKRelayAbstract = $d962ce7096963f21$var$WalletSDKRelayAbstract;

});

parcelRequire.register("gx2Ud", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c091fb6c83989e87$require$Buffer = $6ZWSX.Buffer;

var $8DE9V = parcelRequire("8DE9V");

var $9QIdz = parcelRequire("9QIdz");
const $c091fb6c83989e87$var$TYPED_MESSAGE_SCHEMA = {
    type: "object",
    properties: {
        types: {
            type: "object",
            additionalProperties: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        name: {
                            type: "string"
                        },
                        type: {
                            type: "string"
                        }
                    },
                    required: [
                        "name",
                        "type"
                    ]
                }
            }
        },
        primaryType: {
            type: "string"
        },
        domain: {
            type: "object"
        },
        message: {
            type: "object"
        }
    },
    required: [
        "types",
        "primaryType",
        "domain",
        "message"
    ]
};
/**
 * A collection of utility functions used for signing typed data
 */ const $c091fb6c83989e87$var$TypedDataUtils = {
    /**
   * Encodes an object by encoding and concatenating each of its members
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of an object
   */ encodeData (primaryType, data, types, useV4 = true) {
        const encodedTypes = [
            "bytes32"
        ];
        const encodedValues = [
            this.hashType(primaryType, types)
        ];
        if (useV4) {
            const encodeField = (name, type, value)=>{
                if (types[type] !== undefined) return [
                    "bytes32",
                    value == null ? "0x0000000000000000000000000000000000000000000000000000000000000000" : $8DE9V.keccak(this.encodeData(type, value, types, useV4))
                ];
                if (value === undefined) throw new Error(`missing value for field ${name} of type ${type}`);
                if (type === "bytes") return [
                    "bytes32",
                    $8DE9V.keccak(value)
                ];
                if (type === "string") {
                    // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
                    if (typeof value === "string") value = $c091fb6c83989e87$require$Buffer.from(value, "utf8");
                    return [
                        "bytes32",
                        $8DE9V.keccak(value)
                    ];
                }
                if (type.lastIndexOf("]") === type.length - 1) {
                    const parsedType = type.slice(0, type.lastIndexOf("["));
                    const typeValuePairs = value.map((item)=>encodeField(name, parsedType, item));
                    return [
                        "bytes32",
                        $8DE9V.keccak($9QIdz.rawEncode(typeValuePairs.map(([type])=>type), typeValuePairs.map(([, value])=>value)))
                    ];
                }
                return [
                    type,
                    value
                ];
            };
            for (const field of types[primaryType]){
                const [type, value] = encodeField(field.name, field.type, data[field.name]);
                encodedTypes.push(type);
                encodedValues.push(value);
            }
        } else for (const field of types[primaryType]){
            let value = data[field.name];
            if (value !== undefined) {
                if (field.type === "bytes") {
                    encodedTypes.push("bytes32");
                    value = $8DE9V.keccak(value);
                    encodedValues.push(value);
                } else if (field.type === "string") {
                    encodedTypes.push("bytes32");
                    // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
                    if (typeof value === "string") value = $c091fb6c83989e87$require$Buffer.from(value, "utf8");
                    value = $8DE9V.keccak(value);
                    encodedValues.push(value);
                } else if (types[field.type] !== undefined) {
                    encodedTypes.push("bytes32");
                    value = $8DE9V.keccak(this.encodeData(field.type, value, types, useV4));
                    encodedValues.push(value);
                } else if (field.type.lastIndexOf("]") === field.type.length - 1) throw new Error("Arrays currently unimplemented in encodeData");
                else {
                    encodedTypes.push(field.type);
                    encodedValues.push(value);
                }
            }
        }
        return $9QIdz.rawEncode(encodedTypes, encodedValues);
    },
    /**
   * Encodes the type of an object by encoding a comma delimited list of its members
   *
   * @param {string} primaryType - Root type to encode
   * @param {Object} types - Type definitions
   * @returns {string} - Encoded representation of the type of an object
   */ encodeType (primaryType, types) {
        let result = "";
        let deps = this.findTypeDependencies(primaryType, types).filter((dep)=>dep !== primaryType);
        deps = [
            primaryType
        ].concat(deps.sort());
        for (const type of deps){
            const children = types[type];
            if (!children) throw new Error("No type definition specified: " + type);
            result += type + "(" + types[type].map(({ name: name, type: type })=>type + " " + name).join(",") + ")";
        }
        return result;
    },
    /**
   * Finds all types within a type defintion object
   *
   * @param {string} primaryType - Root type
   * @param {Object} types - Type definitions
   * @param {Array} results - current set of accumulated types
   * @returns {Array} - Set of all types found in the type definition
   */ findTypeDependencies (primaryType, types, results = []) {
        primaryType = primaryType.match(/^\w*/)[0];
        if (results.includes(primaryType) || types[primaryType] === undefined) return results;
        results.push(primaryType);
        for (const field of types[primaryType])for (const dep of this.findTypeDependencies(field.type, types, results))!results.includes(dep) && results.push(dep);
        return results;
    },
    /**
   * Hashes an object
   *
   * @param {string} primaryType - Root type
   * @param {Object} data - Object to hash
   * @param {Object} types - Type definitions
   * @returns {Buffer} - Hash of an object
   */ hashStruct (primaryType, data, types, useV4 = true) {
        return $8DE9V.keccak(this.encodeData(primaryType, data, types, useV4));
    },
    /**
   * Hashes the type of an object
   *
   * @param {string} primaryType - Root type to hash
   * @param {Object} types - Type definitions
   * @returns {string} - Hash of an object
   */ hashType (primaryType, types) {
        return $8DE9V.keccak(this.encodeType(primaryType, types));
    },
    /**
   * Removes properties from a message object that are not defined per EIP-712
   *
   * @param {Object} data - typed message object
   * @returns {Object} - typed message object with only allowed fields
   */ sanitizeData (data) {
        const sanitizedData = {};
        for(const key in $c091fb6c83989e87$var$TYPED_MESSAGE_SCHEMA.properties)data[key] && (sanitizedData[key] = data[key]);
        if (sanitizedData.types) sanitizedData.types = Object.assign({
            EIP712Domain: []
        }, sanitizedData.types);
        return sanitizedData;
    },
    /**
   * Returns the hash of a typed message as per EIP-712 for signing
   *
   * @param {Object} typedData - Types message data to sign
   * @returns {string} - sha3 hash for signing
   */ hash (typedData, useV4 = true) {
        const sanitizedData = this.sanitizeData(typedData);
        const parts = [
            $c091fb6c83989e87$require$Buffer.from("1901", "hex")
        ];
        parts.push(this.hashStruct("EIP712Domain", sanitizedData.domain, sanitizedData.types, useV4));
        if (sanitizedData.primaryType !== "EIP712Domain") parts.push(this.hashStruct(sanitizedData.primaryType, sanitizedData.message, sanitizedData.types, useV4));
        return $8DE9V.keccak($c091fb6c83989e87$require$Buffer.concat(parts));
    }
};
module.exports = {
    TYPED_MESSAGE_SCHEMA: $c091fb6c83989e87$var$TYPED_MESSAGE_SCHEMA,
    TypedDataUtils: $c091fb6c83989e87$var$TypedDataUtils,
    hashForSignTypedDataLegacy: function(msgParams) {
        return $c091fb6c83989e87$var$typedSignatureHashLegacy(msgParams.data);
    },
    hashForSignTypedData_v3: function(msgParams) {
        return $c091fb6c83989e87$var$TypedDataUtils.hash(msgParams.data, false);
    },
    hashForSignTypedData_v4: function(msgParams) {
        return $c091fb6c83989e87$var$TypedDataUtils.hash(msgParams.data);
    }
};
/**
 * @param typedData - Array of data along with types, as per EIP712.
 * @returns Buffer
 */ function $c091fb6c83989e87$var$typedSignatureHashLegacy(typedData) {
    const error = new Error("Expect argument to be non-empty array");
    if (typeof typedData !== "object" || !typedData.length) throw error;
    const data = typedData.map(function(e) {
        return e.type === "bytes" ? $8DE9V.toBuffer(e.value) : e.value;
    });
    const types = typedData.map(function(e) {
        return e.type;
    });
    const schema = typedData.map(function(e) {
        if (!e.name) throw error;
        return e.type + " " + e.name;
    });
    return $9QIdz.soliditySHA3([
        "bytes32",
        "bytes32"
    ], [
        $9QIdz.soliditySHA3(new Array(typedData.length).fill("string"), schema),
        $9QIdz.soliditySHA3(types, data)
    ]);
}

});
parcelRequire.register("8DE9V", function(module, exports) {
// Extracted from https://github.com/ethereumjs/ethereumjs-util and stripped out irrelevant code
// Original code licensed under the Mozilla Public License Version 2.0

var $6ZWSX = parcelRequire("6ZWSX");
var $64a11e06490e3e2b$require$Buffer = $6ZWSX.Buffer;

var $X8PsT = parcelRequire("X8PsT");

var $dEXSZ = parcelRequire("dEXSZ");
/**
 * Returns a buffer filled with 0s
 * @method zeros
 * @param {Number} bytes  the number of bytes the buffer should be
 * @return {Buffer}
 */ function $64a11e06490e3e2b$var$zeros(bytes) {
    return $64a11e06490e3e2b$require$Buffer.allocUnsafe(bytes).fill(0);
}
/**
 * Left Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @method setLength
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @param {Boolean} [right=false] whether to start padding form the left or right
 * @return {Buffer|Array}
 */ function $64a11e06490e3e2b$var$setLength(msg, length, right) {
    const buf = $64a11e06490e3e2b$var$zeros(length);
    msg = $64a11e06490e3e2b$var$toBuffer(msg);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
}
/**
 * Right Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param {Buffer|Array} msg the value to pad
 * @param {Number} length the number of bytes the output should be
 * @return {Buffer|Array}
 */ function $64a11e06490e3e2b$var$setLengthRight(msg, length) {
    return $64a11e06490e3e2b$var$setLength(msg, length, true);
}
/**
 * Attempts to turn a value into a `Buffer`. As input it supports `Buffer`, `String`, `Number`, null/undefined, `BN` and other objects with a `toArray()` method.
 * @param {*} v the value
 */ function $64a11e06490e3e2b$var$toBuffer(v) {
    if (!$64a11e06490e3e2b$require$Buffer.isBuffer(v)) {
        if (Array.isArray(v)) v = $64a11e06490e3e2b$require$Buffer.from(v);
        else if (typeof v === "string") {
            if ($64a11e06490e3e2b$var$isHexString(v)) v = $64a11e06490e3e2b$require$Buffer.from($64a11e06490e3e2b$var$padToEven($64a11e06490e3e2b$var$stripHexPrefix(v)), "hex");
            else v = $64a11e06490e3e2b$require$Buffer.from(v);
        } else if (typeof v === "number") v = intToBuffer(v);
        else if (v === null || v === undefined) v = $64a11e06490e3e2b$require$Buffer.allocUnsafe(0);
        else if ($dEXSZ.isBN(v)) v = v.toArrayLike($64a11e06490e3e2b$require$Buffer);
        else if (v.toArray) // converts a BN to a Buffer
        v = $64a11e06490e3e2b$require$Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}
/**
 * Converts a `Buffer` into a hex `String`
 * @param {Buffer} buf
 * @return {String}
 */ function $64a11e06490e3e2b$var$bufferToHex(buf) {
    buf = $64a11e06490e3e2b$var$toBuffer(buf);
    return "0x" + buf.toString("hex");
}
/**
 * Creates Keccak hash of the input
 * @param {Buffer|Array|String|Number} a the input data
 * @param {Number} [bits=256] the Keccak width
 * @return {Buffer}
 */ function $64a11e06490e3e2b$var$keccak(a, bits) {
    a = $64a11e06490e3e2b$var$toBuffer(a);
    if (!bits) bits = 256;
    return $X8PsT("keccak" + bits).update(a).digest();
}
function $64a11e06490e3e2b$var$padToEven(str) {
    return str.length % 2 ? "0" + str : str;
}
function $64a11e06490e3e2b$var$isHexString(str) {
    return typeof str === "string" && str.match(/^0x[0-9A-Fa-f]*$/);
}
function $64a11e06490e3e2b$var$stripHexPrefix(str) {
    if (typeof str === "string" && str.startsWith("0x")) return str.slice(2);
    return str;
}
module.exports = {
    zeros: $64a11e06490e3e2b$var$zeros,
    setLength: $64a11e06490e3e2b$var$setLength,
    setLengthRight: $64a11e06490e3e2b$var$setLengthRight,
    isHexString: $64a11e06490e3e2b$var$isHexString,
    stripHexPrefix: $64a11e06490e3e2b$var$stripHexPrefix,
    toBuffer: $64a11e06490e3e2b$var$toBuffer,
    bufferToHex: $64a11e06490e3e2b$var$bufferToHex,
    keccak: $64a11e06490e3e2b$var$keccak
};

});
parcelRequire.register("X8PsT", function(module, exports) {


module.exports = (parcelRequire("d8tul"))((parcelRequire("l2DpN")));

});
parcelRequire.register("d8tul", function(module, exports) {

var $lO6fo = parcelRequire("lO6fo");

var $4jc6M = parcelRequire("4jc6M");
module.exports = function(KeccakState) {
    const Keccak = $lO6fo(KeccakState);
    const Shake = $4jc6M(KeccakState);
    return function(algorithm, options) {
        const hash = typeof algorithm === "string" ? algorithm.toLowerCase() : algorithm;
        switch(hash){
            case "keccak224":
                return new Keccak(1152, 448, null, 224, options);
            case "keccak256":
                return new Keccak(1088, 512, null, 256, options);
            case "keccak384":
                return new Keccak(832, 768, null, 384, options);
            case "keccak512":
                return new Keccak(576, 1024, null, 512, options);
            case "sha3-224":
                return new Keccak(1152, 448, 0x06, 224, options);
            case "sha3-256":
                return new Keccak(1088, 512, 0x06, 256, options);
            case "sha3-384":
                return new Keccak(832, 768, 0x06, 384, options);
            case "sha3-512":
                return new Keccak(576, 1024, 0x06, 512, options);
            case "shake128":
                return new Shake(1344, 256, 0x1f, options);
            case "shake256":
                return new Shake(1088, 512, 0x1f, options);
            default:
                throw new Error("Invald algorithm: " + algorithm);
        }
    };
};

});
parcelRequire.register("lO6fo", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $fe031d0e6064652e$require$Buffer = $6ZWSX.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $fe031d0e6064652e$require$Transform = $b6RFW.Transform;
module.exports = (KeccakState)=>class Keccak extends $fe031d0e6064652e$require$Transform {
        constructor(rate, capacity, delimitedSuffix, hashBitLength, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._hashBitLength = hashBitLength;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush(callback) {
            let error = null;
            try {
                this.push(this.digest());
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        update(data, encoding) {
            if (!$fe031d0e6064652e$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Digest already called");
            if (!$fe031d0e6064652e$require$Buffer.isBuffer(data)) data = $fe031d0e6064652e$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        digest(encoding) {
            if (this._finalized) throw new Error("Digest already called");
            this._finalized = true;
            if (this._delimitedSuffix) this._state.absorbLastFewBits(this._delimitedSuffix);
            let digest = this._state.squeeze(this._hashBitLength / 8);
            if (encoding !== undefined) digest = digest.toString(encoding);
            this._resetState();
            return digest;
        }
        // remove result from memory
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        // because sometimes we need hash right now and little later
        _clone() {
            const clone = new Keccak(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});
parcelRequire.register("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

exports.finished = (parcelRequire("fiCvv"));

exports.pipeline = (parcelRequire("aGSwO"));

});
parcelRequire.register("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRequire.register("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRequire.register("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRequire.register("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRequire.register("04a3B", function(module, exports) {
"use strict";

var $6JySE = parcelRequire("6JySE");
var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = $6JySE.codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRequire.register("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRequire.register("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRequire.register("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRequire.register("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRequire.register("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "�";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "�";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "�";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "�";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRequire.register("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRequire.register("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $6JySE = parcelRequire("6JySE");
var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = $6JySE.codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRequire.register("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRequire.register("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRequire.register("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRequire.register("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});



parcelRequire.register("4jc6M", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $323254414dacbac4$require$Buffer = $6ZWSX.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $323254414dacbac4$require$Transform = $b6RFW.Transform;
module.exports = (KeccakState)=>class Shake extends $323254414dacbac4$require$Transform {
        constructor(rate, capacity, delimitedSuffix, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush() {}
        _read(size) {
            this.push(this.squeeze(size));
        }
        update(data, encoding) {
            if (!$323254414dacbac4$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Squeeze already called");
            if (!$323254414dacbac4$require$Buffer.isBuffer(data)) data = $323254414dacbac4$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        squeeze(dataByteLength, encoding) {
            if (!this._finalized) {
                this._finalized = true;
                this._state.absorbLastFewBits(this._delimitedSuffix);
            }
            let data = this._state.squeeze(dataByteLength);
            if (encoding !== undefined) data = data.toString(encoding);
            return data;
        }
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        _clone() {
            const clone = new Shake(this._rate, this._capacity, this._delimitedSuffix, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});


parcelRequire.register("l2DpN", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f5185be9cd3a5624$require$Buffer = $6ZWSX.Buffer;

var $93Kfq = parcelRequire("93Kfq");
function $f5185be9cd3a5624$var$Keccak() {
    // much faster than `new Array(50)`
    this.state = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    this.blockSize = null;
    this.count = 0;
    this.squeezing = false;
}
$f5185be9cd3a5624$var$Keccak.prototype.initialize = function(rate, capacity) {
    for(let i = 0; i < 50; ++i)this.state[i] = 0;
    this.blockSize = rate / 8;
    this.count = 0;
    this.squeezing = false;
};
$f5185be9cd3a5624$var$Keccak.prototype.absorb = function(data) {
    for(let i = 0; i < data.length; ++i){
        this.state[~~(this.count / 4)] ^= data[i] << 8 * (this.count % 4);
        this.count += 1;
        if (this.count === this.blockSize) {
            $93Kfq.p1600(this.state);
            this.count = 0;
        }
    }
};
$f5185be9cd3a5624$var$Keccak.prototype.absorbLastFewBits = function(bits) {
    this.state[~~(this.count / 4)] ^= bits << 8 * (this.count % 4);
    if ((bits & 0x80) !== 0 && this.count === this.blockSize - 1) $93Kfq.p1600(this.state);
    this.state[~~((this.blockSize - 1) / 4)] ^= 0x80 << 8 * ((this.blockSize - 1) % 4);
    $93Kfq.p1600(this.state);
    this.count = 0;
    this.squeezing = true;
};
$f5185be9cd3a5624$var$Keccak.prototype.squeeze = function(length) {
    if (!this.squeezing) this.absorbLastFewBits(0x01);
    const output = $f5185be9cd3a5624$require$Buffer.alloc(length);
    for(let i = 0; i < length; ++i){
        output[i] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 0xff;
        this.count += 1;
        if (this.count === this.blockSize) {
            $93Kfq.p1600(this.state);
            this.count = 0;
        }
    }
    return output;
};
$f5185be9cd3a5624$var$Keccak.prototype.copy = function(dest) {
    for(let i = 0; i < 50; ++i)dest.state[i] = this.state[i];
    dest.blockSize = this.blockSize;
    dest.count = this.count;
    dest.squeezing = this.squeezing;
};
module.exports = $f5185be9cd3a5624$var$Keccak;

});
parcelRequire.register("93Kfq", function(module, exports) {

$parcel$export(module.exports, "p1600", () => $698844b958219b6e$export$471358fe9e8379c0, (v) => $698844b958219b6e$export$471358fe9e8379c0 = v);
var $698844b958219b6e$export$471358fe9e8379c0;
const $698844b958219b6e$var$P1600_ROUND_CONSTANTS = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
$698844b958219b6e$export$471358fe9e8379c0 = function(s) {
    for(let round = 0; round < 24; ++round){
        // theta
        const lo0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        const hi0 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        const lo1 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        const hi1 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        const lo2 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        const hi2 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        const lo3 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        const hi3 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        const lo4 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        const hi4 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        let lo = lo4 ^ (lo1 << 1 | hi1 >>> 31);
        let hi = hi4 ^ (hi1 << 1 | lo1 >>> 31);
        const t1slo0 = s[0] ^ lo;
        const t1shi0 = s[1] ^ hi;
        const t1slo5 = s[10] ^ lo;
        const t1shi5 = s[11] ^ hi;
        const t1slo10 = s[20] ^ lo;
        const t1shi10 = s[21] ^ hi;
        const t1slo15 = s[30] ^ lo;
        const t1shi15 = s[31] ^ hi;
        const t1slo20 = s[40] ^ lo;
        const t1shi20 = s[41] ^ hi;
        lo = lo0 ^ (lo2 << 1 | hi2 >>> 31);
        hi = hi0 ^ (hi2 << 1 | lo2 >>> 31);
        const t1slo1 = s[2] ^ lo;
        const t1shi1 = s[3] ^ hi;
        const t1slo6 = s[12] ^ lo;
        const t1shi6 = s[13] ^ hi;
        const t1slo11 = s[22] ^ lo;
        const t1shi11 = s[23] ^ hi;
        const t1slo16 = s[32] ^ lo;
        const t1shi16 = s[33] ^ hi;
        const t1slo21 = s[42] ^ lo;
        const t1shi21 = s[43] ^ hi;
        lo = lo1 ^ (lo3 << 1 | hi3 >>> 31);
        hi = hi1 ^ (hi3 << 1 | lo3 >>> 31);
        const t1slo2 = s[4] ^ lo;
        const t1shi2 = s[5] ^ hi;
        const t1slo7 = s[14] ^ lo;
        const t1shi7 = s[15] ^ hi;
        const t1slo12 = s[24] ^ lo;
        const t1shi12 = s[25] ^ hi;
        const t1slo17 = s[34] ^ lo;
        const t1shi17 = s[35] ^ hi;
        const t1slo22 = s[44] ^ lo;
        const t1shi22 = s[45] ^ hi;
        lo = lo2 ^ (lo4 << 1 | hi4 >>> 31);
        hi = hi2 ^ (hi4 << 1 | lo4 >>> 31);
        const t1slo3 = s[6] ^ lo;
        const t1shi3 = s[7] ^ hi;
        const t1slo8 = s[16] ^ lo;
        const t1shi8 = s[17] ^ hi;
        const t1slo13 = s[26] ^ lo;
        const t1shi13 = s[27] ^ hi;
        const t1slo18 = s[36] ^ lo;
        const t1shi18 = s[37] ^ hi;
        const t1slo23 = s[46] ^ lo;
        const t1shi23 = s[47] ^ hi;
        lo = lo3 ^ (lo0 << 1 | hi0 >>> 31);
        hi = hi3 ^ (hi0 << 1 | lo0 >>> 31);
        const t1slo4 = s[8] ^ lo;
        const t1shi4 = s[9] ^ hi;
        const t1slo9 = s[18] ^ lo;
        const t1shi9 = s[19] ^ hi;
        const t1slo14 = s[28] ^ lo;
        const t1shi14 = s[29] ^ hi;
        const t1slo19 = s[38] ^ lo;
        const t1shi19 = s[39] ^ hi;
        const t1slo24 = s[48] ^ lo;
        const t1shi24 = s[49] ^ hi;
        // rho & pi
        const t2slo0 = t1slo0;
        const t2shi0 = t1shi0;
        const t2slo16 = t1shi5 << 4 | t1slo5 >>> 28;
        const t2shi16 = t1slo5 << 4 | t1shi5 >>> 28;
        const t2slo7 = t1slo10 << 3 | t1shi10 >>> 29;
        const t2shi7 = t1shi10 << 3 | t1slo10 >>> 29;
        const t2slo23 = t1shi15 << 9 | t1slo15 >>> 23;
        const t2shi23 = t1slo15 << 9 | t1shi15 >>> 23;
        const t2slo14 = t1slo20 << 18 | t1shi20 >>> 14;
        const t2shi14 = t1shi20 << 18 | t1slo20 >>> 14;
        const t2slo10 = t1slo1 << 1 | t1shi1 >>> 31;
        const t2shi10 = t1shi1 << 1 | t1slo1 >>> 31;
        const t2slo1 = t1shi6 << 12 | t1slo6 >>> 20;
        const t2shi1 = t1slo6 << 12 | t1shi6 >>> 20;
        const t2slo17 = t1slo11 << 10 | t1shi11 >>> 22;
        const t2shi17 = t1shi11 << 10 | t1slo11 >>> 22;
        const t2slo8 = t1shi16 << 13 | t1slo16 >>> 19;
        const t2shi8 = t1slo16 << 13 | t1shi16 >>> 19;
        const t2slo24 = t1slo21 << 2 | t1shi21 >>> 30;
        const t2shi24 = t1shi21 << 2 | t1slo21 >>> 30;
        const t2slo20 = t1shi2 << 30 | t1slo2 >>> 2;
        const t2shi20 = t1slo2 << 30 | t1shi2 >>> 2;
        const t2slo11 = t1slo7 << 6 | t1shi7 >>> 26;
        const t2shi11 = t1shi7 << 6 | t1slo7 >>> 26;
        const t2slo2 = t1shi12 << 11 | t1slo12 >>> 21;
        const t2shi2 = t1slo12 << 11 | t1shi12 >>> 21;
        const t2slo18 = t1slo17 << 15 | t1shi17 >>> 17;
        const t2shi18 = t1shi17 << 15 | t1slo17 >>> 17;
        const t2slo9 = t1shi22 << 29 | t1slo22 >>> 3;
        const t2shi9 = t1slo22 << 29 | t1shi22 >>> 3;
        const t2slo5 = t1slo3 << 28 | t1shi3 >>> 4;
        const t2shi5 = t1shi3 << 28 | t1slo3 >>> 4;
        const t2slo21 = t1shi8 << 23 | t1slo8 >>> 9;
        const t2shi21 = t1slo8 << 23 | t1shi8 >>> 9;
        const t2slo12 = t1slo13 << 25 | t1shi13 >>> 7;
        const t2shi12 = t1shi13 << 25 | t1slo13 >>> 7;
        const t2slo3 = t1slo18 << 21 | t1shi18 >>> 11;
        const t2shi3 = t1shi18 << 21 | t1slo18 >>> 11;
        const t2slo19 = t1shi23 << 24 | t1slo23 >>> 8;
        const t2shi19 = t1slo23 << 24 | t1shi23 >>> 8;
        const t2slo15 = t1slo4 << 27 | t1shi4 >>> 5;
        const t2shi15 = t1shi4 << 27 | t1slo4 >>> 5;
        const t2slo6 = t1slo9 << 20 | t1shi9 >>> 12;
        const t2shi6 = t1shi9 << 20 | t1slo9 >>> 12;
        const t2slo22 = t1shi14 << 7 | t1slo14 >>> 25;
        const t2shi22 = t1slo14 << 7 | t1shi14 >>> 25;
        const t2slo13 = t1slo19 << 8 | t1shi19 >>> 24;
        const t2shi13 = t1shi19 << 8 | t1slo19 >>> 24;
        const t2slo4 = t1slo24 << 14 | t1shi24 >>> 18;
        const t2shi4 = t1shi24 << 14 | t1slo24 >>> 18;
        // chi
        s[0] = t2slo0 ^ ~t2slo1 & t2slo2;
        s[1] = t2shi0 ^ ~t2shi1 & t2shi2;
        s[10] = t2slo5 ^ ~t2slo6 & t2slo7;
        s[11] = t2shi5 ^ ~t2shi6 & t2shi7;
        s[20] = t2slo10 ^ ~t2slo11 & t2slo12;
        s[21] = t2shi10 ^ ~t2shi11 & t2shi12;
        s[30] = t2slo15 ^ ~t2slo16 & t2slo17;
        s[31] = t2shi15 ^ ~t2shi16 & t2shi17;
        s[40] = t2slo20 ^ ~t2slo21 & t2slo22;
        s[41] = t2shi20 ^ ~t2shi21 & t2shi22;
        s[2] = t2slo1 ^ ~t2slo2 & t2slo3;
        s[3] = t2shi1 ^ ~t2shi2 & t2shi3;
        s[12] = t2slo6 ^ ~t2slo7 & t2slo8;
        s[13] = t2shi6 ^ ~t2shi7 & t2shi8;
        s[22] = t2slo11 ^ ~t2slo12 & t2slo13;
        s[23] = t2shi11 ^ ~t2shi12 & t2shi13;
        s[32] = t2slo16 ^ ~t2slo17 & t2slo18;
        s[33] = t2shi16 ^ ~t2shi17 & t2shi18;
        s[42] = t2slo21 ^ ~t2slo22 & t2slo23;
        s[43] = t2shi21 ^ ~t2shi22 & t2shi23;
        s[4] = t2slo2 ^ ~t2slo3 & t2slo4;
        s[5] = t2shi2 ^ ~t2shi3 & t2shi4;
        s[14] = t2slo7 ^ ~t2slo8 & t2slo9;
        s[15] = t2shi7 ^ ~t2shi8 & t2shi9;
        s[24] = t2slo12 ^ ~t2slo13 & t2slo14;
        s[25] = t2shi12 ^ ~t2shi13 & t2shi14;
        s[34] = t2slo17 ^ ~t2slo18 & t2slo19;
        s[35] = t2shi17 ^ ~t2shi18 & t2shi19;
        s[44] = t2slo22 ^ ~t2slo23 & t2slo24;
        s[45] = t2shi22 ^ ~t2shi23 & t2shi24;
        s[6] = t2slo3 ^ ~t2slo4 & t2slo0;
        s[7] = t2shi3 ^ ~t2shi4 & t2shi0;
        s[16] = t2slo8 ^ ~t2slo9 & t2slo5;
        s[17] = t2shi8 ^ ~t2shi9 & t2shi5;
        s[26] = t2slo13 ^ ~t2slo14 & t2slo10;
        s[27] = t2shi13 ^ ~t2shi14 & t2shi10;
        s[36] = t2slo18 ^ ~t2slo19 & t2slo15;
        s[37] = t2shi18 ^ ~t2shi19 & t2shi15;
        s[46] = t2slo23 ^ ~t2slo24 & t2slo20;
        s[47] = t2shi23 ^ ~t2shi24 & t2shi20;
        s[8] = t2slo4 ^ ~t2slo0 & t2slo1;
        s[9] = t2shi4 ^ ~t2shi0 & t2shi1;
        s[18] = t2slo9 ^ ~t2slo5 & t2slo6;
        s[19] = t2shi9 ^ ~t2shi5 & t2shi6;
        s[28] = t2slo14 ^ ~t2slo10 & t2slo11;
        s[29] = t2shi14 ^ ~t2shi10 & t2shi11;
        s[38] = t2slo19 ^ ~t2slo15 & t2slo16;
        s[39] = t2shi19 ^ ~t2shi15 & t2shi16;
        s[48] = t2slo24 ^ ~t2slo20 & t2slo21;
        s[49] = t2shi24 ^ ~t2shi20 & t2shi21;
        // iota
        s[0] ^= $698844b958219b6e$var$P1600_ROUND_CONSTANTS[round * 2];
        s[1] ^= $698844b958219b6e$var$P1600_ROUND_CONSTANTS[round * 2 + 1];
    }
};

});




parcelRequire.register("9QIdz", function(module, exports) {
// Extracted from https://github.com/ethereumjs/ethereumjs-abi and stripped out irrelevant code
// Original code licensed under the MIT License - Copyright (c) 2015 Alex Beregszaszi

var $6ZWSX = parcelRequire("6ZWSX");
var $72bb45218010f324$require$Buffer = $6ZWSX.Buffer;

var $8DE9V = parcelRequire("8DE9V");

var $dEXSZ = parcelRequire("dEXSZ");
// Convert from short to canonical names
// FIXME: optimise or make this nicer?
function $72bb45218010f324$var$elementaryName(name) {
    if (name.startsWith("int[")) return "int256" + name.slice(3);
    else if (name === "int") return "int256";
    else if (name.startsWith("uint[")) return "uint256" + name.slice(4);
    else if (name === "uint") return "uint256";
    else if (name.startsWith("fixed[")) return "fixed128x128" + name.slice(5);
    else if (name === "fixed") return "fixed128x128";
    else if (name.startsWith("ufixed[")) return "ufixed128x128" + name.slice(6);
    else if (name === "ufixed") return "ufixed128x128";
    return name;
}
// Parse N from type<N>
function $72bb45218010f324$var$parseTypeN(type) {
    return parseInt(/^\D+(\d+)$/.exec(type)[1], 10);
}
// Parse N,M from type<N>x<M>
function $72bb45218010f324$var$parseTypeNxM(type) {
    var tmp = /^\D+(\d+)x(\d+)$/.exec(type);
    return [
        parseInt(tmp[1], 10),
        parseInt(tmp[2], 10)
    ];
}
// Parse N in type[<N>] where "type" can itself be an array type.
function $72bb45218010f324$var$parseTypeArray(type) {
    var tmp = type.match(/(.*)\[(.*?)\]$/);
    if (tmp) return tmp[2] === "" ? "dynamic" : parseInt(tmp[2], 10);
    return null;
}
function $72bb45218010f324$var$parseNumber(arg) {
    var type = typeof arg;
    if (type === "string") {
        if ($8DE9V.isHexString(arg)) return new $dEXSZ($8DE9V.stripHexPrefix(arg), 16);
        else return new $dEXSZ(arg, 10);
    } else if (type === "number") return new $dEXSZ(arg);
    else if (arg.toArray) // assume this is a BN for the moment, replace with BN.isBN soon
    return arg;
    else throw new Error("Argument is not a number");
}
// Encodes a single item (can be dynamic array)
// @returns: Buffer
function $72bb45218010f324$var$encodeSingle(type, arg) {
    var size, num, ret, i;
    if (type === "address") return $72bb45218010f324$var$encodeSingle("uint160", $72bb45218010f324$var$parseNumber(arg));
    else if (type === "bool") return $72bb45218010f324$var$encodeSingle("uint8", arg ? 1 : 0);
    else if (type === "string") return $72bb45218010f324$var$encodeSingle("bytes", new $72bb45218010f324$require$Buffer(arg, "utf8"));
    else if ($72bb45218010f324$var$isArray(type)) {
        // this part handles fixed-length ([2]) and variable length ([]) arrays
        // NOTE: we catch here all calls to arrays, that simplifies the rest
        if (typeof arg.length === "undefined") throw new Error("Not an array?");
        size = $72bb45218010f324$var$parseTypeArray(type);
        if (size !== "dynamic" && size !== 0 && arg.length > size) throw new Error("Elements exceed array size: " + size);
        ret = [];
        type = type.slice(0, type.lastIndexOf("["));
        if (typeof arg === "string") arg = JSON.parse(arg);
        for(i in arg)ret.push($72bb45218010f324$var$encodeSingle(type, arg[i]));
        if (size === "dynamic") {
            var length = $72bb45218010f324$var$encodeSingle("uint256", arg.length);
            ret.unshift(length);
        }
        return $72bb45218010f324$require$Buffer.concat(ret);
    } else if (type === "bytes") {
        arg = new $72bb45218010f324$require$Buffer(arg);
        ret = $72bb45218010f324$require$Buffer.concat([
            $72bb45218010f324$var$encodeSingle("uint256", arg.length),
            arg
        ]);
        if (arg.length % 32 !== 0) ret = $72bb45218010f324$require$Buffer.concat([
            ret,
            $8DE9V.zeros(32 - arg.length % 32)
        ]);
        return ret;
    } else if (type.startsWith("bytes")) {
        size = $72bb45218010f324$var$parseTypeN(type);
        if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
        return $8DE9V.setLengthRight(arg, 32);
    } else if (type.startsWith("uint")) {
        size = $72bb45218010f324$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
        num = $72bb45218010f324$var$parseNumber(arg);
        if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
        if (num < 0) throw new Error("Supplied uint is negative");
        return num.toArrayLike($72bb45218010f324$require$Buffer, "be", 32);
    } else if (type.startsWith("int")) {
        size = $72bb45218010f324$var$parseTypeN(type);
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
        num = $72bb45218010f324$var$parseNumber(arg);
        if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
        return num.toTwos(256).toArrayLike($72bb45218010f324$require$Buffer, "be", 32);
    } else if (type.startsWith("ufixed")) {
        size = $72bb45218010f324$var$parseTypeNxM(type);
        num = $72bb45218010f324$var$parseNumber(arg);
        if (num < 0) throw new Error("Supplied ufixed is negative");
        return $72bb45218010f324$var$encodeSingle("uint256", num.mul(new $dEXSZ(2).pow(new $dEXSZ(size[1]))));
    } else if (type.startsWith("fixed")) {
        size = $72bb45218010f324$var$parseTypeNxM(type);
        return $72bb45218010f324$var$encodeSingle("int256", $72bb45218010f324$var$parseNumber(arg).mul(new $dEXSZ(2).pow(new $dEXSZ(size[1]))));
    }
    throw new Error("Unsupported or invalid type: " + type);
}
// Is a type dynamic?
function $72bb45218010f324$var$isDynamic(type) {
    // FIXME: handle all types? I don't think anything is missing now
    return type === "string" || type === "bytes" || $72bb45218010f324$var$parseTypeArray(type) === "dynamic";
}
// Is a type an array?
function $72bb45218010f324$var$isArray(type) {
    return type.lastIndexOf("]") === type.length - 1;
}
// Encode a method/event with arguments
// @types an array of string type names
// @args  an array of the appropriate values
function $72bb45218010f324$var$rawEncode(types, values) {
    var output = [];
    var data = [];
    var headLength = 32 * types.length;
    for(var i in types){
        var type = $72bb45218010f324$var$elementaryName(types[i]);
        var value = values[i];
        var cur = $72bb45218010f324$var$encodeSingle(type, value);
        // Use the head/tail method for storing dynamic data
        if ($72bb45218010f324$var$isDynamic(type)) {
            output.push($72bb45218010f324$var$encodeSingle("uint256", headLength));
            data.push(cur);
            headLength += cur.length;
        } else output.push(cur);
    }
    return $72bb45218010f324$require$Buffer.concat(output.concat(data));
}
function $72bb45218010f324$var$solidityPack(types, values) {
    if (types.length !== values.length) throw new Error("Number of types are not matching the values");
    var size, num;
    var ret = [];
    for(var i = 0; i < types.length; i++){
        var type = $72bb45218010f324$var$elementaryName(types[i]);
        var value = values[i];
        if (type === "bytes") ret.push(value);
        else if (type === "string") ret.push(new $72bb45218010f324$require$Buffer(value, "utf8"));
        else if (type === "bool") ret.push(new $72bb45218010f324$require$Buffer(value ? "01" : "00", "hex"));
        else if (type === "address") ret.push($8DE9V.setLength(value, 20));
        else if (type.startsWith("bytes")) {
            size = $72bb45218010f324$var$parseTypeN(type);
            if (size < 1 || size > 32) throw new Error("Invalid bytes<N> width: " + size);
            ret.push($8DE9V.setLengthRight(value, size));
        } else if (type.startsWith("uint")) {
            size = $72bb45218010f324$var$parseTypeN(type);
            if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint<N> width: " + size);
            num = $72bb45218010f324$var$parseNumber(value);
            if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
            ret.push(num.toArrayLike($72bb45218010f324$require$Buffer, "be", size / 8));
        } else if (type.startsWith("int")) {
            size = $72bb45218010f324$var$parseTypeN(type);
            if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int<N> width: " + size);
            num = $72bb45218010f324$var$parseNumber(value);
            if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
            ret.push(num.toTwos(size).toArrayLike($72bb45218010f324$require$Buffer, "be", size / 8));
        } else // FIXME: support all other types
        throw new Error("Unsupported or invalid type: " + type);
    }
    return $72bb45218010f324$require$Buffer.concat(ret);
}
function $72bb45218010f324$var$soliditySHA3(types, values) {
    return $8DE9V.keccak($72bb45218010f324$var$solidityPack(types, values));
}
module.exports = {
    rawEncode: $72bb45218010f324$var$rawEncode,
    solidityPack: $72bb45218010f324$var$solidityPack,
    soliditySHA3: $72bb45218010f324$var$soliditySHA3
};

});


parcelRequire.register("fEUWi", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filterFromParam = module.exports.FilterPolyfill = void 0;

var $iJH0e = parcelRequire("iJH0e");

var $1mY3j = parcelRequire("1mY3j");
const $b666c2652a5c21f4$var$TIMEOUT = 300000; // 5 minutes
const $b666c2652a5c21f4$var$JSONRPC_TEMPLATE = {
    jsonrpc: "2.0",
    id: 0
};
class $b666c2652a5c21f4$var$FilterPolyfill {
    constructor(provider){
        this.logFilters = new Map(); // <id, filter>
        this.blockFilters = new Set(); // <id>
        this.pendingTransactionFilters = new Set(); // <id, true>
        this.cursors = new Map(); // <id, cursor>
        this.timeouts = new Map(); // <id, setTimeout id>
        this.nextFilterId = (0, $iJH0e.IntNumber)(1);
        this.provider = provider;
    }
    async newFilter(param) {
        const filter = $b666c2652a5c21f4$var$filterFromParam(param);
        const id = this.makeFilterId();
        const cursor = await this.setInitialCursorPosition(id, filter.fromBlock);
        console.log(`Installing new log filter(${id}):`, filter, "initial cursor position:", cursor);
        this.logFilters.set(id, filter);
        this.setFilterTimeout(id);
        return (0, $1mY3j.hexStringFromIntNumber)(id);
    }
    async newBlockFilter() {
        const id = this.makeFilterId();
        const cursor = await this.setInitialCursorPosition(id, "latest");
        console.log(`Installing new block filter (${id}) with initial cursor position:`, cursor);
        this.blockFilters.add(id);
        this.setFilterTimeout(id);
        return (0, $1mY3j.hexStringFromIntNumber)(id);
    }
    async newPendingTransactionFilter() {
        const id = this.makeFilterId();
        const cursor = await this.setInitialCursorPosition(id, "latest");
        console.log(`Installing new block filter (${id}) with initial cursor position:`, cursor);
        this.pendingTransactionFilters.add(id);
        this.setFilterTimeout(id);
        return (0, $1mY3j.hexStringFromIntNumber)(id);
    }
    uninstallFilter(filterId) {
        const id = (0, $1mY3j.intNumberFromHexString)(filterId);
        console.log(`Uninstalling filter (${id})`);
        this.deleteFilter(id);
        return true;
    }
    getFilterChanges(filterId) {
        const id = (0, $1mY3j.intNumberFromHexString)(filterId);
        if (this.timeouts.has(id)) // extend timeout
        this.setFilterTimeout(id);
        if (this.logFilters.has(id)) return this.getLogFilterChanges(id);
        else if (this.blockFilters.has(id)) return this.getBlockFilterChanges(id);
        else if (this.pendingTransactionFilters.has(id)) return this.getPendingTransactionFilterChanges(id);
        return Promise.resolve($b666c2652a5c21f4$var$filterNotFoundError());
    }
    async getFilterLogs(filterId) {
        const id = (0, $1mY3j.intNumberFromHexString)(filterId);
        const filter = this.logFilters.get(id);
        if (!filter) return $b666c2652a5c21f4$var$filterNotFoundError();
        return this.sendAsyncPromise(Object.assign(Object.assign({}, $b666c2652a5c21f4$var$JSONRPC_TEMPLATE), {
            method: "eth_getLogs",
            params: [
                $b666c2652a5c21f4$var$paramFromFilter(filter)
            ]
        }));
    }
    makeFilterId() {
        return (0, $iJH0e.IntNumber)(++this.nextFilterId);
    }
    sendAsyncPromise(request) {
        return new Promise((resolve, reject)=>{
            this.provider.sendAsync(request, (err, response)=>{
                if (err) return reject(err);
                if (Array.isArray(response) || response == null) return reject(new Error(`unexpected response received: ${JSON.stringify(response)}`));
                resolve(response);
            });
        });
    }
    deleteFilter(id) {
        console.log(`Deleting filter (${id})`);
        this.logFilters.delete(id);
        this.blockFilters.delete(id);
        this.pendingTransactionFilters.delete(id);
        this.cursors.delete(id);
        this.timeouts.delete(id);
    }
    async getLogFilterChanges(id) {
        const filter = this.logFilters.get(id);
        const cursorPosition = this.cursors.get(id);
        if (!cursorPosition || !filter) return $b666c2652a5c21f4$var$filterNotFoundError();
        const currentBlockHeight = await this.getCurrentBlockHeight();
        const toBlock = filter.toBlock === "latest" ? currentBlockHeight : filter.toBlock;
        if (cursorPosition > currentBlockHeight) return $b666c2652a5c21f4$var$emptyResult();
        if (cursorPosition > filter.toBlock) return $b666c2652a5c21f4$var$emptyResult();
        console.log(`Fetching logs from ${cursorPosition} to ${toBlock} for filter ${id}`);
        const response = await this.sendAsyncPromise(Object.assign(Object.assign({}, $b666c2652a5c21f4$var$JSONRPC_TEMPLATE), {
            method: "eth_getLogs",
            params: [
                $b666c2652a5c21f4$var$paramFromFilter(Object.assign(Object.assign({}, filter), {
                    fromBlock: cursorPosition,
                    toBlock: toBlock
                }))
            ]
        }));
        if (Array.isArray(response.result)) {
            const blocks = response.result.map((log)=>(0, $1mY3j.intNumberFromHexString)(log.blockNumber || "0x0"));
            const highestBlock = Math.max(...blocks);
            if (highestBlock && highestBlock > cursorPosition) {
                const newCursorPosition = (0, $iJH0e.IntNumber)(highestBlock + 1);
                console.log(`Moving cursor position for filter (${id}) from ${cursorPosition} to ${newCursorPosition}`);
                this.cursors.set(id, newCursorPosition);
            }
        }
        return response;
    }
    async getBlockFilterChanges(id) {
        const cursorPosition = this.cursors.get(id);
        if (!cursorPosition) return $b666c2652a5c21f4$var$filterNotFoundError();
        const currentBlockHeight = await this.getCurrentBlockHeight();
        if (cursorPosition > currentBlockHeight) return $b666c2652a5c21f4$var$emptyResult();
        console.log(`Fetching blocks from ${cursorPosition} to ${currentBlockHeight} for filter (${id})`);
        const blocks = (await Promise.all(// eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        (0, $1mY3j.range)(cursorPosition, currentBlockHeight + 1).map((i)=>this.getBlockHashByNumber((0, $iJH0e.IntNumber)(i))))).filter((hash)=>!!hash);
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        const newCursorPosition = (0, $iJH0e.IntNumber)(cursorPosition + blocks.length);
        console.log(`Moving cursor position for filter (${id}) from ${cursorPosition} to ${newCursorPosition}`);
        this.cursors.set(id, newCursorPosition);
        return Object.assign(Object.assign({}, $b666c2652a5c21f4$var$JSONRPC_TEMPLATE), {
            result: blocks
        });
    }
    async getPendingTransactionFilterChanges(_id) {
        // pending transaction filters are not supported
        return Promise.resolve($b666c2652a5c21f4$var$emptyResult());
    }
    async setInitialCursorPosition(id, startBlock) {
        const currentBlockHeight = await this.getCurrentBlockHeight();
        const initialCursorPosition = typeof startBlock === "number" && startBlock > currentBlockHeight ? startBlock : currentBlockHeight;
        this.cursors.set(id, initialCursorPosition);
        return initialCursorPosition;
    }
    setFilterTimeout(id) {
        const existing = this.timeouts.get(id);
        if (existing) window.clearTimeout(existing);
        const timeout = window.setTimeout(()=>{
            console.log(`Filter (${id}) timed out`);
            this.deleteFilter(id);
        }, $b666c2652a5c21f4$var$TIMEOUT);
        this.timeouts.set(id, timeout);
    }
    async getCurrentBlockHeight() {
        const { result: result } = await this.sendAsyncPromise(Object.assign(Object.assign({}, $b666c2652a5c21f4$var$JSONRPC_TEMPLATE), {
            method: "eth_blockNumber",
            params: []
        }));
        return (0, $1mY3j.intNumberFromHexString)((0, $1mY3j.ensureHexString)(result));
    }
    async getBlockHashByNumber(blockNumber) {
        const response = await this.sendAsyncPromise(Object.assign(Object.assign({}, $b666c2652a5c21f4$var$JSONRPC_TEMPLATE), {
            method: "eth_getBlockByNumber",
            params: [
                (0, $1mY3j.hexStringFromIntNumber)(blockNumber),
                false
            ]
        }));
        if (response.result && typeof response.result.hash === "string") return (0, $1mY3j.ensureHexString)(response.result.hash);
        return null;
    }
}
module.exports.FilterPolyfill = $b666c2652a5c21f4$var$FilterPolyfill;
function $b666c2652a5c21f4$var$filterFromParam(param) {
    return {
        fromBlock: $b666c2652a5c21f4$var$intBlockHeightFromHexBlockHeight(param.fromBlock),
        toBlock: $b666c2652a5c21f4$var$intBlockHeightFromHexBlockHeight(param.toBlock),
        addresses: param.address === undefined ? null : Array.isArray(param.address) ? param.address : [
            param.address
        ],
        topics: param.topics || []
    };
}
module.exports.filterFromParam = $b666c2652a5c21f4$var$filterFromParam;
function $b666c2652a5c21f4$var$paramFromFilter(filter) {
    const param = {
        fromBlock: $b666c2652a5c21f4$var$hexBlockHeightFromIntBlockHeight(filter.fromBlock),
        toBlock: $b666c2652a5c21f4$var$hexBlockHeightFromIntBlockHeight(filter.toBlock),
        topics: filter.topics
    };
    if (filter.addresses !== null) param.address = filter.addresses;
    return param;
}
function $b666c2652a5c21f4$var$intBlockHeightFromHexBlockHeight(value) {
    if (value === undefined || value === "latest" || value === "pending") return "latest";
    else if (value === "earliest") return (0, $iJH0e.IntNumber)(0);
    else if ((0, $1mY3j.isHexString)(value)) return (0, $1mY3j.intNumberFromHexString)(value);
    throw new Error(`Invalid block option: ${String(value)}`);
}
function $b666c2652a5c21f4$var$hexBlockHeightFromIntBlockHeight(value) {
    if (value === "latest") return value;
    return (0, $1mY3j.hexStringFromIntNumber)(value);
}
function $b666c2652a5c21f4$var$filterNotFoundError() {
    return Object.assign(Object.assign({}, $b666c2652a5c21f4$var$JSONRPC_TEMPLATE), {
        error: {
            code: -32000,
            message: "filter not found"
        }
    });
}
function $b666c2652a5c21f4$var$emptyResult() {
    return Object.assign(Object.assign({}, $b666c2652a5c21f4$var$JSONRPC_TEMPLATE), {
        result: []
    });
}

});

parcelRequire.register("fpSI4", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCMethod = void 0;
var $b393a110658db3be$var$JSONRPCMethod;
(function(JSONRPCMethod) {
    // synchronous or asynchronous
    JSONRPCMethod["eth_accounts"] = "eth_accounts";
    JSONRPCMethod["eth_coinbase"] = "eth_coinbase";
    JSONRPCMethod["net_version"] = "net_version";
    JSONRPCMethod["eth_chainId"] = "eth_chainId";
    JSONRPCMethod["eth_uninstallFilter"] = "eth_uninstallFilter";
    // asynchronous only
    JSONRPCMethod["eth_requestAccounts"] = "eth_requestAccounts";
    JSONRPCMethod["eth_sign"] = "eth_sign";
    JSONRPCMethod["eth_ecRecover"] = "eth_ecRecover";
    JSONRPCMethod["personal_sign"] = "personal_sign";
    JSONRPCMethod["personal_ecRecover"] = "personal_ecRecover";
    JSONRPCMethod["eth_signTransaction"] = "eth_signTransaction";
    JSONRPCMethod["eth_sendRawTransaction"] = "eth_sendRawTransaction";
    JSONRPCMethod["eth_sendTransaction"] = "eth_sendTransaction";
    JSONRPCMethod["eth_signTypedData_v1"] = "eth_signTypedData_v1";
    JSONRPCMethod["eth_signTypedData_v2"] = "eth_signTypedData_v2";
    JSONRPCMethod["eth_signTypedData_v3"] = "eth_signTypedData_v3";
    JSONRPCMethod["eth_signTypedData_v4"] = "eth_signTypedData_v4";
    JSONRPCMethod["eth_signTypedData"] = "eth_signTypedData";
    JSONRPCMethod["cbWallet_arbitrary"] = "walletlink_arbitrary";
    JSONRPCMethod["wallet_addEthereumChain"] = "wallet_addEthereumChain";
    JSONRPCMethod["wallet_switchEthereumChain"] = "wallet_switchEthereumChain";
    JSONRPCMethod["wallet_watchAsset"] = "wallet_watchAsset";
    // asynchronous pub/sub
    JSONRPCMethod["eth_subscribe"] = "eth_subscribe";
    JSONRPCMethod["eth_unsubscribe"] = "eth_unsubscribe";
    // asynchronous filter methods
    JSONRPCMethod["eth_newFilter"] = "eth_newFilter";
    JSONRPCMethod["eth_newBlockFilter"] = "eth_newBlockFilter";
    JSONRPCMethod["eth_newPendingTransactionFilter"] = "eth_newPendingTransactionFilter";
    JSONRPCMethod["eth_getFilterChanges"] = "eth_getFilterChanges";
    JSONRPCMethod["eth_getFilterLogs"] = "eth_getFilterLogs";
})($b393a110658db3be$var$JSONRPCMethod = module.exports.JSONRPCMethod || (module.exports.JSONRPCMethod = {}));

});

parcelRequire.register("jUU2a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubscriptionManager = void 0;

var $dpJiA = parcelRequire("dpJiA");

var $ellgK = parcelRequire("ellgK");
const $e7feb67939b53492$var$noop = ()=>{};
class $e7feb67939b53492$var$SubscriptionManager {
    constructor(provider){
        const blockTracker = new $dpJiA.PollingBlockTracker({
            provider: provider,
            pollingInterval: 15000,
            setSkipCacheFlag: true
        });
        const { events: events, middleware: middleware } = $ellgK({
            blockTracker: blockTracker,
            provider: provider
        });
        this.events = events;
        this.subscriptionMiddleware = middleware;
    }
    async handleRequest(request) {
        const result = {};
        await this.subscriptionMiddleware(request, result, $e7feb67939b53492$var$noop, $e7feb67939b53492$var$noop);
        return result;
    }
    destroy() {
        this.subscriptionMiddleware.destroy();
    }
}
module.exports.SubscriptionManager = $e7feb67939b53492$var$SubscriptionManager;

});
parcelRequire.register("dpJiA", function(module, exports) {
"use strict";
var $9c40bf93c783d886$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9c40bf93c783d886$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9c40bf93c783d886$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9c40bf93c783d886$var$__exportStar((parcelRequire("2m7Lt")), module.exports);

$9c40bf93c783d886$var$__exportStar((parcelRequire("8yEY0")), module.exports);

$9c40bf93c783d886$var$__exportStar((parcelRequire("e2LHQ")), module.exports);

});
parcelRequire.register("2m7Lt", function(module, exports) {
"use strict";
var $1b73a8c4b77a204a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PollingBlockTracker = void 0;

const $1b73a8c4b77a204a$var$json_rpc_random_id_1 = $1b73a8c4b77a204a$var$__importDefault((parcelRequire("gCr7l")));

const $1b73a8c4b77a204a$var$pify_1 = $1b73a8c4b77a204a$var$__importDefault((parcelRequire("8NrUT")));

var $liQ5X = parcelRequire("liQ5X");

var $3mqZm = parcelRequire("3mqZm");
const $1b73a8c4b77a204a$var$log = (0, $3mqZm.createModuleLogger)($3mqZm.projectLogger, "polling-block-tracker");
const $1b73a8c4b77a204a$var$createRandomId = (0, $1b73a8c4b77a204a$var$json_rpc_random_id_1.default)();
const $1b73a8c4b77a204a$var$sec = 1000;
class $1b73a8c4b77a204a$var$PollingBlockTracker extends $liQ5X.BaseBlockTracker {
    constructor(opts = {}){
        var _a;
        // parse + validate args
        if (!opts.provider) throw new Error("PollingBlockTracker - no provider specified.");
        super({
            blockResetDuration: (_a = opts.blockResetDuration) !== null && _a !== void 0 ? _a : opts.pollingInterval
        });
        // config
        this._provider = opts.provider;
        this._pollingInterval = opts.pollingInterval || 20 * $1b73a8c4b77a204a$var$sec;
        this._retryTimeout = opts.retryTimeout || this._pollingInterval / 10;
        this._keepEventLoopActive = opts.keepEventLoopActive === undefined ? true : opts.keepEventLoopActive;
        this._setSkipCacheFlag = opts.setSkipCacheFlag || false;
    }
    // trigger block polling
    async checkForLatestBlock() {
        await this._updateLatestBlock();
        return await this.getLatestBlock();
    }
    async _start() {
        this._synchronize();
    }
    async _end() {
    // No-op
    }
    async _synchronize() {
        var _a;
        while(this._isRunning)try {
            await this._updateLatestBlock();
            const promise = $1b73a8c4b77a204a$var$timeout(this._pollingInterval, !this._keepEventLoopActive);
            this.emit("_waitingForNextIteration");
            await promise;
        } catch (err) {
            const newErr = new Error(`PollingBlockTracker - encountered an error while attempting to update latest block:\n${(_a = err.stack) !== null && _a !== void 0 ? _a : err}`);
            try {
                this.emit("error", newErr);
            } catch (emitErr) {
                console.error(newErr);
            }
            const promise = $1b73a8c4b77a204a$var$timeout(this._retryTimeout, !this._keepEventLoopActive);
            this.emit("_waitingForNextIteration");
            await promise;
        }
    }
    async _updateLatestBlock() {
        // fetch + set latest block
        const latestBlock = await this._fetchLatestBlock();
        this._newPotentialLatest(latestBlock);
    }
    async _fetchLatestBlock() {
        const req = {
            jsonrpc: "2.0",
            id: $1b73a8c4b77a204a$var$createRandomId(),
            method: "eth_blockNumber",
            params: []
        };
        if (this._setSkipCacheFlag) req.skipCache = true;
        $1b73a8c4b77a204a$var$log("Making request", req);
        const res = await (0, $1b73a8c4b77a204a$var$pify_1.default)((cb)=>this._provider.sendAsync(req, cb))();
        $1b73a8c4b77a204a$var$log("Got response", res);
        if (res.error) throw new Error(`PollingBlockTracker - encountered error fetching block:\n${res.error.message}`);
        return res.result;
    }
}
module.exports.PollingBlockTracker = $1b73a8c4b77a204a$var$PollingBlockTracker;
/**
 * Waits for the specified amount of time.
 *
 * @param duration - The amount of time in milliseconds.
 * @param unref - Assuming this function is run in a Node context, governs
 * whether Node should wait before the `setTimeout` has completed before ending
 * the process (true for no, false for yes). Defaults to false.
 * @returns A promise that can be used to wait.
 */ function $1b73a8c4b77a204a$var$timeout(duration, unref) {
    return new Promise((resolve)=>{
        const timeoutRef = setTimeout(resolve, duration);
        // don't keep process open
        if (timeoutRef.unref && unref) timeoutRef.unref();
    });
}

});
parcelRequire.register("gCr7l", function(module, exports) {
module.exports = $c1953aeef1925e6a$var$IdIterator;
function $c1953aeef1925e6a$var$IdIterator(opts) {
    opts = opts || {};
    var max = opts.max || Number.MAX_SAFE_INTEGER;
    var idCounter = typeof opts.start !== "undefined" ? opts.start : Math.floor(Math.random() * max);
    return function createRandomId() {
        idCounter = idCounter % max;
        return idCounter++;
    };
}

});

parcelRequire.register("8NrUT", function(module, exports) {
"use strict";
const $66788e029a430918$var$processFn = (fn, opts)=>function() {
        const P = opts.promiseModule;
        const args = new Array(arguments.length);
        for(let i = 0; i < arguments.length; i++)args[i] = arguments[i];
        return new P((resolve, reject)=>{
            if (opts.errorFirst) args.push(function(err, result) {
                if (opts.multiArgs) {
                    const results = new Array(arguments.length - 1);
                    for(let i = 1; i < arguments.length; i++)results[i - 1] = arguments[i];
                    if (err) {
                        results.unshift(err);
                        reject(results);
                    } else resolve(results);
                } else if (err) reject(err);
                else resolve(result);
            });
            else args.push(function(result) {
                if (opts.multiArgs) {
                    const results = new Array(arguments.length - 1);
                    for(let i = 0; i < arguments.length; i++)results[i] = arguments[i];
                    resolve(results);
                } else resolve(result);
            });
            fn.apply(this, args);
        });
    };
module.exports = (obj, opts)=>{
    opts = Object.assign({
        exclude: [
            /.+(Sync|Stream)$/
        ],
        errorFirst: true,
        promiseModule: Promise
    }, opts);
    const filter = (key)=>{
        const match = (pattern)=>typeof pattern === "string" ? key === pattern : pattern.test(key);
        return opts.include ? opts.include.some(match) : !opts.exclude.some(match);
    };
    let ret;
    if (typeof obj === "function") ret = function() {
        if (opts.excludeMain) return obj.apply(this, arguments);
        return $66788e029a430918$var$processFn(obj, opts).apply(this, arguments);
    };
    else ret = Object.create(Object.getPrototypeOf(obj));
    for(const key in obj){
        const x = obj[key];
        ret[key] = typeof x === "function" && filter(key) ? $66788e029a430918$var$processFn(x, opts) : x;
    }
    return ret;
};

});

parcelRequire.register("liQ5X", function(module, exports) {
"use strict";
var $f823b067c80eb96c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseBlockTracker = void 0;

const $f823b067c80eb96c$var$safe_event_emitter_1 = $f823b067c80eb96c$var$__importDefault((parcelRequire("e5MJz")));
const $f823b067c80eb96c$var$sec = 1000;
const $f823b067c80eb96c$var$calculateSum = (accumulator, currentValue)=>accumulator + currentValue;
const $f823b067c80eb96c$var$blockTrackerEvents = [
    "sync",
    "latest"
];
class $f823b067c80eb96c$var$BaseBlockTracker extends $f823b067c80eb96c$var$safe_event_emitter_1.default {
    constructor(opts){
        super();
        // config
        this._blockResetDuration = opts.blockResetDuration || 20 * $f823b067c80eb96c$var$sec;
        // state
        this._currentBlock = null;
        this._isRunning = false;
        // bind functions for internal use
        this._onNewListener = this._onNewListener.bind(this);
        this._onRemoveListener = this._onRemoveListener.bind(this);
        this._resetCurrentBlock = this._resetCurrentBlock.bind(this);
        // listen for handler changes
        this._setupInternalEvents();
    }
    async destroy() {
        this._cancelBlockResetTimeout();
        await this._maybeEnd();
        super.removeAllListeners();
    }
    isRunning() {
        return this._isRunning;
    }
    getCurrentBlock() {
        return this._currentBlock;
    }
    async getLatestBlock() {
        // return if available
        if (this._currentBlock) return this._currentBlock;
        // wait for a new latest block
        const latestBlock = await new Promise((resolve)=>this.once("latest", resolve));
        // return newly set current block
        return latestBlock;
    }
    // dont allow module consumer to remove our internal event listeners
    removeAllListeners(eventName) {
        // perform default behavior, preserve fn arity
        if (eventName) super.removeAllListeners(eventName);
        else super.removeAllListeners();
        // re-add internal events
        this._setupInternalEvents();
        // trigger stop check just in case
        this._onRemoveListener();
        return this;
    }
    _setupInternalEvents() {
        // first remove listeners for idempotence
        this.removeListener("newListener", this._onNewListener);
        this.removeListener("removeListener", this._onRemoveListener);
        // then add them
        this.on("newListener", this._onNewListener);
        this.on("removeListener", this._onRemoveListener);
    }
    _onNewListener(eventName) {
        // `newListener` is called *before* the listener is added
        if ($f823b067c80eb96c$var$blockTrackerEvents.includes(eventName)) this._maybeStart();
    }
    _onRemoveListener() {
        // `removeListener` is called *after* the listener is removed
        if (this._getBlockTrackerEventCount() > 0) return;
        this._maybeEnd();
    }
    async _maybeStart() {
        if (this._isRunning) return;
        this._isRunning = true;
        // cancel setting latest block to stale
        this._cancelBlockResetTimeout();
        await this._start();
        this.emit("_started");
    }
    async _maybeEnd() {
        if (!this._isRunning) return;
        this._isRunning = false;
        this._setupBlockResetTimeout();
        await this._end();
        this.emit("_ended");
    }
    _getBlockTrackerEventCount() {
        return $f823b067c80eb96c$var$blockTrackerEvents.map((eventName)=>this.listenerCount(eventName)).reduce($f823b067c80eb96c$var$calculateSum);
    }
    _newPotentialLatest(newBlock) {
        const currentBlock = this._currentBlock;
        // only update if blok number is higher
        if (currentBlock && $f823b067c80eb96c$var$hexToInt(newBlock) <= $f823b067c80eb96c$var$hexToInt(currentBlock)) return;
        this._setCurrentBlock(newBlock);
    }
    _setCurrentBlock(newBlock) {
        const oldBlock = this._currentBlock;
        this._currentBlock = newBlock;
        this.emit("latest", newBlock);
        this.emit("sync", {
            oldBlock: oldBlock,
            newBlock: newBlock
        });
    }
    _setupBlockResetTimeout() {
        // clear any existing timeout
        this._cancelBlockResetTimeout();
        // clear latest block when stale
        this._blockResetTimeout = setTimeout(this._resetCurrentBlock, this._blockResetDuration);
        // nodejs - dont hold process open
        if (this._blockResetTimeout.unref) this._blockResetTimeout.unref();
    }
    _cancelBlockResetTimeout() {
        if (this._blockResetTimeout) clearTimeout(this._blockResetTimeout);
    }
    _resetCurrentBlock() {
        this._currentBlock = null;
    }
}
module.exports.BaseBlockTracker = $f823b067c80eb96c$var$BaseBlockTracker;
/**
 * Converts a number represented as a string in hexadecimal format into a native
 * number.
 *
 * @param hexInt - The hex string.
 * @returns The number.
 */ function $f823b067c80eb96c$var$hexToInt(hexInt) {
    return Number.parseInt(hexInt, 16);
}

});

parcelRequire.register("3mqZm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createModuleLogger = module.exports.projectLogger = void 0;

var $60dnZ = parcelRequire("60dnZ");
Object.defineProperty(module.exports, "createModuleLogger", {
    enumerable: true,
    get: function() {
        return $60dnZ.createModuleLogger;
    }
});
module.exports.projectLogger = (0, $60dnZ.createProjectLogger)("eth-block-tracker");

});
parcelRequire.register("60dnZ", function(module, exports) {
"use strict";
var $45ed20519e746317$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $45ed20519e746317$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $45ed20519e746317$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$45ed20519e746317$var$__exportStar((parcelRequire("iujXb")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("aEzVd")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("7RCWW")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("bXkll")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("1noEZ")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("e6Ezz")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("iFP5p")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("59WYf")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("2jjno")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("gV9Lp")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("dTiKP")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("igsLb")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("c8egZ")), module.exports);

$45ed20519e746317$var$__exportStar((parcelRequire("2cLPh")), module.exports);

});
parcelRequire.register("iujXb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertExhaustive = module.exports.assertStruct = module.exports.assert = module.exports.AssertionError = void 0;

var $e7b6X = parcelRequire("e7b6X");
/**
 * Type guard for determining whether the given value is an error object with a
 * `message` property, such as an instance of Error.
 *
 * @param error - The object to check.
 * @returns True or false, depending on the result.
 */ function $d75a81af0342c9fc$var$isErrorWithMessage(error) {
    return typeof error === "object" && error !== null && "message" in error;
}
/**
 * Check if a value is a constructor, i.e., a function that can be called with
 * the `new` keyword.
 *
 * @param fn - The value to check.
 * @returns `true` if the value is a constructor, or `false` otherwise.
 */ function $d75a81af0342c9fc$var$isConstructable(fn) {
    var _a, _b;
    /* istanbul ignore next */ return Boolean(typeof ((_b = (_a = fn === null || fn === void 0 ? void 0 : fn.prototype) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name) === "string");
}
/**
 * Get the error message from an unknown error object. If the error object has
 * a `message` property, that property is returned. Otherwise, the stringified
 * error object is returned.
 *
 * @param error - The error object to get the message from.
 * @returns The error message.
 */ function $d75a81af0342c9fc$var$getErrorMessage(error) {
    const message = $d75a81af0342c9fc$var$isErrorWithMessage(error) ? error.message : String(error);
    // If the error ends with a period, remove it, as we'll add our own period.
    if (message.endsWith(".")) return message.slice(0, -1);
    return message;
}
/**
 * Initialise an {@link AssertionErrorConstructor} error.
 *
 * @param ErrorWrapper - The error class to use.
 * @param message - The error message.
 * @returns The error object.
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $d75a81af0342c9fc$var$getError(ErrorWrapper, message) {
    if ($d75a81af0342c9fc$var$isConstructable(ErrorWrapper)) return new ErrorWrapper({
        message: message
    });
    return ErrorWrapper({
        message: message
    });
}
/**
 * The default error class that is thrown if an assertion fails.
 */ class $d75a81af0342c9fc$var$AssertionError extends Error {
    constructor(options){
        super(options.message);
        this.code = "ERR_ASSERTION";
    }
}
module.exports.AssertionError = $d75a81af0342c9fc$var$AssertionError;
/**
 * Same as Node.js assert.
 * If the value is falsy, throws an error, does nothing otherwise.
 *
 * @throws {@link AssertionError} If value is falsy.
 * @param value - The test that should be truthy to pass.
 * @param message - Message to be passed to {@link AssertionError} or an
 * {@link Error} instance to throw.
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}. If a custom error class is provided for
 * the `message` argument, this argument is ignored.
 */ function $d75a81af0342c9fc$var$assert(value, message = "Assertion failed.", // eslint-disable-next-line @typescript-eslint/naming-convention
ErrorWrapper = $d75a81af0342c9fc$var$AssertionError) {
    if (!value) {
        if (message instanceof Error) throw message;
        throw $d75a81af0342c9fc$var$getError(ErrorWrapper, message);
    }
}
module.exports.assert = $d75a81af0342c9fc$var$assert;
/**
 * Assert a value against a Superstruct struct.
 *
 * @param value - The value to validate.
 * @param struct - The struct to validate against.
 * @param errorPrefix - A prefix to add to the error message. Defaults to
 * "Assertion failed".
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}.
 * @throws If the value is not valid.
 */ function $d75a81af0342c9fc$var$assertStruct(value, struct, errorPrefix = "Assertion failed", // eslint-disable-next-line @typescript-eslint/naming-convention
ErrorWrapper = $d75a81af0342c9fc$var$AssertionError) {
    try {
        (0, $e7b6X.assert)(value, struct);
    } catch (error) {
        throw $d75a81af0342c9fc$var$getError(ErrorWrapper, `${errorPrefix}: ${$d75a81af0342c9fc$var$getErrorMessage(error)}.`);
    }
}
module.exports.assertStruct = $d75a81af0342c9fc$var$assertStruct;
/**
 * Use in the default case of a switch that you want to be fully exhaustive.
 * Using this function forces the compiler to enforce exhaustivity during
 * compile-time.
 *
 * @example
 * ```
 * const number = 1;
 * switch (number) {
 *   case 0:
 *     ...
 *   case 1:
 *     ...
 *   default:
 *     assertExhaustive(snapPrefix);
 * }
 * ```
 * @param _object - The object on which the switch is being operated.
 */ function $d75a81af0342c9fc$var$assertExhaustive(_object) {
    throw new Error("Invalid branch reached. Should be detected during compilation.");
}
module.exports.assertExhaustive = $d75a81af0342c9fc$var$assertExhaustive;

});
parcelRequire.register("e7b6X", function(module, exports) {

$parcel$export(module.exports, "StructError", () => $f32ddde451a648f6$export$58cc9131e3e8861b);
$parcel$export(module.exports, "assert", () => $f32ddde451a648f6$export$a7a9523472993e97);
$parcel$export(module.exports, "create", () => $f32ddde451a648f6$export$185802fd694ee1f5);
$parcel$export(module.exports, "is", () => $f32ddde451a648f6$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "object", () => $f32ddde451a648f6$export$be5493f9613cbbe);
$parcel$export(module.exports, "define", () => $f32ddde451a648f6$export$f36d6a7a5c09a23e);
$parcel$export(module.exports, "omit", () => $f32ddde451a648f6$export$30a06c8d3562193f);
$parcel$export(module.exports, "optional", () => $f32ddde451a648f6$export$516e28dec6a4b6d4);
$parcel$export(module.exports, "array", () => $f32ddde451a648f6$export$2f23118c22fb2630);
$parcel$export(module.exports, "bigint", () => $f32ddde451a648f6$export$a0f65b52274bcc00);
$parcel$export(module.exports, "instance", () => $f32ddde451a648f6$export$9544d5bb712b01ea);
$parcel$export(module.exports, "integer", () => $f32ddde451a648f6$export$32744b5b3bba4764);
$parcel$export(module.exports, "literal", () => $f32ddde451a648f6$export$c8ec6e1ec9fefcb0);
$parcel$export(module.exports, "nullable", () => $f32ddde451a648f6$export$133fc36489ac9add);
$parcel$export(module.exports, "number", () => $f32ddde451a648f6$export$98e628dec113755e);
$parcel$export(module.exports, "record", () => $f32ddde451a648f6$export$e5185e241753e543);
$parcel$export(module.exports, "string", () => $f32ddde451a648f6$export$22b082955e083ec3);
$parcel$export(module.exports, "union", () => $f32ddde451a648f6$export$971dd5b0dfd021b6);
$parcel$export(module.exports, "unknown", () => $f32ddde451a648f6$export$19282c40b967aec6);
$parcel$export(module.exports, "coerce", () => $f32ddde451a648f6$export$8c14e57e778d3873);
$parcel$export(module.exports, "refine", () => $f32ddde451a648f6$export$edc9d475108b3212);
$parcel$export(module.exports, "pattern", () => $f32ddde451a648f6$export$24f82734ea047e6f);
$parcel$export(module.exports, "size", () => $f32ddde451a648f6$export$346677f925de839c);
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $f32ddde451a648f6$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, explanation: explanation, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : `At path: ${path.join(".")} -- ${message}`;
        super(explanation ?? msg);
        if (explanation != null) this.cause = msg;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            return cached ?? (cached = [
                failure,
                ...failures()
            ]);
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $f32ddde451a648f6$var$isIterable(x) {
    return $f32ddde451a648f6$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $f32ddde451a648f6$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $f32ddde451a648f6$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $f32ddde451a648f6$var$print(value) {
    if (typeof value === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : `${value}`;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $f32ddde451a648f6$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $f32ddde451a648f6$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = `Expected a value of type \`${type}\`${refinement ? ` with refinement \`${refinement}\`` : ""}, but received: \`${$f32ddde451a648f6$var$print(value)}\`` } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $f32ddde451a648f6$var$toFailures(result, context, struct, value) {
    if (!$f32ddde451a648f6$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $f32ddde451a648f6$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $f32ddde451a648f6$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $f32ddde451a648f6$var$isObject(struct.schema) && $f32ddde451a648f6$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let status = "valid";
    for (const failure of struct.validator(value, ctx)){
        failure.explanation = options.message;
        status = "not_valid";
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $f32ddde451a648f6$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask,
            message: options.message
        });
        for (const t of ts){
            if (t[0]) {
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($f32ddde451a648f6$var$isObject(value)) {
                    if (v !== undefined || k in value) value[k] = v;
                }
            }
        }
    }
    if (status !== "not_valid") for (const failure of struct.refiner(value, ctx)){
        failure.explanation = options.message;
        status = "not_refined";
        yield [
            failure,
            undefined
        ];
    }
    if (status === "valid") yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $f32ddde451a648f6$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $f32ddde451a648f6$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $f32ddde451a648f6$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ assert(value, message) {
        return $f32ddde451a648f6$export$a7a9523472993e97(value, this, message);
    }
    /**
     * Create a value with the struct's coercion logic, then validate it.
     */ create(value, message) {
        return $f32ddde451a648f6$export$185802fd694ee1f5(value, this, message);
    }
    /**
     * Check if a value passes the struct's validation.
     */ is(value) {
        return $f32ddde451a648f6$export$226b3eccf92c9ed9(value, this);
    }
    /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema.
     */ mask(value, message) {
        return $f32ddde451a648f6$export$d99f0801a68bbcf1(value, this, message);
    }
    /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `withCoercion` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful.
     */ validate(value, options = {}) {
        return $f32ddde451a648f6$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $f32ddde451a648f6$export$a7a9523472993e97(value, struct, message) {
    const result = $f32ddde451a648f6$export$a22775fa5e2eebd9(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $f32ddde451a648f6$export$185802fd694ee1f5(value, struct, message) {
    const result = $f32ddde451a648f6$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $f32ddde451a648f6$export$d99f0801a68bbcf1(value, struct, message) {
    const result = $f32ddde451a648f6$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $f32ddde451a648f6$export$226b3eccf92c9ed9(value, struct) {
    const result = $f32ddde451a648f6$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $f32ddde451a648f6$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $f32ddde451a648f6$var$run(value, struct, options);
    const tuple = $f32ddde451a648f6$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $f32ddde451a648f6$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $f32ddde451a648f6$export$e6e34fd1f2686227(...Structs) {
    const isType = Structs[0].type === "type";
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return isType ? $f32ddde451a648f6$export$bf9fb029d174d554(schema) : $f32ddde451a648f6$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $f32ddde451a648f6$export$f36d6a7a5c09a23e(name, validator) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $f32ddde451a648f6$export$cdd73fc4100a6ef4(struct, log) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $f32ddde451a648f6$export$7077912c31975674(fn) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            const struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $f32ddde451a648f6$export$488013bae63b21da(fn) {
    let struct;
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            struct ?? (struct = fn());
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            struct ?? (struct = fn());
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            struct ?? (struct = fn());
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            struct ?? (struct = fn());
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $f32ddde451a648f6$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    switch(struct.type){
        case "type":
            return $f32ddde451a648f6$export$bf9fb029d174d554(subschema);
        default:
            return $f32ddde451a648f6$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $f32ddde451a648f6$export$e45945969df8035a(struct) {
    const schema = struct instanceof $f32ddde451a648f6$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $f32ddde451a648f6$export$516e28dec6a4b6d4(schema[key]);
    return $f32ddde451a648f6$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $f32ddde451a648f6$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $f32ddde451a648f6$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $f32ddde451a648f6$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $f32ddde451a648f6$export$4154a199d7d90455() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $f32ddde451a648f6$export$2f23118c22fb2630(Element) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array value, but received: ${$f32ddde451a648f6$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function $f32ddde451a648f6$export$a0f65b52274bcc00() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("bigint", (value)=>{
        return typeof value === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $f32ddde451a648f6$export$4a21f16c33752377() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $f32ddde451a648f6$export$324d90190a8b822a() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || `Expected a valid \`Date\` object, but received: ${$f32ddde451a648f6$var$print(value)}`;
    });
}
function $f32ddde451a648f6$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$f32ddde451a648f6$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || `Expected one of \`${description}\`, but received: ${$f32ddde451a648f6$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $f32ddde451a648f6$export$86951950244e2001() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || `Expected a function, but received: ${$f32ddde451a648f6$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $f32ddde451a648f6$export$9544d5bb712b01ea(Class) {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || `Expected a \`${Class.name}\` instance, but received: ${$f32ddde451a648f6$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an integer.
 */ function $f32ddde451a648f6$export$32744b5b3bba4764() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || `Expected an integer, but received: ${$f32ddde451a648f6$var$print(value)}`;
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function $f32ddde451a648f6$export$bc86dfbf7795668c(Structs) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $f32ddde451a648f6$export$c8ec6e1ec9fefcb0(constant) {
    const description = $f32ddde451a648f6$var$print(constant);
    const t = typeof constant;
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || `Expected the literal \`${description}\`, but received: ${$f32ddde451a648f6$var$print(value)}`;
        }
    });
}
function $f32ddde451a648f6$export$871de8747c9eaa88(Key, Value) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || `Expected a \`Map\` object, but received: ${$f32ddde451a648f6$var$print(value)}`;
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $f32ddde451a648f6$export$b3e22bcfd64c1022() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $f32ddde451a648f6$export$133fc36489ac9add(struct) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $f32ddde451a648f6$export$98e628dec113755e() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || `Expected a number, but received: ${$f32ddde451a648f6$var$print(value)}`;
    });
}
function $f32ddde451a648f6$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $f32ddde451a648f6$export$b3e22bcfd64c1022();
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $f32ddde451a648f6$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $f32ddde451a648f6$var$isObject(value) || `Expected an object, but received: ${$f32ddde451a648f6$var$print(value)}`;
        },
        coercer (value) {
            return $f32ddde451a648f6$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $f32ddde451a648f6$export$516e28dec6a4b6d4(struct) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $f32ddde451a648f6$export$e5185e241753e543(Key, Value) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($f32ddde451a648f6$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $f32ddde451a648f6$var$isObject(value) || `Expected an object, but received: ${$f32ddde451a648f6$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $f32ddde451a648f6$export$efdc1e5bdb609bb() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $f32ddde451a648f6$export$adaa4cf7ef1b65be(Element) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || `Expected a \`Set\` object, but received: ${$f32ddde451a648f6$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $f32ddde451a648f6$export$22b082955e083ec3() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || `Expected a string, but received: ${$f32ddde451a648f6$var$print(value)}`;
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function $f32ddde451a648f6$export$65e3907585753458(Structs) {
    const Never = $f32ddde451a648f6$export$b3e22bcfd64c1022();
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Structs.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Structs[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array, but received: ${$f32ddde451a648f6$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $f32ddde451a648f6$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($f32ddde451a648f6$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $f32ddde451a648f6$var$isObject(value) || `Expected an object, but received: ${$f32ddde451a648f6$var$print(value)}`;
        },
        coercer (value) {
            return $f32ddde451a648f6$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $f32ddde451a648f6$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        type: "union",
        schema: null,
        coercer (value) {
            for (const S of Structs){
                const [error, coerced] = S.validate(value, {
                    coerce: true
                });
                if (!error) return coerced;
            }
            return value;
        },
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $f32ddde451a648f6$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                `Expected the value to satisfy a union of \`${description}\`, but received: ${$f32ddde451a648f6$var$print(value)}`,
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $f32ddde451a648f6$export$19282c40b967aec6() {
    return $f32ddde451a648f6$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $f32ddde451a648f6$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $f32ddde451a648f6$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $f32ddde451a648f6$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $f32ddde451a648f6$export$8c14e57e778d3873(struct, $f32ddde451a648f6$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $f32ddde451a648f6$var$isPlainObject(x) && $f32ddde451a648f6$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $f32ddde451a648f6$export$41f369984ed28930(struct) {
    return $f32ddde451a648f6$export$8c14e57e778d3873(struct, $f32ddde451a648f6$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $f32ddde451a648f6$export$6e22c362a0406a2c(struct) {
    return $f32ddde451a648f6$export$edc9d475108b3212(struct, "empty", (value)=>{
        const size = $f32ddde451a648f6$var$getSize(value);
        return size === 0 || `Expected an empty ${struct.type} but received one with a size of \`${size}\``;
    });
}
function $f32ddde451a648f6$var$getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $f32ddde451a648f6$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $f32ddde451a648f6$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || `Expected a ${struct.type} less than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $f32ddde451a648f6$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $f32ddde451a648f6$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || `Expected a ${struct.type} greater than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function $f32ddde451a648f6$export$6ce6c9218151d511(struct) {
    return $f32ddde451a648f6$export$edc9d475108b3212(struct, "nonempty", (value)=>{
        const size = $f32ddde451a648f6$var$getSize(value);
        return size > 0 || `Expected a nonempty ${struct.type} but received an empty one`;
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $f32ddde451a648f6$export$24f82734ea047e6f(struct, regexp) {
    return $f32ddde451a648f6$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || `Expected a ${struct.type} matching \`/${regexp.source}/\` but received "${value}"`;
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $f32ddde451a648f6$export$346677f925de839c(struct, min, max = min) {
    const expected = `Expected a ${struct.type}`;
    const of = min === max ? `of \`${min}\`` : `between \`${min}\` and \`${max}\``;
    return $f32ddde451a648f6$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || `${expected} ${of} but received \`${value}\``;
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || `${expected} with a size ${of} but received one with a size of \`${size}\``;
        } else {
            const { length: length } = value;
            return min <= length && length <= max || `${expected} with a length ${of} but received one with a length of \`${length}\``;
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $f32ddde451a648f6$export$edc9d475108b3212(struct, name, refiner) {
    return new $f32ddde451a648f6$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $f32ddde451a648f6$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}

});


parcelRequire.register("aEzVd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.base64 = void 0;

var $e7b6X = parcelRequire("e7b6X");

var $iujXb = parcelRequire("iujXb");
/**
 * Ensure that a provided string-based struct is valid base64.
 *
 * @param struct - The string based struct.
 * @param options - Optional options to specialize base64 validation. See {@link Base64Options} documentation.
 * @returns A superstruct validating base64.
 */ const $7c198124939faaaf$var$base64 = (struct, options = {})=>{
    var _a, _b;
    const paddingRequired = (_a = options.paddingRequired) !== null && _a !== void 0 ? _a : false;
    const characterSet = (_b = options.characterSet) !== null && _b !== void 0 ? _b : "base64";
    let letters;
    if (characterSet === "base64") letters = String.raw`[A-Za-z0-9+\/]`;
    else {
        (0, $iujXb.assert)(characterSet === "base64url");
        letters = String.raw`[-_A-Za-z0-9]`;
    }
    let re;
    if (paddingRequired) re = new RegExp(`^(?:${letters}{4})*(?:${letters}{3}=|${letters}{2}==)?$`, "u");
    else re = new RegExp(`^(?:${letters}{4})*(?:${letters}{2,3}|${letters}{3}=|${letters}{2}==)?$`, "u");
    return (0, $e7b6X.pattern)(struct, re);
};
module.exports.base64 = $7c198124939faaaf$var$base64;

});

parcelRequire.register("7RCWW", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5b9bb241f6bfa58c$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createDataView = module.exports.concatBytes = module.exports.valueToBytes = module.exports.stringToBytes = module.exports.numberToBytes = module.exports.signedBigIntToBytes = module.exports.bigIntToBytes = module.exports.hexToBytes = module.exports.bytesToString = module.exports.bytesToNumber = module.exports.bytesToSignedBigInt = module.exports.bytesToBigInt = module.exports.bytesToHex = module.exports.assertIsBytes = module.exports.isBytes = void 0;

var $iujXb = parcelRequire("iujXb");

var $iFP5p = parcelRequire("iFP5p");
// '0'.charCodeAt(0) === 48
const $5b9bb241f6bfa58c$var$HEX_MINIMUM_NUMBER_CHARACTER = 48;
// '9'.charCodeAt(0) === 57
const $5b9bb241f6bfa58c$var$HEX_MAXIMUM_NUMBER_CHARACTER = 58;
const $5b9bb241f6bfa58c$var$HEX_CHARACTER_OFFSET = 87;
/**
 * Memoized function that returns an array to be used as a lookup table for
 * converting bytes to hexadecimal values.
 *
 * The array is created lazily and then cached for future use. The benefit of
 * this approach is that the performance of converting bytes to hex is much
 * better than if we were to call `toString(16)` on each byte.
 *
 * The downside is that the array is created once and then never garbage
 * collected. This is not a problem in practice because the array is only 256
 * elements long.
 *
 * @returns A function that returns the lookup table.
 */ function $5b9bb241f6bfa58c$var$getPrecomputedHexValuesBuilder() {
    // To avoid issues with tree shaking, we need to use a function to return the
    // array. This is because the array is only used in the `bytesToHex` function
    // and if we were to use a global variable, the array might be removed by the
    // tree shaker.
    const lookupTable = [];
    return ()=>{
        if (lookupTable.length === 0) for(let i = 0; i < 256; i++)lookupTable.push(i.toString(16).padStart(2, "0"));
        return lookupTable;
    };
}
/**
 * Function implementation of the {@link getPrecomputedHexValuesBuilder}
 * function.
 */ const $5b9bb241f6bfa58c$var$getPrecomputedHexValues = $5b9bb241f6bfa58c$var$getPrecomputedHexValuesBuilder();
/**
 * Check if a value is a `Uint8Array`.
 *
 * @param value - The value to check.
 * @returns Whether the value is a `Uint8Array`.
 */ function $5b9bb241f6bfa58c$var$isBytes(value) {
    return value instanceof Uint8Array;
}
module.exports.isBytes = $5b9bb241f6bfa58c$var$isBytes;
/**
 * Assert that a value is a `Uint8Array`.
 *
 * @param value - The value to check.
 * @throws If the value is not a `Uint8Array`.
 */ function $5b9bb241f6bfa58c$var$assertIsBytes(value) {
    (0, $iujXb.assert)($5b9bb241f6bfa58c$var$isBytes(value), "Value must be a Uint8Array.");
}
module.exports.assertIsBytes = $5b9bb241f6bfa58c$var$assertIsBytes;
/**
 * Convert a `Uint8Array` to a hexadecimal string.
 *
 * @param bytes - The bytes to convert to a hexadecimal string.
 * @returns The hexadecimal string.
 */ function $5b9bb241f6bfa58c$var$bytesToHex(bytes) {
    $5b9bb241f6bfa58c$var$assertIsBytes(bytes);
    if (bytes.length === 0) return "0x";
    const lookupTable = $5b9bb241f6bfa58c$var$getPrecomputedHexValues();
    const hexadecimal = new Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    hexadecimal[i] = lookupTable[bytes[i]];
    return (0, $iFP5p.add0x)(hexadecimal.join(""));
}
module.exports.bytesToHex = $5b9bb241f6bfa58c$var$bytesToHex;
/**
 * Convert a `Uint8Array` to a `bigint`.
 *
 * To convert a `Uint8Array` to a `number` instead, use {@link bytesToNumber}.
 * To convert a two's complement encoded `Uint8Array` to a `bigint`, use
 * {@link bytesToSignedBigInt}.
 *
 * @param bytes - The bytes to convert to a `bigint`.
 * @returns The `bigint`.
 */ function $5b9bb241f6bfa58c$var$bytesToBigInt(bytes) {
    $5b9bb241f6bfa58c$var$assertIsBytes(bytes);
    const hexadecimal = $5b9bb241f6bfa58c$var$bytesToHex(bytes);
    return BigInt(hexadecimal);
}
module.exports.bytesToBigInt = $5b9bb241f6bfa58c$var$bytesToBigInt;
/**
 * Convert a `Uint8Array` to a signed `bigint`. This assumes that the bytes are
 * encoded in two's complement.
 *
 * To convert a `Uint8Array` to an unsigned `bigint` instead, use
 * {@link bytesToBigInt}.
 *
 * @see https://en.wikipedia.org/wiki/Two%27s_complement
 * @param bytes - The bytes to convert to a signed `bigint`.
 * @returns The signed `bigint`.
 */ function $5b9bb241f6bfa58c$var$bytesToSignedBigInt(bytes) {
    $5b9bb241f6bfa58c$var$assertIsBytes(bytes);
    let value = BigInt(0);
    for (const byte of bytes)// eslint-disable-next-line no-bitwise
    value = (value << BigInt(8)) + BigInt(byte);
    return BigInt.asIntN(bytes.length * 8, value);
}
module.exports.bytesToSignedBigInt = $5b9bb241f6bfa58c$var$bytesToSignedBigInt;
/**
 * Convert a `Uint8Array` to a `number`.
 *
 * To convert a `Uint8Array` to a `bigint` instead, use {@link bytesToBigInt}.
 *
 * @param bytes - The bytes to convert to a number.
 * @returns The number.
 * @throws If the resulting number is not a safe integer.
 */ function $5b9bb241f6bfa58c$var$bytesToNumber(bytes) {
    $5b9bb241f6bfa58c$var$assertIsBytes(bytes);
    const bigint = $5b9bb241f6bfa58c$var$bytesToBigInt(bytes);
    (0, $iujXb.assert)(bigint <= BigInt(Number.MAX_SAFE_INTEGER), "Number is not a safe integer. Use `bytesToBigInt` instead.");
    return Number(bigint);
}
module.exports.bytesToNumber = $5b9bb241f6bfa58c$var$bytesToNumber;
/**
 * Convert a UTF-8 encoded `Uint8Array` to a `string`.
 *
 * @param bytes - The bytes to convert to a string.
 * @returns The string.
 */ function $5b9bb241f6bfa58c$var$bytesToString(bytes) {
    $5b9bb241f6bfa58c$var$assertIsBytes(bytes);
    return new TextDecoder().decode(bytes);
}
module.exports.bytesToString = $5b9bb241f6bfa58c$var$bytesToString;
/**
 * Convert a hexadecimal string to a `Uint8Array`. The string can optionally be
 * prefixed with `0x`. It accepts even and odd length strings.
 *
 * If the value is "0x", an empty `Uint8Array` is returned.
 *
 * @param value - The hexadecimal string to convert to bytes.
 * @returns The bytes as `Uint8Array`.
 */ function $5b9bb241f6bfa58c$var$hexToBytes(value) {
    var _a;
    // "0x" is often used as empty byte array.
    if (((_a = value === null || value === void 0 ? void 0 : value.toLowerCase) === null || _a === void 0 ? void 0 : _a.call(value)) === "0x") return new Uint8Array();
    (0, $iFP5p.assertIsHexString)(value);
    // Remove the `0x` prefix if it exists, and pad the string to have an even
    // number of characters.
    const strippedValue = (0, $iFP5p.remove0x)(value).toLowerCase();
    const normalizedValue = strippedValue.length % 2 === 0 ? strippedValue : `0${strippedValue}`;
    const bytes = new Uint8Array(normalizedValue.length / 2);
    for(let i = 0; i < bytes.length; i++){
        // While this is not the prettiest way to convert a hexadecimal string to a
        // `Uint8Array`, it is a lot faster than using `parseInt` to convert each
        // character.
        const c1 = normalizedValue.charCodeAt(i * 2);
        const c2 = normalizedValue.charCodeAt(i * 2 + 1);
        const n1 = c1 - (c1 < $5b9bb241f6bfa58c$var$HEX_MAXIMUM_NUMBER_CHARACTER ? $5b9bb241f6bfa58c$var$HEX_MINIMUM_NUMBER_CHARACTER : $5b9bb241f6bfa58c$var$HEX_CHARACTER_OFFSET);
        const n2 = c2 - (c2 < $5b9bb241f6bfa58c$var$HEX_MAXIMUM_NUMBER_CHARACTER ? $5b9bb241f6bfa58c$var$HEX_MINIMUM_NUMBER_CHARACTER : $5b9bb241f6bfa58c$var$HEX_CHARACTER_OFFSET);
        bytes[i] = n1 * 16 + n2;
    }
    return bytes;
}
module.exports.hexToBytes = $5b9bb241f6bfa58c$var$hexToBytes;
/**
 * Convert a `bigint` to a `Uint8Array`.
 *
 * This assumes that the `bigint` is an unsigned integer. To convert a signed
 * `bigint` instead, use {@link signedBigIntToBytes}.
 *
 * @param value - The bigint to convert to bytes.
 * @returns The bytes as `Uint8Array`.
 */ function $5b9bb241f6bfa58c$var$bigIntToBytes(value) {
    (0, $iujXb.assert)(typeof value === "bigint", "Value must be a bigint.");
    (0, $iujXb.assert)(value >= BigInt(0), "Value must be a non-negative bigint.");
    const hexadecimal = value.toString(16);
    return $5b9bb241f6bfa58c$var$hexToBytes(hexadecimal);
}
module.exports.bigIntToBytes = $5b9bb241f6bfa58c$var$bigIntToBytes;
/**
 * Check if a `bigint` fits in a certain number of bytes.
 *
 * @param value - The `bigint` to check.
 * @param bytes - The number of bytes.
 * @returns Whether the `bigint` fits in the number of bytes.
 */ function $5b9bb241f6bfa58c$var$bigIntFits(value, bytes) {
    (0, $iujXb.assert)(bytes > 0);
    /* eslint-disable no-bitwise */ const mask = value >> BigInt(31);
    return !((~value & mask) + (value & ~mask) >> BigInt(bytes * 8 + -1));
/* eslint-enable no-bitwise */ }
/**
 * Convert a signed `bigint` to a `Uint8Array`. This uses two's complement
 * encoding to represent negative numbers.
 *
 * To convert an unsigned `bigint` to a `Uint8Array` instead, use
 * {@link bigIntToBytes}.
 *
 * @see https://en.wikipedia.org/wiki/Two%27s_complement
 * @param value - The number to convert to bytes.
 * @param byteLength - The length of the resulting `Uint8Array`. If the number
 * is larger than the maximum value that can be represented by the given length,
 * an error is thrown.
 * @returns The bytes as `Uint8Array`.
 */ function $5b9bb241f6bfa58c$var$signedBigIntToBytes(value, byteLength) {
    (0, $iujXb.assert)(typeof value === "bigint", "Value must be a bigint.");
    (0, $iujXb.assert)(typeof byteLength === "number", "Byte length must be a number.");
    (0, $iujXb.assert)(byteLength > 0, "Byte length must be greater than 0.");
    (0, $iujXb.assert)($5b9bb241f6bfa58c$var$bigIntFits(value, byteLength), "Byte length is too small to represent the given value.");
    // ESLint doesn't like mutating function parameters, so to avoid having to
    // disable the rule, we create a new variable.
    let numberValue = value;
    const bytes = new Uint8Array(byteLength);
    for(let i = 0; i < bytes.length; i++){
        bytes[i] = Number(BigInt.asUintN(8, numberValue));
        // eslint-disable-next-line no-bitwise
        numberValue >>= BigInt(8);
    }
    return bytes.reverse();
}
module.exports.signedBigIntToBytes = $5b9bb241f6bfa58c$var$signedBigIntToBytes;
/**
 * Convert a `number` to a `Uint8Array`.
 *
 * @param value - The number to convert to bytes.
 * @returns The bytes as `Uint8Array`.
 * @throws If the number is not a safe integer.
 */ function $5b9bb241f6bfa58c$var$numberToBytes(value) {
    (0, $iujXb.assert)(typeof value === "number", "Value must be a number.");
    (0, $iujXb.assert)(value >= 0, "Value must be a non-negative number.");
    (0, $iujXb.assert)(Number.isSafeInteger(value), "Value is not a safe integer. Use `bigIntToBytes` instead.");
    const hexadecimal = value.toString(16);
    return $5b9bb241f6bfa58c$var$hexToBytes(hexadecimal);
}
module.exports.numberToBytes = $5b9bb241f6bfa58c$var$numberToBytes;
/**
 * Convert a `string` to a UTF-8 encoded `Uint8Array`.
 *
 * @param value - The string to convert to bytes.
 * @returns The bytes as `Uint8Array`.
 */ function $5b9bb241f6bfa58c$var$stringToBytes(value) {
    (0, $iujXb.assert)(typeof value === "string", "Value must be a string.");
    return new TextEncoder().encode(value);
}
module.exports.stringToBytes = $5b9bb241f6bfa58c$var$stringToBytes;
/**
 * Convert a byte-like value to a `Uint8Array`. The value can be a `Uint8Array`,
 * a `bigint`, a `number`, or a `string`.
 *
 * This will attempt to guess the type of the value based on its type and
 * contents. For more control over the conversion, use the more specific
 * conversion functions, such as {@link hexToBytes} or {@link stringToBytes}.
 *
 * If the value is a `string`, and it is prefixed with `0x`, it will be
 * interpreted as a hexadecimal string. Otherwise, it will be interpreted as a
 * UTF-8 string. To convert a hexadecimal string to bytes without interpreting
 * it as a UTF-8 string, use {@link hexToBytes} instead.
 *
 * If the value is a `bigint`, it is assumed to be unsigned. To convert a signed
 * `bigint` to bytes, use {@link signedBigIntToBytes} instead.
 *
 * If the value is a `Uint8Array`, it will be returned as-is.
 *
 * @param value - The value to convert to bytes.
 * @returns The bytes as `Uint8Array`.
 */ function $5b9bb241f6bfa58c$var$valueToBytes(value) {
    if (typeof value === "bigint") return $5b9bb241f6bfa58c$var$bigIntToBytes(value);
    if (typeof value === "number") return $5b9bb241f6bfa58c$var$numberToBytes(value);
    if (typeof value === "string") {
        if (value.startsWith("0x")) return $5b9bb241f6bfa58c$var$hexToBytes(value);
        return $5b9bb241f6bfa58c$var$stringToBytes(value);
    }
    if ($5b9bb241f6bfa58c$var$isBytes(value)) return value;
    throw new TypeError(`Unsupported value type: "${typeof value}".`);
}
module.exports.valueToBytes = $5b9bb241f6bfa58c$var$valueToBytes;
/**
 * Concatenate multiple byte-like values into a single `Uint8Array`. The values
 * can be `Uint8Array`, `bigint`, `number`, or `string`. This uses
 * {@link valueToBytes} under the hood to convert each value to bytes. Refer to
 * the documentation of that function for more information.
 *
 * @param values - The values to concatenate.
 * @returns The concatenated bytes as `Uint8Array`.
 */ function $5b9bb241f6bfa58c$var$concatBytes(values) {
    const normalizedValues = new Array(values.length);
    let byteLength = 0;
    for(let i = 0; i < values.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const value = $5b9bb241f6bfa58c$var$valueToBytes(values[i]);
        normalizedValues[i] = value;
        byteLength += value.length;
    }
    const bytes = new Uint8Array(byteLength);
    for(let i = 0, offset = 0; i < normalizedValues.length; i++){
        // While we could simply spread the values into an array and use
        // `Uint8Array.from`, that is a lot slower than using `Uint8Array.set`.
        bytes.set(normalizedValues[i], offset);
        offset += normalizedValues[i].length;
    }
    return bytes;
}
module.exports.concatBytes = $5b9bb241f6bfa58c$var$concatBytes;
/**
 * Create a {@link DataView} from a {@link Uint8Array}. This is a convenience
 * function that avoids having to create a {@link DataView} manually, which
 * requires passing the `byteOffset` and `byteLength` parameters every time.
 *
 * Not passing the `byteOffset` and `byteLength` parameters can result in
 * unexpected behavior when the {@link Uint8Array} is a view of a larger
 * {@link ArrayBuffer}, e.g., when using {@link Uint8Array.subarray}.
 *
 * This function also supports Node.js {@link Buffer}s.
 *
 * @example
 * ```typescript
 * const bytes = new Uint8Array([1, 2, 3]);
 *
 * // This is equivalent to:
 * // const dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
 * const dataView = createDataView(bytes);
 * ```
 * @param bytes - The bytes to create the {@link DataView} from.
 * @returns The {@link DataView}.
 */ function $5b9bb241f6bfa58c$var$createDataView(bytes) {
    // To maintain compatibility with Node.js, we need to check if the bytes are
    // a Buffer. If so, we need to slice the buffer to get the underlying
    // ArrayBuffer.
    // eslint-disable-next-line no-restricted-globals
    if (typeof $5b9bb241f6bfa58c$require$Buffer !== "undefined" && bytes instanceof $5b9bb241f6bfa58c$require$Buffer) {
        const buffer = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
        return new DataView(buffer);
    }
    return new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}
module.exports.createDataView = $5b9bb241f6bfa58c$var$createDataView;

});
parcelRequire.register("iFP5p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.remove0x = module.exports.add0x = module.exports.assertIsStrictHexString = module.exports.assertIsHexString = module.exports.isStrictHexString = module.exports.isHexString = module.exports.StrictHexStruct = module.exports.HexStruct = void 0;

var $e7b6X = parcelRequire("e7b6X");

var $iujXb = parcelRequire("iujXb");
module.exports.HexStruct = (0, $e7b6X.pattern)((0, $e7b6X.string)(), /^(?:0x)?[0-9a-f]+$/iu);
module.exports.StrictHexStruct = (0, $e7b6X.pattern)((0, $e7b6X.string)(), /^0x[0-9a-f]+$/iu);
/**
 * Check if a string is a valid hex string.
 *
 * @param value - The value to check.
 * @returns Whether the value is a valid hex string.
 */ function $d983af04ad2da5cf$var$isHexString(value) {
    return (0, $e7b6X.is)(value, module.exports.HexStruct);
}
module.exports.isHexString = $d983af04ad2da5cf$var$isHexString;
/**
 * Strictly check if a string is a valid hex string. A valid hex string must
 * start with the "0x"-prefix.
 *
 * @param value - The value to check.
 * @returns Whether the value is a valid hex string.
 */ function $d983af04ad2da5cf$var$isStrictHexString(value) {
    return (0, $e7b6X.is)(value, module.exports.StrictHexStruct);
}
module.exports.isStrictHexString = $d983af04ad2da5cf$var$isStrictHexString;
/**
 * Assert that a value is a valid hex string.
 *
 * @param value - The value to check.
 * @throws If the value is not a valid hex string.
 */ function $d983af04ad2da5cf$var$assertIsHexString(value) {
    (0, $iujXb.assert)($d983af04ad2da5cf$var$isHexString(value), "Value must be a hexadecimal string.");
}
module.exports.assertIsHexString = $d983af04ad2da5cf$var$assertIsHexString;
/**
 * Assert that a value is a valid hex string. A valid hex string must start with
 * the "0x"-prefix.
 *
 * @param value - The value to check.
 * @throws If the value is not a valid hex string.
 */ function $d983af04ad2da5cf$var$assertIsStrictHexString(value) {
    (0, $iujXb.assert)($d983af04ad2da5cf$var$isStrictHexString(value), 'Value must be a hexadecimal string, starting with "0x".');
}
module.exports.assertIsStrictHexString = $d983af04ad2da5cf$var$assertIsStrictHexString;
/**
 * Add the `0x`-prefix to a hexadecimal string. If the string already has the
 * prefix, it is returned as-is.
 *
 * @param hexadecimal - The hexadecimal string to add the prefix to.
 * @returns The prefixed hexadecimal string.
 */ function $d983af04ad2da5cf$var$add0x(hexadecimal) {
    if (hexadecimal.startsWith("0x")) return hexadecimal;
    if (hexadecimal.startsWith("0X")) return `0x${hexadecimal.substring(2)}`;
    return `0x${hexadecimal}`;
}
module.exports.add0x = $d983af04ad2da5cf$var$add0x;
/**
 * Remove the `0x`-prefix from a hexadecimal string. If the string doesn't have
 * the prefix, it is returned as-is.
 *
 * @param hexadecimal - The hexadecimal string to remove the prefix from.
 * @returns The un-prefixed hexadecimal string.
 */ function $d983af04ad2da5cf$var$remove0x(hexadecimal) {
    if (hexadecimal.startsWith("0x") || hexadecimal.startsWith("0X")) return hexadecimal.substring(2);
    return hexadecimal;
}
module.exports.remove0x = $d983af04ad2da5cf$var$remove0x;

});


parcelRequire.register("bXkll", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChecksumStruct = void 0;

var $e7b6X = parcelRequire("e7b6X");

var $aEzVd = parcelRequire("aEzVd");
module.exports.ChecksumStruct = (0, $e7b6X.size)((0, $aEzVd.base64)((0, $e7b6X.string)(), {
    paddingRequired: true
}), 44, 44);

});

parcelRequire.register("1noEZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createHex = module.exports.createBytes = module.exports.createBigInt = module.exports.createNumber = void 0;

var $e7b6X = parcelRequire("e7b6X");

var $iujXb = parcelRequire("iujXb");

var $7RCWW = parcelRequire("7RCWW");

var $iFP5p = parcelRequire("iFP5p");
const $100b116bfae301f6$var$NumberLikeStruct = (0, $e7b6X.union)([
    (0, $e7b6X.number)(),
    (0, $e7b6X.bigint)(),
    (0, $e7b6X.string)(),
    $iFP5p.StrictHexStruct
]);
const $100b116bfae301f6$var$NumberCoercer = (0, $e7b6X.coerce)((0, $e7b6X.number)(), $100b116bfae301f6$var$NumberLikeStruct, Number);
const $100b116bfae301f6$var$BigIntCoercer = (0, $e7b6X.coerce)((0, $e7b6X.bigint)(), $100b116bfae301f6$var$NumberLikeStruct, BigInt);
const $100b116bfae301f6$var$BytesLikeStruct = (0, $e7b6X.union)([
    $iFP5p.StrictHexStruct,
    (0, $e7b6X.instance)(Uint8Array)
]);
const $100b116bfae301f6$var$BytesCoercer = (0, $e7b6X.coerce)((0, $e7b6X.instance)(Uint8Array), (0, $e7b6X.union)([
    $iFP5p.StrictHexStruct
]), $7RCWW.hexToBytes);
const $100b116bfae301f6$var$HexCoercer = (0, $e7b6X.coerce)($iFP5p.StrictHexStruct, (0, $e7b6X.instance)(Uint8Array), $7RCWW.bytesToHex);
/**
 * Create a number from a number-like value.
 *
 * - If the value is a number, it is returned as-is.
 * - If the value is a `bigint`, it is converted to a number.
 * - If the value is a string, it is interpreted as a decimal number.
 * - If the value is a hex string (i.e., it starts with "0x"), it is
 * interpreted as a hexadecimal number.
 *
 * This validates that the value is a number-like value, and that the resulting
 * number is not `NaN` or `Infinity`.
 *
 * @example
 * ```typescript
 * const value = createNumber('0x010203');
 * console.log(value); // 66051
 *
 * const otherValue = createNumber(123n);
 * console.log(otherValue); // 123
 * ```
 * @param value - The value to create the number from.
 * @returns The created number.
 * @throws If the value is not a number-like value, or if the resulting number
 * is `NaN` or `Infinity`.
 */ function $100b116bfae301f6$var$createNumber(value) {
    try {
        const result = (0, $e7b6X.create)(value, $100b116bfae301f6$var$NumberCoercer);
        (0, $iujXb.assert)(Number.isFinite(result), `Expected a number-like value, got "${value}".`);
        return result;
    } catch (error) {
        if (error instanceof $e7b6X.StructError) throw new Error(`Expected a number-like value, got "${value}".`);
        /* istanbul ignore next */ throw error;
    }
}
module.exports.createNumber = $100b116bfae301f6$var$createNumber;
/**
 * Create a `bigint` from a number-like value.
 *
 * - If the value is a number, it is converted to a `bigint`.
 * - If the value is a `bigint`, it is returned as-is.
 * - If the value is a string, it is interpreted as a decimal number and
 * converted to a `bigint`.
 * - If the value is a hex string (i.e., it starts with "0x"), it is
 * interpreted as a hexadecimal number and converted to a `bigint`.
 *
 * @example
 * ```typescript
 * const value = createBigInt('0x010203');
 * console.log(value); // 16909060n
 *
 * const otherValue = createBigInt(123);
 * console.log(otherValue); // 123n
 * ```
 * @param value - The value to create the bigint from.
 * @returns The created bigint.
 * @throws If the value is not a number-like value.
 */ function $100b116bfae301f6$var$createBigInt(value) {
    try {
        // The `BigInt` constructor throws if the value is not a number-like value.
        // There is no need to validate the value manually.
        return (0, $e7b6X.create)(value, $100b116bfae301f6$var$BigIntCoercer);
    } catch (error) {
        if (error instanceof $e7b6X.StructError) throw new Error(`Expected a number-like value, got "${String(error.value)}".`);
        /* istanbul ignore next */ throw error;
    }
}
module.exports.createBigInt = $100b116bfae301f6$var$createBigInt;
/**
 * Create a byte array from a bytes-like value.
 *
 * - If the value is a byte array, it is returned as-is.
 * - If the value is a hex string (i.e., it starts with "0x"), it is interpreted
 * as a hexadecimal number and converted to a byte array.
 *
 * @example
 * ```typescript
 * const value = createBytes('0x010203');
 * console.log(value); // Uint8Array [ 1, 2, 3 ]
 *
 * const otherValue = createBytes('0x010203');
 * console.log(otherValue); // Uint8Array [ 1, 2, 3 ]
 * ```
 * @param value - The value to create the byte array from.
 * @returns The created byte array.
 * @throws If the value is not a bytes-like value.
 */ function $100b116bfae301f6$var$createBytes(value) {
    if (typeof value === "string" && value.toLowerCase() === "0x") return new Uint8Array();
    try {
        return (0, $e7b6X.create)(value, $100b116bfae301f6$var$BytesCoercer);
    } catch (error) {
        if (error instanceof $e7b6X.StructError) throw new Error(`Expected a bytes-like value, got "${String(error.value)}".`);
        /* istanbul ignore next */ throw error;
    }
}
module.exports.createBytes = $100b116bfae301f6$var$createBytes;
/**
 * Create a hexadecimal string from a bytes-like value.
 *
 * - If the value is a hex string (i.e., it starts with "0x"), it is returned
 * as-is.
 * - If the value is a `Uint8Array`, it is converted to a hex string.
 *
 * @example
 * ```typescript
 * const value = createHex(new Uint8Array([1, 2, 3]));
 * console.log(value); // '0x010203'
 *
 * const otherValue = createHex('0x010203');
 * console.log(otherValue); // '0x010203'
 * ```
 * @param value - The value to create the hex string from.
 * @returns The created hex string.
 * @throws If the value is not a bytes-like value.
 */ function $100b116bfae301f6$var$createHex(value) {
    if (value instanceof Uint8Array && value.length === 0 || typeof value === "string" && value.toLowerCase() === "0x") return "0x";
    try {
        return (0, $e7b6X.create)(value, $100b116bfae301f6$var$HexCoercer);
    } catch (error) {
        if (error instanceof $e7b6X.StructError) throw new Error(`Expected a bytes-like value, got "${String(error.value)}".`);
        /* istanbul ignore next */ throw error;
    }
}
module.exports.createHex = $100b116bfae301f6$var$createHex;

});

parcelRequire.register("e6Ezz", function(module, exports) {
"use strict";
var $a451191ed7c184b3$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $a451191ed7c184b3$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $a451191ed7c184b3$var$_FrozenMap_map, $a451191ed7c184b3$var$_FrozenSet_set;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FrozenSet = module.exports.FrozenMap = void 0;
/**
 * A {@link ReadonlyMap} that cannot be modified after instantiation.
 * The implementation uses an inner map hidden via a private field, and the
 * immutability guarantee relies on it being impossible to get a reference
 * to this map.
 */ class $a451191ed7c184b3$var$FrozenMap {
    constructor(entries){
        $a451191ed7c184b3$var$_FrozenMap_map.set(this, void 0);
        $a451191ed7c184b3$var$__classPrivateFieldSet(this, $a451191ed7c184b3$var$_FrozenMap_map, new Map(entries), "f");
        Object.freeze(this);
    }
    get size() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenMap_map, "f").size;
    }
    [($a451191ed7c184b3$var$_FrozenMap_map = new WeakMap(), Symbol.iterator)]() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenMap_map, "f")[Symbol.iterator]();
    }
    entries() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenMap_map, "f").entries();
    }
    forEach(callbackfn, thisArg) {
        // We have to wrap the specified callback in order to prevent it from
        // receiving a reference to the inner map.
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenMap_map, "f").forEach((value, key, _map)=>callbackfn.call(thisArg, value, key, this));
    }
    get(key) {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenMap_map, "f").get(key);
    }
    has(key) {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenMap_map, "f").has(key);
    }
    keys() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenMap_map, "f").keys();
    }
    values() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenMap_map, "f").values();
    }
    toString() {
        return `FrozenMap(${this.size}) {${this.size > 0 ? ` ${[
            ...this.entries()
        ].map(([key, value])=>`${String(key)} => ${String(value)}`).join(", ")} ` : ""}}`;
    }
}
module.exports.FrozenMap = $a451191ed7c184b3$var$FrozenMap;
/**
 * A {@link ReadonlySet} that cannot be modified after instantiation.
 * The implementation uses an inner set hidden via a private field, and the
 * immutability guarantee relies on it being impossible to get a reference
 * to this set.
 */ class $a451191ed7c184b3$var$FrozenSet {
    constructor(values){
        $a451191ed7c184b3$var$_FrozenSet_set.set(this, void 0);
        $a451191ed7c184b3$var$__classPrivateFieldSet(this, $a451191ed7c184b3$var$_FrozenSet_set, new Set(values), "f");
        Object.freeze(this);
    }
    get size() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenSet_set, "f").size;
    }
    [($a451191ed7c184b3$var$_FrozenSet_set = new WeakMap(), Symbol.iterator)]() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenSet_set, "f")[Symbol.iterator]();
    }
    entries() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenSet_set, "f").entries();
    }
    forEach(callbackfn, thisArg) {
        // We have to wrap the specified callback in order to prevent it from
        // receiving a reference to the inner set.
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenSet_set, "f").forEach((value, value2, _set)=>callbackfn.call(thisArg, value, value2, this));
    }
    has(value) {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenSet_set, "f").has(value);
    }
    keys() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenSet_set, "f").keys();
    }
    values() {
        return $a451191ed7c184b3$var$__classPrivateFieldGet(this, $a451191ed7c184b3$var$_FrozenSet_set, "f").values();
    }
    toString() {
        return `FrozenSet(${this.size}) {${this.size > 0 ? ` ${[
            ...this.values()
        ].map((member)=>String(member)).join(", ")} ` : ""}}`;
    }
}
module.exports.FrozenSet = $a451191ed7c184b3$var$FrozenSet;
Object.freeze($a451191ed7c184b3$var$FrozenMap);
Object.freeze($a451191ed7c184b3$var$FrozenMap.prototype);
Object.freeze($a451191ed7c184b3$var$FrozenSet);
Object.freeze($a451191ed7c184b3$var$FrozenSet.prototype);

});

parcelRequire.register("59WYf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateJsonAndGetSize = module.exports.getJsonRpcIdValidator = module.exports.assertIsJsonRpcError = module.exports.isJsonRpcError = module.exports.assertIsJsonRpcFailure = module.exports.isJsonRpcFailure = module.exports.assertIsJsonRpcSuccess = module.exports.isJsonRpcSuccess = module.exports.assertIsJsonRpcResponse = module.exports.isJsonRpcResponse = module.exports.assertIsPendingJsonRpcResponse = module.exports.isPendingJsonRpcResponse = module.exports.JsonRpcResponseStruct = module.exports.JsonRpcFailureStruct = module.exports.JsonRpcSuccessStruct = module.exports.PendingJsonRpcResponseStruct = module.exports.assertIsJsonRpcRequest = module.exports.isJsonRpcRequest = module.exports.assertIsJsonRpcNotification = module.exports.isJsonRpcNotification = module.exports.JsonRpcNotificationStruct = module.exports.JsonRpcRequestStruct = module.exports.JsonRpcParamsStruct = module.exports.JsonRpcErrorStruct = module.exports.JsonRpcIdStruct = module.exports.JsonRpcVersionStruct = module.exports.jsonrpc2 = module.exports.isValidJson = module.exports.JsonStruct = void 0;

var $e7b6X = parcelRequire("e7b6X");

var $iujXb = parcelRequire("iujXb");

var $gV9Lp = parcelRequire("gV9Lp");
module.exports.JsonStruct = (0, $e7b6X.define)("Json", (value)=>{
    const [isValid] = $3c1b895a0fa1ed40$var$validateJsonAndGetSize(value, true);
    if (!isValid) return "Expected a valid JSON-serializable value";
    return true;
});
/**
 * Check if the given value is a valid {@link Json} value, i.e., a value that is
 * serializable to JSON.
 *
 * @param value - The value to check.
 * @returns Whether the value is a valid {@link Json} value.
 */ function $3c1b895a0fa1ed40$var$isValidJson(value) {
    return (0, $e7b6X.is)(value, module.exports.JsonStruct);
}
module.exports.isValidJson = $3c1b895a0fa1ed40$var$isValidJson;
/**
 * The string '2.0'.
 */ module.exports.jsonrpc2 = "2.0";
module.exports.JsonRpcVersionStruct = (0, $e7b6X.literal)(module.exports.jsonrpc2);
module.exports.JsonRpcIdStruct = (0, $e7b6X.nullable)((0, $e7b6X.union)([
    (0, $e7b6X.number)(),
    (0, $e7b6X.string)()
]));
module.exports.JsonRpcErrorStruct = (0, $e7b6X.object)({
    code: (0, $e7b6X.integer)(),
    message: (0, $e7b6X.string)(),
    data: (0, $e7b6X.optional)(module.exports.JsonStruct),
    stack: (0, $e7b6X.optional)((0, $e7b6X.string)())
});
module.exports.JsonRpcParamsStruct = (0, $e7b6X.optional)((0, $e7b6X.union)([
    (0, $e7b6X.record)((0, $e7b6X.string)(), module.exports.JsonStruct),
    (0, $e7b6X.array)(module.exports.JsonStruct)
]));
module.exports.JsonRpcRequestStruct = (0, $e7b6X.object)({
    id: module.exports.JsonRpcIdStruct,
    jsonrpc: module.exports.JsonRpcVersionStruct,
    method: (0, $e7b6X.string)(),
    params: module.exports.JsonRpcParamsStruct
});
module.exports.JsonRpcNotificationStruct = (0, $e7b6X.omit)(module.exports.JsonRpcRequestStruct, [
    "id"
]);
/**
 * Check if the given value is a valid {@link JsonRpcNotification} object.
 *
 * @param value - The value to check.
 * @returns Whether the given value is a valid {@link JsonRpcNotification}
 * object.
 */ function $3c1b895a0fa1ed40$var$isJsonRpcNotification(value) {
    return (0, $e7b6X.is)(value, module.exports.JsonRpcNotificationStruct);
}
module.exports.isJsonRpcNotification = $3c1b895a0fa1ed40$var$isJsonRpcNotification;
/**
 * Assert that the given value is a valid {@link JsonRpcNotification} object.
 *
 * @param value - The value to check.
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}.
 * @throws If the given value is not a valid {@link JsonRpcNotification} object.
 */ function $3c1b895a0fa1ed40$var$assertIsJsonRpcNotification(value, // eslint-disable-next-line @typescript-eslint/naming-convention
ErrorWrapper) {
    (0, $iujXb.assertStruct)(value, module.exports.JsonRpcNotificationStruct, "Invalid JSON-RPC notification", ErrorWrapper);
}
module.exports.assertIsJsonRpcNotification = $3c1b895a0fa1ed40$var$assertIsJsonRpcNotification;
/**
 * Check if the given value is a valid {@link JsonRpcRequest} object.
 *
 * @param value - The value to check.
 * @returns Whether the given value is a valid {@link JsonRpcRequest} object.
 */ function $3c1b895a0fa1ed40$var$isJsonRpcRequest(value) {
    return (0, $e7b6X.is)(value, module.exports.JsonRpcRequestStruct);
}
module.exports.isJsonRpcRequest = $3c1b895a0fa1ed40$var$isJsonRpcRequest;
/**
 * Assert that the given value is a valid {@link JsonRpcRequest} object.
 *
 * @param value - The JSON-RPC request or notification to check.
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}.
 * @throws If the given value is not a valid {@link JsonRpcRequest} object.
 */ function $3c1b895a0fa1ed40$var$assertIsJsonRpcRequest(value, // eslint-disable-next-line @typescript-eslint/naming-convention
ErrorWrapper) {
    (0, $iujXb.assertStruct)(value, module.exports.JsonRpcRequestStruct, "Invalid JSON-RPC request", ErrorWrapper);
}
module.exports.assertIsJsonRpcRequest = $3c1b895a0fa1ed40$var$assertIsJsonRpcRequest;
module.exports.PendingJsonRpcResponseStruct = (0, $e7b6X.object)({
    id: module.exports.JsonRpcIdStruct,
    jsonrpc: module.exports.JsonRpcVersionStruct,
    result: (0, $e7b6X.optional)((0, $e7b6X.unknown)()),
    error: (0, $e7b6X.optional)(module.exports.JsonRpcErrorStruct)
});
module.exports.JsonRpcSuccessStruct = (0, $e7b6X.object)({
    id: module.exports.JsonRpcIdStruct,
    jsonrpc: module.exports.JsonRpcVersionStruct,
    result: module.exports.JsonStruct
});
module.exports.JsonRpcFailureStruct = (0, $e7b6X.object)({
    id: module.exports.JsonRpcIdStruct,
    jsonrpc: module.exports.JsonRpcVersionStruct,
    error: module.exports.JsonRpcErrorStruct
});
module.exports.JsonRpcResponseStruct = (0, $e7b6X.union)([
    module.exports.JsonRpcSuccessStruct,
    module.exports.JsonRpcFailureStruct
]);
/**
 * Type guard to check whether specified JSON-RPC response is a
 * {@link PendingJsonRpcResponse}.
 *
 * @param response - The JSON-RPC response to check.
 * @returns Whether the specified JSON-RPC response is pending.
 */ function $3c1b895a0fa1ed40$var$isPendingJsonRpcResponse(response) {
    return (0, $e7b6X.is)(response, module.exports.PendingJsonRpcResponseStruct);
}
module.exports.isPendingJsonRpcResponse = $3c1b895a0fa1ed40$var$isPendingJsonRpcResponse;
/**
 * Assert that the given value is a valid {@link PendingJsonRpcResponse} object.
 *
 * @param response - The JSON-RPC response to check.
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}.
 * @throws If the given value is not a valid {@link PendingJsonRpcResponse}
 * object.
 */ function $3c1b895a0fa1ed40$var$assertIsPendingJsonRpcResponse(response, // eslint-disable-next-line @typescript-eslint/naming-convention
ErrorWrapper) {
    (0, $iujXb.assertStruct)(response, module.exports.PendingJsonRpcResponseStruct, "Invalid pending JSON-RPC response", ErrorWrapper);
}
module.exports.assertIsPendingJsonRpcResponse = $3c1b895a0fa1ed40$var$assertIsPendingJsonRpcResponse;
/**
 * Type guard to check if a value is a {@link JsonRpcResponse}.
 *
 * @param response - The object to check.
 * @returns Whether the object is a JsonRpcResponse.
 */ function $3c1b895a0fa1ed40$var$isJsonRpcResponse(response) {
    return (0, $e7b6X.is)(response, module.exports.JsonRpcResponseStruct);
}
module.exports.isJsonRpcResponse = $3c1b895a0fa1ed40$var$isJsonRpcResponse;
/**
 * Assert that the given value is a valid {@link JsonRpcResponse} object.
 *
 * @param value - The value to check.
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}.
 * @throws If the given value is not a valid {@link JsonRpcResponse} object.
 */ function $3c1b895a0fa1ed40$var$assertIsJsonRpcResponse(value, // eslint-disable-next-line @typescript-eslint/naming-convention
ErrorWrapper) {
    (0, $iujXb.assertStruct)(value, module.exports.JsonRpcResponseStruct, "Invalid JSON-RPC response", ErrorWrapper);
}
module.exports.assertIsJsonRpcResponse = $3c1b895a0fa1ed40$var$assertIsJsonRpcResponse;
/**
 * Check if the given value is a valid {@link JsonRpcSuccess} object.
 *
 * @param value - The value to check.
 * @returns Whether the given value is a valid {@link JsonRpcSuccess} object.
 */ function $3c1b895a0fa1ed40$var$isJsonRpcSuccess(value) {
    return (0, $e7b6X.is)(value, module.exports.JsonRpcSuccessStruct);
}
module.exports.isJsonRpcSuccess = $3c1b895a0fa1ed40$var$isJsonRpcSuccess;
/**
 * Assert that the given value is a valid {@link JsonRpcSuccess} object.
 *
 * @param value - The value to check.
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}.
 * @throws If the given value is not a valid {@link JsonRpcSuccess} object.
 */ function $3c1b895a0fa1ed40$var$assertIsJsonRpcSuccess(value, // eslint-disable-next-line @typescript-eslint/naming-convention
ErrorWrapper) {
    (0, $iujXb.assertStruct)(value, module.exports.JsonRpcSuccessStruct, "Invalid JSON-RPC success response", ErrorWrapper);
}
module.exports.assertIsJsonRpcSuccess = $3c1b895a0fa1ed40$var$assertIsJsonRpcSuccess;
/**
 * Check if the given value is a valid {@link JsonRpcFailure} object.
 *
 * @param value - The value to check.
 * @returns Whether the given value is a valid {@link JsonRpcFailure} object.
 */ function $3c1b895a0fa1ed40$var$isJsonRpcFailure(value) {
    return (0, $e7b6X.is)(value, module.exports.JsonRpcFailureStruct);
}
module.exports.isJsonRpcFailure = $3c1b895a0fa1ed40$var$isJsonRpcFailure;
/**
 * Assert that the given value is a valid {@link JsonRpcFailure} object.
 *
 * @param value - The value to check.
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}.
 * @throws If the given value is not a valid {@link JsonRpcFailure} object.
 */ function $3c1b895a0fa1ed40$var$assertIsJsonRpcFailure(value, // eslint-disable-next-line @typescript-eslint/naming-convention
ErrorWrapper) {
    (0, $iujXb.assertStruct)(value, module.exports.JsonRpcFailureStruct, "Invalid JSON-RPC failure response", ErrorWrapper);
}
module.exports.assertIsJsonRpcFailure = $3c1b895a0fa1ed40$var$assertIsJsonRpcFailure;
/**
 * Check if the given value is a valid {@link JsonRpcError} object.
 *
 * @param value - The value to check.
 * @returns Whether the given value is a valid {@link JsonRpcError} object.
 */ function $3c1b895a0fa1ed40$var$isJsonRpcError(value) {
    return (0, $e7b6X.is)(value, module.exports.JsonRpcErrorStruct);
}
module.exports.isJsonRpcError = $3c1b895a0fa1ed40$var$isJsonRpcError;
/**
 * Assert that the given value is a valid {@link JsonRpcError} object.
 *
 * @param value - The value to check.
 * @param ErrorWrapper - The error class to throw if the assertion fails.
 * Defaults to {@link AssertionError}.
 * @throws If the given value is not a valid {@link JsonRpcError} object.
 */ function $3c1b895a0fa1ed40$var$assertIsJsonRpcError(value, // eslint-disable-next-line @typescript-eslint/naming-convention
ErrorWrapper) {
    (0, $iujXb.assertStruct)(value, module.exports.JsonRpcErrorStruct, "Invalid JSON-RPC error", ErrorWrapper);
}
module.exports.assertIsJsonRpcError = $3c1b895a0fa1ed40$var$assertIsJsonRpcError;
/**
 * Gets a function for validating JSON-RPC request / response `id` values.
 *
 * By manipulating the options of this factory, you can control the behavior
 * of the resulting validator for some edge cases. This is useful because e.g.
 * `null` should sometimes but not always be permitted.
 *
 * Note that the empty string (`''`) is always permitted by the JSON-RPC
 * specification, but that kind of sucks and you may want to forbid it in some
 * instances anyway.
 *
 * For more details, see the
 * [JSON-RPC Specification](https://www.jsonrpc.org/specification).
 *
 * @param options - An options object.
 * @param options.permitEmptyString - Whether the empty string (i.e. `''`)
 * should be treated as a valid ID. Default: `true`
 * @param options.permitFractions - Whether fractional numbers (e.g. `1.2`)
 * should be treated as valid IDs. Default: `false`
 * @param options.permitNull - Whether `null` should be treated as a valid ID.
 * Default: `true`
 * @returns The JSON-RPC ID validator function.
 */ function $3c1b895a0fa1ed40$var$getJsonRpcIdValidator(options) {
    const { permitEmptyString: permitEmptyString, permitFractions: permitFractions, permitNull: permitNull } = Object.assign({
        permitEmptyString: true,
        permitFractions: false,
        permitNull: true
    }, options);
    /**
     * Type guard for {@link JsonRpcId}.
     *
     * @param id - The JSON-RPC ID value to check.
     * @returns Whether the given ID is valid per the options given to the
     * factory.
     */ const isValidJsonRpcId = (id)=>{
        return Boolean(typeof id === "number" && (permitFractions || Number.isInteger(id)) || typeof id === "string" && (permitEmptyString || id.length > 0) || permitNull && id === null);
    };
    return isValidJsonRpcId;
}
module.exports.getJsonRpcIdValidator = $3c1b895a0fa1ed40$var$getJsonRpcIdValidator;
/**
 * Checks whether a value is JSON serializable and counts the total number
 * of bytes needed to store the serialized version of the value.
 *
 * @param jsObject - Potential JSON serializable object.
 * @param skipSizingProcess - Skip JSON size calculation (default: false).
 * @returns Tuple [isValid, plainTextSizeInBytes] containing a boolean that signals whether
 * the value was serializable and a number of bytes that it will use when serialized to JSON.
 */ function $3c1b895a0fa1ed40$var$validateJsonAndGetSize(jsObject, skipSizingProcess = false) {
    const seenObjects = new Set();
    /**
     * Checks whether a value is JSON serializable and counts the total number
     * of bytes needed to store the serialized version of the value.
     *
     * This function assumes the encoding of the JSON is done in UTF-8.
     *
     * @param value - Potential JSON serializable value.
     * @param skipSizing - Skip JSON size calculation (default: false).
     * @returns Tuple [isValid, plainTextSizeInBytes] containing a boolean that signals whether
     * the value was serializable and a number of bytes that it will use when serialized to JSON.
     */ function getJsonSerializableInfo(value, skipSizing) {
        if (value === undefined) return [
            false,
            0
        ];
        else if (value === null) // Return already specified constant size for null (special object)
        return [
            true,
            skipSizing ? 0 : $gV9Lp.JsonSize.Null
        ];
        // Check and calculate sizes for basic (and some special) types
        const typeOfValue = typeof value;
        try {
            if (typeOfValue === "function") return [
                false,
                0
            ];
            else if (typeOfValue === "string" || value instanceof String) return [
                true,
                skipSizing ? 0 : (0, $gV9Lp.calculateStringSize)(value) + $gV9Lp.JsonSize.Quote * 2
            ];
            else if (typeOfValue === "boolean" || value instanceof Boolean) {
                if (skipSizing) return [
                    true,
                    0
                ];
                // eslint-disable-next-line eqeqeq
                return [
                    true,
                    value == true ? $gV9Lp.JsonSize.True : $gV9Lp.JsonSize.False
                ];
            } else if (typeOfValue === "number" || value instanceof Number) {
                if (skipSizing) return [
                    true,
                    0
                ];
                return [
                    true,
                    (0, $gV9Lp.calculateNumberSize)(value)
                ];
            } else if (value instanceof Date) {
                if (skipSizing) return [
                    true,
                    0
                ];
                return [
                    true,
                    // Note: Invalid dates will serialize to null
                    isNaN(value.getDate()) ? $gV9Lp.JsonSize.Null : $gV9Lp.JsonSize.Date + $gV9Lp.JsonSize.Quote * 2
                ];
            }
        } catch (_) {
            return [
                false,
                0
            ];
        }
        // If object is not plain and cannot be serialized properly,
        // stop here and return false for serialization
        if (!(0, $gV9Lp.isPlainObject)(value) && !Array.isArray(value)) return [
            false,
            0
        ];
        // Circular object detection (handling)
        // Check if the same object already exists
        if (seenObjects.has(value)) return [
            false,
            0
        ];
        // Add new object to the seen objects set
        // Only the plain objects should be added (Primitive types are skipped)
        seenObjects.add(value);
        // Continue object decomposition
        try {
            return [
                true,
                Object.entries(value).reduce((sum, [key, nestedValue], idx, arr)=>{
                    // Recursively process next nested object or primitive type
                    // eslint-disable-next-line prefer-const
                    let [valid, size] = getJsonSerializableInfo(nestedValue, skipSizing);
                    if (!valid) throw new Error("JSON validation did not pass. Validation process stopped.");
                    // Circular object detection
                    // Once a child node is visited and processed remove it from the set.
                    // This will prevent false positives with the same adjacent objects.
                    seenObjects.delete(value);
                    if (skipSizing) return 0;
                    // Objects will have be serialized with "key": value,
                    // therefore we include the key in the calculation here
                    const keySize = Array.isArray(value) ? 0 : key.length + $gV9Lp.JsonSize.Comma + $gV9Lp.JsonSize.Colon * 2;
                    const separator = idx < arr.length - 1 ? $gV9Lp.JsonSize.Comma : 0;
                    return sum + keySize + size + separator;
                }, // Starts at 2 because the serialized JSON string data (plain text)
                // will minimally contain {}/[]
                skipSizing ? 0 : $gV9Lp.JsonSize.Wrapper * 2)
            ];
        } catch (_) {
            return [
                false,
                0
            ];
        }
    }
    return getJsonSerializableInfo(jsObject, skipSizingProcess);
}
module.exports.validateJsonAndGetSize = $3c1b895a0fa1ed40$var$validateJsonAndGetSize;

});
parcelRequire.register("gV9Lp", function(module, exports) {
"use strict";
//
// Types
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateNumberSize = module.exports.calculateStringSize = module.exports.isASCII = module.exports.isPlainObject = module.exports.ESCAPE_CHARACTERS_REGEXP = module.exports.JsonSize = module.exports.hasProperty = module.exports.isObject = module.exports.isNullOrUndefined = module.exports.isNonEmptyArray = void 0;
//
// Type Guards
//
/**
 * A {@link NonEmptyArray} type guard.
 *
 * @template Element - The non-empty array member type.
 * @param value - The value to check.
 * @returns Whether the value is a non-empty array.
 */ function $c5198b0e0da1b08f$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
module.exports.isNonEmptyArray = $c5198b0e0da1b08f$var$isNonEmptyArray;
/**
 * Type guard for "nullishness".
 *
 * @param value - Any value.
 * @returns `true` if the value is null or undefined, `false` otherwise.
 */ function $c5198b0e0da1b08f$var$isNullOrUndefined(value) {
    return value === null || value === undefined;
}
module.exports.isNullOrUndefined = $c5198b0e0da1b08f$var$isNullOrUndefined;
/**
 * A type guard for {@link RuntimeObject}.
 *
 * @param value - The value to check.
 * @returns Whether the specified value has a runtime type of `object` and is
 * neither `null` nor an `Array`.
 */ function $c5198b0e0da1b08f$var$isObject(value) {
    return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}
module.exports.isObject = $c5198b0e0da1b08f$var$isObject;
//
// Other utility functions
//
/**
 * A type guard for ensuring an object has a property.
 *
 * @param objectToCheck - The object to check.
 * @param name - The property name to check for.
 * @returns Whether the specified object has an own property with the specified
 * name, regardless of whether it is enumerable or not.
 */ const $c5198b0e0da1b08f$var$hasProperty = (objectToCheck, name)=>Object.hasOwnProperty.call(objectToCheck, name);
module.exports.hasProperty = $c5198b0e0da1b08f$var$hasProperty;
/**
 * Predefined sizes (in Bytes) of specific parts of JSON structure.
 */ var $c5198b0e0da1b08f$var$JsonSize;
(function(JsonSize) {
    JsonSize[JsonSize["Null"] = 4] = "Null";
    JsonSize[JsonSize["Comma"] = 1] = "Comma";
    JsonSize[JsonSize["Wrapper"] = 1] = "Wrapper";
    JsonSize[JsonSize["True"] = 4] = "True";
    JsonSize[JsonSize["False"] = 5] = "False";
    JsonSize[JsonSize["Quote"] = 1] = "Quote";
    JsonSize[JsonSize["Colon"] = 1] = "Colon";
    // eslint-disable-next-line @typescript-eslint/no-shadow
    JsonSize[JsonSize["Date"] = 24] = "Date";
})($c5198b0e0da1b08f$var$JsonSize = module.exports.JsonSize || (module.exports.JsonSize = {}));
/**
 * Regular expression with pattern matching for (special) escaped characters.
 */ module.exports.ESCAPE_CHARACTERS_REGEXP = /"|\\|\n|\r|\t/gu;
/**
 * Check if the value is plain object.
 *
 * @param value - Value to be checked.
 * @returns True if an object is the plain JavaScript object,
 * false if the object is not plain (e.g. function).
 */ function $c5198b0e0da1b08f$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null) return false;
    try {
        let proto = value;
        while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
        return Object.getPrototypeOf(value) === proto;
    } catch (_) {
        return false;
    }
}
module.exports.isPlainObject = $c5198b0e0da1b08f$var$isPlainObject;
/**
 * Check if character is ASCII.
 *
 * @param character - Character.
 * @returns True if a character code is ASCII, false if not.
 */ function $c5198b0e0da1b08f$var$isASCII(character) {
    return character.charCodeAt(0) <= 127;
}
module.exports.isASCII = $c5198b0e0da1b08f$var$isASCII;
/**
 * Calculate string size.
 *
 * @param value - String value to calculate size.
 * @returns Number of bytes used to store whole string value.
 */ function $c5198b0e0da1b08f$var$calculateStringSize(value) {
    var _a;
    const size = value.split("").reduce((total, character)=>{
        if ($c5198b0e0da1b08f$var$isASCII(character)) return total + 1;
        return total + 2;
    }, 0);
    // Also detect characters that need backslash escape
    return size + ((_a = value.match(module.exports.ESCAPE_CHARACTERS_REGEXP)) !== null && _a !== void 0 ? _a : []).length;
}
module.exports.calculateStringSize = $c5198b0e0da1b08f$var$calculateStringSize;
/**
 * Calculate size of a number ofter JSON serialization.
 *
 * @param value - Number value to calculate size.
 * @returns Number of bytes used to store whole number in JSON.
 */ function $c5198b0e0da1b08f$var$calculateNumberSize(value) {
    return value.toString().length;
}
module.exports.calculateNumberSize = $c5198b0e0da1b08f$var$calculateNumberSize;

});


parcelRequire.register("2jjno", function(module, exports) {
"use strict";
var $1aec62dbca97a9c8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createModuleLogger = module.exports.createProjectLogger = void 0;

const $1aec62dbca97a9c8$var$debug_1 = $1aec62dbca97a9c8$var$__importDefault((parcelRequire("763s9")));
const $1aec62dbca97a9c8$var$globalLogger = (0, $1aec62dbca97a9c8$var$debug_1.default)("metamask");
/**
 * Creates a logger via the `debug` library whose log messages will be tagged
 * using the name of your project. By default, such messages will be
 * suppressed, but you can reveal them by setting the `DEBUG` environment
 * variable to `metamask:<projectName>`. You can also set this variable to
 * `metamask:*` if you want to see log messages from all MetaMask projects that
 * are also using this function to create their loggers.
 *
 * @param projectName - The name of your project. This should be the name of
 * your NPM package if you're developing one.
 * @returns An instance of `debug`.
 */ function $1aec62dbca97a9c8$var$createProjectLogger(projectName) {
    return $1aec62dbca97a9c8$var$globalLogger.extend(projectName);
}
module.exports.createProjectLogger = $1aec62dbca97a9c8$var$createProjectLogger;
/**
 * Creates a logger via the `debug` library which is derived from the logger for
 * the whole project whose log messages will be tagged using the name of your
 * module. By default, such messages will be suppressed, but you can reveal them
 * by setting the `DEBUG` environment variable to
 * `metamask:<projectName>:<moduleName>`. You can also set this variable to
 * `metamask:<projectName>:*` if you want to see log messages from the project,
 * or `metamask:*` if you want to see log messages from all MetaMask projects.
 *
 * @param projectLogger - The logger created via {@link createProjectLogger}.
 * @param moduleName - The name of your module. You could use the name of the
 * file where you're using this logger or some other name.
 * @returns An instance of `debug`.
 */ function $1aec62dbca97a9c8$var$createModuleLogger(projectLogger, moduleName) {
    return projectLogger.extend(moduleName);
}
module.exports.createModuleLogger = $1aec62dbca97a9c8$var$createModuleLogger;

});
parcelRequire.register("763s9", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $hPtJY = parcelRequire("hPtJY");
module.exports.formatArgs = $52abc59f0382c338$var$formatArgs;
module.exports.save = $52abc59f0382c338$var$save;
module.exports.load = $52abc59f0382c338$var$load;
module.exports.useColors = $52abc59f0382c338$var$useColors;
module.exports.storage = $52abc59f0382c338$var$localstorage();
module.exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ module.exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function $52abc59f0382c338$var$useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function $52abc59f0382c338$var$formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ module.exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function $52abc59f0382c338$var$save(namespaces) {
    try {
        if (namespaces) module.exports.storage.setItem("debug", namespaces);
        else module.exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function $52abc59f0382c338$var$load() {
    let r;
    try {
        r = module.exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $hPtJY !== "undefined" && "env" in $hPtJY) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function $52abc59f0382c338$var$localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("hSX94"))(module.exports);
const { formatters: $52abc59f0382c338$var$formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ $52abc59f0382c338$var$formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRequire.register("hSX94", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $d0555bd84512fa45$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("ftEmp"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $d0555bd84512fa45$var$setup;

});
parcelRequire.register("ftEmp", function(module, exports) {
/**
 * Helpers.
 */ var $b448df2f3f28bfc7$var$s = 1000;
var $b448df2f3f28bfc7$var$m = $b448df2f3f28bfc7$var$s * 60;
var $b448df2f3f28bfc7$var$h = $b448df2f3f28bfc7$var$m * 60;
var $b448df2f3f28bfc7$var$d = $b448df2f3f28bfc7$var$h * 24;
var $b448df2f3f28bfc7$var$w = $b448df2f3f28bfc7$var$d * 7;
var $b448df2f3f28bfc7$var$y = $b448df2f3f28bfc7$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $b448df2f3f28bfc7$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $b448df2f3f28bfc7$var$fmtLong(val) : $b448df2f3f28bfc7$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $b448df2f3f28bfc7$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $b448df2f3f28bfc7$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $b448df2f3f28bfc7$var$w;
        case "days":
        case "day":
        case "d":
            return n * $b448df2f3f28bfc7$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $b448df2f3f28bfc7$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $b448df2f3f28bfc7$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $b448df2f3f28bfc7$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $b448df2f3f28bfc7$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $b448df2f3f28bfc7$var$d) return Math.round(ms / $b448df2f3f28bfc7$var$d) + "d";
    if (msAbs >= $b448df2f3f28bfc7$var$h) return Math.round(ms / $b448df2f3f28bfc7$var$h) + "h";
    if (msAbs >= $b448df2f3f28bfc7$var$m) return Math.round(ms / $b448df2f3f28bfc7$var$m) + "m";
    if (msAbs >= $b448df2f3f28bfc7$var$s) return Math.round(ms / $b448df2f3f28bfc7$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $b448df2f3f28bfc7$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $b448df2f3f28bfc7$var$d) return $b448df2f3f28bfc7$var$plural(ms, msAbs, $b448df2f3f28bfc7$var$d, "day");
    if (msAbs >= $b448df2f3f28bfc7$var$h) return $b448df2f3f28bfc7$var$plural(ms, msAbs, $b448df2f3f28bfc7$var$h, "hour");
    if (msAbs >= $b448df2f3f28bfc7$var$m) return $b448df2f3f28bfc7$var$plural(ms, msAbs, $b448df2f3f28bfc7$var$m, "minute");
    if (msAbs >= $b448df2f3f28bfc7$var$s) return $b448df2f3f28bfc7$var$plural(ms, msAbs, $b448df2f3f28bfc7$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $b448df2f3f28bfc7$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});




parcelRequire.register("dTiKP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hexToBigInt = module.exports.hexToNumber = module.exports.bigIntToHex = module.exports.numberToHex = void 0;

var $iujXb = parcelRequire("iujXb");

var $iFP5p = parcelRequire("iFP5p");
/**
 * Convert a number to a hexadecimal string. This verifies that the number is a
 * non-negative safe integer.
 *
 * To convert a `bigint` to a hexadecimal string instead, use
 * {@link bigIntToHex}.
 *
 * @example
 * ```typescript
 * numberToHex(0); // '0x0'
 * numberToHex(1); // '0x1'
 * numberToHex(16); // '0x10'
 * ```
 * @param value - The number to convert to a hexadecimal string.
 * @returns The hexadecimal string, with the "0x"-prefix.
 * @throws If the number is not a non-negative safe integer.
 */ const $a1cef5a077800a33$var$numberToHex = (value)=>{
    (0, $iujXb.assert)(typeof value === "number", "Value must be a number.");
    (0, $iujXb.assert)(value >= 0, "Value must be a non-negative number.");
    (0, $iujXb.assert)(Number.isSafeInteger(value), "Value is not a safe integer. Use `bigIntToHex` instead.");
    return (0, $iFP5p.add0x)(value.toString(16));
};
module.exports.numberToHex = $a1cef5a077800a33$var$numberToHex;
/**
 * Convert a `bigint` to a hexadecimal string. This verifies that the `bigint`
 * is a non-negative integer.
 *
 * To convert a number to a hexadecimal string instead, use {@link numberToHex}.
 *
 * @example
 * ```typescript
 * bigIntToHex(0n); // '0x0'
 * bigIntToHex(1n); // '0x1'
 * bigIntToHex(16n); // '0x10'
 * ```
 * @param value - The `bigint` to convert to a hexadecimal string.
 * @returns The hexadecimal string, with the "0x"-prefix.
 * @throws If the `bigint` is not a non-negative integer.
 */ const $a1cef5a077800a33$var$bigIntToHex = (value)=>{
    (0, $iujXb.assert)(typeof value === "bigint", "Value must be a bigint.");
    (0, $iujXb.assert)(value >= 0, "Value must be a non-negative bigint.");
    return (0, $iFP5p.add0x)(value.toString(16));
};
module.exports.bigIntToHex = $a1cef5a077800a33$var$bigIntToHex;
/**
 * Convert a hexadecimal string to a number. This verifies that the string is a
 * valid hex string, and that the resulting number is a safe integer. Both
 * "0x"-prefixed and unprefixed strings are supported.
 *
 * To convert a hexadecimal string to a `bigint` instead, use
 * {@link hexToBigInt}.
 *
 * @example
 * ```typescript
 * hexToNumber('0x0'); // 0
 * hexToNumber('0x1'); // 1
 * hexToNumber('0x10'); // 16
 * ```
 * @param value - The hexadecimal string to convert to a number.
 * @returns The number.
 * @throws If the value is not a valid hexadecimal string, or if the resulting
 * number is not a safe integer.
 */ const $a1cef5a077800a33$var$hexToNumber = (value)=>{
    (0, $iFP5p.assertIsHexString)(value);
    // `parseInt` accepts values without the "0x"-prefix, whereas `Number` does
    // not. Using this is slightly faster than `Number(add0x(value))`.
    const numberValue = parseInt(value, 16);
    (0, $iujXb.assert)(Number.isSafeInteger(numberValue), "Value is not a safe integer. Use `hexToBigInt` instead.");
    return numberValue;
};
module.exports.hexToNumber = $a1cef5a077800a33$var$hexToNumber;
/**
 * Convert a hexadecimal string to a `bigint`. This verifies that the string is
 * a valid hex string. Both "0x"-prefixed and unprefixed strings are supported.
 *
 * To convert a hexadecimal string to a number instead, use {@link hexToNumber}.
 *
 * @example
 * ```typescript
 * hexToBigInt('0x0'); // 0n
 * hexToBigInt('0x1'); // 1n
 * hexToBigInt('0x10'); // 16n
 * ```
 * @param value - The hexadecimal string to convert to a `bigint`.
 * @returns The `bigint`.
 * @throws If the value is not a valid hexadecimal string.
 */ const $a1cef5a077800a33$var$hexToBigInt = (value)=>{
    (0, $iFP5p.assertIsHexString)(value);
    // The `BigInt` constructor requires the "0x"-prefix to parse a hex string.
    return BigInt((0, $iFP5p.add0x)(value));
};
module.exports.hexToBigInt = $a1cef5a077800a33$var$hexToBigInt;

});

parcelRequire.register("igsLb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRequire.register("c8egZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.timeSince = module.exports.inMilliseconds = module.exports.Duration = void 0;
/**
 * Common duration constants, in milliseconds.
 */ var $8d514db102153ba8$var$Duration;
(function(Duration) {
    /**
     * A millisecond.
     */ Duration[Duration["Millisecond"] = 1] = "Millisecond";
    /**
     * A second, in milliseconds.
     */ Duration[Duration["Second"] = 1000] = "Second";
    /**
     * A minute, in milliseconds.
     */ Duration[Duration["Minute"] = 60000] = "Minute";
    /**
     * An hour, in milliseconds.
     */ Duration[Duration["Hour"] = 3600000] = "Hour";
    /**
     * A day, in milliseconds.
     */ Duration[Duration["Day"] = 86400000] = "Day";
    /**
     * A week, in milliseconds.
     */ Duration[Duration["Week"] = 604800000] = "Week";
    /**
     * A year, in milliseconds.
     */ Duration[Duration["Year"] = 31536000000] = "Year";
})($8d514db102153ba8$var$Duration = module.exports.Duration || (module.exports.Duration = {}));
const $8d514db102153ba8$var$isNonNegativeInteger = (number)=>Number.isInteger(number) && number >= 0;
const $8d514db102153ba8$var$assertIsNonNegativeInteger = (number, name)=>{
    if (!$8d514db102153ba8$var$isNonNegativeInteger(number)) throw new Error(`"${name}" must be a non-negative integer. Received: "${number}".`);
};
/**
 * Calculates the millisecond value of the specified number of units of time.
 *
 * @param count - The number of units of time.
 * @param duration - The unit of time to count.
 * @returns The count multiplied by the specified duration.
 */ function $8d514db102153ba8$var$inMilliseconds(count, duration) {
    $8d514db102153ba8$var$assertIsNonNegativeInteger(count, "count");
    return count * duration;
}
module.exports.inMilliseconds = $8d514db102153ba8$var$inMilliseconds;
/**
 * Gets the milliseconds since a particular Unix epoch timestamp.
 *
 * @param timestamp - A Unix millisecond timestamp.
 * @returns The number of milliseconds elapsed since the specified timestamp.
 */ function $8d514db102153ba8$var$timeSince(timestamp) {
    $8d514db102153ba8$var$assertIsNonNegativeInteger(timestamp, "timestamp");
    return Date.now() - timestamp;
}
module.exports.timeSince = $8d514db102153ba8$var$timeSince;

});

parcelRequire.register("2cLPh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.satisfiesVersionRange = module.exports.gtRange = module.exports.gtVersion = module.exports.assertIsSemVerRange = module.exports.assertIsSemVerVersion = module.exports.isValidSemVerRange = module.exports.isValidSemVerVersion = module.exports.VersionRangeStruct = module.exports.VersionStruct = void 0;

var $iRB8M = parcelRequire("iRB8M");

var $e7b6X = parcelRequire("e7b6X");

var $iujXb = parcelRequire("iujXb");
/**
 * A struct for validating a version string.
 */ module.exports.VersionStruct = (0, $e7b6X.refine)((0, $e7b6X.string)(), "Version", (value)=>{
    if ((0, $iRB8M.valid)(value) === null) return `Expected SemVer version, got "${value}"`;
    return true;
});
module.exports.VersionRangeStruct = (0, $e7b6X.refine)((0, $e7b6X.string)(), "Version range", (value)=>{
    if ((0, $iRB8M.validRange)(value) === null) return `Expected SemVer range, got "${value}"`;
    return true;
});
/**
 * Checks whether a SemVer version is valid.
 *
 * @param version - A potential version.
 * @returns `true` if the version is valid, and `false` otherwise.
 */ function $19b1cd0b3ba84b89$var$isValidSemVerVersion(version) {
    return (0, $e7b6X.is)(version, module.exports.VersionStruct);
}
module.exports.isValidSemVerVersion = $19b1cd0b3ba84b89$var$isValidSemVerVersion;
/**
 * Checks whether a SemVer version range is valid.
 *
 * @param versionRange - A potential version range.
 * @returns `true` if the version range is valid, and `false` otherwise.
 */ function $19b1cd0b3ba84b89$var$isValidSemVerRange(versionRange) {
    return (0, $e7b6X.is)(versionRange, module.exports.VersionRangeStruct);
}
module.exports.isValidSemVerRange = $19b1cd0b3ba84b89$var$isValidSemVerRange;
/**
 * Asserts that a value is a valid concrete SemVer version.
 *
 * @param version - A potential SemVer concrete version.
 */ function $19b1cd0b3ba84b89$var$assertIsSemVerVersion(version) {
    (0, $iujXb.assertStruct)(version, module.exports.VersionStruct);
}
module.exports.assertIsSemVerVersion = $19b1cd0b3ba84b89$var$assertIsSemVerVersion;
/**
 * Asserts that a value is a valid SemVer range.
 *
 * @param range - A potential SemVer range.
 */ function $19b1cd0b3ba84b89$var$assertIsSemVerRange(range) {
    (0, $iujXb.assertStruct)(range, module.exports.VersionRangeStruct);
}
module.exports.assertIsSemVerRange = $19b1cd0b3ba84b89$var$assertIsSemVerRange;
/**
 * Checks whether a SemVer version is greater than another.
 *
 * @param version1 - The left-hand version.
 * @param version2 - The right-hand version.
 * @returns `version1 > version2`.
 */ function $19b1cd0b3ba84b89$var$gtVersion(version1, version2) {
    return (0, $iRB8M.gt)(version1, version2);
}
module.exports.gtVersion = $19b1cd0b3ba84b89$var$gtVersion;
/**
 * Checks whether a SemVer version is greater than all possibilities in a range.
 *
 * @param version - A SemvVer version.
 * @param range - The range to check against.
 * @returns `version > range`.
 */ function $19b1cd0b3ba84b89$var$gtRange(version, range) {
    return (0, $iRB8M.gtr)(version, range);
}
module.exports.gtRange = $19b1cd0b3ba84b89$var$gtRange;
/**
 * Returns whether a SemVer version satisfies a SemVer range.
 *
 * @param version - The SemVer version to check.
 * @param versionRange - The SemVer version range to check against.
 * @returns Whether the version satisfied the version range.
 */ function $19b1cd0b3ba84b89$var$satisfiesVersionRange(version, versionRange) {
    return (0, $iRB8M.satisfies)(version, versionRange, {
        includePrerelease: true
    });
}
module.exports.satisfiesVersionRange = $19b1cd0b3ba84b89$var$satisfiesVersionRange;

});
parcelRequire.register("iRB8M", function(module, exports) {
// just pre-load all the stuff that index.js lazily exports

var $kGRcS = parcelRequire("kGRcS");

var $fJ45P = parcelRequire("fJ45P");

var $jc2hE = parcelRequire("jc2hE");

var $knvD1 = parcelRequire("knvD1");

var $7044y = parcelRequire("7044y");

var $h0sfq = parcelRequire("h0sfq");

var $bJ0RQ = parcelRequire("bJ0RQ");

var $ieYcB = parcelRequire("ieYcB");

var $eGp6O = parcelRequire("eGp6O");

var $5cyvG = parcelRequire("5cyvG");

var $9uxfK = parcelRequire("9uxfK");

var $6xp5n = parcelRequire("6xp5n");

var $cFVW5 = parcelRequire("cFVW5");

var $b7QMB = parcelRequire("b7QMB");

var $6EDzK = parcelRequire("6EDzK");

var $79aP4 = parcelRequire("79aP4");

var $2OL5Q = parcelRequire("2OL5Q");

var $6ku4B = parcelRequire("6ku4B");

var $59O2c = parcelRequire("59O2c");

var $1oAel = parcelRequire("1oAel");

var $lbYuD = parcelRequire("lbYuD");

var $86id8 = parcelRequire("86id8");

var $4oysg = parcelRequire("4oysg");

var $h5qJB = parcelRequire("h5qJB");

var $eFVx2 = parcelRequire("eFVx2");

var $2XmCu = parcelRequire("2XmCu");

var $2Jjdf = parcelRequire("2Jjdf");

var $5fzkR = parcelRequire("5fzkR");

var $4F7Xz = parcelRequire("4F7Xz");

var $5R6Au = parcelRequire("5R6Au");

var $9gGuZ = parcelRequire("9gGuZ");

var $3HMbn = parcelRequire("3HMbn");

var $avwTw = parcelRequire("avwTw");

var $9V0t0 = parcelRequire("9V0t0");

var $1TYcj = parcelRequire("1TYcj");

var $7feqK = parcelRequire("7feqK");

var $9tQ1X = parcelRequire("9tQ1X");

var $17FfA = parcelRequire("17FfA");

var $lTAGj = parcelRequire("lTAGj");

var $9QGcz = parcelRequire("9QGcz");

var $6nO3Y = parcelRequire("6nO3Y");
module.exports = {
    parse: $7044y,
    valid: $h0sfq,
    clean: $bJ0RQ,
    inc: $ieYcB,
    diff: $eGp6O,
    major: $5cyvG,
    minor: $9uxfK,
    patch: $6xp5n,
    prerelease: $cFVW5,
    compare: $b7QMB,
    rcompare: $6EDzK,
    compareLoose: $79aP4,
    compareBuild: $2OL5Q,
    sort: $6ku4B,
    rsort: $59O2c,
    gt: $1oAel,
    lt: $lbYuD,
    eq: $86id8,
    neq: $4oysg,
    gte: $h5qJB,
    lte: $eFVx2,
    cmp: $2XmCu,
    coerce: $2Jjdf,
    Comparator: $5fzkR,
    Range: $4F7Xz,
    satisfies: $5R6Au,
    toComparators: $9gGuZ,
    maxSatisfying: $3HMbn,
    minSatisfying: $avwTw,
    minVersion: $9V0t0,
    validRange: $1TYcj,
    outside: $7feqK,
    gtr: $9tQ1X,
    ltr: $17FfA,
    intersects: $lTAGj,
    simplifyRange: $9QGcz,
    subset: $6nO3Y,
    SemVer: $jc2hE,
    re: $kGRcS.re,
    src: $kGRcS.src,
    tokens: $kGRcS.t,
    SEMVER_SPEC_VERSION: $fJ45P.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $fJ45P.RELEASE_TYPES,
    compareIdentifiers: $knvD1.compareIdentifiers,
    rcompareIdentifiers: $knvD1.rcompareIdentifiers
};

});
parcelRequire.register("kGRcS", function(module, exports) {

var $fJ45P = parcelRequire("fJ45P");
var $f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH = $fJ45P.MAX_SAFE_COMPONENT_LENGTH;
var $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH = $fJ45P.MAX_SAFE_BUILD_LENGTH;
var $f101009ed9c0563c$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;

var $i9RZm = parcelRequire("i9RZm");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        $f101009ed9c0563c$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $i9RZm(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCE", `${"(^|[^\\d])(\\d{1,"}${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRequire.register("fJ45P", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION = "2.0.0";
const $b72e3bc5fa8d2c21$var$MAX_LENGTH = 256;
const $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH = $b72e3bc5fa8d2c21$var$MAX_LENGTH - 6;
const $b72e3bc5fa8d2c21$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $b72e3bc5fa8d2c21$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $b72e3bc5fa8d2c21$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRequire.register("i9RZm", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
const $d382f2433df5837c$var$debug = (typeof $hPtJY === "object" && $hPtJY.env && undefined, ()=>{});
module.exports = $d382f2433df5837c$var$debug;

});


parcelRequire.register("jc2hE", function(module, exports) {

var $i9RZm = parcelRequire("i9RZm");

var $fJ45P = parcelRequire("fJ45P");
var $df90e8d1cf1cf055$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;
var $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER = $fJ45P.MAX_SAFE_INTEGER;

var $kGRcS = parcelRequire("kGRcS");
var $df90e8d1cf1cf055$require$re = $kGRcS.safeRe;
var $df90e8d1cf1cf055$require$t = $kGRcS.t;

var $1nuyy = parcelRequire("1nuyy");

var $knvD1 = parcelRequire("knvD1");
var $df90e8d1cf1cf055$require$compareIdentifiers = $knvD1.compareIdentifiers;
class $df90e8d1cf1cf055$var$SemVer {
    constructor(version, options){
        options = $1nuyy(options);
        if (version instanceof $df90e8d1cf1cf055$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $df90e8d1cf1cf055$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$df90e8d1cf1cf055$require$MAX_LENGTH} characters`);
        $i9RZm("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.LOOSE] : $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $i9RZm("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        return $df90e8d1cf1cf055$require$compareIdentifiers(this.major, other.major) || $df90e8d1cf1cf055$require$compareIdentifiers(this.minor, other.minor) || $df90e8d1cf1cf055$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $i9RZm("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $i9RZm("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($df90e8d1cf1cf055$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join(".")}`;
        return this;
    }
}
module.exports = $df90e8d1cf1cf055$var$SemVer;

});
parcelRequire.register("1nuyy", function(module, exports) {
// parse out just the options we care about
const $100fa442ed30ac34$var$looseOption = Object.freeze({
    loose: true
});
const $100fa442ed30ac34$var$emptyOpts = Object.freeze({});
const $100fa442ed30ac34$var$parseOptions = (options)=>{
    if (!options) return $100fa442ed30ac34$var$emptyOpts;
    if (typeof options !== "object") return $100fa442ed30ac34$var$looseOption;
    return options;
};
module.exports = $100fa442ed30ac34$var$parseOptions;

});

parcelRequire.register("knvD1", function(module, exports) {
const $ed5e7d6476f836e9$var$numeric = /^[0-9]+$/;
const $ed5e7d6476f836e9$var$compareIdentifiers = (a, b)=>{
    const anum = $ed5e7d6476f836e9$var$numeric.test(a);
    const bnum = $ed5e7d6476f836e9$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $ed5e7d6476f836e9$var$rcompareIdentifiers = (a, b)=>$ed5e7d6476f836e9$var$compareIdentifiers(b, a);
module.exports = {
    compareIdentifiers: $ed5e7d6476f836e9$var$compareIdentifiers,
    rcompareIdentifiers: $ed5e7d6476f836e9$var$rcompareIdentifiers
};

});


parcelRequire.register("7044y", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");
const $518bb137cbdf72c3$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $jc2hE) return version;
    try {
        return new $jc2hE(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = $518bb137cbdf72c3$var$parse;

});

parcelRequire.register("h0sfq", function(module, exports) {

var $7044y = parcelRequire("7044y");
const $c618592c32f826bd$var$valid = (version, options)=>{
    const v = $7044y(version, options);
    return v ? v.version : null;
};
module.exports = $c618592c32f826bd$var$valid;

});

parcelRequire.register("bJ0RQ", function(module, exports) {

var $7044y = parcelRequire("7044y");
const $889491f0ea5a6118$var$clean = (version, options)=>{
    const s = $7044y(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
module.exports = $889491f0ea5a6118$var$clean;

});

parcelRequire.register("ieYcB", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");
const $d4783bb52460fa90$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === "string") {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $jc2hE(version instanceof $jc2hE ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = $d4783bb52460fa90$var$inc;

});

parcelRequire.register("eGp6O", function(module, exports) {

var $7044y = parcelRequire("7044y");
const $ab0877022a91d748$var$diff = (version1, version2)=>{
    const v1 = $7044y(version1, null, true);
    const v2 = $7044y(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return "major";
        // Otherwise it can be determined by checking the high version
        if (highVersion.patch) // anything higher than a patch bump would result in the wrong version
        return "patch";
        if (highVersion.minor) // anything higher than a minor bump would result in the wrong version
        return "minor";
        // bumping major/minor/patch all have same result
        return "major";
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? "pre" : "";
    if (v1.major !== v2.major) return prefix + "major";
    if (v1.minor !== v2.minor) return prefix + "minor";
    if (v1.patch !== v2.patch) return prefix + "patch";
    // high and low are preleases
    return "prerelease";
};
module.exports = $ab0877022a91d748$var$diff;

});

parcelRequire.register("5cyvG", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");
const $3c98d7b64d202a78$var$major = (a, loose)=>new $jc2hE(a, loose).major;
module.exports = $3c98d7b64d202a78$var$major;

});

parcelRequire.register("9uxfK", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");
const $6e90b5c2fe90feeb$var$minor = (a, loose)=>new $jc2hE(a, loose).minor;
module.exports = $6e90b5c2fe90feeb$var$minor;

});

parcelRequire.register("6xp5n", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");
const $4c2948a32081632b$var$patch = (a, loose)=>new $jc2hE(a, loose).patch;
module.exports = $4c2948a32081632b$var$patch;

});

parcelRequire.register("cFVW5", function(module, exports) {

var $7044y = parcelRequire("7044y");
const $93a6413aa1f64654$var$prerelease = (version, options)=>{
    const parsed = $7044y(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = $93a6413aa1f64654$var$prerelease;

});

parcelRequire.register("b7QMB", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");
const $81994ac4c012d104$var$compare = (a, b, loose)=>new $jc2hE(a, loose).compare(new $jc2hE(b, loose));
module.exports = $81994ac4c012d104$var$compare;

});

parcelRequire.register("6EDzK", function(module, exports) {

var $b7QMB = parcelRequire("b7QMB");
const $4d852d6325ac3f0a$var$rcompare = (a, b, loose)=>$b7QMB(b, a, loose);
module.exports = $4d852d6325ac3f0a$var$rcompare;

});

parcelRequire.register("79aP4", function(module, exports) {

var $b7QMB = parcelRequire("b7QMB");
const $5341c4d7c3ddc057$var$compareLoose = (a, b)=>$b7QMB(a, b, true);
module.exports = $5341c4d7c3ddc057$var$compareLoose;

});

parcelRequire.register("2OL5Q", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");
const $20d4c8016361ffad$var$compareBuild = (a, b, loose)=>{
    const versionA = new $jc2hE(a, loose);
    const versionB = new $jc2hE(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = $20d4c8016361ffad$var$compareBuild;

});

parcelRequire.register("6ku4B", function(module, exports) {

var $2OL5Q = parcelRequire("2OL5Q");
const $49bbf04266a7f106$var$sort = (list, loose)=>list.sort((a, b)=>$2OL5Q(a, b, loose));
module.exports = $49bbf04266a7f106$var$sort;

});

parcelRequire.register("59O2c", function(module, exports) {

var $2OL5Q = parcelRequire("2OL5Q");
const $3c149acde0254244$var$rsort = (list, loose)=>list.sort((a, b)=>$2OL5Q(b, a, loose));
module.exports = $3c149acde0254244$var$rsort;

});

parcelRequire.register("1oAel", function(module, exports) {

var $b7QMB = parcelRequire("b7QMB");
const $104422eefe356e5b$var$gt = (a, b, loose)=>$b7QMB(a, b, loose) > 0;
module.exports = $104422eefe356e5b$var$gt;

});

parcelRequire.register("lbYuD", function(module, exports) {

var $b7QMB = parcelRequire("b7QMB");
const $f6d98cb923c33015$var$lt = (a, b, loose)=>$b7QMB(a, b, loose) < 0;
module.exports = $f6d98cb923c33015$var$lt;

});

parcelRequire.register("86id8", function(module, exports) {

var $b7QMB = parcelRequire("b7QMB");
const $5e5d028df14dc03a$var$eq = (a, b, loose)=>$b7QMB(a, b, loose) === 0;
module.exports = $5e5d028df14dc03a$var$eq;

});

parcelRequire.register("4oysg", function(module, exports) {

var $b7QMB = parcelRequire("b7QMB");
const $3334214f1b360179$var$neq = (a, b, loose)=>$b7QMB(a, b, loose) !== 0;
module.exports = $3334214f1b360179$var$neq;

});

parcelRequire.register("h5qJB", function(module, exports) {

var $b7QMB = parcelRequire("b7QMB");
const $c707a43d6c3b801a$var$gte = (a, b, loose)=>$b7QMB(a, b, loose) >= 0;
module.exports = $c707a43d6c3b801a$var$gte;

});

parcelRequire.register("eFVx2", function(module, exports) {

var $b7QMB = parcelRequire("b7QMB");
const $aaf185a79a690d76$var$lte = (a, b, loose)=>$b7QMB(a, b, loose) <= 0;
module.exports = $aaf185a79a690d76$var$lte;

});

parcelRequire.register("2XmCu", function(module, exports) {

var $86id8 = parcelRequire("86id8");

var $4oysg = parcelRequire("4oysg");

var $1oAel = parcelRequire("1oAel");

var $h5qJB = parcelRequire("h5qJB");

var $lbYuD = parcelRequire("lbYuD");

var $eFVx2 = parcelRequire("eFVx2");
const $2272a34159523aa5$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $86id8(a, b, loose);
        case "!=":
            return $4oysg(a, b, loose);
        case ">":
            return $1oAel(a, b, loose);
        case ">=":
            return $h5qJB(a, b, loose);
        case "<":
            return $lbYuD(a, b, loose);
        case "<=":
            return $eFVx2(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
module.exports = $2272a34159523aa5$var$cmp;

});

parcelRequire.register("2Jjdf", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");

var $7044y = parcelRequire("7044y");

var $kGRcS = parcelRequire("kGRcS");
var $1fceaff8ff23f299$require$re = $kGRcS.safeRe;
var $1fceaff8ff23f299$require$t = $kGRcS.t;
const $1fceaff8ff23f299$var$coerce = (version, options)=>{
    if (version instanceof $jc2hE) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match($1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        let next;
        while((next = $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return $7044y(`${match[2]}.${match[3] || "0"}.${match[4] || "0"}`, options);
};
module.exports = $1fceaff8ff23f299$var$coerce;

});

parcelRequire.register("5fzkR", function(module, exports) {
const $3d29c357640e9d06$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
class $3d29c357640e9d06$var$Comparator {
    static get ANY() {
        return $3d29c357640e9d06$var$ANY;
    }
    constructor(comp, options){
        options = $1nuyy(options);
        if (comp instanceof $3d29c357640e9d06$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(" ");
        $i9RZm("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $3d29c357640e9d06$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $i9RZm("comp", this);
    }
    parse(comp) {
        const r = this.options.loose ? $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATORLOOSE] : $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : "";
        if (this.operator === "=") this.operator = "";
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $3d29c357640e9d06$var$ANY;
        else this.semver = new $jc2hE(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $i9RZm("Comparator.test", version, this.options.loose);
        if (this.semver === $3d29c357640e9d06$var$ANY || version === $3d29c357640e9d06$var$ANY) return true;
        if (typeof version === "string") try {
            version = new $jc2hE(version, this.options);
        } catch (er) {
            return false;
        }
        return $2XmCu(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $3d29c357640e9d06$var$Comparator)) throw new TypeError("a Comparator is required");
        if (this.operator === "") {
            if (this.value === "") return true;
            return new $4F7Xz(comp.value, options).test(this.value);
        } else if (comp.operator === "") {
            if (comp.value === "") return true;
            return new $4F7Xz(this.value, options).test(comp.semver);
        }
        options = $1nuyy(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0")) return false;
        if (!options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0"))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith(">") && comp.operator.startsWith(">")) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith("<") && comp.operator.startsWith("<")) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=")) return true;
        // opposite directions less than
        if ($2XmCu(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<")) return true;
        // opposite directions greater than
        if ($2XmCu(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")) return true;
        return false;
    }
}
module.exports = $3d29c357640e9d06$var$Comparator;

var $1nuyy = parcelRequire("1nuyy");

var $kGRcS = parcelRequire("kGRcS");
var $3d29c357640e9d06$require$re = $kGRcS.safeRe;
var $3d29c357640e9d06$require$t = $kGRcS.t;

var $2XmCu = parcelRequire("2XmCu");

var $i9RZm = parcelRequire("i9RZm");

var $jc2hE = parcelRequire("jc2hE");

var $4F7Xz = parcelRequire("4F7Xz");

});
parcelRequire.register("4F7Xz", function(module, exports) {
// hoisted class for cyclic dependency
class $36512a6be0346a51$var$Range {
    constructor(range, options){
        options = $1nuyy(options);
        if (range instanceof $36512a6be0346a51$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $36512a6be0346a51$var$Range(range.raw, options);
        }
        if (range instanceof $5fzkR) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().split(/\s+/).join(" ");
        // First, split on ||
        this.set = this.raw.split("||")// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$36512a6be0346a51$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $36512a6be0346a51$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.format();
    }
    format() {
        this.range = this.set.map((comps)=>comps.join(" ").trim()).join("||").trim();
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $36512a6be0346a51$require$FLAG_LOOSE);
        const memoKey = memoOpts + ":" + range;
        const cached = $36512a6be0346a51$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGE];
        range = range.replace(hr, $36512a6be0346a51$var$hyphenReplace(this.options.includePrerelease));
        $i9RZm("hyphen replace", range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORTRIM], $36512a6be0346a51$require$comparatorTrimReplace);
        $i9RZm("comparator trim", range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDETRIM], $36512a6be0346a51$require$tildeTrimReplace);
        $i9RZm("tilde trim", range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETTRIM], $36512a6be0346a51$require$caretTrimReplace);
        $i9RZm("caret trim", range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(" ").map((comp)=>$36512a6be0346a51$var$parseComparator(comp, this.options)).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$36512a6be0346a51$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $i9RZm("loose invalid filter", comp, this.options);
            return !!comp.match($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORLOOSE]);
        });
        $i9RZm("range list", rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $5fzkR(comp, this.options));
        for (const comp of comparators){
            if ($36512a6be0346a51$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
        const result = [
            ...rangeMap.values()
        ];
        $36512a6be0346a51$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $36512a6be0346a51$var$Range)) throw new TypeError("a Range is required");
        return this.set.some((thisComparators)=>{
            return $36512a6be0346a51$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $36512a6be0346a51$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === "string") try {
            version = new $jc2hE(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($36512a6be0346a51$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
module.exports = $36512a6be0346a51$var$Range;

var $bnToR = parcelRequire("bnToR");
const $36512a6be0346a51$var$cache = new $bnToR({
    max: 1000
});

var $1nuyy = parcelRequire("1nuyy");

var $5fzkR = parcelRequire("5fzkR");

var $i9RZm = parcelRequire("i9RZm");

var $jc2hE = parcelRequire("jc2hE");

var $kGRcS = parcelRequire("kGRcS");
var $36512a6be0346a51$require$re = $kGRcS.safeRe;
var $36512a6be0346a51$require$t = $kGRcS.t;
var $36512a6be0346a51$require$comparatorTrimReplace = $kGRcS.comparatorTrimReplace;
var $36512a6be0346a51$require$tildeTrimReplace = $kGRcS.tildeTrimReplace;
var $36512a6be0346a51$require$caretTrimReplace = $kGRcS.caretTrimReplace;

var $fJ45P = parcelRequire("fJ45P");
var $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE = $fJ45P.FLAG_INCLUDE_PRERELEASE;
var $36512a6be0346a51$require$FLAG_LOOSE = $fJ45P.FLAG_LOOSE;
const $36512a6be0346a51$var$isNullSet = (c)=>c.value === "<0.0.0-0";
const $36512a6be0346a51$var$isAny = (c)=>c.value === "";
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $36512a6be0346a51$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $36512a6be0346a51$var$parseComparator = (comp, options)=>{
    $i9RZm("comp", comp, options);
    comp = $36512a6be0346a51$var$replaceCarets(comp, options);
    $i9RZm("caret", comp);
    comp = $36512a6be0346a51$var$replaceTildes(comp, options);
    $i9RZm("tildes", comp);
    comp = $36512a6be0346a51$var$replaceXRanges(comp, options);
    $i9RZm("xrange", comp);
    comp = $36512a6be0346a51$var$replaceStars(comp, options);
    $i9RZm("stars", comp);
    return comp;
};
const $36512a6be0346a51$var$isX = (id)=>!id || id.toLowerCase() === "x" || id === "*";
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $36512a6be0346a51$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceTilde(c, options)).join(" ");
};
const $36512a6be0346a51$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm("tilde", comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = "";
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $i9RZm("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $i9RZm("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $36512a6be0346a51$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceCaret(c, options)).join(" ");
};
const $36512a6be0346a51$var$replaceCaret = (comp, options)=>{
    $i9RZm("caret", comp, options);
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETLOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARET];
    const z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm("caret", comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = "";
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) {
            if (M === "0") ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $i9RZm("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $i9RZm("no pr");
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $i9RZm("caret return", ret);
        return ret;
    });
};
const $36512a6be0346a51$var$replaceXRanges = (comp, options)=>{
    $i9RZm("replaceXRanges", comp, options);
    return comp.split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceXRange(c, options)).join(" ");
};
const $36512a6be0346a51$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $i9RZm("xRange", comp, ret, gtlt, M, m, p, pr);
        const xM = $36512a6be0346a51$var$isX(M);
        const xm = xM || $36512a6be0346a51$var$isX(m);
        const xp = xm || $36512a6be0346a51$var$isX(p);
        const anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $i9RZm("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $36512a6be0346a51$var$replaceStars = (comp, options)=>{
    $i9RZm("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.STAR], "");
};
const $36512a6be0346a51$var$replaceGTE0 = (comp, options)=>{
    $i9RZm("replaceGTE0", comp, options);
    return comp.trim().replace($36512a6be0346a51$require$re[options.includePrerelease ? $36512a6be0346a51$require$t.GTE0PRE : $36512a6be0346a51$require$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
const $36512a6be0346a51$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb)=>{
        if ($36512a6be0346a51$var$isX(fM)) from = "";
        else if ($36512a6be0346a51$var$isX(fm)) from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        else if ($36512a6be0346a51$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? "-0" : ""}`;
        if ($36512a6be0346a51$var$isX(tM)) to = "";
        else if ($36512a6be0346a51$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $36512a6be0346a51$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $i9RZm(set[i].semver);
            if (set[i].semver === $5fzkR.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

});
parcelRequire.register("bnToR", function(module, exports) {
"use strict";

var $5qBd4 = parcelRequire("5qBd4");
const $849cd0fb8cde656f$var$MAX = Symbol("max");
const $849cd0fb8cde656f$var$LENGTH = Symbol("length");
const $849cd0fb8cde656f$var$LENGTH_CALCULATOR = Symbol("lengthCalculator");
const $849cd0fb8cde656f$var$ALLOW_STALE = Symbol("allowStale");
const $849cd0fb8cde656f$var$MAX_AGE = Symbol("maxAge");
const $849cd0fb8cde656f$var$DISPOSE = Symbol("dispose");
const $849cd0fb8cde656f$var$NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
const $849cd0fb8cde656f$var$LRU_LIST = Symbol("lruList");
const $849cd0fb8cde656f$var$CACHE = Symbol("cache");
const $849cd0fb8cde656f$var$UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
const $849cd0fb8cde656f$var$naiveLength = ()=>1;
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class $849cd0fb8cde656f$var$LRUCache {
    constructor(options){
        if (typeof options === "number") options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
        // Kind of weird to have a default max of Infinity, but oh well.
        const max = this[$849cd0fb8cde656f$var$MAX] = options.max || Infinity;
        const lc = options.length || $849cd0fb8cde656f$var$naiveLength;
        this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR] = typeof lc !== "function" ? $849cd0fb8cde656f$var$naiveLength : lc;
        this[$849cd0fb8cde656f$var$ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
        this[$849cd0fb8cde656f$var$MAX_AGE] = options.maxAge || 0;
        this[$849cd0fb8cde656f$var$DISPOSE] = options.dispose;
        this[$849cd0fb8cde656f$var$NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[$849cd0fb8cde656f$var$UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    // resize the cache when the max changes.
    set max(mL) {
        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
        this[$849cd0fb8cde656f$var$MAX] = mL || Infinity;
        $849cd0fb8cde656f$var$trim(this);
    }
    get max() {
        return this[$849cd0fb8cde656f$var$MAX];
    }
    set allowStale(allowStale) {
        this[$849cd0fb8cde656f$var$ALLOW_STALE] = !!allowStale;
    }
    get allowStale() {
        return this[$849cd0fb8cde656f$var$ALLOW_STALE];
    }
    set maxAge(mA) {
        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
        this[$849cd0fb8cde656f$var$MAX_AGE] = mA;
        $849cd0fb8cde656f$var$trim(this);
    }
    get maxAge() {
        return this[$849cd0fb8cde656f$var$MAX_AGE];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(lC) {
        if (typeof lC !== "function") lC = $849cd0fb8cde656f$var$naiveLength;
        if (lC !== this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR]) {
            this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR] = lC;
            this[$849cd0fb8cde656f$var$LENGTH] = 0;
            this[$849cd0fb8cde656f$var$LRU_LIST].forEach((hit)=>{
                hit.length = this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR](hit.value, hit.key);
                this[$849cd0fb8cde656f$var$LENGTH] += hit.length;
            });
        }
        $849cd0fb8cde656f$var$trim(this);
    }
    get lengthCalculator() {
        return this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR];
    }
    get length() {
        return this[$849cd0fb8cde656f$var$LENGTH];
    }
    get itemCount() {
        return this[$849cd0fb8cde656f$var$LRU_LIST].length;
    }
    rforEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$849cd0fb8cde656f$var$LRU_LIST].tail; walker !== null;){
            const prev = walker.prev;
            $849cd0fb8cde656f$var$forEachStep(this, fn, walker, thisp);
            walker = prev;
        }
    }
    forEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$849cd0fb8cde656f$var$LRU_LIST].head; walker !== null;){
            const next = walker.next;
            $849cd0fb8cde656f$var$forEachStep(this, fn, walker, thisp);
            walker = next;
        }
    }
    keys() {
        return this[$849cd0fb8cde656f$var$LRU_LIST].toArray().map((k)=>k.key);
    }
    values() {
        return this[$849cd0fb8cde656f$var$LRU_LIST].toArray().map((k)=>k.value);
    }
    reset() {
        if (this[$849cd0fb8cde656f$var$DISPOSE] && this[$849cd0fb8cde656f$var$LRU_LIST] && this[$849cd0fb8cde656f$var$LRU_LIST].length) this[$849cd0fb8cde656f$var$LRU_LIST].forEach((hit)=>this[$849cd0fb8cde656f$var$DISPOSE](hit.key, hit.value));
        this[$849cd0fb8cde656f$var$CACHE] = new Map() // hash of items by key
        ;
        this[$849cd0fb8cde656f$var$LRU_LIST] = new $5qBd4() // list of items in order of use recency
        ;
        this[$849cd0fb8cde656f$var$LENGTH] = 0 // length of items in the list
        ;
    }
    dump() {
        return this[$849cd0fb8cde656f$var$LRU_LIST].map((hit)=>$849cd0fb8cde656f$var$isStale(this, hit) ? false : {
                k: hit.key,
                v: hit.value,
                e: hit.now + (hit.maxAge || 0)
            }).toArray().filter((h)=>h);
    }
    dumpLru() {
        return this[$849cd0fb8cde656f$var$LRU_LIST];
    }
    set(key, value, maxAge) {
        maxAge = maxAge || this[$849cd0fb8cde656f$var$MAX_AGE];
        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
        const now = maxAge ? Date.now() : 0;
        const len = this[$849cd0fb8cde656f$var$LENGTH_CALCULATOR](value, key);
        if (this[$849cd0fb8cde656f$var$CACHE].has(key)) {
            if (len > this[$849cd0fb8cde656f$var$MAX]) {
                $849cd0fb8cde656f$var$del(this, this[$849cd0fb8cde656f$var$CACHE].get(key));
                return false;
            }
            const node = this[$849cd0fb8cde656f$var$CACHE].get(key);
            const item = node.value;
            // dispose of the old one before overwriting
            // split out into 2 ifs for better coverage tracking
            if (this[$849cd0fb8cde656f$var$DISPOSE]) {
                if (!this[$849cd0fb8cde656f$var$NO_DISPOSE_ON_SET]) this[$849cd0fb8cde656f$var$DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[$849cd0fb8cde656f$var$LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            $849cd0fb8cde656f$var$trim(this);
            return true;
        }
        const hit = new $849cd0fb8cde656f$var$Entry(key, value, len, now, maxAge);
        // oversized objects fall out of cache automatically.
        if (hit.length > this[$849cd0fb8cde656f$var$MAX]) {
            if (this[$849cd0fb8cde656f$var$DISPOSE]) this[$849cd0fb8cde656f$var$DISPOSE](key, value);
            return false;
        }
        this[$849cd0fb8cde656f$var$LENGTH] += hit.length;
        this[$849cd0fb8cde656f$var$LRU_LIST].unshift(hit);
        this[$849cd0fb8cde656f$var$CACHE].set(key, this[$849cd0fb8cde656f$var$LRU_LIST].head);
        $849cd0fb8cde656f$var$trim(this);
        return true;
    }
    has(key) {
        if (!this[$849cd0fb8cde656f$var$CACHE].has(key)) return false;
        const hit = this[$849cd0fb8cde656f$var$CACHE].get(key).value;
        return !$849cd0fb8cde656f$var$isStale(this, hit);
    }
    get(key) {
        return $849cd0fb8cde656f$var$get(this, key, true);
    }
    peek(key) {
        return $849cd0fb8cde656f$var$get(this, key, false);
    }
    pop() {
        const node = this[$849cd0fb8cde656f$var$LRU_LIST].tail;
        if (!node) return null;
        $849cd0fb8cde656f$var$del(this, node);
        return node.value;
    }
    del(key) {
        $849cd0fb8cde656f$var$del(this, this[$849cd0fb8cde656f$var$CACHE].get(key));
    }
    load(arr) {
        // reset the cache
        this.reset();
        const now = Date.now();
        // A previous serialized cache has the most recent items first
        for(let l = arr.length - 1; l >= 0; l--){
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0) // the item was created without expiration in a non aged cache
            this.set(hit.k, hit.v);
            else {
                const maxAge = expiresAt - now;
                // dont add already expired items
                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
            }
        }
    }
    prune() {
        this[$849cd0fb8cde656f$var$CACHE].forEach((value, key)=>$849cd0fb8cde656f$var$get(this, key, false));
    }
}
const $849cd0fb8cde656f$var$get = (self, key, doUse)=>{
    const node = self[$849cd0fb8cde656f$var$CACHE].get(key);
    if (node) {
        const hit = node.value;
        if ($849cd0fb8cde656f$var$isStale(self, hit)) {
            $849cd0fb8cde656f$var$del(self, node);
            if (!self[$849cd0fb8cde656f$var$ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[$849cd0fb8cde656f$var$UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[$849cd0fb8cde656f$var$LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
const $849cd0fb8cde656f$var$isStale = (self, hit)=>{
    if (!hit || !hit.maxAge && !self[$849cd0fb8cde656f$var$MAX_AGE]) return false;
    const diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[$849cd0fb8cde656f$var$MAX_AGE] && diff > self[$849cd0fb8cde656f$var$MAX_AGE];
};
const $849cd0fb8cde656f$var$trim = (self)=>{
    if (self[$849cd0fb8cde656f$var$LENGTH] > self[$849cd0fb8cde656f$var$MAX]) for(let walker = self[$849cd0fb8cde656f$var$LRU_LIST].tail; self[$849cd0fb8cde656f$var$LENGTH] > self[$849cd0fb8cde656f$var$MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        const prev = walker.prev;
        $849cd0fb8cde656f$var$del(self, walker);
        walker = prev;
    }
};
const $849cd0fb8cde656f$var$del = (self, node)=>{
    if (node) {
        const hit = node.value;
        if (self[$849cd0fb8cde656f$var$DISPOSE]) self[$849cd0fb8cde656f$var$DISPOSE](hit.key, hit.value);
        self[$849cd0fb8cde656f$var$LENGTH] -= hit.length;
        self[$849cd0fb8cde656f$var$CACHE].delete(hit.key);
        self[$849cd0fb8cde656f$var$LRU_LIST].removeNode(node);
    }
};
class $849cd0fb8cde656f$var$Entry {
    constructor(key, value, length, now, maxAge){
        this.key = key;
        this.value = value;
        this.length = length;
        this.now = now;
        this.maxAge = maxAge || 0;
    }
}
const $849cd0fb8cde656f$var$forEachStep = (self, fn, node, thisp)=>{
    let hit = node.value;
    if ($849cd0fb8cde656f$var$isStale(self, hit)) {
        $849cd0fb8cde656f$var$del(self, node);
        if (!self[$849cd0fb8cde656f$var$ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
module.exports = $849cd0fb8cde656f$var$LRUCache;

});
parcelRequire.register("5qBd4", function(module, exports) {
"use strict";
module.exports = $3f3c3e91d91e9f6c$var$Yallist;
$3f3c3e91d91e9f6c$var$Yallist.Node = $3f3c3e91d91e9f6c$var$Node;
$3f3c3e91d91e9f6c$var$Yallist.create = $3f3c3e91d91e9f6c$var$Yallist;
function $3f3c3e91d91e9f6c$var$Yallist(list) {
    var self = this;
    if (!(self instanceof $3f3c3e91d91e9f6c$var$Yallist)) self = new $3f3c3e91d91e9f6c$var$Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === "function") list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
$3f3c3e91d91e9f6c$var$Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error("removing node which does not belong to this list");
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$3f3c3e91d91e9f6c$var$push(this, arguments[i]);
    return this.length;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$3f3c3e91d91e9f6c$var$unshift(this, arguments[i]);
    return this.length;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $3f3c3e91d91e9f6c$var$Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $3f3c3e91d91e9f6c$var$Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $3f3c3e91d91e9f6c$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $3f3c3e91d91e9f6c$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 0; i < nodes.length; i++)walker = $3f3c3e91d91e9f6c$var$insert(this, walker, nodes[i]);
    return ret;
};
$3f3c3e91d91e9f6c$var$Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function $3f3c3e91d91e9f6c$var$insert(self, node, value) {
    var inserted = node === self.head ? new $3f3c3e91d91e9f6c$var$Node(value, null, node, self) : new $3f3c3e91d91e9f6c$var$Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function $3f3c3e91d91e9f6c$var$push(self, item) {
    self.tail = new $3f3c3e91d91e9f6c$var$Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function $3f3c3e91d91e9f6c$var$unshift(self, item) {
    self.head = new $3f3c3e91d91e9f6c$var$Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function $3f3c3e91d91e9f6c$var$Node(value, prev, next, list) {
    if (!(this instanceof $3f3c3e91d91e9f6c$var$Node)) return new $3f3c3e91d91e9f6c$var$Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}

try {
    // add if support for Symbol.iterator is present
    (parcelRequire("fcGo5"))($3f3c3e91d91e9f6c$var$Yallist);
} catch (er) {}

});
parcelRequire.register("fcGo5", function(module, exports) {
"use strict";
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function*() {
        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
    };
};

});





parcelRequire.register("5R6Au", function(module, exports) {

var $4F7Xz = parcelRequire("4F7Xz");
const $44370327d4e393bf$var$satisfies = (version, range, options)=>{
    try {
        range = new $4F7Xz(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = $44370327d4e393bf$var$satisfies;

});

parcelRequire.register("9gGuZ", function(module, exports) {

var $4F7Xz = parcelRequire("4F7Xz");
// Mostly just for testing and legacy API reasons
const $6bf6930ad20f8979$var$toComparators = (range, options)=>new $4F7Xz(range, options).set.map((comp)=>comp.map((c)=>c.value).join(" ").trim().split(" "));
module.exports = $6bf6930ad20f8979$var$toComparators;

});

parcelRequire.register("3HMbn", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");

var $4F7Xz = parcelRequire("4F7Xz");
const $2b2ac348dee0803e$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $4F7Xz(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $jc2hE(max, options);
            }
        }
    });
    return max;
};
module.exports = $2b2ac348dee0803e$var$maxSatisfying;

});

parcelRequire.register("avwTw", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");

var $4F7Xz = parcelRequire("4F7Xz");
const $7a6650c8d62ec668$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $4F7Xz(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $jc2hE(min, options);
            }
        }
    });
    return min;
};
module.exports = $7a6650c8d62ec668$var$minSatisfying;

});

parcelRequire.register("9V0t0", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");

var $4F7Xz = parcelRequire("4F7Xz");

var $1oAel = parcelRequire("1oAel");
const $7389cc9c1db09b0d$var$minVersion = (range, loose)=>{
    range = new $4F7Xz(range, loose);
    let minver = new $jc2hE("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $jc2hE("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $jc2hE(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $1oAel(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $1oAel(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = $7389cc9c1db09b0d$var$minVersion;

});

parcelRequire.register("1TYcj", function(module, exports) {

var $4F7Xz = parcelRequire("4F7Xz");
const $16299f7793385cf3$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $4F7Xz(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
module.exports = $16299f7793385cf3$var$validRange;

});

parcelRequire.register("7feqK", function(module, exports) {

var $jc2hE = parcelRequire("jc2hE");

var $5fzkR = parcelRequire("5fzkR");
const { ANY: $546520af951b9b5a$var$ANY } = $5fzkR;

var $4F7Xz = parcelRequire("4F7Xz");

var $5R6Au = parcelRequire("5R6Au");

var $1oAel = parcelRequire("1oAel");

var $lbYuD = parcelRequire("lbYuD");

var $eFVx2 = parcelRequire("eFVx2");

var $h5qJB = parcelRequire("h5qJB");
const $546520af951b9b5a$var$outside = (version, range, hilo, options)=>{
    version = new $jc2hE(version, options);
    range = new $4F7Xz(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $1oAel;
            ltefn = $eFVx2;
            ltfn = $lbYuD;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $lbYuD;
            ltefn = $h5qJB;
            ltfn = $1oAel;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($5R6Au(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $546520af951b9b5a$var$ANY) comparator = new $5fzkR(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
module.exports = $546520af951b9b5a$var$outside;

});

parcelRequire.register("9tQ1X", function(module, exports) {
// Determine if version is greater than all the versions possible in the range.

var $7feqK = parcelRequire("7feqK");
const $6e6f2ea8eb78962a$var$gtr = (version, range, options)=>$7feqK(version, range, ">", options);
module.exports = $6e6f2ea8eb78962a$var$gtr;

});

parcelRequire.register("17FfA", function(module, exports) {

var $7feqK = parcelRequire("7feqK");
// Determine if version is less than all the versions possible in the range
const $0d167156795b8123$var$ltr = (version, range, options)=>$7feqK(version, range, "<", options);
module.exports = $0d167156795b8123$var$ltr;

});

parcelRequire.register("lTAGj", function(module, exports) {

var $4F7Xz = parcelRequire("4F7Xz");
const $ff0b302dd979be82$var$intersects = (r1, r2, options)=>{
    r1 = new $4F7Xz(r1, options);
    r2 = new $4F7Xz(r2, options);
    return r1.intersects(r2, options);
};
module.exports = $ff0b302dd979be82$var$intersects;

});

parcelRequire.register("9QGcz", function(module, exports) {
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.

var $5R6Au = parcelRequire("5R6Au");

var $b7QMB = parcelRequire("b7QMB");
module.exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$b7QMB(a, b, options));
    for (const version of v){
        const included = $5R6Au(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push("*");
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(" || ");
    const original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

});

parcelRequire.register("6nO3Y", function(module, exports) {

var $4F7Xz = parcelRequire("4F7Xz");

var $5fzkR = parcelRequire("5fzkR");
const { ANY: $4a5bb988105271bd$var$ANY } = $5fzkR;

var $5R6Au = parcelRequire("5R6Au");

var $b7QMB = parcelRequire("b7QMB");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $4a5bb988105271bd$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $4F7Xz(sub, options);
    dom = new $4F7Xz(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $4a5bb988105271bd$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $4a5bb988105271bd$var$minimumVersionWithPreRelease = [
    new $5fzkR(">=0.0.0-0")
];
const $4a5bb988105271bd$var$minimumVersion = [
    new $5fzkR(">=0.0.0")
];
const $4a5bb988105271bd$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $4a5bb988105271bd$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) return true;
        else if (options.includePrerelease) sub = $4a5bb988105271bd$var$minimumVersionWithPreRelease;
        else sub = $4a5bb988105271bd$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $4a5bb988105271bd$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === ">" || c.operator === ">=") gt = $4a5bb988105271bd$var$higherGT(gt, c, options);
        else if (c.operator === "<" || c.operator === "<=") lt = $4a5bb988105271bd$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $b7QMB(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$5R6Au(eq, String(gt), options)) return null;
        if (lt && !$5R6Au(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$5R6Au(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
        hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === ">" || c.operator === ">=") {
                higher = $4a5bb988105271bd$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === ">=" && !$5R6Au(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === "<" || c.operator === "<=") {
                lower = $4a5bb988105271bd$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === "<=" && !$5R6Au(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $4a5bb988105271bd$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $b7QMB(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $4a5bb988105271bd$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $b7QMB(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
module.exports = $4a5bb988105271bd$var$subset;

});






parcelRequire.register("8yEY0", function(module, exports) {
"use strict";
var $63b146dc3aa128a7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubscribeBlockTracker = void 0;

const $63b146dc3aa128a7$var$json_rpc_random_id_1 = $63b146dc3aa128a7$var$__importDefault((parcelRequire("gCr7l")));

var $liQ5X = parcelRequire("liQ5X");
const $63b146dc3aa128a7$var$createRandomId = (0, $63b146dc3aa128a7$var$json_rpc_random_id_1.default)();
class $63b146dc3aa128a7$var$SubscribeBlockTracker extends $liQ5X.BaseBlockTracker {
    constructor(opts = {}){
        // parse + validate args
        if (!opts.provider) throw new Error("SubscribeBlockTracker - no provider specified.");
        // BaseBlockTracker constructor
        super(opts);
        // config
        this._provider = opts.provider;
        this._subscriptionId = null;
    }
    async checkForLatestBlock() {
        return await this.getLatestBlock();
    }
    async _start() {
        if (this._subscriptionId === undefined || this._subscriptionId === null) try {
            const blockNumber = await this._call("eth_blockNumber");
            this._subscriptionId = await this._call("eth_subscribe", "newHeads");
            this._provider.on("data", this._handleSubData.bind(this));
            this._newPotentialLatest(blockNumber);
        } catch (e) {
            this.emit("error", e);
        }
    }
    async _end() {
        if (this._subscriptionId !== null && this._subscriptionId !== undefined) try {
            await this._call("eth_unsubscribe", this._subscriptionId);
            this._subscriptionId = null;
        } catch (e) {
            this.emit("error", e);
        }
    }
    _call(method, ...params) {
        return new Promise((resolve, reject)=>{
            this._provider.sendAsync({
                id: $63b146dc3aa128a7$var$createRandomId(),
                method: method,
                params: params,
                jsonrpc: "2.0"
            }, (err, res)=>{
                if (err) reject(err);
                else resolve(res.result);
            });
        });
    }
    _handleSubData(_, response) {
        var _a;
        if (response.method === "eth_subscription" && ((_a = response.params) === null || _a === void 0 ? void 0 : _a.subscription) === this._subscriptionId) this._newPotentialLatest(response.params.result.number);
    }
}
module.exports.SubscribeBlockTracker = $63b146dc3aa128a7$var$SubscribeBlockTracker;

});

parcelRequire.register("e2LHQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRequire.register("ellgK", function(module, exports) {

var $e5MJz = parcelRequire("e5MJz");
var $a713867bdd3b58cc$require$SafeEventEmitter = $e5MJz.default;

var $7Qse7 = parcelRequire("7Qse7");
var $a713867bdd3b58cc$require$createAsyncMiddleware = $7Qse7.createAsyncMiddleware;
var $a713867bdd3b58cc$require$createScaffoldMiddleware = $7Qse7.createScaffoldMiddleware;

var $1vVYc = parcelRequire("1vVYc");

var $5nre7 = parcelRequire("5nre7");
var $a713867bdd3b58cc$require$unsafeRandomBytes = $5nre7.unsafeRandomBytes;
var $a713867bdd3b58cc$require$incrementHexInt = $5nre7.incrementHexInt;

var $iAHBh = parcelRequire("iAHBh");
module.exports = $a713867bdd3b58cc$var$createSubscriptionMiddleware;
function $a713867bdd3b58cc$var$createSubscriptionMiddleware({ blockTracker: blockTracker, provider: provider }) {
    // state and utilities for handling subscriptions
    const subscriptions = {};
    const filterManager = $1vVYc({
        blockTracker: blockTracker,
        provider: provider
    });
    // internal flag
    let isDestroyed = false;
    // create subscriptionManager api object
    const events = new $a713867bdd3b58cc$require$SafeEventEmitter();
    const middleware = $a713867bdd3b58cc$require$createScaffoldMiddleware({
        eth_subscribe: $a713867bdd3b58cc$require$createAsyncMiddleware(subscribe),
        eth_unsubscribe: $a713867bdd3b58cc$require$createAsyncMiddleware(unsubscribe)
    });
    middleware.destroy = destroy;
    return {
        events: events,
        middleware: middleware
    };
    async function subscribe(req, res) {
        if (isDestroyed) throw new Error("SubscriptionManager - attempting to use after destroying");
        const subscriptionType = req.params[0];
        // subId is 16 byte hex string
        const subId = $a713867bdd3b58cc$require$unsafeRandomBytes(16);
        // create sub
        let sub;
        switch(subscriptionType){
            case "newHeads":
                sub = createSubNewHeads({
                    subId: subId
                });
                break;
            case "logs":
                const filterParams = req.params[1];
                const filter = await filterManager.newLogFilter(filterParams);
                sub = createSubFromFilter({
                    subId: subId,
                    filter: filter
                });
                break;
            default:
                throw new Error(`SubscriptionManager - unsupported subscription type "${subscriptionType}"`);
        }
        subscriptions[subId] = sub;
        res.result = subId;
        return;
        function createSubNewHeads({ subId: subId }) {
            const sub = {
                type: subscriptionType,
                destroy: async ()=>{
                    blockTracker.removeListener("sync", sub.update);
                },
                update: async ({ oldBlock: oldBlock, newBlock: newBlock })=>{
                    // for newHeads
                    const toBlock = newBlock;
                    const fromBlock = $a713867bdd3b58cc$require$incrementHexInt(oldBlock);
                    const rawBlocks = await $iAHBh({
                        provider: provider,
                        fromBlock: fromBlock,
                        toBlock: toBlock
                    });
                    const results = rawBlocks.map($a713867bdd3b58cc$var$normalizeBlock).filter((block)=>block !== null);
                    results.forEach((value)=>{
                        _emitSubscriptionResult(subId, value);
                    });
                }
            };
            // check for subscription updates on new block
            blockTracker.on("sync", sub.update);
            return sub;
        }
        function createSubFromFilter({ subId: subId, filter: filter }) {
            filter.on("update", (result)=>_emitSubscriptionResult(subId, result));
            const sub = {
                type: subscriptionType,
                destroy: async ()=>{
                    return await filterManager.uninstallFilter(filter.idHex);
                }
            };
            return sub;
        }
    }
    async function unsubscribe(req, res) {
        if (isDestroyed) throw new Error("SubscriptionManager - attempting to use after destroying");
        const id = req.params[0];
        const subscription = subscriptions[id];
        // if missing, return "false" to indicate it was not removed
        if (!subscription) {
            res.result = false;
            return;
        }
        // cleanup subscription
        delete subscriptions[id];
        await subscription.destroy();
        res.result = true;
    }
    function _emitSubscriptionResult(filterIdHex, value) {
        events.emit("notification", {
            jsonrpc: "2.0",
            method: "eth_subscription",
            params: {
                subscription: filterIdHex,
                result: value
            }
        });
    }
    function destroy() {
        events.removeAllListeners();
        for(const id in subscriptions){
            subscriptions[id].destroy();
            delete subscriptions[id];
        }
        isDestroyed = true;
    }
}
function $a713867bdd3b58cc$var$normalizeBlock(block) {
    if (block === null || block === undefined) return null;
    return {
        hash: block.hash,
        parentHash: block.parentHash,
        sha3Uncles: block.sha3Uncles,
        miner: block.miner,
        stateRoot: block.stateRoot,
        transactionsRoot: block.transactionsRoot,
        receiptsRoot: block.receiptsRoot,
        logsBloom: block.logsBloom,
        difficulty: block.difficulty,
        number: block.number,
        gasLimit: block.gasLimit,
        gasUsed: block.gasUsed,
        nonce: block.nonce,
        mixHash: block.mixHash,
        timestamp: block.timestamp,
        extraData: block.extraData
    };
}

});
parcelRequire.register("7Qse7", function(module, exports) {
"use strict";
var $5b6348f487e5c834$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5b6348f487e5c834$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5b6348f487e5c834$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5b6348f487e5c834$var$__exportStar((parcelRequire("6qzwt")), module.exports);

$5b6348f487e5c834$var$__exportStar((parcelRequire("hVM3P")), module.exports);

$5b6348f487e5c834$var$__exportStar((parcelRequire("jyTEY")), module.exports);

$5b6348f487e5c834$var$__exportStar((parcelRequire("Rwczo")), module.exports);

$5b6348f487e5c834$var$__exportStar((parcelRequire("lNrQU")), module.exports);

$5b6348f487e5c834$var$__exportStar((parcelRequire("gW4ru")), module.exports);

});
parcelRequire.register("6qzwt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIdRemapMiddleware = void 0;

var $Rwczo = parcelRequire("Rwczo");
function $4ae0b9de4d358ea8$var$createIdRemapMiddleware() {
    return (req, res, next, _end)=>{
        const originalId = req.id;
        const newId = $Rwczo.getUniqueId();
        req.id = newId;
        res.id = newId;
        next((done)=>{
            req.id = originalId;
            res.id = originalId;
            done();
        });
    };
}
module.exports.createIdRemapMiddleware = $4ae0b9de4d358ea8$var$createIdRemapMiddleware;

});
parcelRequire.register("Rwczo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUniqueId = void 0;
// uint32 (two's complement) max
// more conservative than Number.MAX_SAFE_INTEGER
const $0a0dedf26b11e5de$var$MAX = 4294967295;
let $0a0dedf26b11e5de$var$idCounter = Math.floor(Math.random() * $0a0dedf26b11e5de$var$MAX);
function $0a0dedf26b11e5de$var$getUniqueId() {
    $0a0dedf26b11e5de$var$idCounter = ($0a0dedf26b11e5de$var$idCounter + 1) % $0a0dedf26b11e5de$var$MAX;
    return $0a0dedf26b11e5de$var$idCounter;
}
module.exports.getUniqueId = $0a0dedf26b11e5de$var$getUniqueId;

});


parcelRequire.register("hVM3P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createAsyncMiddleware = void 0;
/**
 * JsonRpcEngine only accepts callback-based middleware directly.
 * createAsyncMiddleware exists to enable consumers to pass in async middleware
 * functions.
 *
 * Async middleware have no "end" function. Instead, they "end" if they return
 * without calling "next". Rather than passing in explicit return handlers,
 * async middleware can simply await "next", and perform operations on the
 * response object when execution resumes.
 *
 * To accomplish this, createAsyncMiddleware passes the async middleware a
 * wrapped "next" function. That function calls the internal JsonRpcEngine
 * "next" function with a return handler that resolves a promise when called.
 *
 * The return handler will always be called. Its resolution of the promise
 * enables the control flow described above.
 */ function $d0dd0a641f7615d2$var$createAsyncMiddleware(asyncMiddleware) {
    return async (req, res, next, end)=>{
        // nextPromise is the key to the implementation
        // it is resolved by the return handler passed to the
        // "next" function
        let resolveNextPromise;
        const nextPromise = new Promise((resolve)=>{
            resolveNextPromise = resolve;
        });
        let returnHandlerCallback = null;
        let nextWasCalled = false;
        // This will be called by the consumer's async middleware.
        const asyncNext = async ()=>{
            nextWasCalled = true;
            // We pass a return handler to next(). When it is called by the engine,
            // the consumer's async middleware will resume executing.
            // eslint-disable-next-line node/callback-return
            next((runReturnHandlersCallback)=>{
                // This callback comes from JsonRpcEngine._runReturnHandlers
                returnHandlerCallback = runReturnHandlersCallback;
                resolveNextPromise();
            });
            await nextPromise;
        };
        try {
            await asyncMiddleware(req, res, asyncNext);
            if (nextWasCalled) {
                await nextPromise; // we must wait until the return handler is called
                returnHandlerCallback(null);
            } else end(null);
        } catch (error) {
            if (returnHandlerCallback) returnHandlerCallback(error);
            else end(error);
        }
    };
}
module.exports.createAsyncMiddleware = $d0dd0a641f7615d2$var$createAsyncMiddleware;

});

parcelRequire.register("jyTEY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createScaffoldMiddleware = void 0;
function $e3dc5e3017326d93$var$createScaffoldMiddleware(handlers) {
    return (req, res, next, end)=>{
        const handler = handlers[req.method];
        // if no handler, return
        if (handler === undefined) return next();
        // if handler is fn, call as middleware
        if (typeof handler === "function") return handler(req, res, next, end);
        // if handler is some other value, use as result
        res.result = handler;
        return end();
    };
}
module.exports.createScaffoldMiddleware = $e3dc5e3017326d93$var$createScaffoldMiddleware;

});

parcelRequire.register("lNrQU", function(module, exports) {
"use strict";
var $fde3c77ef9f84b84$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcEngine = void 0;

const $fde3c77ef9f84b84$var$safe_event_emitter_1 = $fde3c77ef9f84b84$var$__importDefault((parcelRequire("e5MJz")));

var $5Who5 = parcelRequire("5Who5");
/**
 * A JSON-RPC request and response processor.
 * Give it a stack of middleware, pass it requests, and get back responses.
 */ class $fde3c77ef9f84b84$var$JsonRpcEngine extends $fde3c77ef9f84b84$var$safe_event_emitter_1.default {
    constructor(){
        super();
        this._middleware = [];
    }
    /**
     * Add a middleware function to the engine's middleware stack.
     *
     * @param middleware - The middleware function to add.
     */ push(middleware) {
        this._middleware.push(middleware);
    }
    handle(req, cb) {
        if (cb && typeof cb !== "function") throw new Error('"callback" must be a function if provided.');
        if (Array.isArray(req)) {
            if (cb) return this._handleBatch(req, cb);
            return this._handleBatch(req);
        }
        if (cb) return this._handle(req, cb);
        return this._promiseHandle(req);
    }
    /**
     * Returns this engine as a middleware function that can be pushed to other
     * engines.
     *
     * @returns This engine as a middleware function.
     */ asMiddleware() {
        return async (req, res, next, end)=>{
            try {
                const [middlewareError, isComplete, returnHandlers] = await $fde3c77ef9f84b84$var$JsonRpcEngine._runAllMiddleware(req, res, this._middleware);
                if (isComplete) {
                    await $fde3c77ef9f84b84$var$JsonRpcEngine._runReturnHandlers(returnHandlers);
                    return end(middlewareError);
                }
                return next(async (handlerCallback)=>{
                    try {
                        await $fde3c77ef9f84b84$var$JsonRpcEngine._runReturnHandlers(returnHandlers);
                    } catch (error) {
                        return handlerCallback(error);
                    }
                    return handlerCallback();
                });
            } catch (error) {
                return end(error);
            }
        };
    }
    async _handleBatch(reqs, cb) {
        // The order here is important
        try {
            // 2. Wait for all requests to finish, or throw on some kind of fatal
            // error
            const responses = await Promise.all(// 1. Begin executing each request in the order received
            reqs.map(this._promiseHandle.bind(this)));
            // 3. Return batch response
            if (cb) return cb(null, responses);
            return responses;
        } catch (error) {
            if (cb) return cb(error);
            throw error;
        }
    }
    /**
     * A promise-wrapped _handle.
     */ _promiseHandle(req) {
        return new Promise((resolve)=>{
            this._handle(req, (_err, res)=>{
                // There will always be a response, and it will always have any error
                // that is caught and propagated.
                resolve(res);
            });
        });
    }
    /**
     * Ensures that the request object is valid, processes it, and passes any
     * error and the response object to the given callback.
     *
     * Does not reject.
     */ async _handle(callerReq, cb) {
        if (!callerReq || Array.isArray(callerReq) || typeof callerReq !== "object") {
            const error = new $5Who5.EthereumRpcError($5Who5.errorCodes.rpc.invalidRequest, `Requests must be plain objects. Received: ${typeof callerReq}`, {
                request: callerReq
            });
            return cb(error, {
                id: undefined,
                jsonrpc: "2.0",
                error: error
            });
        }
        if (typeof callerReq.method !== "string") {
            const error = new $5Who5.EthereumRpcError($5Who5.errorCodes.rpc.invalidRequest, `Must specify a string method. Received: ${typeof callerReq.method}`, {
                request: callerReq
            });
            return cb(error, {
                id: callerReq.id,
                jsonrpc: "2.0",
                error: error
            });
        }
        const req = Object.assign({}, callerReq);
        const res = {
            id: req.id,
            jsonrpc: req.jsonrpc
        };
        let error = null;
        try {
            await this._processRequest(req, res);
        } catch (_error) {
            // A request handler error, a re-thrown middleware error, or something
            // unexpected.
            error = _error;
        }
        if (error) {
            // Ensure no result is present on an errored response
            delete res.result;
            if (!res.error) res.error = $5Who5.serializeError(error);
        }
        return cb(error, res);
    }
    /**
     * For the given request and response, runs all middleware and their return
     * handlers, if any, and ensures that internal request processing semantics
     * are satisfied.
     */ async _processRequest(req, res) {
        const [error, isComplete, returnHandlers] = await $fde3c77ef9f84b84$var$JsonRpcEngine._runAllMiddleware(req, res, this._middleware);
        // Throw if "end" was not called, or if the response has neither a result
        // nor an error.
        $fde3c77ef9f84b84$var$JsonRpcEngine._checkForCompletion(req, res, isComplete);
        // The return handlers should run even if an error was encountered during
        // middleware processing.
        await $fde3c77ef9f84b84$var$JsonRpcEngine._runReturnHandlers(returnHandlers);
        // Now we re-throw the middleware processing error, if any, to catch it
        // further up the call chain.
        if (error) throw error;
    }
    /**
     * Serially executes the given stack of middleware.
     *
     * @returns An array of any error encountered during middleware execution,
     * a boolean indicating whether the request was completed, and an array of
     * middleware-defined return handlers.
     */ static async _runAllMiddleware(req, res, middlewareStack) {
        const returnHandlers = [];
        let error = null;
        let isComplete = false;
        // Go down stack of middleware, call and collect optional returnHandlers
        for (const middleware of middlewareStack){
            [error, isComplete] = await $fde3c77ef9f84b84$var$JsonRpcEngine._runMiddleware(req, res, middleware, returnHandlers);
            if (isComplete) break;
        }
        return [
            error,
            isComplete,
            returnHandlers.reverse()
        ];
    }
    /**
     * Runs an individual middleware.
     *
     * @returns An array of any error encountered during middleware exection,
     * and a boolean indicating whether the request should end.
     */ static _runMiddleware(req, res, middleware, returnHandlers) {
        return new Promise((resolve)=>{
            const end = (err)=>{
                const error = err || res.error;
                if (error) res.error = $5Who5.serializeError(error);
                // True indicates that the request should end
                resolve([
                    error,
                    true
                ]);
            };
            const next = (returnHandler)=>{
                if (res.error) end(res.error);
                else {
                    if (returnHandler) {
                        if (typeof returnHandler !== "function") end(new $5Who5.EthereumRpcError($5Who5.errorCodes.rpc.internal, `JsonRpcEngine: "next" return handlers must be functions. ` + `Received "${typeof returnHandler}" for request:\n${$fde3c77ef9f84b84$var$jsonify(req)}`, {
                            request: req
                        }));
                        returnHandlers.push(returnHandler);
                    }
                    // False indicates that the request should not end
                    resolve([
                        null,
                        false
                    ]);
                }
            };
            try {
                middleware(req, res, next, end);
            } catch (error) {
                end(error);
            }
        });
    }
    /**
     * Serially executes array of return handlers. The request and response are
     * assumed to be in their scope.
     */ static async _runReturnHandlers(handlers) {
        for (const handler of handlers)await new Promise((resolve, reject)=>{
            handler((err)=>err ? reject(err) : resolve());
        });
    }
    /**
     * Throws an error if the response has neither a result nor an error, or if
     * the "isComplete" flag is falsy.
     */ static _checkForCompletion(req, res, isComplete) {
        if (!("result" in res) && !("error" in res)) throw new $5Who5.EthereumRpcError($5Who5.errorCodes.rpc.internal, `JsonRpcEngine: Response has no error or result for request:\n${$fde3c77ef9f84b84$var$jsonify(req)}`, {
            request: req
        });
        if (!isComplete) throw new $5Who5.EthereumRpcError($5Who5.errorCodes.rpc.internal, `JsonRpcEngine: Nothing ended request:\n${$fde3c77ef9f84b84$var$jsonify(req)}`, {
            request: req
        });
    }
}
module.exports.JsonRpcEngine = $fde3c77ef9f84b84$var$JsonRpcEngine;
function $fde3c77ef9f84b84$var$jsonify(request) {
    return JSON.stringify(request, null, 2);
}

});

parcelRequire.register("gW4ru", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeMiddleware = void 0;

var $lNrQU = parcelRequire("lNrQU");
function $c545824bb7ebd85d$var$mergeMiddleware(middlewareStack) {
    const engine = new $lNrQU.JsonRpcEngine();
    middlewareStack.forEach((middleware)=>engine.push(middleware));
    return engine.asMiddleware();
}
module.exports.mergeMiddleware = $c545824bb7ebd85d$var$mergeMiddleware;

});


parcelRequire.register("1vVYc", function(module, exports) {
parcelRequire("6LT7r");
var $hvf1I = parcelRequire("hvf1I");
var $11a5a74f7ef7c044$require$Mutex = $hvf1I.default;

var $7Qse7 = parcelRequire("7Qse7");
var $11a5a74f7ef7c044$require$createAsyncMiddleware = $7Qse7.createAsyncMiddleware;
var $11a5a74f7ef7c044$require$createScaffoldMiddleware = $7Qse7.createScaffoldMiddleware;

var $bA71x = parcelRequire("bA71x");

var $bWRmt = parcelRequire("bWRmt");

var $ivOGw = parcelRequire("ivOGw");

var $5nre7 = parcelRequire("5nre7");
var $11a5a74f7ef7c044$require$intToHex = $5nre7.intToHex;
var $11a5a74f7ef7c044$require$hexToInt = $5nre7.hexToInt;
module.exports = $11a5a74f7ef7c044$var$createEthFilterMiddleware;
function $11a5a74f7ef7c044$var$createEthFilterMiddleware({ blockTracker: blockTracker, provider: provider }) {
    // create filter collection
    let filterIndex = 0;
    let filters = {};
    // create update mutex
    const mutex = new $11a5a74f7ef7c044$require$Mutex();
    const waitForFree = $11a5a74f7ef7c044$var$mutexMiddlewareWrapper({
        mutex: mutex
    });
    const middleware = $11a5a74f7ef7c044$require$createScaffoldMiddleware({
        // install filters
        eth_newFilter: waitForFree($11a5a74f7ef7c044$var$toFilterCreationMiddleware(newLogFilter)),
        eth_newBlockFilter: waitForFree($11a5a74f7ef7c044$var$toFilterCreationMiddleware(newBlockFilter)),
        eth_newPendingTransactionFilter: waitForFree($11a5a74f7ef7c044$var$toFilterCreationMiddleware(newPendingTransactionFilter)),
        // uninstall filters
        eth_uninstallFilter: waitForFree($11a5a74f7ef7c044$var$toAsyncRpcMiddleware(uninstallFilterHandler)),
        // checking filter changes
        eth_getFilterChanges: waitForFree($11a5a74f7ef7c044$var$toAsyncRpcMiddleware(getFilterChanges)),
        eth_getFilterLogs: waitForFree($11a5a74f7ef7c044$var$toAsyncRpcMiddleware(getFilterLogs))
    });
    // setup filter updating and destroy handler
    const filterUpdater = async ({ oldBlock: oldBlock, newBlock: newBlock })=>{
        if (filters.length === 0) return;
        // lock update reads
        const releaseLock = await mutex.acquire();
        try {
            // process all filters in parallel
            await Promise.all($11a5a74f7ef7c044$var$objValues(filters).map(async (filter)=>{
                try {
                    await filter.update({
                        oldBlock: oldBlock,
                        newBlock: newBlock
                    });
                } catch (err) {
                    // handle each error individually so filter update errors don't affect other filters
                    console.error(err);
                }
            }));
        } catch (err) {
            // log error so we don't skip the releaseLock
            console.error(err);
        }
        // unlock update reads
        releaseLock();
    };
    // expose filter methods directly
    middleware.newLogFilter = newLogFilter;
    middleware.newBlockFilter = newBlockFilter;
    middleware.newPendingTransactionFilter = newPendingTransactionFilter;
    middleware.uninstallFilter = uninstallFilterHandler;
    middleware.getFilterChanges = getFilterChanges;
    middleware.getFilterLogs = getFilterLogs;
    // expose destroy method for cleanup
    middleware.destroy = ()=>{
        uninstallAllFilters();
    };
    return middleware;
    //
    // new filters
    //
    async function newLogFilter(params) {
        const filter = new $bA71x({
            provider: provider,
            params: params
        });
        const filterIndex = await installFilter(filter);
        return filter;
    }
    async function newBlockFilter() {
        const filter = new $bWRmt({
            provider: provider
        });
        const filterIndex = await installFilter(filter);
        return filter;
    }
    async function newPendingTransactionFilter() {
        const filter = new $ivOGw({
            provider: provider
        });
        const filterIndex = await installFilter(filter);
        return filter;
    }
    //
    // get filter changes
    //
    async function getFilterChanges(filterIndexHex) {
        const filterIndex = $11a5a74f7ef7c044$require$hexToInt(filterIndexHex);
        const filter = filters[filterIndex];
        if (!filter) throw new Error(`No filter for index "${filterIndex}"`);
        const results = filter.getChangesAndClear();
        return results;
    }
    async function getFilterLogs(filterIndexHex) {
        const filterIndex = $11a5a74f7ef7c044$require$hexToInt(filterIndexHex);
        const filter = filters[filterIndex];
        if (!filter) throw new Error(`No filter for index "${filterIndex}"`);
        // only return results for log filters
        let results = [];
        if (filter.type === "log") results = filter.getAllResults();
        return results;
    }
    //
    // remove filters
    //
    async function uninstallFilterHandler(filterIndexHex) {
        // check filter exists
        const filterIndex = $11a5a74f7ef7c044$require$hexToInt(filterIndexHex);
        const filter = filters[filterIndex];
        const result = Boolean(filter);
        // uninstall filter
        if (result) await uninstallFilter(filterIndex);
        return result;
    }
    //
    // utils
    //
    async function installFilter(filter) {
        const prevFilterCount = $11a5a74f7ef7c044$var$objValues(filters).length;
        // install filter
        const currentBlock = await blockTracker.getLatestBlock();
        await filter.initialize({
            currentBlock: currentBlock
        });
        filterIndex++;
        filters[filterIndex] = filter;
        filter.id = filterIndex;
        filter.idHex = $11a5a74f7ef7c044$require$intToHex(filterIndex);
        // update block tracker subs
        const newFilterCount = $11a5a74f7ef7c044$var$objValues(filters).length;
        updateBlockTrackerSubs({
            prevFilterCount: prevFilterCount,
            newFilterCount: newFilterCount
        });
        return filterIndex;
    }
    async function uninstallFilter(filterIndex) {
        const prevFilterCount = $11a5a74f7ef7c044$var$objValues(filters).length;
        delete filters[filterIndex];
        // update block tracker subs
        const newFilterCount = $11a5a74f7ef7c044$var$objValues(filters).length;
        updateBlockTrackerSubs({
            prevFilterCount: prevFilterCount,
            newFilterCount: newFilterCount
        });
    }
    async function uninstallAllFilters() {
        const prevFilterCount = $11a5a74f7ef7c044$var$objValues(filters).length;
        filters = {};
        // update block tracker subs
        updateBlockTrackerSubs({
            prevFilterCount: prevFilterCount,
            newFilterCount: 0
        });
    }
    function updateBlockTrackerSubs({ prevFilterCount: prevFilterCount, newFilterCount: newFilterCount }) {
        // subscribe
        if (prevFilterCount === 0 && newFilterCount > 0) {
            blockTracker.on("sync", filterUpdater);
            return;
        }
        // unsubscribe
        if (prevFilterCount > 0 && newFilterCount === 0) {
            blockTracker.removeListener("sync", filterUpdater);
            return;
        }
    }
}
// helper for turning filter constructors into rpc middleware
function $11a5a74f7ef7c044$var$toFilterCreationMiddleware(createFilterFn) {
    return $11a5a74f7ef7c044$var$toAsyncRpcMiddleware(async (...args)=>{
        const filter = await createFilterFn(...args);
        const result = $11a5a74f7ef7c044$require$intToHex(filter.id);
        return result;
    });
}
// helper for pulling out req.params and setting res.result
function $11a5a74f7ef7c044$var$toAsyncRpcMiddleware(asyncFn) {
    return $11a5a74f7ef7c044$require$createAsyncMiddleware(async (req, res)=>{
        const result = await asyncFn.apply(null, req.params);
        res.result = result;
    });
}
function $11a5a74f7ef7c044$var$mutexMiddlewareWrapper({ mutex: mutex }) {
    return (middleware)=>{
        return async (req, res, next, end)=>{
            // wait for mutex available
            // we can release immediately because
            // we just need to make sure updates aren't active
            const releaseLock = await mutex.acquire();
            releaseLock();
            middleware(req, res, next, end);
        };
    };
}
function $11a5a74f7ef7c044$var$objValues(obj, fn) {
    const values = [];
    for(let key in obj)values.push(obj[key]);
    return values;
}

});
parcelRequire.register("6LT7r", function(module, exports) {

$parcel$export(module.exports, "Mutex", () => (parcelRequire("hvf1I")).default);

var $hvf1I = parcelRequire("hvf1I");

var $3FUcs = parcelRequire("3FUcs");

var $nTHQO = parcelRequire("nTHQO");

});
parcelRequire.register("hvf1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe0fce7176d8e00$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $3FUcs = parcelRequire("3FUcs");
var $cbe0fce7176d8e00$var$Mutex = /** @class */ function() {
    function Mutex() {
        this._semaphore = new (0, $3FUcs.default)(1);
    }
    Mutex.prototype.acquire = function() {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var _a, releaser;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this._semaphore.acquire()
                        ];
                    case 1:
                        _a = _b.sent(), releaser = _a[1];
                        return [
                            2 /*return*/ ,
                            releaser
                        ];
                }
            });
        });
    };
    Mutex.prototype.runExclusive = function(callback) {
        return this._semaphore.runExclusive(function() {
            return callback();
        });
    };
    Mutex.prototype.isLocked = function() {
        return this._semaphore.isLocked();
    };
    Mutex.prototype.release = function() {
        this._semaphore.release();
    };
    return Mutex;
}();
var $cbe0fce7176d8e00$export$2e2bcd8739ae039 = $cbe0fce7176d8e00$var$Mutex;

});
parcelRequire.register("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};

});

parcelRequire.register("3FUcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad0cb8d6c5b0ed2$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");
var $2ad0cb8d6c5b0ed2$var$Semaphore = /** @class */ function() {
    function Semaphore(_maxConcurrency) {
        this._maxConcurrency = _maxConcurrency;
        this._queue = [];
        if (_maxConcurrency <= 0) throw new Error("semaphore must be initialized to a positive value");
        this._value = _maxConcurrency;
    }
    Semaphore.prototype.acquire = function() {
        var _this = this;
        var locked = this.isLocked();
        var ticket = new Promise(function(r) {
            return _this._queue.push(r);
        });
        if (!locked) this._dispatch();
        return ticket;
    };
    Semaphore.prototype.runExclusive = function(callback) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
            var _a, value, release;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.acquire()
                        ];
                    case 1:
                        _a = _b.sent(), value = _a[0], release = _a[1];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([
                            2,
                            ,
                            4,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            callback(value)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                    case 4:
                        release();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Semaphore.prototype.isLocked = function() {
        return this._value <= 0;
    };
    Semaphore.prototype.release = function() {
        if (this._maxConcurrency > 1) throw new Error("this method is unavailabel on semaphores with concurrency > 1; use the scoped release returned by acquire instead");
        if (this._currentReleaser) {
            var releaser = this._currentReleaser;
            this._currentReleaser = undefined;
            releaser();
        }
    };
    Semaphore.prototype._dispatch = function() {
        var _this = this;
        var nextConsumer = this._queue.shift();
        if (!nextConsumer) return;
        var released = false;
        this._currentReleaser = function() {
            if (released) return;
            released = true;
            _this._value++;
            _this._dispatch();
        };
        nextConsumer([
            this._value--,
            this._currentReleaser
        ]);
    };
    return Semaphore;
}();
var $2ad0cb8d6c5b0ed2$export$2e2bcd8739ae039 = $2ad0cb8d6c5b0ed2$var$Semaphore;

});


parcelRequire.register("nTHQO", function(module, exports) {

var $7WQrb = parcelRequire("7WQrb");
function $047d5c33b3ea7900$export$e86e19342bc4850e(sync, timeout, timeoutError) {
    var _this = this;
    if (timeoutError === void 0) timeoutError = new Error("timeout");
    return {
        acquire: function() {
            return new Promise(function(resolve, reject) {
                return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
                    var isTimeout, ticket, release;
                    return (0, $7WQrb.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                isTimeout = false;
                                setTimeout(function() {
                                    isTimeout = true;
                                    reject(timeoutError);
                                }, timeout);
                                return [
                                    4 /*yield*/ ,
                                    sync.acquire()
                                ];
                            case 1:
                                ticket = _a.sent();
                                if (isTimeout) {
                                    release = Array.isArray(ticket) ? ticket[1] : ticket;
                                    release();
                                } else resolve(ticket);
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            });
        },
        runExclusive: function(callback) {
            return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
                var release, ticket;
                return (0, $7WQrb.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            release = function() {
                                return undefined;
                            };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([
                                1,
                                ,
                                7,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.acquire()
                            ];
                        case 2:
                            ticket = _a.sent();
                            if (!Array.isArray(ticket)) return [
                                3 /*break*/ ,
                                4
                            ];
                            release = ticket[1];
                            return [
                                4 /*yield*/ ,
                                callback(ticket[0])
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 4:
                            release = ticket;
                            return [
                                4 /*yield*/ ,
                                callback()
                            ];
                        case 5:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                        case 6:
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            release();
                            return [
                                7 /*endfinally*/ 
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        release: function() {
            sync.release();
        },
        isLocked: function() {
            return sync.isLocked();
        }
    };
}

});


parcelRequire.register("bA71x", function(module, exports) {

var $IaFfH = parcelRequire("IaFfH");

var $kZt26 = parcelRequire("kZt26");

var $fIdq3 = parcelRequire("fIdq3");

var $5nre7 = parcelRequire("5nre7");
var $86e8814def92cf21$require$bnToHex = $5nre7.bnToHex;
var $86e8814def92cf21$require$hexToInt = $5nre7.hexToInt;
var $86e8814def92cf21$require$incrementHexInt = $5nre7.incrementHexInt;
var $86e8814def92cf21$require$minBlockRef = $5nre7.minBlockRef;
var $86e8814def92cf21$require$blockRefIsNumber = $5nre7.blockRefIsNumber;
class $86e8814def92cf21$var$LogFilter extends $fIdq3 {
    constructor({ provider: provider, params: params }){
        super();
        this.type = "log";
        this.ethQuery = new $IaFfH(provider);
        this.params = Object.assign({
            fromBlock: "latest",
            toBlock: "latest",
            address: undefined,
            topics: []
        }, params);
        // normalize address parameter
        if (this.params.address) {
            // ensure array
            if (!Array.isArray(this.params.address)) this.params.address = [
                this.params.address
            ];
            // ensure lowercase
            this.params.address = this.params.address.map((address)=>address.toLowerCase());
        }
    }
    async initialize({ currentBlock: currentBlock }) {
        // resolve params.fromBlock
        let fromBlock = this.params.fromBlock;
        if ([
            "latest",
            "pending"
        ].includes(fromBlock)) fromBlock = currentBlock;
        if ("earliest" === fromBlock) fromBlock = "0x0";
        this.params.fromBlock = fromBlock;
        // set toBlock for initial lookup
        const toBlock = $86e8814def92cf21$require$minBlockRef(this.params.toBlock, currentBlock);
        const params = Object.assign({}, this.params, {
            toBlock: toBlock
        });
        // fetch logs and add to results
        const newLogs = await this._fetchLogs(params);
        this.addInitialResults(newLogs);
    }
    async update({ oldBlock: oldBlock, newBlock: newBlock }) {
        // configure params for this update
        const toBlock = newBlock;
        let fromBlock;
        // oldBlock is empty on first sync
        if (oldBlock) fromBlock = $86e8814def92cf21$require$incrementHexInt(oldBlock);
        else fromBlock = newBlock;
        // fetch logs
        const params = Object.assign({}, this.params, {
            fromBlock: fromBlock,
            toBlock: toBlock
        });
        const newLogs = await this._fetchLogs(params);
        const matchingLogs = newLogs.filter((log)=>this.matchLog(log));
        // add to results
        this.addResults(matchingLogs);
    }
    async _fetchLogs(params) {
        const newLogs = await $kZt26((cb)=>this.ethQuery.getLogs(params, cb))();
        // add to results
        return newLogs;
    }
    matchLog(log) {
        // check if block number in bounds:
        if ($86e8814def92cf21$require$hexToInt(this.params.fromBlock) >= $86e8814def92cf21$require$hexToInt(log.blockNumber)) return false;
        if ($86e8814def92cf21$require$blockRefIsNumber(this.params.toBlock) && $86e8814def92cf21$require$hexToInt(this.params.toBlock) <= $86e8814def92cf21$require$hexToInt(log.blockNumber)) return false;
        // address is correct:
        const normalizedLogAddress = log.address && log.address.toLowerCase();
        if (this.params.address && normalizedLogAddress && !this.params.address.includes(normalizedLogAddress)) return false;
        // topics match:
        // topics are position-dependant
        // topics can be nested to represent `or` [[a || b], c]
        // topics can be null, representing a wild card for that position
        const topicsMatch = this.params.topics.every((topicPattern, index)=>{
            // pattern is longer than actual topics
            let logTopic = log.topics[index];
            if (!logTopic) return false;
            logTopic = logTopic.toLowerCase();
            // normalize subTopics
            let subtopicsToMatch = Array.isArray(topicPattern) ? topicPattern : [
                topicPattern
            ];
            // check for wild card
            const subtopicsIncludeWildcard = subtopicsToMatch.includes(null);
            if (subtopicsIncludeWildcard) return true;
            subtopicsToMatch = subtopicsToMatch.map((topic)=>topic.toLowerCase());
            // check each possible matching topic
            const topicDoesMatch = subtopicsToMatch.includes(logTopic);
            return topicDoesMatch;
        });
        return topicsMatch;
    }
}
module.exports = $86e8814def92cf21$var$LogFilter;

});
parcelRequire.register("IaFfH", function(module, exports) {

var $h0kNM = parcelRequire("h0kNM");

const $084c61e5002f19e0$var$createRandomId = (parcelRequire("gCr7l"))();
module.exports = $084c61e5002f19e0$var$EthQuery;
function $084c61e5002f19e0$var$EthQuery(provider) {
    const self = this;
    self.currentProvider = provider;
}
//
// base queries
//
// default block
$084c61e5002f19e0$var$EthQuery.prototype.getBalance = $084c61e5002f19e0$var$generateFnWithDefaultBlockFor(2, "eth_getBalance");
$084c61e5002f19e0$var$EthQuery.prototype.getCode = $084c61e5002f19e0$var$generateFnWithDefaultBlockFor(2, "eth_getCode");
$084c61e5002f19e0$var$EthQuery.prototype.getTransactionCount = $084c61e5002f19e0$var$generateFnWithDefaultBlockFor(2, "eth_getTransactionCount");
$084c61e5002f19e0$var$EthQuery.prototype.getStorageAt = $084c61e5002f19e0$var$generateFnWithDefaultBlockFor(3, "eth_getStorageAt");
$084c61e5002f19e0$var$EthQuery.prototype.call = $084c61e5002f19e0$var$generateFnWithDefaultBlockFor(2, "eth_call");
// standard
$084c61e5002f19e0$var$EthQuery.prototype.protocolVersion = $084c61e5002f19e0$var$generateFnFor("eth_protocolVersion");
$084c61e5002f19e0$var$EthQuery.prototype.syncing = $084c61e5002f19e0$var$generateFnFor("eth_syncing");
$084c61e5002f19e0$var$EthQuery.prototype.coinbase = $084c61e5002f19e0$var$generateFnFor("eth_coinbase");
$084c61e5002f19e0$var$EthQuery.prototype.mining = $084c61e5002f19e0$var$generateFnFor("eth_mining");
$084c61e5002f19e0$var$EthQuery.prototype.hashrate = $084c61e5002f19e0$var$generateFnFor("eth_hashrate");
$084c61e5002f19e0$var$EthQuery.prototype.gasPrice = $084c61e5002f19e0$var$generateFnFor("eth_gasPrice");
$084c61e5002f19e0$var$EthQuery.prototype.accounts = $084c61e5002f19e0$var$generateFnFor("eth_accounts");
$084c61e5002f19e0$var$EthQuery.prototype.blockNumber = $084c61e5002f19e0$var$generateFnFor("eth_blockNumber");
$084c61e5002f19e0$var$EthQuery.prototype.getBlockTransactionCountByHash = $084c61e5002f19e0$var$generateFnFor("eth_getBlockTransactionCountByHash");
$084c61e5002f19e0$var$EthQuery.prototype.getBlockTransactionCountByNumber = $084c61e5002f19e0$var$generateFnFor("eth_getBlockTransactionCountByNumber");
$084c61e5002f19e0$var$EthQuery.prototype.getUncleCountByBlockHash = $084c61e5002f19e0$var$generateFnFor("eth_getUncleCountByBlockHash");
$084c61e5002f19e0$var$EthQuery.prototype.getUncleCountByBlockNumber = $084c61e5002f19e0$var$generateFnFor("eth_getUncleCountByBlockNumber");
$084c61e5002f19e0$var$EthQuery.prototype.sign = $084c61e5002f19e0$var$generateFnFor("eth_sign");
$084c61e5002f19e0$var$EthQuery.prototype.sendTransaction = $084c61e5002f19e0$var$generateFnFor("eth_sendTransaction");
$084c61e5002f19e0$var$EthQuery.prototype.sendRawTransaction = $084c61e5002f19e0$var$generateFnFor("eth_sendRawTransaction");
$084c61e5002f19e0$var$EthQuery.prototype.estimateGas = $084c61e5002f19e0$var$generateFnFor("eth_estimateGas");
$084c61e5002f19e0$var$EthQuery.prototype.getBlockByHash = $084c61e5002f19e0$var$generateFnFor("eth_getBlockByHash");
$084c61e5002f19e0$var$EthQuery.prototype.getBlockByNumber = $084c61e5002f19e0$var$generateFnFor("eth_getBlockByNumber");
$084c61e5002f19e0$var$EthQuery.prototype.getTransactionByHash = $084c61e5002f19e0$var$generateFnFor("eth_getTransactionByHash");
$084c61e5002f19e0$var$EthQuery.prototype.getTransactionByBlockHashAndIndex = $084c61e5002f19e0$var$generateFnFor("eth_getTransactionByBlockHashAndIndex");
$084c61e5002f19e0$var$EthQuery.prototype.getTransactionByBlockNumberAndIndex = $084c61e5002f19e0$var$generateFnFor("eth_getTransactionByBlockNumberAndIndex");
$084c61e5002f19e0$var$EthQuery.prototype.getTransactionReceipt = $084c61e5002f19e0$var$generateFnFor("eth_getTransactionReceipt");
$084c61e5002f19e0$var$EthQuery.prototype.getUncleByBlockHashAndIndex = $084c61e5002f19e0$var$generateFnFor("eth_getUncleByBlockHashAndIndex");
$084c61e5002f19e0$var$EthQuery.prototype.getUncleByBlockNumberAndIndex = $084c61e5002f19e0$var$generateFnFor("eth_getUncleByBlockNumberAndIndex");
$084c61e5002f19e0$var$EthQuery.prototype.getCompilers = $084c61e5002f19e0$var$generateFnFor("eth_getCompilers");
$084c61e5002f19e0$var$EthQuery.prototype.compileLLL = $084c61e5002f19e0$var$generateFnFor("eth_compileLLL");
$084c61e5002f19e0$var$EthQuery.prototype.compileSolidity = $084c61e5002f19e0$var$generateFnFor("eth_compileSolidity");
$084c61e5002f19e0$var$EthQuery.prototype.compileSerpent = $084c61e5002f19e0$var$generateFnFor("eth_compileSerpent");
$084c61e5002f19e0$var$EthQuery.prototype.newFilter = $084c61e5002f19e0$var$generateFnFor("eth_newFilter");
$084c61e5002f19e0$var$EthQuery.prototype.newBlockFilter = $084c61e5002f19e0$var$generateFnFor("eth_newBlockFilter");
$084c61e5002f19e0$var$EthQuery.prototype.newPendingTransactionFilter = $084c61e5002f19e0$var$generateFnFor("eth_newPendingTransactionFilter");
$084c61e5002f19e0$var$EthQuery.prototype.uninstallFilter = $084c61e5002f19e0$var$generateFnFor("eth_uninstallFilter");
$084c61e5002f19e0$var$EthQuery.prototype.getFilterChanges = $084c61e5002f19e0$var$generateFnFor("eth_getFilterChanges");
$084c61e5002f19e0$var$EthQuery.prototype.getFilterLogs = $084c61e5002f19e0$var$generateFnFor("eth_getFilterLogs");
$084c61e5002f19e0$var$EthQuery.prototype.getLogs = $084c61e5002f19e0$var$generateFnFor("eth_getLogs");
$084c61e5002f19e0$var$EthQuery.prototype.getWork = $084c61e5002f19e0$var$generateFnFor("eth_getWork");
$084c61e5002f19e0$var$EthQuery.prototype.submitWork = $084c61e5002f19e0$var$generateFnFor("eth_submitWork");
$084c61e5002f19e0$var$EthQuery.prototype.submitHashrate = $084c61e5002f19e0$var$generateFnFor("eth_submitHashrate");
// network level
$084c61e5002f19e0$var$EthQuery.prototype.sendAsync = function(opts, cb) {
    const self = this;
    self.currentProvider.sendAsync($084c61e5002f19e0$var$createPayload(opts), function(err, response) {
        if (!err && response.error) err = new Error("EthQuery - RPC Error - " + response.error.message);
        if (err) return cb(err);
        cb(null, response.result);
    });
};
// util
function $084c61e5002f19e0$var$generateFnFor(methodName) {
    return function() {
        const self = this;
        var args = [].slice.call(arguments);
        var cb = args.pop();
        self.sendAsync({
            method: methodName,
            params: args
        }, cb);
    };
}
function $084c61e5002f19e0$var$generateFnWithDefaultBlockFor(argCount, methodName) {
    return function() {
        const self = this;
        var args = [].slice.call(arguments);
        var cb = args.pop();
        // set optional default block param
        if (args.length < argCount) args.push("latest");
        self.sendAsync({
            method: methodName,
            params: args
        }, cb);
    };
}
function $084c61e5002f19e0$var$createPayload(data) {
    return $h0kNM({
        // defaults
        id: $084c61e5002f19e0$var$createRandomId(),
        jsonrpc: "2.0",
        params: []
    }, data);
}

});
parcelRequire.register("h0kNM", function(module, exports) {
module.exports = $c61292941889f8f2$var$extend;
var $c61292941889f8f2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c61292941889f8f2$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($c61292941889f8f2$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});


parcelRequire.register("kZt26", function(module, exports) {
"use strict";
const $f480067b9bff6018$var$processFn = (fn, options, proxy, unwrapped)=>function(...arguments_) {
        const P = options.promiseModule;
        return new P((resolve, reject)=>{
            if (options.multiArgs) arguments_.push((...result)=>{
                if (options.errorFirst) {
                    if (result[0]) reject(result);
                    else {
                        result.shift();
                        resolve(result);
                    }
                } else resolve(result);
            });
            else if (options.errorFirst) arguments_.push((error, result)=>{
                if (error) reject(error);
                else resolve(result);
            });
            else arguments_.push(resolve);
            const self = this === proxy ? unwrapped : this;
            Reflect.apply(fn, self, arguments_);
        });
    };
const $f480067b9bff6018$var$filterCache = new WeakMap();
module.exports = (input, options)=>{
    options = {
        exclude: [
            /.+(?:Sync|Stream)$/
        ],
        errorFirst: true,
        promiseModule: Promise,
        ...options
    };
    const objectType = typeof input;
    if (!(input !== null && (objectType === "object" || objectType === "function"))) throw new TypeError(`Expected \`input\` to be a \`Function\` or \`Object\`, got \`${input === null ? "null" : objectType}\``);
    const filter = (target, key)=>{
        let cached = $f480067b9bff6018$var$filterCache.get(target);
        if (!cached) {
            cached = {};
            $f480067b9bff6018$var$filterCache.set(target, cached);
        }
        if (key in cached) return cached[key];
        const match = (pattern)=>typeof pattern === "string" || typeof key === "symbol" ? key === pattern : pattern.test(key);
        const desc = Reflect.getOwnPropertyDescriptor(target, key);
        const writableOrConfigurableOwn = desc === undefined || desc.writable || desc.configurable;
        const included = options.include ? options.include.some(match) : !options.exclude.some(match);
        const shouldFilter = included && writableOrConfigurableOwn;
        cached[key] = shouldFilter;
        return shouldFilter;
    };
    const cache = new WeakMap();
    const proxy = new Proxy(input, {
        apply (target, thisArg, args) {
            const cached = cache.get(target);
            if (cached) return Reflect.apply(cached, thisArg, args);
            const pified = options.excludeMain ? target : $f480067b9bff6018$var$processFn(target, options, proxy, target);
            cache.set(target, pified);
            return Reflect.apply(pified, thisArg, args);
        },
        get (target, key) {
            const property = target[key];
            // eslint-disable-next-line no-use-extend-native/no-use-extend-native
            if (!filter(target, key) || property === Function.prototype[key]) return property;
            const cached = cache.get(property);
            if (cached) return cached;
            if (typeof property === "function") {
                const pified = $f480067b9bff6018$var$processFn(property, options, proxy, target);
                cache.set(property, pified);
                return pified;
            }
            return property;
        }
    });
    return proxy;
};

});

parcelRequire.register("fIdq3", function(module, exports) {

var $jq4FX = parcelRequire("jq4FX");
// tracks all results ever recorded
class $b7055fd48091723e$var$BaseFilterWithHistory extends $jq4FX {
    constructor(){
        super();
        this.allResults = [];
    }
    async update() {
        throw new Error("BaseFilterWithHistory - no update method specified");
    }
    addResults(newResults) {
        this.allResults = this.allResults.concat(newResults);
        super.addResults(newResults);
    }
    addInitialResults(newResults) {
        this.allResults = this.allResults.concat(newResults);
        super.addInitialResults(newResults);
    }
    getAllResults() {
        return this.allResults;
    }
}
module.exports = $b7055fd48091723e$var$BaseFilterWithHistory;

});
parcelRequire.register("jq4FX", function(module, exports) {

var $e5MJz = parcelRequire("e5MJz");
var $e2341282705ceb0f$require$SafeEventEmitter = $e5MJz.default;
class $e2341282705ceb0f$var$BaseFilter extends $e2341282705ceb0f$require$SafeEventEmitter {
    constructor(){
        super();
        this.updates = [];
    }
    async initialize() {}
    async update() {
        throw new Error("BaseFilter - no update method specified");
    }
    addResults(newResults) {
        this.updates = this.updates.concat(newResults);
        newResults.forEach((result)=>this.emit("update", result));
    }
    addInitialResults(newResults) {}
    getChangesAndClear() {
        const updates = this.updates;
        this.updates = [];
        return updates;
    }
}
module.exports = $e2341282705ceb0f$var$BaseFilter;

});


parcelRequire.register("5nre7", function(module, exports) {
module.exports = {
    minBlockRef: $3ea43866df51a0dc$var$minBlockRef,
    maxBlockRef: $3ea43866df51a0dc$var$maxBlockRef,
    sortBlockRefs: $3ea43866df51a0dc$var$sortBlockRefs,
    bnToHex: $3ea43866df51a0dc$var$bnToHex,
    blockRefIsNumber: $3ea43866df51a0dc$var$blockRefIsNumber,
    hexToInt: $3ea43866df51a0dc$var$hexToInt,
    incrementHexInt: $3ea43866df51a0dc$var$incrementHexInt,
    intToHex: $3ea43866df51a0dc$var$intToHex,
    unsafeRandomBytes: $3ea43866df51a0dc$var$unsafeRandomBytes
};
function $3ea43866df51a0dc$var$minBlockRef(...refs) {
    const sortedRefs = $3ea43866df51a0dc$var$sortBlockRefs(refs);
    return sortedRefs[0];
}
function $3ea43866df51a0dc$var$maxBlockRef(...refs) {
    const sortedRefs = $3ea43866df51a0dc$var$sortBlockRefs(refs);
    return sortedRefs[sortedRefs.length - 1];
}
function $3ea43866df51a0dc$var$sortBlockRefs(refs) {
    return refs.sort((refA, refB)=>{
        if (refA === "latest" || refB === "earliest") return 1;
        if (refB === "latest" || refA === "earliest") return -1;
        return $3ea43866df51a0dc$var$hexToInt(refA) - $3ea43866df51a0dc$var$hexToInt(refB);
    });
}
function $3ea43866df51a0dc$var$bnToHex(bn) {
    return "0x" + bn.toString(16);
}
function $3ea43866df51a0dc$var$blockRefIsNumber(blockRef) {
    return blockRef && ![
        "earliest",
        "latest",
        "pending"
    ].includes(blockRef);
}
function $3ea43866df51a0dc$var$hexToInt(hexString) {
    if (hexString === undefined || hexString === null) return hexString;
    return Number.parseInt(hexString, 16);
}
function $3ea43866df51a0dc$var$incrementHexInt(hexString) {
    if (hexString === undefined || hexString === null) return hexString;
    const value = $3ea43866df51a0dc$var$hexToInt(hexString);
    return $3ea43866df51a0dc$var$intToHex(value + 1);
}
function $3ea43866df51a0dc$var$intToHex(int) {
    if (int === undefined || int === null) return int;
    let hexString = int.toString(16);
    const needsLeftPad = hexString.length % 2;
    if (needsLeftPad) hexString = "0" + hexString;
    return "0x" + hexString;
}
function $3ea43866df51a0dc$var$unsafeRandomBytes(byteCount) {
    let result = "0x";
    for(let i = 0; i < byteCount; i++){
        result += $3ea43866df51a0dc$var$unsafeRandomNibble();
        result += $3ea43866df51a0dc$var$unsafeRandomNibble();
    }
    return result;
}
function $3ea43866df51a0dc$var$unsafeRandomNibble() {
    return Math.floor(Math.random() * 16).toString(16);
}

});


parcelRequire.register("bWRmt", function(module, exports) {

var $jq4FX = parcelRequire("jq4FX");

var $iAHBh = parcelRequire("iAHBh");

var $5nre7 = parcelRequire("5nre7");
var $8b2e80f56241fed0$require$incrementHexInt = $5nre7.incrementHexInt;
class $8b2e80f56241fed0$var$BlockFilter extends $jq4FX {
    constructor({ provider: provider, params: params }){
        super();
        this.type = "block";
        this.provider = provider;
    }
    async update({ oldBlock: oldBlock, newBlock: newBlock }) {
        const toBlock = newBlock;
        const fromBlock = $8b2e80f56241fed0$require$incrementHexInt(oldBlock);
        const blockBodies = await $iAHBh({
            provider: this.provider,
            fromBlock: fromBlock,
            toBlock: toBlock
        });
        const blockHashes = blockBodies.map((block)=>block.hash);
        this.addResults(blockHashes);
    }
}
module.exports = $8b2e80f56241fed0$var$BlockFilter;

});
parcelRequire.register("iAHBh", function(module, exports) {
module.exports = $d88d68e2e16e1a5f$var$getBlocksForRange;
async function $d88d68e2e16e1a5f$var$getBlocksForRange({ provider: provider, fromBlock: fromBlock, toBlock: toBlock }) {
    if (!fromBlock) fromBlock = toBlock;
    const fromBlockNumber = $d88d68e2e16e1a5f$var$hexToInt(fromBlock);
    const toBlockNumber = $d88d68e2e16e1a5f$var$hexToInt(toBlock);
    const blockCountToQuery = toBlockNumber - fromBlockNumber + 1;
    // load all blocks from old to new (inclusive)
    const missingBlockNumbers = Array(blockCountToQuery).fill().map((_, index)=>fromBlockNumber + index).map($d88d68e2e16e1a5f$var$intToHex);
    const blockBodies = await Promise.all(missingBlockNumbers.map((blockNum)=>$d88d68e2e16e1a5f$var$query(provider, "eth_getBlockByNumber", [
            blockNum,
            false
        ])));
    return blockBodies;
}
function $d88d68e2e16e1a5f$var$hexToInt(hexString) {
    if (hexString === undefined || hexString === null) return hexString;
    return Number.parseInt(hexString, 16);
}
function $d88d68e2e16e1a5f$var$incrementHexInt(hexString) {
    if (hexString === undefined || hexString === null) return hexString;
    const value = $d88d68e2e16e1a5f$var$hexToInt(hexString);
    return $d88d68e2e16e1a5f$var$intToHex(value + 1);
}
function $d88d68e2e16e1a5f$var$intToHex(int) {
    if (int === undefined || int === null) return int;
    const hexString = int.toString(16);
    return "0x" + hexString;
}
function $d88d68e2e16e1a5f$var$sendAsync(provider, request) {
    return new Promise((resolve, reject)=>{
        provider.sendAsync(request, (error, response)=>{
            if (error) reject(error);
            else if (response.error) reject(response.error);
            else if (response.result) resolve(response.result);
            else reject(new Error("Result was empty"));
        });
    });
}
async function $d88d68e2e16e1a5f$var$query(provider, method, params) {
    for(let i = 0; i < 3; i++)try {
        return await $d88d68e2e16e1a5f$var$sendAsync(provider, {
            id: 1,
            jsonrpc: "2.0",
            method: method,
            params: params
        });
    } catch (error) {
        console.error(`provider.sendAsync failed: ${error.stack || error.message || error}`);
    }
    throw new Error(`Block not found for params: ${JSON.stringify(params)}`);
}

});


parcelRequire.register("ivOGw", function(module, exports) {

var $jq4FX = parcelRequire("jq4FX");

var $iAHBh = parcelRequire("iAHBh");

var $5nre7 = parcelRequire("5nre7");
var $d7a2703733c1b49c$require$incrementHexInt = $5nre7.incrementHexInt;
class $d7a2703733c1b49c$var$TxFilter extends $jq4FX {
    constructor({ provider: provider }){
        super();
        this.type = "tx";
        this.provider = provider;
    }
    async update({ oldBlock: oldBlock }) {
        const toBlock = oldBlock;
        const fromBlock = $d7a2703733c1b49c$require$incrementHexInt(oldBlock);
        const blocks = await $iAHBh({
            provider: this.provider,
            fromBlock: fromBlock,
            toBlock: toBlock
        });
        const blockTxHashes = [];
        for (const block of blocks)blockTxHashes.push(...block.transactions);
        // add to results
        this.addResults(blockTxHashes);
    }
}
module.exports = $d7a2703733c1b49c$var$TxFilter;

});





parcelRequire.register("jU9nd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletSDKUI = void 0;

var $9bzyO = parcelRequire("9bzyO");

var $4tT4E = parcelRequire("4tT4E");

var $gscOu = parcelRequire("gscOu");
class $e7da84a2ae1bb583$var$WalletSDKUI {
    constructor(options){
        this.standalone = null;
        this.attached = false;
        this.appSrc = null;
        this.snackbar = new $4tT4E.Snackbar({
            darkMode: options.darkMode
        });
        this.linkFlow = new $9bzyO.LinkFlow({
            darkMode: options.darkMode,
            version: options.version,
            sessionId: options.session.id,
            sessionSecret: options.session.secret,
            linkAPIUrl: options.linkAPIUrl,
            connected$: options.connected$,
            chainId$: options.chainId$,
            isParentConnection: false
        });
    }
    attach() {
        if (this.attached) throw new Error("Coinbase Wallet SDK UI is already attached");
        const el = document.documentElement;
        const container = document.createElement("div");
        container.className = "-cbwsdk-css-reset";
        el.appendChild(container);
        this.linkFlow.attach(container);
        this.snackbar.attach(container);
        this.attached = true;
        (0, $gscOu.injectCssReset)();
    }
    setConnectDisabled(connectDisabled) {
        this.linkFlow.setConnectDisabled(connectDisabled);
    }
    /* istanbul ignore next */ addEthereumChain(_options) {
    // no-op
    }
    /* istanbul ignore next */ watchAsset(_options) {
    // no-op
    }
    /* istanbul ignore next */ switchEthereumChain(_options) {
    // no-op
    }
    requestEthereumAccounts(options) {
        this.linkFlow.open({
            onCancel: options.onCancel
        });
    }
    hideRequestEthereumAccounts() {
        this.linkFlow.close();
    }
    /* istanbul ignore next */ signEthereumMessage(_) {
    // No-op
    }
    /* istanbul ignore next */ signEthereumTransaction(_) {
    // No-op
    }
    /* istanbul ignore next */ submitEthereumTransaction(_) {
    // No-op
    }
    /* istanbul ignore next */ ethereumAddressFromSignedMessage(_) {
    // No-op
    }
    showConnecting(options) {
        let snackbarProps;
        if (options.isUnlinkedErrorState) snackbarProps = {
            autoExpand: true,
            message: "Connection lost",
            appSrc: this.appSrc,
            menuItems: [
                {
                    isRed: false,
                    info: "Reset connection",
                    svgWidth: "10",
                    svgHeight: "11",
                    path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
                    defaultFillRule: "evenodd",
                    defaultClipRule: "evenodd",
                    onClick: options.onResetConnection
                }
            ]
        };
        else snackbarProps = {
            message: "Confirm on phone",
            appSrc: this.appSrc,
            menuItems: [
                {
                    isRed: true,
                    info: "Cancel transaction",
                    svgWidth: "11",
                    svgHeight: "11",
                    path: "M10.3711 1.52346L9.21775 0.370117L5.37109 4.21022L1.52444 0.370117L0.371094 1.52346L4.2112 5.37012L0.371094 9.21677L1.52444 10.3701L5.37109 6.53001L9.21775 10.3701L10.3711 9.21677L6.53099 5.37012L10.3711 1.52346Z",
                    defaultFillRule: "inherit",
                    defaultClipRule: "inherit",
                    onClick: options.onCancel
                },
                {
                    isRed: false,
                    info: "Reset connection",
                    svgWidth: "10",
                    svgHeight: "11",
                    path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
                    defaultFillRule: "evenodd",
                    defaultClipRule: "evenodd",
                    onClick: options.onResetConnection
                }
            ]
        };
        return this.snackbar.presentItem(snackbarProps);
    }
    /* istanbul ignore next */ setAppSrc(appSrc) {
        this.appSrc = appSrc;
    }
    /* istanbul ignore next */ reloadUI() {
        document.location.reload();
    }
    /* istanbul ignore next */ inlineAccountsResponse() {
        return false;
    }
    /* istanbul ignore next */ inlineAddEthereumChain(_chainId) {
        return false;
    }
    /* istanbul ignore next */ inlineWatchAsset() {
        return false;
    }
    /* istanbul ignore next */ inlineSwitchEthereumChain() {
        return false;
    }
    /* istanbul ignore next */ setStandalone(status) {
        this.standalone = status;
    }
    /* istanbul ignore next */ isStandalone() {
        var _a;
        return (_a = this.standalone) !== null && _a !== void 0 ? _a : false;
    }
}
module.exports.WalletSDKUI = $e7da84a2ae1bb583$var$WalletSDKUI;

});
parcelRequire.register("9bzyO", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LinkFlow = void 0;

var $1Hdcz = parcelRequire("1Hdcz");

var $1j1JC = parcelRequire("1j1JC");
var $cnFOC = parcelRequire("cnFOC");

var $hnFIC = parcelRequire("hnFIC");
class $6b00b9b3debe8b34$var$LinkFlow {
    constructor(options){
        this.extensionUI$ = new $1j1JC.BehaviorSubject({});
        this.subscriptions = new $cnFOC.Subscription();
        this.isConnected = false;
        this.chainId = 1;
        this.isOpen = false;
        this.onCancel = null;
        this.root = null;
        // if true, hide QR code in LinkFlow (which happens if no jsonRpcUrl is provided)
        this.connectDisabled = false;
        this.darkMode = options.darkMode;
        this.version = options.version;
        this.sessionId = options.sessionId;
        this.sessionSecret = options.sessionSecret;
        this.linkAPIUrl = options.linkAPIUrl;
        this.isParentConnection = options.isParentConnection;
        this.connected$ = options.connected$;
        this.chainId$ = options.chainId$;
    }
    attach(el) {
        this.root = document.createElement("div");
        this.root.className = "-cbwsdk-link-flow-root";
        el.appendChild(this.root);
        this.render();
        this.subscriptions.add(this.connected$.subscribe((v)=>{
            if (this.isConnected !== v) {
                this.isConnected = v;
                this.render();
            }
        }));
        this.subscriptions.add(this.chainId$.subscribe((chainId)=>{
            if (this.chainId !== chainId) {
                this.chainId = chainId;
                this.render();
            }
        }));
    }
    detach() {
        var _a;
        if (!this.root) return;
        this.subscriptions.unsubscribe();
        (0, $1Hdcz.render)(null, this.root);
        (_a = this.root.parentElement) === null || _a === void 0 || _a.removeChild(this.root);
    }
    setConnectDisabled(connectDisabled) {
        this.connectDisabled = connectDisabled;
    }
    open(options) {
        this.isOpen = true;
        this.onCancel = options.onCancel;
        this.render();
    }
    close() {
        this.isOpen = false;
        this.onCancel = null;
        this.render();
    }
    render() {
        if (!this.root) return;
        const subscription = this.extensionUI$.subscribe(()=>{
            if (!this.root) return;
            (0, $1Hdcz.render)((0, $1Hdcz.h)($hnFIC.ConnectDialog, {
                darkMode: this.darkMode,
                version: this.version,
                sessionId: this.sessionId,
                sessionSecret: this.sessionSecret,
                linkAPIUrl: this.linkAPIUrl,
                isOpen: this.isOpen,
                isConnected: this.isConnected,
                isParentConnection: this.isParentConnection,
                chainId: this.chainId,
                onCancel: this.onCancel,
                connectDisabled: this.connectDisabled
            }), this.root);
        });
        this.subscriptions.add(subscription);
    }
}
module.exports.LinkFlow = $6b00b9b3debe8b34$var$LinkFlow;

});
parcelRequire.register("1Hdcz", function(module, exports) {

$parcel$export(module.exports, "options", () => $13c40c34b78c8ee2$export$41c562ebe57d11e2);
$parcel$export(module.exports, "render", () => $13c40c34b78c8ee2$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "h", () => $13c40c34b78c8ee2$export$c8a8987d4410bf2d);
var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$c = {}, $13c40c34b78c8ee2$var$s = [], $13c40c34b78c8ee2$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$h = Array.isArray;
function $13c40c34b78c8ee2$var$v(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $13c40c34b78c8ee2$var$d(l, f, i, o, null);
}
function $13c40c34b78c8ee2$var$d(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$13c40c34b78c8ee2$var$u : r
    };
    return null == r && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$g(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$g(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$g(n) : null;
}
function $13c40c34b78c8ee2$var$m(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$m(n);
    }
}
function $13c40c34b78c8ee2$var$w(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$x.__r++ || $13c40c34b78c8ee2$var$o !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$r)($13c40c34b78c8ee2$var$x);
}
function $13c40c34b78c8ee2$var$x() {
    var n, l, u, t, o, r, e, c, s;
    for($13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f); n = $13c40c34b78c8ee2$var$i.shift();)n.__d && (l = $13c40c34b78c8ee2$var$i.length, t = void 0, o = void 0, r = void 0, c = (e = (u = n).__v).__e, (s = u.__P) && (t = [], o = [], (r = $13c40c34b78c8ee2$var$v({}, e)).__v = e.__v + 1, $13c40c34b78c8ee2$var$L(s, e, r, u.__n, void 0 !== s.ownerSVGElement, null != e.__h ? [
        c
    ] : null, t, null == c ? $13c40c34b78c8ee2$var$g(e) : c, e.__h, o), $13c40c34b78c8ee2$var$M(t, e, o), e.__e != c && $13c40c34b78c8ee2$var$m(e)), $13c40c34b78c8ee2$var$i.length > l && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f));
    $13c40c34b78c8ee2$var$x.__r = 0;
}
function $13c40c34b78c8ee2$var$P(n, l, u, t, i, o, r, f, e, a, v) {
    var p, y, _, b, m, w, x, P, C, H = 0, I = t && t.__k || $13c40c34b78c8ee2$var$s, T = I.length, j = T, z = l.length;
    for(u.__k = [], p = 0; p < z; p++)null != (b = u.__k[p] = null == (b = l[p]) || "boolean" == typeof b || "function" == typeof b ? null : "string" == typeof b || "number" == typeof b || "bigint" == typeof b ? $13c40c34b78c8ee2$var$d(null, b, null, null, b) : $13c40c34b78c8ee2$var$h(b) ? $13c40c34b78c8ee2$var$d($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: b
    }, null, null, null) : b.__b > 0 ? $13c40c34b78c8ee2$var$d(b.type, b.props, b.key, b.ref ? b.ref : null, b.__v) : b) ? (b.__ = u, b.__b = u.__b + 1, -1 === (P = $13c40c34b78c8ee2$var$A(b, I, x = p + H, j)) ? _ = $13c40c34b78c8ee2$var$c : (_ = I[P] || $13c40c34b78c8ee2$var$c, I[P] = void 0, j--), $13c40c34b78c8ee2$var$L(n, b, _, i, o, r, f, e, a, v), m = b.__e, (y = b.ref) && _.ref != y && (_.ref && $13c40c34b78c8ee2$var$O(_.ref, null, b), v.push(y, b.__c || m, b)), null != m && (null == w && (w = m), (C = _ === $13c40c34b78c8ee2$var$c || null === _.__v) ? -1 == P && H-- : P !== x && (P === x + 1 ? H++ : P > x ? j > z - x ? H += P - x : H-- : H = P < x && P == x - 1 ? P - x : 0), x = p + H, "function" != typeof b.type || P === x && _.__k !== b.__k ? "function" == typeof b.type || P === x && !C ? void 0 !== b.__d ? (e = b.__d, b.__d = void 0) : e = m.nextSibling : e = $13c40c34b78c8ee2$var$S(n, m, e) : e = $13c40c34b78c8ee2$var$$(b, e, n), "function" == typeof u.type && (u.__d = e))) : (_ = I[p]) && null == _.key && _.__e && (_.__e == e && (e = $13c40c34b78c8ee2$var$g(_)), $13c40c34b78c8ee2$var$q(_, _, !1), I[p] = null);
    for(u.__e = w, p = T; p--;)null != I[p] && ("function" == typeof u.type && null != I[p].__e && I[p].__e == u.__d && (u.__d = I[p].__e.nextSibling), $13c40c34b78c8ee2$var$q(I[p], I[p]));
}
function $13c40c34b78c8ee2$var$$(n, l, u) {
    for(var t, i = n.__k, o = 0; i && o < i.length; o++)(t = i[o]) && (t.__ = n, l = "function" == typeof t.type ? $13c40c34b78c8ee2$var$$(t, l, u) : $13c40c34b78c8ee2$var$S(u, t.__e, l));
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$h(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$S(n, l, u) {
    return null == u || u.parentNode !== n ? n.insertBefore(l, null) : l == u && null != l.parentNode || n.insertBefore(l, u), l.nextSibling;
}
function $13c40c34b78c8ee2$var$A(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $13c40c34b78c8ee2$var$H(n, l, u, t, i) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $13c40c34b78c8ee2$var$T(n, o, null, u[o], t);
    for(o in l)i && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $13c40c34b78c8ee2$var$T(n, o, l[o], u[o], t);
}
function $13c40c34b78c8ee2$var$I(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$a.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$T(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$I(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $13c40c34b78c8ee2$var$I(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t || n.addEventListener(l, o ? $13c40c34b78c8ee2$var$z : $13c40c34b78c8ee2$var$j, o) : n.removeEventListener(l, o ? $13c40c34b78c8ee2$var$z : $13c40c34b78c8ee2$var$j, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $13c40c34b78c8ee2$var$j(n) {
    return this.l[n.type + !1]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$z(n) {
    return this.l[n.type + !0]($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(n) : n);
}
function $13c40c34b78c8ee2$var$L(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, g, m, w, x, $, C, S, A, H, I, T = u.type;
    if (void 0 !== u.constructor) return null;
    null != t.__h && (c = t.__h, e = u.__e = t.__e, u.__h = null, r = [
        e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (w = u.props, x = (a = T.contextType) && i[a.__c], $ = a ? x ? x.props.value : a.__ : i, t.__c ? m = (p = u.__c = t.__c).__ = p.__E : ("prototype" in T && T.prototype.render ? u.__c = p = new T(w, $) : (u.__c = p = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(w, $), p.constructor = T, p.render = $13c40c34b78c8ee2$var$B), x && x.sub(p), p.props = w, p.state || (p.state = {}), p.context = $, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != T.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $13c40c34b78c8ee2$var$v({}, p.__s)), $13c40c34b78c8ee2$var$v(p.__s, T.getDerivedStateFromProps(w, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == T.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == T.getDerivedStateFromProps && w !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(w, $), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(w, p.__s, $) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = w, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), C = 0; C < p._sb.length; C++)p.__h.push(p._sb[C]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(w, p.__s, $), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, g);
            });
        }
        if (p.context = $, p.props = w, p.__P = n, p.__e = !1, S = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, A = 0, "prototype" in T && T.prototype.render) {
            for(p.state = p.__s, p.__d = !1, S && S(u), a = p.render(p.props, p.state, p.context), H = 0; H < p._sb.length; H++)p.__h.push(p._sb[H]);
            p._sb = [];
        } else do p.__d = !1, S && S(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++A < 25);
        p.state = p.__s, null != p.getChildContext && (i = $13c40c34b78c8ee2$var$v($13c40c34b78c8ee2$var$v({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (g = p.getSnapshotBeforeUpdate(d, _)), $13c40c34b78c8ee2$var$P(n, $13c40c34b78c8ee2$var$h(I = null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? I : [
            I
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__h = null, p.__h.length && f.push(p), m && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $13c40c34b78c8ee2$var$N(t.__e, u, t, i, o, r, f, c, s);
    (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u);
}
function $13c40c34b78c8ee2$var$M(n, u, t) {
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$O(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$N(l, u, t, i, o, r, f, e, s) {
    var a, v, y, d = t.props, _ = u.props, k = u.type, b = 0;
    if ("svg" === k && (o = !0), null != r) {
        for(; b < r.length; b++)if ((a = r[b]) && "setAttribute" in a == !!k && (k ? a.localName === k : 3 === a.nodeType)) {
            l = a, r[b] = null;
            break;
        }
    }
    if (null == l) {
        if (null === k) return document.createTextNode(_);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", k) : document.createElement(k, _.is && _), r = null, e = !1;
    }
    if (null === k) d === _ || e && l.data === _ || (l.data = _);
    else {
        if (r = r && $13c40c34b78c8ee2$var$n.call(l.childNodes), v = (d = t.props || $13c40c34b78c8ee2$var$c).dangerouslySetInnerHTML, y = _.dangerouslySetInnerHTML, !e) {
            if (null != r) for(d = {}, b = 0; b < l.attributes.length; b++)d[l.attributes[b].name] = l.attributes[b].value;
            (y || v) && (y && (v && y.__html == v.__html || y.__html === l.innerHTML) || (l.innerHTML = y && y.__html || ""));
        }
        if ($13c40c34b78c8ee2$var$H(l, _, d, o, e), y) u.__k = [];
        else if ($13c40c34b78c8ee2$var$P(l, $13c40c34b78c8ee2$var$h(b = u.props.children) ? b : [
            b
        ], u, t, i, o && "foreignObject" !== k, r, f, r ? r[0] : t.__k && $13c40c34b78c8ee2$var$g(t, 0), e, s), null != r) for(b = r.length; b--;)null != r[b] && $13c40c34b78c8ee2$var$p(r[b]);
        e || ("value" in _ && void 0 !== (b = _.value) && (b !== l.value || "progress" === k && !b || "option" === k && b !== d.value) && $13c40c34b78c8ee2$var$T(l, "value", b, d.value, !1), "checked" in _ && void 0 !== (b = _.checked) && b !== l.checked && $13c40c34b78c8ee2$var$T(l, "checked", b, d.checked, !1));
    }
    return l;
}
function $13c40c34b78c8ee2$var$O(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$q(n, u, t) {
    var i, o;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $13c40c34b78c8ee2$var$O(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $13c40c34b78c8ee2$var$q(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $13c40c34b78c8ee2$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $13c40c34b78c8ee2$var$L(t, u = (!o && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), r || $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$c, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $13c40c34b78c8ee2$var$M(f, u, e);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $13c40c34b78c8ee2$var$v({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$d(l.type, e, i || l.key, o || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $13c40c34b78c8ee2$var$w(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$s.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$v({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$v({}, u), this.props)), n && $13c40c34b78c8ee2$var$v(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$w(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$w(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$x.__r = 0, $13c40c34b78c8ee2$var$e = 0;

});

parcelRequire.register("1j1JC", function(module, exports) {

$parcel$export(module.exports, "BehaviorSubject", () => $0f38e94e8ff7034b$export$cc3d42e6b2b9cf8b);
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $atRt2 = parcelRequire("atRt2");

var $2sFVS = parcelRequire("2sFVS");
var $0f38e94e8ff7034b$export$cc3d42e6b2b9cf8b = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new (0, $2sFVS.ObjectUnsubscribedError)();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $atRt2.Subject));

});
parcelRequire.register("9D8rd", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $702e4d306615a028$export$a8ba968b8961cb8a);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $702e4d306615a028$var$extendStatics = function(d, b) {
    $702e4d306615a028$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $702e4d306615a028$var$extendStatics(d, b);
};
function $702e4d306615a028$export$a8ba968b8961cb8a(d, b) {
    $702e4d306615a028$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $702e4d306615a028$export$18ce0697a983be9b = function() {
    $702e4d306615a028$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $702e4d306615a028$export$18ce0697a983be9b.apply(this, arguments);
};
function $702e4d306615a028$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $702e4d306615a028$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $702e4d306615a028$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $702e4d306615a028$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $702e4d306615a028$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $702e4d306615a028$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $702e4d306615a028$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $702e4d306615a028$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $702e4d306615a028$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $702e4d306615a028$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $702e4d306615a028$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($702e4d306615a028$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $702e4d306615a028$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $702e4d306615a028$export$10c90e4f7922046c(v) {
    return this instanceof $702e4d306615a028$export$10c90e4f7922046c ? (this.v = v, this) : new $702e4d306615a028$export$10c90e4f7922046c(v);
}
function $702e4d306615a028$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $702e4d306615a028$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $702e4d306615a028$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $702e4d306615a028$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $702e4d306615a028$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $702e4d306615a028$export$19a8beecd37a4c45 === "function" ? $702e4d306615a028$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $702e4d306615a028$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $702e4d306615a028$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $702e4d306615a028$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $702e4d306615a028$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $702e4d306615a028$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRequire.register("atRt2", function(module, exports) {

$parcel$export(module.exports, "Subject", () => $7a16164e7ee15ac3$export$b6bbab5a9b109038);
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $bFD5F = parcelRequire("bFD5F");

var $13PY0 = parcelRequire("13PY0");

var $cnFOC = parcelRequire("cnFOC");

var $2sFVS = parcelRequire("2sFVS");

var $iR1mZ = parcelRequire("iR1mZ");

var $36hAL = parcelRequire("36hAL");
var $7a16164e7ee15ac3$export$d2a63025e8078d0c = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}((0, $13PY0.Subscriber));
var $7a16164e7ee15ac3$export$b6bbab5a9b109038 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[0, $36hAL.rxSubscriber] = function() {
        return new $7a16164e7ee15ac3$export$d2a63025e8078d0c(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $7a16164e7ee15ac3$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new (0, $2sFVS.ObjectUnsubscribedError)();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new (0, $2sFVS.ObjectUnsubscribedError)();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new (0, $2sFVS.ObjectUnsubscribedError)();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new (0, $2sFVS.ObjectUnsubscribedError)();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new (0, $2sFVS.ObjectUnsubscribedError)();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return (0, $cnFOC.Subscription).EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return (0, $cnFOC.Subscription).EMPTY;
        } else {
            this.observers.push(subscriber);
            return new (0, $iR1mZ.SubjectSubscription)(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $bFD5F.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $7a16164e7ee15ac3$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $bFD5F.Observable));
var $7a16164e7ee15ac3$export$155189cde295587d = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return (0, $cnFOC.Subscription).EMPTY;
    };
    return AnonymousSubject;
}($7a16164e7ee15ac3$export$b6bbab5a9b109038);

});
parcelRequire.register("bFD5F", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $87f1d8962784e676$export$77cea355fa80b5f4);
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ 
var $gLHFw = parcelRequire("gLHFw");

var $8TYif = parcelRequire("8TYif");

var $7lh9v = parcelRequire("7lh9v");

var $ccE92 = parcelRequire("ccE92");

var $bgLbz = parcelRequire("bgLbz");
var $87f1d8962784e676$export$77cea355fa80b5f4 = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, $8TYif.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, $bgLbz.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, $bgLbz.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, $bgLbz.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, $gLHFw.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $87f1d8962784e676$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, $7lh9v.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, $ccE92.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $87f1d8962784e676$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $87f1d8962784e676$var$getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, $bgLbz.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

});
parcelRequire.register("gLHFw", function(module, exports) {

$parcel$export(module.exports, "canReportError", () => $c352e8cd44aa2a9a$export$f7d54ecb625129e3);
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ 
var $13PY0 = parcelRequire("13PY0");
function $c352e8cd44aa2a9a$export$f7d54ecb625129e3(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, $13PY0.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

});
parcelRequire.register("13PY0", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $0c5e61cfa4404ac4$export$60959659b2c22881);
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $3kPv7 = parcelRequire("3kPv7");

var $6CPVT = parcelRequire("6CPVT");

var $cnFOC = parcelRequire("cnFOC");

var $36hAL = parcelRequire("36hAL");

var $bgLbz = parcelRequire("bgLbz");

var $lcU8y = parcelRequire("lcU8y");
var $0c5e61cfa4404ac4$export$60959659b2c22881 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, $6CPVT.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, $6CPVT.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new $0c5e61cfa4404ac4$export$94eeb6a328cab6c7(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new $0c5e61cfa4404ac4$export$94eeb6a328cab6c7(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, $36hAL.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, $cnFOC.Subscription));
var $0c5e61cfa4404ac4$export$94eeb6a328cab6c7 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, $3kPv7.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, $6CPVT.empty)) {
                context = Object.create(observerOrNext);
                if ((0, $3kPv7.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, $bgLbz.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, $bgLbz.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, $lcU8y.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, $lcU8y.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, $bgLbz.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, $bgLbz.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, $lcU8y.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, $bgLbz.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, $bgLbz.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, $lcU8y.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($0c5e61cfa4404ac4$export$60959659b2c22881);

});
parcelRequire.register("3kPv7", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $26db305c839bca5f$export$f6e2535fb5126e54);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $26db305c839bca5f$export$f6e2535fb5126e54(x) {
    return typeof x === "function";
}

});

parcelRequire.register("6CPVT", function(module, exports) {

$parcel$export(module.exports, "empty", () => $4d2e93797ac4fd7c$export$6e22c362a0406a2c);
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ 
var $bgLbz = parcelRequire("bgLbz");

var $lcU8y = parcelRequire("lcU8y");
var $4d2e93797ac4fd7c$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, $bgLbz.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, $lcU8y.hostReportError)(err);
    },
    complete: function() {}
};

});
parcelRequire.register("bgLbz", function(module, exports) {

$parcel$export(module.exports, "config", () => $8345ca6ec0377a1b$export$e506a1d27d1eaa20);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $8345ca6ec0377a1b$var$_enable_super_gross_mode_that_will_cause_bad_things = false;
var $8345ca6ec0377a1b$export$e506a1d27d1eaa20 = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if ($8345ca6ec0377a1b$var$_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        $8345ca6ec0377a1b$var$_enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return $8345ca6ec0377a1b$var$_enable_super_gross_mode_that_will_cause_bad_things;
    }
};

});

parcelRequire.register("lcU8y", function(module, exports) {

$parcel$export(module.exports, "hostReportError", () => $f706439a796b1aea$export$ebb0f299889f975f);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $f706439a796b1aea$export$ebb0f299889f975f(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

});


parcelRequire.register("cnFOC", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $903811aedba8ff04$export$f55210826850c514);
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ 
var $9WhX5 = parcelRequire("9WhX5");

var $ciIuB = parcelRequire("ciIuB");

var $3kPv7 = parcelRequire("3kPv7");

var $d9ixE = parcelRequire("d9ixE");
var $903811aedba8ff04$export$f55210826850c514 = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, $3kPv7.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, $d9ixE.UnsubscriptionError) ? $903811aedba8ff04$var$flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, $9WhX5.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, $ciIuB.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, $d9ixE.UnsubscriptionError)) errors = errors.concat($903811aedba8ff04$var$flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, $d9ixE.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function $903811aedba8ff04$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, $d9ixE.UnsubscriptionError) ? err.errors : err);
    }, []);
}

});
parcelRequire.register("9WhX5", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $73c774b8baa8f75c$export$43bee75e5e14138e);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $73c774b8baa8f75c$export$43bee75e5e14138e = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

});

parcelRequire.register("ciIuB", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $8f49adcd985e1d52$export$a6cdc56e425d0d0a);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $8f49adcd985e1d52$export$a6cdc56e425d0d0a(x) {
    return x !== null && typeof x === "object";
}

});

parcelRequire.register("d9ixE", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $992a7f9fdade20e5$export$c9648b76fd580c34);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $992a7f9fdade20e5$var$UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var $992a7f9fdade20e5$export$c9648b76fd580c34 = $992a7f9fdade20e5$var$UnsubscriptionErrorImpl;

});


parcelRequire.register("36hAL", function(module, exports) {

$parcel$export(module.exports, "rxSubscriber", () => $241f94060c5a71eb$export$77f77496d7cade10);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $241f94060c5a71eb$export$77f77496d7cade10 = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $241f94060c5a71eb$export$4a2e07ff24d010f0 = $241f94060c5a71eb$export$77f77496d7cade10;

});



parcelRequire.register("8TYif", function(module, exports) {

$parcel$export(module.exports, "toSubscriber", () => $67b23ac9d57820a8$export$2a12c2cebbfd1087);
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ 
var $13PY0 = parcelRequire("13PY0");

var $36hAL = parcelRequire("36hAL");

var $6CPVT = parcelRequire("6CPVT");
function $67b23ac9d57820a8$export$2a12c2cebbfd1087(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, $13PY0.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, $36hAL.rxSubscriber]) return nextOrObserver[0, $36hAL.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, $13PY0.Subscriber)((0, $6CPVT.empty));
    return new (0, $13PY0.Subscriber)(nextOrObserver, error, complete);
}

});

parcelRequire.register("7lh9v", function(module, exports) {

$parcel$export(module.exports, "observable", () => $5587cca356a45e0d$export$5ab46cbf6120b33a);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $5587cca356a45e0d$export$5ab46cbf6120b33a = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

});

parcelRequire.register("ccE92", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $8e25beeee3ff28a2$export$71f88a61afaa14d7);
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ 
var $jwiWF = parcelRequire("jwiWF");
function $8e25beeee3ff28a2$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $8e25beeee3ff28a2$export$71f88a61afaa14d7(fns);
}
function $8e25beeee3ff28a2$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $jwiWF.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRequire.register("jwiWF", function(module, exports) {

$parcel$export(module.exports, "identity", () => $e35fb39d7fe871e0$export$f0954fd7d5368655);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $e35fb39d7fe871e0$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRequire.register("2sFVS", function(module, exports) {

$parcel$export(module.exports, "ObjectUnsubscribedError", () => $1caeb93c32a31d5c$export$f708eee25634bc80);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $1caeb93c32a31d5c$var$ObjectUnsubscribedErrorImpl = /*@__PURE__*/ function() {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
}();
var $1caeb93c32a31d5c$export$f708eee25634bc80 = $1caeb93c32a31d5c$var$ObjectUnsubscribedErrorImpl;

});

parcelRequire.register("iR1mZ", function(module, exports) {

$parcel$export(module.exports, "SubjectSubscription", () => $db9e3d3ccbb347be$export$b7a41f2bfb5c60c3);
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $cnFOC = parcelRequire("cnFOC");
var $db9e3d3ccbb347be$export$b7a41f2bfb5c60c3 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}((0, $cnFOC.Subscription));

});



parcelRequire.register("hnFIC", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $ca74f21595059498$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectDialog = void 0;

const $ca74f21595059498$var$clsx_1 = $ca74f21595059498$var$__importDefault((parcelRequire("1SA7b")));

var $1Hdcz = parcelRequire("1Hdcz");

var $2LSrt = parcelRequire("2LSrt");

var $3e4sL = parcelRequire("3e4sL");

var $2o0Sm = parcelRequire("2o0Sm");

const $ca74f21595059498$var$ConnectDialog_css_1 = $ca74f21595059498$var$__importDefault((parcelRequire("7xnP4")));
const $ca74f21595059498$var$ConnectDialog = (props)=>{
    const { isOpen: isOpen, darkMode: darkMode } = props;
    const [containerHidden, setContainerHidden] = (0, $2LSrt.useState)(!isOpen);
    const [dialogHidden, setDialogHidden] = (0, $2LSrt.useState)(!isOpen);
    (0, $2LSrt.useEffect)(()=>{
        const timers = [
            window.setTimeout(()=>{
                setDialogHidden(!isOpen);
            }, 10)
        ];
        if (isOpen) setContainerHidden(false);
        else timers.push(window.setTimeout(()=>{
            setContainerHidden(true);
        }, 360));
        return ()=>{
            timers.forEach(window.clearTimeout);
        };
    }, [
        props.isOpen
    ]);
    const theme = darkMode ? "dark" : "light";
    return (0, $1Hdcz.h)("div", {
        class: (0, $ca74f21595059498$var$clsx_1.default)("-cbwsdk-connect-dialog-container", containerHidden && "-cbwsdk-connect-dialog-container-hidden")
    }, (0, $1Hdcz.h)("style", null, $ca74f21595059498$var$ConnectDialog_css_1.default), (0, $1Hdcz.h)("div", {
        class: (0, $ca74f21595059498$var$clsx_1.default)("-cbwsdk-connect-dialog-backdrop", theme, dialogHidden && "-cbwsdk-connect-dialog-backdrop-hidden")
    }), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-connect-dialog"
    }, (0, $1Hdcz.h)("div", {
        class: (0, $ca74f21595059498$var$clsx_1.default)("-cbwsdk-connect-dialog-box", dialogHidden && "-cbwsdk-connect-dialog-box-hidden")
    }, !props.connectDisabled ? (0, $1Hdcz.h)($3e4sL.ConnectContent, {
        theme: theme,
        version: props.version,
        sessionId: props.sessionId,
        sessionSecret: props.sessionSecret,
        linkAPIUrl: props.linkAPIUrl,
        isConnected: props.isConnected,
        isParentConnection: props.isParentConnection,
        chainId: props.chainId,
        onCancel: props.onCancel
    }) : null, (0, $1Hdcz.h)($2o0Sm.TryExtensionContent, {
        theme: theme
    }))));
};
module.exports.ConnectDialog = $ca74f21595059498$var$ConnectDialog;

});
parcelRequire.register("1SA7b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $15e6d94060e5d8b6$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $15e6d94060e5d8b6$export$2e2bcd8739ae039);
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;

});

parcelRequire.register("2LSrt", function(module, exports) {

$parcel$export(module.exports, "useState", () => $204a33a7557cbbd0$export$60241385465d0a34);
$parcel$export(module.exports, "useEffect", () => $204a33a7557cbbd0$export$6d9c69b0de29b591);
$parcel$export(module.exports, "useCallback", () => $204a33a7557cbbd0$export$35808ee640e87ca7);

var $1Hdcz = parcelRequire("1Hdcz");
var $204a33a7557cbbd0$var$t, $204a33a7557cbbd0$var$r, $204a33a7557cbbd0$var$u, $204a33a7557cbbd0$var$i, $204a33a7557cbbd0$var$o = 0, $204a33a7557cbbd0$var$f = [], $204a33a7557cbbd0$var$c = [], $204a33a7557cbbd0$var$e = (0, $1Hdcz.options).__b, $204a33a7557cbbd0$var$a = (0, $1Hdcz.options).__r, $204a33a7557cbbd0$var$v = (0, $1Hdcz.options).diffed, $204a33a7557cbbd0$var$l = (0, $1Hdcz.options).__c, $204a33a7557cbbd0$var$m = (0, $1Hdcz.options).unmount;
function $204a33a7557cbbd0$var$d(t, u) {
    (0, $1Hdcz.options).__h && (0, $1Hdcz.options).__h($204a33a7557cbbd0$var$r, t, $204a33a7557cbbd0$var$o || u), $204a33a7557cbbd0$var$o = 0;
    var i = $204a33a7557cbbd0$var$r.__H || ($204a33a7557cbbd0$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $204a33a7557cbbd0$var$c
    }), i.__[t];
}
function $204a33a7557cbbd0$export$60241385465d0a34(n) {
    return $204a33a7557cbbd0$var$o = 1, $204a33a7557cbbd0$export$13e3392192263954($204a33a7557cbbd0$var$B, n);
}
function $204a33a7557cbbd0$export$13e3392192263954(n, u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $204a33a7557cbbd0$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $204a33a7557cbbd0$var$r, !$204a33a7557cbbd0$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $204a33a7557cbbd0$var$r.u = !0;
        var c = $204a33a7557cbbd0$var$r.shouldComponentUpdate, e = $204a33a7557cbbd0$var$r.componentWillUpdate;
        $204a33a7557cbbd0$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $204a33a7557cbbd0$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $204a33a7557cbbd0$export$6d9c69b0de29b591(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 3);
    !(0, $1Hdcz.options).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__H.__h.push(o));
}
function $204a33a7557cbbd0$export$e5c5a5f917a5871c(u, i) {
    var o = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 4);
    !(0, $1Hdcz.options).__s && $204a33a7557cbbd0$var$z(o.__H, i) && (o.__ = u, o.i = i, $204a33a7557cbbd0$var$r.__h.push(o));
}
function $204a33a7557cbbd0$export$b8f5890fc79d6aca(n) {
    return $204a33a7557cbbd0$var$o = 5, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $204a33a7557cbbd0$export$d5a552a76deda3c2(n, t, r) {
    $204a33a7557cbbd0$var$o = 6, $204a33a7557cbbd0$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $204a33a7557cbbd0$export$1538c33de8887b59(n, r) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 7);
    return $204a33a7557cbbd0$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $204a33a7557cbbd0$export$35808ee640e87ca7(n, t) {
    return $204a33a7557cbbd0$var$o = 8, $204a33a7557cbbd0$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $204a33a7557cbbd0$export$fae74005e78b1a27(n) {
    var u = $204a33a7557cbbd0$var$r.context[n.__c], i = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($204a33a7557cbbd0$var$r)), u.props.value) : n.__;
}
function $204a33a7557cbbd0$export$dc8fbce3eb94dc1e(t, r) {
    (0, $1Hdcz.options).useDebugValue && (0, $1Hdcz.options).useDebugValue(r ? r(t) : t);
}
function $204a33a7557cbbd0$export$c052f6604b7d51fe(n) {
    var u = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 10), i = $204a33a7557cbbd0$export$60241385465d0a34();
    return u.__ = n, $204a33a7557cbbd0$var$r.componentDidCatch || ($204a33a7557cbbd0$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $204a33a7557cbbd0$export$f680877a34711e37() {
    var n = $204a33a7557cbbd0$var$d($204a33a7557cbbd0$var$t++, 11);
    if (!n.__) {
        for(var u = $204a33a7557cbbd0$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $204a33a7557cbbd0$var$b() {
    for(var t; t = $204a33a7557cbbd0$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($204a33a7557cbbd0$var$k), t.__H.__h.forEach($204a33a7557cbbd0$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $1Hdcz.options).__e(r, t.__v);
    }
}
(0, $1Hdcz.options).__b = function(n) {
    $204a33a7557cbbd0$var$r = null, $204a33a7557cbbd0$var$e && $204a33a7557cbbd0$var$e(n);
}, (0, $1Hdcz.options).__r = function(n) {
    $204a33a7557cbbd0$var$a && $204a33a7557cbbd0$var$a(n), $204a33a7557cbbd0$var$t = 0;
    var i = ($204a33a7557cbbd0$var$r = n.__c).__H;
    i && ($204a33a7557cbbd0$var$u === $204a33a7557cbbd0$var$r ? (i.__h = [], $204a33a7557cbbd0$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $204a33a7557cbbd0$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($204a33a7557cbbd0$var$k), i.__h.forEach($204a33a7557cbbd0$var$w), i.__h = [], $204a33a7557cbbd0$var$t = 0)), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r;
}, (0, $1Hdcz.options).diffed = function(t) {
    $204a33a7557cbbd0$var$v && $204a33a7557cbbd0$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $204a33a7557cbbd0$var$f.push(o) && $204a33a7557cbbd0$var$i === (0, $1Hdcz.options).requestAnimationFrame || (($204a33a7557cbbd0$var$i = (0, $1Hdcz.options).requestAnimationFrame) || $204a33a7557cbbd0$var$j)($204a33a7557cbbd0$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $204a33a7557cbbd0$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $204a33a7557cbbd0$var$c;
    })), $204a33a7557cbbd0$var$u = $204a33a7557cbbd0$var$r = null;
}, (0, $1Hdcz.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($204a33a7557cbbd0$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $204a33a7557cbbd0$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $1Hdcz.options).__e(u, t.__v);
        }
    }), $204a33a7557cbbd0$var$l && $204a33a7557cbbd0$var$l(t, r);
}, (0, $1Hdcz.options).unmount = function(t) {
    $204a33a7557cbbd0$var$m && $204a33a7557cbbd0$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $204a33a7557cbbd0$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $1Hdcz.options).__e(r, u.__v));
};
var $204a33a7557cbbd0$var$g = "function" == typeof requestAnimationFrame;
function $204a33a7557cbbd0$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $204a33a7557cbbd0$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $204a33a7557cbbd0$var$g && (t = requestAnimationFrame(r));
}
function $204a33a7557cbbd0$var$k(n) {
    var t = $204a33a7557cbbd0$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$w(n) {
    var t = $204a33a7557cbbd0$var$r;
    n.__c = n.__(), $204a33a7557cbbd0$var$r = t;
}
function $204a33a7557cbbd0$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $204a33a7557cbbd0$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});

parcelRequire.register("3e4sL", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $2596242138ff3209$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinbaseAppSteps = module.exports.CoinbaseWalletSteps = module.exports.ConnectItem = module.exports.ConnectContent = void 0;

const $2596242138ff3209$var$clsx_1 = $2596242138ff3209$var$__importDefault((parcelRequire("1SA7b")));

var $1Hdcz = parcelRequire("1Hdcz");

var $2LSrt = parcelRequire("2LSrt");

var $1mY3j = parcelRequire("1mY3j");

var $ejuBv = parcelRequire("ejuBv");

var $6HgFW = parcelRequire("6HgFW");

const $2596242138ff3209$var$coinbase_round_svg_1 = $2596242138ff3209$var$__importDefault((parcelRequire("6CmOD")));

const $2596242138ff3209$var$coinbase_wallet_round_svg_1 = $2596242138ff3209$var$__importDefault((parcelRequire("6temh")));

var $d3cX0 = parcelRequire("d3cX0");

const $2596242138ff3209$var$QRLogoCoinbase_1 = $2596242138ff3209$var$__importDefault((parcelRequire("aP6Ar")));

const $2596242138ff3209$var$QRLogoWallet_1 = $2596242138ff3209$var$__importDefault((parcelRequire("7NpBs")));

var $jPPj8 = parcelRequire("jPPj8");

var $g2R7r = parcelRequire("g2R7r");

var $8kxCd = parcelRequire("8kxCd");

const $2596242138ff3209$var$ConnectContent_css_1 = $2596242138ff3209$var$__importDefault((parcelRequire("kWxjl")));
const $2596242138ff3209$var$wallets = {
    "coinbase-wallet-app": {
        title: "Coinbase Wallet app",
        description: "Connect with your self-custody wallet",
        icon: $2596242138ff3209$var$coinbase_wallet_round_svg_1.default,
        steps: $2596242138ff3209$var$CoinbaseWalletSteps
    },
    "coinbase-app": {
        title: "Coinbase app",
        description: "Connect with your Coinbase account",
        icon: $2596242138ff3209$var$coinbase_round_svg_1.default,
        steps: $2596242138ff3209$var$CoinbaseAppSteps
    }
};
const $2596242138ff3209$var$makeQrCodeImage = (app)=>{
    switch(app){
        case "coinbase-app":
            return $2596242138ff3209$var$QRLogoCoinbase_1.default;
        case "coinbase-wallet-app":
        default:
            return $2596242138ff3209$var$QRLogoWallet_1.default;
    }
};
const $2596242138ff3209$var$makeIconColor = (theme)=>{
    return theme === "light" ? "#FFFFFF" : "#0A0B0D";
};
function $2596242138ff3209$var$ConnectContent(props) {
    const { theme: theme } = props;
    const [selected, setSelected] = (0, $2LSrt.useState)("coinbase-wallet-app");
    const handleSelect = (0, $2LSrt.useCallback)((id)=>{
        setSelected(id);
    }, []);
    const qrUrl = (0, $1mY3j.createQrUrl)(props.sessionId, props.sessionSecret, props.linkAPIUrl, props.isParentConnection, props.version, props.chainId);
    const wallet = $2596242138ff3209$var$wallets[selected];
    if (!selected) return null;
    const WalletSteps = wallet.steps;
    const coinbaseApp = selected === "coinbase-app";
    return (0, $1Hdcz.h)("div", {
        "data-testid": "connect-content",
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-connect-content", theme)
    }, (0, $1Hdcz.h)("style", null, $2596242138ff3209$var$ConnectContent_css_1.default), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-connect-content-header"
    }, (0, $1Hdcz.h)("h2", {
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-connect-content-heading", theme)
    }, "Scan to connect with one of our mobile apps"), props.onCancel && (0, $1Hdcz.h)("button", {
        type: "button",
        class: "-cbwsdk-cancel-button",
        onClick: props.onCancel
    }, (0, $1Hdcz.h)($6HgFW.CloseIcon, {
        fill: theme === "light" ? "#0A0B0D" : "#FFFFFF"
    }))), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-connect-content-layout"
    }, (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-connect-content-column-left"
    }, (0, $1Hdcz.h)("div", null, Object.entries($2596242138ff3209$var$wallets).map(([key, value])=>{
        return (0, $1Hdcz.h)($2596242138ff3209$var$ConnectItem, {
            key: key,
            title: value.title,
            description: value.description,
            icon: value.icon,
            selected: selected === key,
            onClick: ()=>handleSelect(key),
            theme: theme
        });
    })), coinbaseApp && (0, $1Hdcz.h)("div", {
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-connect-content-update-app", theme)
    }, "Don’t see a ", (0, $1Hdcz.h)("strong", null, "Scan"), " option? Update your Coinbase app to the latest version and try again.")), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-connect-content-column-right"
    }, (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-connect-content-qr-wrapper"
    }, (0, $1Hdcz.h)($g2R7r.QRCode, {
        content: qrUrl,
        width: 200,
        height: 200,
        fgColor: "#000",
        bgColor: "transparent",
        image: {
            svg: $2596242138ff3209$var$makeQrCodeImage(selected),
            width: 25,
            height: 25
        }
    }), (0, $1Hdcz.h)("input", {
        type: "hidden",
        name: "cbw-cbwsdk-version",
        value: $ejuBv.LIB_VERSION
    }), (0, $1Hdcz.h)("input", {
        type: "hidden",
        value: qrUrl
    })), (0, $1Hdcz.h)(WalletSteps, {
        theme: theme
    }), !props.isConnected && (0, $1Hdcz.h)("div", {
        "data-testid": "connecting-spinner",
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-connect-content-qr-connecting", theme)
    }, (0, $1Hdcz.h)($8kxCd.Spinner, {
        size: 36,
        color: theme === "dark" ? "#FFF" : "#000"
    }), (0, $1Hdcz.h)("p", null, "Connecting...")))));
}
module.exports.ConnectContent = $2596242138ff3209$var$ConnectContent;
function $2596242138ff3209$var$ConnectItem({ title: title, description: description, icon: icon, selected: selected, theme: theme, onClick: onClick }) {
    return (0, $1Hdcz.h)("div", {
        onClick: onClick,
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-connect-item", theme, {
            selected: selected
        })
    }, (0, $1Hdcz.h)("div", null, (0, $1Hdcz.h)("img", {
        src: icon,
        alt: title
    })), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-connect-item-copy-wrapper"
    }, (0, $1Hdcz.h)("h3", {
        class: "-cbwsdk-connect-item-title"
    }, title), (0, $1Hdcz.h)("p", {
        class: "-cbwsdk-connect-item-description"
    }, description)));
}
module.exports.ConnectItem = $2596242138ff3209$var$ConnectItem;
function $2596242138ff3209$var$CoinbaseWalletSteps({ theme: theme }) {
    return (0, $1Hdcz.h)("ol", {
        class: "-cbwsdk-wallet-steps"
    }, (0, $1Hdcz.h)("li", {
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-wallet-steps-item", theme)
    }, (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-wallet-steps-item-wrapper"
    }, "Open Coinbase Wallet app")), (0, $1Hdcz.h)("li", {
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-wallet-steps-item", theme)
    }, (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-wallet-steps-item-wrapper"
    }, (0, $1Hdcz.h)("span", null, "Tap ", (0, $1Hdcz.h)("strong", null, "Scan"), " "), (0, $1Hdcz.h)("span", {
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-wallet-steps-pad-left", "-cbwsdk-wallet-steps-icon", theme)
    }, (0, $1Hdcz.h)($d3cX0.QRCodeIcon, {
        fill: $2596242138ff3209$var$makeIconColor(theme)
    })))));
}
module.exports.CoinbaseWalletSteps = $2596242138ff3209$var$CoinbaseWalletSteps;
function $2596242138ff3209$var$CoinbaseAppSteps({ theme: theme }) {
    return (0, $1Hdcz.h)("ol", {
        class: "-cbwsdk-wallet-steps"
    }, (0, $1Hdcz.h)("li", {
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-wallet-steps-item", theme)
    }, (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-wallet-steps-item-wrapper"
    }, "Open Coinbase app")), (0, $1Hdcz.h)("li", {
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-wallet-steps-item", theme)
    }, (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-wallet-steps-item-wrapper"
    }, (0, $1Hdcz.h)("span", null, "Tap ", (0, $1Hdcz.h)("strong", null, "More")), (0, $1Hdcz.h)("span", {
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-wallet-steps-pad-left", "-cbwsdk-wallet-steps-icon", theme)
    }, (0, $1Hdcz.h)($jPPj8.StatusDotIcon, {
        fill: $2596242138ff3209$var$makeIconColor(theme)
    })), (0, $1Hdcz.h)("span", {
        class: "-cbwsdk-wallet-steps-pad-left"
    }, "then ", (0, $1Hdcz.h)("strong", null, "Scan")), (0, $1Hdcz.h)("span", {
        class: (0, $2596242138ff3209$var$clsx_1.default)("-cbwsdk-wallet-steps-pad-left", "-cbwsdk-wallet-steps-icon", theme)
    }, (0, $1Hdcz.h)($d3cX0.QRCodeIcon, {
        fill: $2596242138ff3209$var$makeIconColor(theme)
    })))));
}
module.exports.CoinbaseAppSteps = $2596242138ff3209$var$CoinbaseAppSteps;

});
parcelRequire.register("6HgFW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CloseIcon = void 0;

var $1Hdcz = parcelRequire("1Hdcz");
function $4e03b1a2f2ff19f3$var$CloseIcon(props) {
    return (0, $1Hdcz.h)("svg", Object.assign({
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), (0, $1Hdcz.h)("path", {
        d: "M13.7677 13L12.3535 14.4142L18.3535 20.4142L12.3535 26.4142L13.7677 27.8284L19.7677 21.8284L25.7677 27.8284L27.1819 26.4142L21.1819 20.4142L27.1819 14.4142L25.7677 13L19.7677 19L13.7677 13Z"
    }));
}
module.exports.CloseIcon = $4e03b1a2f2ff19f3$var$CloseIcon;

});

parcelRequire.register("6CmOD", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIGZpbGw9IiMwMDUyRkYiLz48cGF0aCBkPSJNMTQuMDM3IDE4LjkyNmMtMi43NSAwLTQuOTA3LTIuMjA1LTQuOTA3LTQuOTI2IDAtMi43MiAyLjIzLTQuOTI2IDQuOTA3LTQuOTI2YTQuODY2IDQuODY2IDAgMCAxIDQuODMzIDQuMTE4aDQuOTgyYy0uNDQ2LTUuMDczLTQuNjg0LTkuMDQ0LTkuODE1LTkuMDQ0QzguNjEgNC4xNDggNC4xNDkgOC41NiA0LjE0OSAxNHM0LjM4NyA5Ljg1MiA5Ljg5IDkuODUyYzUuMjA0IDAgOS4zNjgtMy45NyA5LjgxNC05LjA0M0gxOC44N2E0Ljg2NiA0Ljg2NiAwIDAgMS00LjgzMyA0LjExN1oiIGZpbGw9IiNmZmYiLz48L3N2Zz4=`;

});

parcelRequire.register("6temh", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIGZpbGw9IiMwMDUyRkYiLz48cGF0aCBkPSJNMjMuODUyIDE0QTkuODM0IDkuODM0IDAgMCAxIDE0IDIzLjg1MiA5LjgzNCA5LjgzNCAwIDAgMSA0LjE0OCAxNCA5LjgzNCA5LjgzNCAwIDAgMSAxNCA0LjE0OCA5LjgzNCA5LjgzNCAwIDAgMSAyMy44NTIgMTRaIiBmaWxsPSIjZmZmIi8+PHBhdGggZD0iTTExLjE4NSAxMi41MDRjMC0uNDU2IDAtLjcxLjA5OC0uODYyLjA5OC0uMTUyLjE5Ni0uMzA0LjM0My0uMzU1LjE5Ni0uMTAyLjM5Mi0uMTAyLjg4MS0uMTAyaDIuOTg2Yy40OSAwIC42ODYgMCAuODgyLjEwMi4xNDYuMTAxLjI5My4yMDMuMzQyLjM1NS4wOTguMjAzLjA5OC40MDYuMDk4Ljg2MnYyLjk5MmMwIC40NTcgMCAuNzEtLjA5OC44NjMtLjA5OC4xNTItLjE5NS4zMDQtLjM0Mi4zNTUtLjE5Ni4xMDEtLjM5Mi4xMDEtLjg4Mi4xMDFoLTIuOTg2Yy0uNDkgMC0uNjg1IDAtLjg4LS4xMDEtLjE0OC0uMTAyLS4yOTUtLjIwMy0uMzQ0LS4zNTUtLjA5OC0uMjAzLS4wOTgtLjQwNi0uMDk4LS44NjN2LTIuOTkyWiIgZmlsbD0iIzAwNTJGRiIvPjwvc3ZnPg==`;

});

parcelRequire.register("d3cX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QRCodeIcon = void 0;

var $1Hdcz = parcelRequire("1Hdcz");
function $980599e9193357fe$var$QRCodeIcon(props) {
    return (0, $1Hdcz.h)("svg", Object.assign({
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), (0, $1Hdcz.h)("path", {
        d: "M8.2271 1.77124L7.0271 1.77124V2.97124H8.2271V1.77124Z"
    }), (0, $1Hdcz.h)("path", {
        d: "M5.44922 0.199219L5.44922 4.54922L9.79922 4.54922V0.199219L5.44922 0.199219ZM8.89922 3.64922L6.34922 3.64922L6.34922 1.09922L8.89922 1.09922V3.64922Z"
    }), (0, $1Hdcz.h)("path", {
        d: "M2.97124 1.77124L1.77124 1.77124L1.77124 2.97124H2.97124V1.77124Z"
    }), (0, $1Hdcz.h)("path", {
        d: "M0.199219 4.54922L4.54922 4.54922L4.54922 0.199219L0.199219 0.199219L0.199219 4.54922ZM1.09922 1.09922L3.64922 1.09922L3.64922 3.64922L1.09922 3.64922L1.09922 1.09922Z"
    }), (0, $1Hdcz.h)("path", {
        d: "M2.97124 7.0271H1.77124L1.77124 8.2271H2.97124V7.0271Z"
    }), (0, $1Hdcz.h)("path", {
        d: "M0.199219 9.79922H4.54922L4.54922 5.44922L0.199219 5.44922L0.199219 9.79922ZM1.09922 6.34922L3.64922 6.34922L3.64922 8.89922H1.09922L1.09922 6.34922Z"
    }), (0, $1Hdcz.h)("path", {
        d: "M8.89922 7.39912H7.99922V5.40112H5.44922L5.44922 9.79912H6.34922L6.34922 6.30112H7.09922V8.29912H9.79922V5.40112H8.89922V7.39912Z"
    }), (0, $1Hdcz.h)("path", {
        d: "M7.99912 8.89917H7.09912V9.79917H7.99912V8.89917Z"
    }), (0, $1Hdcz.h)("path", {
        d: "M9.79917 8.89917H8.89917V9.79917H9.79917V8.89917Z"
    }));
}
module.exports.QRCodeIcon = $980599e9193357fe$var$QRCodeIcon;

});

parcelRequire.register("aP6Ar", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $7e13c6cb8802a4a3$var$svg = `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z" fill="white"/>
        <path d="M50.512 94C74.2907 94 93.5673 74.5244 93.5673 50.5C93.5673 26.4756 74.2907 7 50.512 7C26.7332 7 7.45667 26.4756 7.45667 50.5C7.45667 74.5244 26.7332 94 50.512 94Z" fill="#0052FF"/>
        <path d="M50.6248 65.4335C42.3697 65.4335 35.8996 58.7469 35.8996 50.5C35.8996 42.2531 42.5928 35.5664 50.6248 35.5664C57.9873 35.5664 64.0111 40.9157 65.1267 48.0481H80.0749C78.7363 32.6688 66.0191 20.6328 50.6248 20.6328C34.3379 20.6328 20.9514 34.0062 20.9514 50.5C20.9514 66.9936 34.1148 80.3671 50.6248 80.3671C66.2422 80.3671 78.7363 68.331 80.0749 52.9516H65.1267C64.0111 60.0841 57.9873 65.4335 50.6248 65.4335Z" fill="white"/>
    </svg>
`;
module.exports.default = $7e13c6cb8802a4a3$var$svg;

});

parcelRequire.register("7NpBs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" fill="white"/>
        <circle cx="49.9996" cy="49.9996" r="43.6363" fill="#1B53E4"/>
        <circle cx="49.9996" cy="49.9996" r="43.6363" stroke="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3379 49.9484C19.3379 66.8508 33.04 80.553 49.9425 80.553C66.8449 80.553 80.5471 66.8508 80.5471 49.9484C80.5471 33.0459 66.8449 19.3438 49.9425 19.3438C33.04 19.3438 19.3379 33.0459 19.3379 49.9484ZM44.0817 40.0799C41.8725 40.0799 40.0817 41.8708 40.0817 44.0799V55.8029C40.0817 58.012 41.8725 59.8029 44.0817 59.8029H55.8046C58.0138 59.8029 59.8046 58.012 59.8046 55.8029V44.0799C59.8046 41.8708 58.0138 40.0799 55.8046 40.0799H44.0817Z" fill="white"/>
    </svg>
`;

});

parcelRequire.register("jPPj8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatusDotIcon = void 0;

var $1Hdcz = parcelRequire("1Hdcz");
function $e70a946228a2cccd$var$StatusDotIcon(props) {
    return (0, $1Hdcz.h)("svg", Object.assign({
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), (0, $1Hdcz.h)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2.29995 4.99995C2.29995 5.57985 1.82985 6.04995 1.24995 6.04995C0.670052 6.04995 0.199951 5.57985 0.199951 4.99995C0.199951 4.42005 0.670052 3.94995 1.24995 3.94995C1.82985 3.94995 2.29995 4.42005 2.29995 4.99995ZM4.99995 6.04995C5.57985 6.04995 6.04995 5.57985 6.04995 4.99995C6.04995 4.42005 5.57985 3.94995 4.99995 3.94995C4.42005 3.94995 3.94995 4.42005 3.94995 4.99995C3.94995 5.57985 4.42005 6.04995 4.99995 6.04995ZM8.74995 6.04995C9.32985 6.04995 9.79995 5.57985 9.79995 4.99995C9.79995 4.42005 9.32985 3.94995 8.74995 3.94995C8.17005 3.94995 7.69995 4.42005 7.69995 4.99995C7.69995 5.57985 8.17005 6.04995 8.74995 6.04995Z"
    }));
}
module.exports.StatusDotIcon = $e70a946228a2cccd$var$StatusDotIcon;

});

parcelRequire.register("g2R7r", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bae6099345e5eea7$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $bae6099345e5eea7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QRCode = void 0;

var $1Hdcz = parcelRequire("1Hdcz");

var $2LSrt = parcelRequire("2LSrt");

const $bae6099345e5eea7$var$qrcode_svg_1 = $bae6099345e5eea7$var$__importDefault((parcelRequire("chbvN")));
const $bae6099345e5eea7$var$QRCode = (props)=>{
    const [svg, setSvg] = (0, $2LSrt.useState)("");
    (0, $2LSrt.useEffect)(()=>{
        var _a, _b;
        const qrcode = new $bae6099345e5eea7$var$qrcode_svg_1.default({
            content: props.content,
            background: props.bgColor || "#ffffff",
            color: props.fgColor || "#000000",
            container: "svg",
            ecl: "M",
            width: (_a = props.width) !== null && _a !== void 0 ? _a : 256,
            height: (_b = props.height) !== null && _b !== void 0 ? _b : 256,
            padding: 0,
            image: props.image
        });
        const base64 = $bae6099345e5eea7$require$Buffer.from(qrcode.svg(), "utf8").toString("base64");
        setSvg(`data:image/svg+xml;base64,${base64}`);
    });
    return svg ? (0, $1Hdcz.h)("img", {
        src: svg,
        alt: "QR Code"
    }) : null;
};
module.exports.QRCode = $bae6099345e5eea7$var$QRCode;

});
parcelRequire.register("chbvN", function(module, exports) {
/**
 * @fileoverview
 * - modified davidshimjs/qrcodejs library for use in node.js
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 *
 * @version 0.9.1 (2016-02-12)
 * @author davidshimjs, papnkukn
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 * @see <a href="https://github.com/davidshimjs/qrcodejs" target="_blank">https://github.com/davidshimjs/qrcodejs</a>
 */ //---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
function $8f0000931ce1e56b$var$QR8bitByte(data) {
    this.mode = $8f0000931ce1e56b$var$QRMode.MODE_8BIT_BYTE;
    this.data = data;
    this.parsedData = [];
    // Added to support UTF-8 Characters
    for(var i = 0, l = this.data.length; i < l; i++){
        var byteArray = [];
        var code = this.data.charCodeAt(i);
        if (code > 0x10000) {
            byteArray[0] = 0xF0 | (code & 0x1C0000) >>> 18;
            byteArray[1] = 0x80 | (code & 0x3F000) >>> 12;
            byteArray[2] = 0x80 | (code & 0xFC0) >>> 6;
            byteArray[3] = 0x80 | code & 0x3F;
        } else if (code > 0x800) {
            byteArray[0] = 0xE0 | (code & 0xF000) >>> 12;
            byteArray[1] = 0x80 | (code & 0xFC0) >>> 6;
            byteArray[2] = 0x80 | code & 0x3F;
        } else if (code > 0x80) {
            byteArray[0] = 0xC0 | (code & 0x7C0) >>> 6;
            byteArray[1] = 0x80 | code & 0x3F;
        } else byteArray[0] = code;
        this.parsedData.push(byteArray);
    }
    this.parsedData = Array.prototype.concat.apply([], this.parsedData);
    if (this.parsedData.length != this.data.length) {
        this.parsedData.unshift(191);
        this.parsedData.unshift(187);
        this.parsedData.unshift(239);
    }
}
$8f0000931ce1e56b$var$QR8bitByte.prototype = {
    getLength: function(buffer) {
        return this.parsedData.length;
    },
    write: function(buffer) {
        for(var i = 0, l = this.parsedData.length; i < l; i++)buffer.put(this.parsedData[i], 8);
    }
};
function $8f0000931ce1e56b$var$QRCodeModel(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
$8f0000931ce1e56b$var$QRCodeModel.prototype = {
    addData: function(data) {
        var newData = new $8f0000931ce1e56b$var$QR8bitByte(data);
        this.dataList.push(newData);
        this.dataCache = null;
    },
    isDark: function(row, col) {
        if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) throw new Error(row + "," + col);
        return this.modules[row][col];
    },
    getModuleCount: function() {
        return this.moduleCount;
    },
    make: function() {
        this.makeImpl(false, this.getBestMaskPattern());
    },
    makeImpl: function(test, maskPattern) {
        this.moduleCount = this.typeNumber * 4 + 17;
        this.modules = new Array(this.moduleCount);
        for(var row = 0; row < this.moduleCount; row++){
            this.modules[row] = new Array(this.moduleCount);
            for(var col = 0; col < this.moduleCount; col++)this.modules[row][col] = null;
        }
        this.setupPositionProbePattern(0, 0);
        this.setupPositionProbePattern(this.moduleCount - 7, 0);
        this.setupPositionProbePattern(0, this.moduleCount - 7);
        this.setupPositionAdjustPattern();
        this.setupTimingPattern();
        this.setupTypeInfo(test, maskPattern);
        if (this.typeNumber >= 7) this.setupTypeNumber(test);
        if (this.dataCache == null) this.dataCache = $8f0000931ce1e56b$var$QRCodeModel.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
        this.mapData(this.dataCache, maskPattern);
    },
    setupPositionProbePattern: function(row, col) {
        for(var r = -1; r <= 7; r++){
            if (row + r <= -1 || this.moduleCount <= row + r) continue;
            for(var c = -1; c <= 7; c++){
                if (col + c <= -1 || this.moduleCount <= col + c) continue;
                if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) this.modules[row + r][col + c] = true;
                else this.modules[row + r][col + c] = false;
            }
        }
    },
    getBestMaskPattern: function() {
        var minLostPoint = 0;
        var pattern = 0;
        for(var i = 0; i < 8; i++){
            this.makeImpl(true, i);
            var lostPoint = $8f0000931ce1e56b$var$QRUtil.getLostPoint(this);
            if (i == 0 || minLostPoint > lostPoint) {
                minLostPoint = lostPoint;
                pattern = i;
            }
        }
        return pattern;
    },
    createMovieClip: function(target_mc, instance_name, depth) {
        var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
        var cs = 1;
        this.make();
        for(var row = 0; row < this.modules.length; row++){
            var y = row * cs;
            for(var col = 0; col < this.modules[row].length; col++){
                var x = col * cs;
                var dark = this.modules[row][col];
                if (dark) {
                    qr_mc.beginFill(0, 100);
                    qr_mc.moveTo(x, y);
                    qr_mc.lineTo(x + cs, y);
                    qr_mc.lineTo(x + cs, y + cs);
                    qr_mc.lineTo(x, y + cs);
                    qr_mc.endFill();
                }
            }
        }
        return qr_mc;
    },
    setupTimingPattern: function() {
        for(var r = 8; r < this.moduleCount - 8; r++){
            if (this.modules[r][6] != null) continue;
            this.modules[r][6] = r % 2 == 0;
        }
        for(var c = 8; c < this.moduleCount - 8; c++){
            if (this.modules[6][c] != null) continue;
            this.modules[6][c] = c % 2 == 0;
        }
    },
    setupPositionAdjustPattern: function() {
        var pos = $8f0000931ce1e56b$var$QRUtil.getPatternPosition(this.typeNumber);
        for(var i = 0; i < pos.length; i++)for(var j = 0; j < pos.length; j++){
            var row = pos[i];
            var col = pos[j];
            if (this.modules[row][col] != null) continue;
            for(var r = -2; r <= 2; r++){
                for(var c = -2; c <= 2; c++)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) this.modules[row + r][col + c] = true;
                else this.modules[row + r][col + c] = false;
            }
        }
    },
    setupTypeNumber: function(test) {
        var bits = $8f0000931ce1e56b$var$QRUtil.getBCHTypeNumber(this.typeNumber);
        for(var i = 0; i < 18; i++){
            var mod = !test && (bits >> i & 1) == 1;
            this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
        }
        for(var i = 0; i < 18; i++){
            var mod = !test && (bits >> i & 1) == 1;
            this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
        }
    },
    setupTypeInfo: function(test, maskPattern) {
        var data = this.errorCorrectLevel << 3 | maskPattern;
        var bits = $8f0000931ce1e56b$var$QRUtil.getBCHTypeInfo(data);
        for(var i = 0; i < 15; i++){
            var mod = !test && (bits >> i & 1) == 1;
            if (i < 6) this.modules[i][8] = mod;
            else if (i < 8) this.modules[i + 1][8] = mod;
            else this.modules[this.moduleCount - 15 + i][8] = mod;
        }
        for(var i = 0; i < 15; i++){
            var mod = !test && (bits >> i & 1) == 1;
            if (i < 8) this.modules[8][this.moduleCount - i - 1] = mod;
            else if (i < 9) this.modules[8][15 - i - 1 + 1] = mod;
            else this.modules[8][15 - i - 1] = mod;
        }
        this.modules[this.moduleCount - 8][8] = !test;
    },
    mapData: function(data, maskPattern) {
        var inc = -1;
        var row = this.moduleCount - 1;
        var bitIndex = 7;
        var byteIndex = 0;
        for(var col = this.moduleCount - 1; col > 0; col -= 2){
            if (col == 6) col--;
            while(true){
                for(var c = 0; c < 2; c++)if (this.modules[row][col - c] == null) {
                    var dark = false;
                    if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                    var mask = $8f0000931ce1e56b$var$QRUtil.getMask(maskPattern, row, col - c);
                    if (mask) dark = !dark;
                    this.modules[row][col - c] = dark;
                    bitIndex--;
                    if (bitIndex == -1) {
                        byteIndex++;
                        bitIndex = 7;
                    }
                }
                row += inc;
                if (row < 0 || this.moduleCount <= row) {
                    row -= inc;
                    inc = -inc;
                    break;
                }
            }
        }
    }
};
$8f0000931ce1e56b$var$QRCodeModel.PAD0 = 0xEC;
$8f0000931ce1e56b$var$QRCodeModel.PAD1 = 0x11;
$8f0000931ce1e56b$var$QRCodeModel.createData = function(typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = $8f0000931ce1e56b$var$QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new $8f0000931ce1e56b$var$QRBitBuffer();
    for(var i = 0; i < dataList.length; i++){
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), $8f0000931ce1e56b$var$QRUtil.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    var totalDataCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
    if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
    while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
    while(true){
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($8f0000931ce1e56b$var$QRCodeModel.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($8f0000931ce1e56b$var$QRCodeModel.PAD1, 8);
    }
    return $8f0000931ce1e56b$var$QRCodeModel.createBytes(buffer, rsBlocks);
};
$8f0000931ce1e56b$var$QRCodeModel.createBytes = function(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for(var r = 0; r < rsBlocks.length; r++){
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for(var i = 0; i < dcdata[r].length; i++)dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        offset += dcCount;
        var rsPoly = $8f0000931ce1e56b$var$QRUtil.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new $8f0000931ce1e56b$var$QRPolynomial(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for(var i = 0; i < ecdata[r].length; i++){
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalCodeCount += rsBlocks[i].totalCount;
    var data = new Array(totalCodeCount);
    var index = 0;
    for(var i = 0; i < maxDcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < dcdata[r].length) data[index++] = dcdata[r][i];
    }
    for(var i = 0; i < maxEcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < ecdata[r].length) data[index++] = ecdata[r][i];
    }
    return data;
};
var $8f0000931ce1e56b$var$QRMode = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};
var $8f0000931ce1e56b$var$QRErrorCorrectLevel = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};
var $8f0000931ce1e56b$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var $8f0000931ce1e56b$var$QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(data) {
        var d = data << 10;
        while($8f0000931ce1e56b$var$QRUtil.getBCHDigit(d) - $8f0000931ce1e56b$var$QRUtil.getBCHDigit($8f0000931ce1e56b$var$QRUtil.G15) >= 0)d ^= $8f0000931ce1e56b$var$QRUtil.G15 << $8f0000931ce1e56b$var$QRUtil.getBCHDigit(d) - $8f0000931ce1e56b$var$QRUtil.getBCHDigit($8f0000931ce1e56b$var$QRUtil.G15);
        return (data << 10 | d) ^ $8f0000931ce1e56b$var$QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function(data) {
        var d = data << 12;
        while($8f0000931ce1e56b$var$QRUtil.getBCHDigit(d) - $8f0000931ce1e56b$var$QRUtil.getBCHDigit($8f0000931ce1e56b$var$QRUtil.G18) >= 0)d ^= $8f0000931ce1e56b$var$QRUtil.G18 << $8f0000931ce1e56b$var$QRUtil.getBCHDigit(d) - $8f0000931ce1e56b$var$QRUtil.getBCHDigit($8f0000931ce1e56b$var$QRUtil.G18);
        return data << 12 | d;
    },
    getBCHDigit: function(data) {
        var digit = 0;
        while(data != 0){
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function(typeNumber) {
        return $8f0000931ce1e56b$var$QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function(maskPattern, i, j) {
        switch(maskPattern){
            case $8f0000931ce1e56b$var$QRMaskPattern.PATTERN000:
                return (i + j) % 2 == 0;
            case $8f0000931ce1e56b$var$QRMaskPattern.PATTERN001:
                return i % 2 == 0;
            case $8f0000931ce1e56b$var$QRMaskPattern.PATTERN010:
                return j % 3 == 0;
            case $8f0000931ce1e56b$var$QRMaskPattern.PATTERN011:
                return (i + j) % 3 == 0;
            case $8f0000931ce1e56b$var$QRMaskPattern.PATTERN100:
                return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case $8f0000931ce1e56b$var$QRMaskPattern.PATTERN101:
                return i * j % 2 + i * j % 3 == 0;
            case $8f0000931ce1e56b$var$QRMaskPattern.PATTERN110:
                return (i * j % 2 + i * j % 3) % 2 == 0;
            case $8f0000931ce1e56b$var$QRMaskPattern.PATTERN111:
                return (i * j % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function(errorCorrectLength) {
        var a = new $8f0000931ce1e56b$var$QRPolynomial([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i++)a = a.multiply(new $8f0000931ce1e56b$var$QRPolynomial([
            1,
            $8f0000931ce1e56b$var$QRMath.gexp(i)
        ], 0));
        return a;
    },
    getLengthInBits: function(mode, type) {
        if (1 <= type && type < 10) switch(mode){
            case $8f0000931ce1e56b$var$QRMode.MODE_NUMBER:
                return 10;
            case $8f0000931ce1e56b$var$QRMode.MODE_ALPHA_NUM:
                return 9;
            case $8f0000931ce1e56b$var$QRMode.MODE_8BIT_BYTE:
                return 8;
            case $8f0000931ce1e56b$var$QRMode.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) switch(mode){
            case $8f0000931ce1e56b$var$QRMode.MODE_NUMBER:
                return 12;
            case $8f0000931ce1e56b$var$QRMode.MODE_ALPHA_NUM:
                return 11;
            case $8f0000931ce1e56b$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $8f0000931ce1e56b$var$QRMode.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) switch(mode){
            case $8f0000931ce1e56b$var$QRMode.MODE_NUMBER:
                return 14;
            case $8f0000931ce1e56b$var$QRMode.MODE_ALPHA_NUM:
                return 13;
            case $8f0000931ce1e56b$var$QRMode.MODE_8BIT_BYTE:
                return 16;
            case $8f0000931ce1e56b$var$QRMode.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    },
    getLostPoint: function(qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        for(var row = 0; row < moduleCount; row++)for(var col = 0; col < moduleCount; col++){
            var sameCount = 0;
            var dark = qrCode.isDark(row, col);
            for(var r = -1; r <= 1; r++){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c++){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrCode.isDark(row + r, col + c)) sameCount++;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        for(var row = 0; row < moduleCount - 1; row++)for(var col = 0; col < moduleCount - 1; col++){
            var count = 0;
            if (qrCode.isDark(row, col)) count++;
            if (qrCode.isDark(row + 1, col)) count++;
            if (qrCode.isDark(row, col + 1)) count++;
            if (qrCode.isDark(row + 1, col + 1)) count++;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        for(var row = 0; row < moduleCount; row++){
            for(var col = 0; col < moduleCount - 6; col++)if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount - 6; row++)if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) lostPoint += 40;
        }
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount; row++)if (qrCode.isDark(row, col)) darkCount++;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
var $8f0000931ce1e56b$var$QRMath = {
    glog: function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return $8f0000931ce1e56b$var$QRMath.LOG_TABLE[n];
    },
    gexp: function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return $8f0000931ce1e56b$var$QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for(var $8f0000931ce1e56b$var$i = 0; $8f0000931ce1e56b$var$i < 8; $8f0000931ce1e56b$var$i++)$8f0000931ce1e56b$var$QRMath.EXP_TABLE[$8f0000931ce1e56b$var$i] = 1 << $8f0000931ce1e56b$var$i;
for(var $8f0000931ce1e56b$var$i = 8; $8f0000931ce1e56b$var$i < 256; $8f0000931ce1e56b$var$i++)$8f0000931ce1e56b$var$QRMath.EXP_TABLE[$8f0000931ce1e56b$var$i] = $8f0000931ce1e56b$var$QRMath.EXP_TABLE[$8f0000931ce1e56b$var$i - 4] ^ $8f0000931ce1e56b$var$QRMath.EXP_TABLE[$8f0000931ce1e56b$var$i - 5] ^ $8f0000931ce1e56b$var$QRMath.EXP_TABLE[$8f0000931ce1e56b$var$i - 6] ^ $8f0000931ce1e56b$var$QRMath.EXP_TABLE[$8f0000931ce1e56b$var$i - 8];
for(var $8f0000931ce1e56b$var$i = 0; $8f0000931ce1e56b$var$i < 255; $8f0000931ce1e56b$var$i++)$8f0000931ce1e56b$var$QRMath.LOG_TABLE[$8f0000931ce1e56b$var$QRMath.EXP_TABLE[$8f0000931ce1e56b$var$i]] = $8f0000931ce1e56b$var$i;
function $8f0000931ce1e56b$var$QRPolynomial(num, shift) {
    if (num.length == undefined) throw new Error(num.length + "/" + shift);
    var offset = 0;
    while(offset < num.length && num[offset] == 0)offset++;
    this.num = new Array(num.length - offset + shift);
    for(var i = 0; i < num.length - offset; i++)this.num[i] = num[i + offset];
}
$8f0000931ce1e56b$var$QRPolynomial.prototype = {
    get: function(index) {
        return this.num[index];
    },
    getLength: function() {
        return this.num.length;
    },
    multiply: function(e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for(var i = 0; i < this.getLength(); i++)for(var j = 0; j < e.getLength(); j++)num[i + j] ^= $8f0000931ce1e56b$var$QRMath.gexp($8f0000931ce1e56b$var$QRMath.glog(this.get(i)) + $8f0000931ce1e56b$var$QRMath.glog(e.get(j)));
        return new $8f0000931ce1e56b$var$QRPolynomial(num, 0);
    },
    mod: function(e) {
        if (this.getLength() - e.getLength() < 0) return this;
        var ratio = $8f0000931ce1e56b$var$QRMath.glog(this.get(0)) - $8f0000931ce1e56b$var$QRMath.glog(e.get(0));
        var num = new Array(this.getLength());
        for(var i = 0; i < this.getLength(); i++)num[i] = this.get(i);
        for(var i = 0; i < e.getLength(); i++)num[i] ^= $8f0000931ce1e56b$var$QRMath.gexp($8f0000931ce1e56b$var$QRMath.glog(e.get(i)) + ratio);
        return new $8f0000931ce1e56b$var$QRPolynomial(num, 0).mod(e);
    }
};
function $8f0000931ce1e56b$var$QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
$8f0000931ce1e56b$var$QRRSBlock.RS_BLOCK_TABLE = [
    [
        1,
        26,
        19
    ],
    [
        1,
        26,
        16
    ],
    [
        1,
        26,
        13
    ],
    [
        1,
        26,
        9
    ],
    [
        1,
        44,
        34
    ],
    [
        1,
        44,
        28
    ],
    [
        1,
        44,
        22
    ],
    [
        1,
        44,
        16
    ],
    [
        1,
        70,
        55
    ],
    [
        1,
        70,
        44
    ],
    [
        2,
        35,
        17
    ],
    [
        2,
        35,
        13
    ],
    [
        1,
        100,
        80
    ],
    [
        2,
        50,
        32
    ],
    [
        2,
        50,
        24
    ],
    [
        4,
        25,
        9
    ],
    [
        1,
        134,
        108
    ],
    [
        2,
        67,
        43
    ],
    [
        2,
        33,
        15,
        2,
        34,
        16
    ],
    [
        2,
        33,
        11,
        2,
        34,
        12
    ],
    [
        2,
        86,
        68
    ],
    [
        4,
        43,
        27
    ],
    [
        4,
        43,
        19
    ],
    [
        4,
        43,
        15
    ],
    [
        2,
        98,
        78
    ],
    [
        4,
        49,
        31
    ],
    [
        2,
        32,
        14,
        4,
        33,
        15
    ],
    [
        4,
        39,
        13,
        1,
        40,
        14
    ],
    [
        2,
        121,
        97
    ],
    [
        2,
        60,
        38,
        2,
        61,
        39
    ],
    [
        4,
        40,
        18,
        2,
        41,
        19
    ],
    [
        4,
        40,
        14,
        2,
        41,
        15
    ],
    [
        2,
        146,
        116
    ],
    [
        3,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        36,
        16,
        4,
        37,
        17
    ],
    [
        4,
        36,
        12,
        4,
        37,
        13
    ],
    [
        2,
        86,
        68,
        2,
        87,
        69
    ],
    [
        4,
        69,
        43,
        1,
        70,
        44
    ],
    [
        6,
        43,
        19,
        2,
        44,
        20
    ],
    [
        6,
        43,
        15,
        2,
        44,
        16
    ],
    [
        4,
        101,
        81
    ],
    [
        1,
        80,
        50,
        4,
        81,
        51
    ],
    [
        4,
        50,
        22,
        4,
        51,
        23
    ],
    [
        3,
        36,
        12,
        8,
        37,
        13
    ],
    [
        2,
        116,
        92,
        2,
        117,
        93
    ],
    [
        6,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        46,
        20,
        6,
        47,
        21
    ],
    [
        7,
        42,
        14,
        4,
        43,
        15
    ],
    [
        4,
        133,
        107
    ],
    [
        8,
        59,
        37,
        1,
        60,
        38
    ],
    [
        8,
        44,
        20,
        4,
        45,
        21
    ],
    [
        12,
        33,
        11,
        4,
        34,
        12
    ],
    [
        3,
        145,
        115,
        1,
        146,
        116
    ],
    [
        4,
        64,
        40,
        5,
        65,
        41
    ],
    [
        11,
        36,
        16,
        5,
        37,
        17
    ],
    [
        11,
        36,
        12,
        5,
        37,
        13
    ],
    [
        5,
        109,
        87,
        1,
        110,
        88
    ],
    [
        5,
        65,
        41,
        5,
        66,
        42
    ],
    [
        5,
        54,
        24,
        7,
        55,
        25
    ],
    [
        11,
        36,
        12
    ],
    [
        5,
        122,
        98,
        1,
        123,
        99
    ],
    [
        7,
        73,
        45,
        3,
        74,
        46
    ],
    [
        15,
        43,
        19,
        2,
        44,
        20
    ],
    [
        3,
        45,
        15,
        13,
        46,
        16
    ],
    [
        1,
        135,
        107,
        5,
        136,
        108
    ],
    [
        10,
        74,
        46,
        1,
        75,
        47
    ],
    [
        1,
        50,
        22,
        15,
        51,
        23
    ],
    [
        2,
        42,
        14,
        17,
        43,
        15
    ],
    [
        5,
        150,
        120,
        1,
        151,
        121
    ],
    [
        9,
        69,
        43,
        4,
        70,
        44
    ],
    [
        17,
        50,
        22,
        1,
        51,
        23
    ],
    [
        2,
        42,
        14,
        19,
        43,
        15
    ],
    [
        3,
        141,
        113,
        4,
        142,
        114
    ],
    [
        3,
        70,
        44,
        11,
        71,
        45
    ],
    [
        17,
        47,
        21,
        4,
        48,
        22
    ],
    [
        9,
        39,
        13,
        16,
        40,
        14
    ],
    [
        3,
        135,
        107,
        5,
        136,
        108
    ],
    [
        3,
        67,
        41,
        13,
        68,
        42
    ],
    [
        15,
        54,
        24,
        5,
        55,
        25
    ],
    [
        15,
        43,
        15,
        10,
        44,
        16
    ],
    [
        4,
        144,
        116,
        4,
        145,
        117
    ],
    [
        17,
        68,
        42
    ],
    [
        17,
        50,
        22,
        6,
        51,
        23
    ],
    [
        19,
        46,
        16,
        6,
        47,
        17
    ],
    [
        2,
        139,
        111,
        7,
        140,
        112
    ],
    [
        17,
        74,
        46
    ],
    [
        7,
        54,
        24,
        16,
        55,
        25
    ],
    [
        34,
        37,
        13
    ],
    [
        4,
        151,
        121,
        5,
        152,
        122
    ],
    [
        4,
        75,
        47,
        14,
        76,
        48
    ],
    [
        11,
        54,
        24,
        14,
        55,
        25
    ],
    [
        16,
        45,
        15,
        14,
        46,
        16
    ],
    [
        6,
        147,
        117,
        4,
        148,
        118
    ],
    [
        6,
        73,
        45,
        14,
        74,
        46
    ],
    [
        11,
        54,
        24,
        16,
        55,
        25
    ],
    [
        30,
        46,
        16,
        2,
        47,
        17
    ],
    [
        8,
        132,
        106,
        4,
        133,
        107
    ],
    [
        8,
        75,
        47,
        13,
        76,
        48
    ],
    [
        7,
        54,
        24,
        22,
        55,
        25
    ],
    [
        22,
        45,
        15,
        13,
        46,
        16
    ],
    [
        10,
        142,
        114,
        2,
        143,
        115
    ],
    [
        19,
        74,
        46,
        4,
        75,
        47
    ],
    [
        28,
        50,
        22,
        6,
        51,
        23
    ],
    [
        33,
        46,
        16,
        4,
        47,
        17
    ],
    [
        8,
        152,
        122,
        4,
        153,
        123
    ],
    [
        22,
        73,
        45,
        3,
        74,
        46
    ],
    [
        8,
        53,
        23,
        26,
        54,
        24
    ],
    [
        12,
        45,
        15,
        28,
        46,
        16
    ],
    [
        3,
        147,
        117,
        10,
        148,
        118
    ],
    [
        3,
        73,
        45,
        23,
        74,
        46
    ],
    [
        4,
        54,
        24,
        31,
        55,
        25
    ],
    [
        11,
        45,
        15,
        31,
        46,
        16
    ],
    [
        7,
        146,
        116,
        7,
        147,
        117
    ],
    [
        21,
        73,
        45,
        7,
        74,
        46
    ],
    [
        1,
        53,
        23,
        37,
        54,
        24
    ],
    [
        19,
        45,
        15,
        26,
        46,
        16
    ],
    [
        5,
        145,
        115,
        10,
        146,
        116
    ],
    [
        19,
        75,
        47,
        10,
        76,
        48
    ],
    [
        15,
        54,
        24,
        25,
        55,
        25
    ],
    [
        23,
        45,
        15,
        25,
        46,
        16
    ],
    [
        13,
        145,
        115,
        3,
        146,
        116
    ],
    [
        2,
        74,
        46,
        29,
        75,
        47
    ],
    [
        42,
        54,
        24,
        1,
        55,
        25
    ],
    [
        23,
        45,
        15,
        28,
        46,
        16
    ],
    [
        17,
        145,
        115
    ],
    [
        10,
        74,
        46,
        23,
        75,
        47
    ],
    [
        10,
        54,
        24,
        35,
        55,
        25
    ],
    [
        19,
        45,
        15,
        35,
        46,
        16
    ],
    [
        17,
        145,
        115,
        1,
        146,
        116
    ],
    [
        14,
        74,
        46,
        21,
        75,
        47
    ],
    [
        29,
        54,
        24,
        19,
        55,
        25
    ],
    [
        11,
        45,
        15,
        46,
        46,
        16
    ],
    [
        13,
        145,
        115,
        6,
        146,
        116
    ],
    [
        14,
        74,
        46,
        23,
        75,
        47
    ],
    [
        44,
        54,
        24,
        7,
        55,
        25
    ],
    [
        59,
        46,
        16,
        1,
        47,
        17
    ],
    [
        12,
        151,
        121,
        7,
        152,
        122
    ],
    [
        12,
        75,
        47,
        26,
        76,
        48
    ],
    [
        39,
        54,
        24,
        14,
        55,
        25
    ],
    [
        22,
        45,
        15,
        41,
        46,
        16
    ],
    [
        6,
        151,
        121,
        14,
        152,
        122
    ],
    [
        6,
        75,
        47,
        34,
        76,
        48
    ],
    [
        46,
        54,
        24,
        10,
        55,
        25
    ],
    [
        2,
        45,
        15,
        64,
        46,
        16
    ],
    [
        17,
        152,
        122,
        4,
        153,
        123
    ],
    [
        29,
        74,
        46,
        14,
        75,
        47
    ],
    [
        49,
        54,
        24,
        10,
        55,
        25
    ],
    [
        24,
        45,
        15,
        46,
        46,
        16
    ],
    [
        4,
        152,
        122,
        18,
        153,
        123
    ],
    [
        13,
        74,
        46,
        32,
        75,
        47
    ],
    [
        48,
        54,
        24,
        14,
        55,
        25
    ],
    [
        42,
        45,
        15,
        32,
        46,
        16
    ],
    [
        20,
        147,
        117,
        4,
        148,
        118
    ],
    [
        40,
        75,
        47,
        7,
        76,
        48
    ],
    [
        43,
        54,
        24,
        22,
        55,
        25
    ],
    [
        10,
        45,
        15,
        67,
        46,
        16
    ],
    [
        19,
        148,
        118,
        6,
        149,
        119
    ],
    [
        18,
        75,
        47,
        31,
        76,
        48
    ],
    [
        34,
        54,
        24,
        34,
        55,
        25
    ],
    [
        20,
        45,
        15,
        61,
        46,
        16
    ]
];
$8f0000931ce1e56b$var$QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
    var rsBlock = $8f0000931ce1e56b$var$QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    var length = rsBlock.length / 3;
    var list = [];
    for(var i = 0; i < length; i++){
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for(var j = 0; j < count; j++)list.push(new $8f0000931ce1e56b$var$QRRSBlock(totalCount, dataCount));
    }
    return list;
};
$8f0000931ce1e56b$var$QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
    switch(errorCorrectLevel){
        case $8f0000931ce1e56b$var$QRErrorCorrectLevel.L:
            return $8f0000931ce1e56b$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case $8f0000931ce1e56b$var$QRErrorCorrectLevel.M:
            return $8f0000931ce1e56b$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case $8f0000931ce1e56b$var$QRErrorCorrectLevel.Q:
            return $8f0000931ce1e56b$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case $8f0000931ce1e56b$var$QRErrorCorrectLevel.H:
            return $8f0000931ce1e56b$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
function $8f0000931ce1e56b$var$QRBitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$8f0000931ce1e56b$var$QRBitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
var $8f0000931ce1e56b$var$QRCodeLimitLength = [
    [
        17,
        14,
        11,
        7
    ],
    [
        32,
        26,
        20,
        14
    ],
    [
        53,
        42,
        32,
        24
    ],
    [
        78,
        62,
        46,
        34
    ],
    [
        106,
        84,
        60,
        44
    ],
    [
        134,
        106,
        74,
        58
    ],
    [
        154,
        122,
        86,
        64
    ],
    [
        192,
        152,
        108,
        84
    ],
    [
        230,
        180,
        130,
        98
    ],
    [
        271,
        213,
        151,
        119
    ],
    [
        321,
        251,
        177,
        137
    ],
    [
        367,
        287,
        203,
        155
    ],
    [
        425,
        331,
        241,
        177
    ],
    [
        458,
        362,
        258,
        194
    ],
    [
        520,
        412,
        292,
        220
    ],
    [
        586,
        450,
        322,
        250
    ],
    [
        644,
        504,
        364,
        280
    ],
    [
        718,
        560,
        394,
        310
    ],
    [
        792,
        624,
        442,
        338
    ],
    [
        858,
        666,
        482,
        382
    ],
    [
        929,
        711,
        509,
        403
    ],
    [
        1003,
        779,
        565,
        439
    ],
    [
        1091,
        857,
        611,
        461
    ],
    [
        1171,
        911,
        661,
        511
    ],
    [
        1273,
        997,
        715,
        535
    ],
    [
        1367,
        1059,
        751,
        593
    ],
    [
        1465,
        1125,
        805,
        625
    ],
    [
        1528,
        1190,
        868,
        658
    ],
    [
        1628,
        1264,
        908,
        698
    ],
    [
        1732,
        1370,
        982,
        742
    ],
    [
        1840,
        1452,
        1030,
        790
    ],
    [
        1952,
        1538,
        1112,
        842
    ],
    [
        2068,
        1628,
        1168,
        898
    ],
    [
        2188,
        1722,
        1228,
        958
    ],
    [
        2303,
        1809,
        1283,
        983
    ],
    [
        2431,
        1911,
        1351,
        1051
    ],
    [
        2563,
        1989,
        1423,
        1093
    ],
    [
        2699,
        2099,
        1499,
        1139
    ],
    [
        2809,
        2213,
        1579,
        1219
    ],
    [
        2953,
        2331,
        1663,
        1273
    ]
];
/** Constructor */ function $8f0000931ce1e56b$var$QRCode(options) {
    var instance = this;
    //Default options
    this.options = {
        padding: 4,
        width: 256,
        height: 256,
        typeNumber: 4,
        color: "#000000",
        background: "#ffffff",
        ecl: "M",
        image: {
            svg: "",
            width: 0,
            height: 0
        }
    };
    //In case the options is string
    if (typeof options === "string") options = {
        content: options
    };
    //Merge options
    if (options) for(var i in options)this.options[i] = options[i];
    if (typeof this.options.content !== "string") throw new Error("Expected 'content' as string!");
    if (this.options.content.length === 0 /* || this.options.content.length > 7089 */ ) throw new Error("Expected 'content' to be non-empty!");
    if (!(this.options.padding >= 0)) throw new Error("Expected 'padding' value to be non-negative!");
    if (!(this.options.width > 0) || !(this.options.height > 0)) throw new Error("Expected 'width' or 'height' value to be higher than zero!");
    //Gets the error correction level
    function _getErrorCorrectLevel(ecl) {
        switch(ecl){
            case "L":
                return $8f0000931ce1e56b$var$QRErrorCorrectLevel.L;
            case "M":
                return $8f0000931ce1e56b$var$QRErrorCorrectLevel.M;
            case "Q":
                return $8f0000931ce1e56b$var$QRErrorCorrectLevel.Q;
            case "H":
                return $8f0000931ce1e56b$var$QRErrorCorrectLevel.H;
            default:
                throw new Error("Unknwon error correction level: " + ecl);
        }
    }
    //Get type number
    function _getTypeNumber(content, ecl) {
        var length = _getUTF8Length(content);
        var type = 1;
        var limit = 0;
        for(var i = 0, len = $8f0000931ce1e56b$var$QRCodeLimitLength.length; i <= len; i++){
            var table = $8f0000931ce1e56b$var$QRCodeLimitLength[i];
            if (!table) throw new Error("Content too long: expected " + limit + " but got " + length);
            switch(ecl){
                case "L":
                    limit = table[0];
                    break;
                case "M":
                    limit = table[1];
                    break;
                case "Q":
                    limit = table[2];
                    break;
                case "H":
                    limit = table[3];
                    break;
                default:
                    throw new Error("Unknwon error correction level: " + ecl);
            }
            if (length <= limit) break;
            type++;
        }
        if (type > $8f0000931ce1e56b$var$QRCodeLimitLength.length) throw new Error("Content too long");
        return type;
    }
    //Gets text length
    function _getUTF8Length(content) {
        var result = encodeURI(content).toString().replace(/\%[0-9a-fA-F]{2}/g, "a");
        return result.length + (result.length != content ? 3 : 0);
    }
    //Generate QR Code matrix
    var content = this.options.content;
    var type = _getTypeNumber(content, this.options.ecl);
    var ecl = _getErrorCorrectLevel(this.options.ecl);
    this.qrcode = new $8f0000931ce1e56b$var$QRCodeModel(type, ecl);
    this.qrcode.addData(content);
    this.qrcode.make();
}
/** Generates QR Code as SVG image */ $8f0000931ce1e56b$var$QRCode.prototype.svg = function(opt) {
    var options = this.options || {};
    var modules = this.qrcode.modules;
    if (typeof opt == "undefined") opt = {
        container: options.container || "svg"
    };
    //Apply new lines and indents in SVG?
    var pretty = typeof options.pretty != "undefined" ? !!options.pretty : true;
    var indent = pretty ? "  " : "";
    var EOL = pretty ? "\r\n" : "";
    var width = options.width;
    var height = options.height;
    var length = modules.length;
    var xsize = width / (length + 2 * options.padding);
    var ysize = height / (length + 2 * options.padding);
    //Join (union, merge) rectangles into one shape?
    var join = typeof options.join != "undefined" ? !!options.join : false;
    //Swap the X and Y modules, pull request #2
    var swap = typeof options.swap != "undefined" ? !!options.swap : false;
    //Apply <?xml...?> declaration in SVG?
    var xmlDeclaration = typeof options.xmlDeclaration != "undefined" ? !!options.xmlDeclaration : true;
    //Populate with predefined shape instead of "rect" elements, thanks to @kkocdko
    var predefined = typeof options.predefined != "undefined" ? !!options.predefined : false;
    var defs = predefined ? indent + '<defs><path id="qrmodule" d="M0 0 h' + ysize + " v" + xsize + ' H0 z" style="fill:' + options.color + ';shape-rendering:crispEdges;" /></defs>' + EOL : "";
    //Background rectangle
    var bgrect = indent + '<rect x="0" y="0" width="' + width + '" height="' + height + '" style="fill:' + options.background + ';shape-rendering:crispEdges;"/>' + EOL;
    //Rectangles representing modules
    var modrect = "";
    var pathdata = "";
    for(var y = 0; y < length; y++)for(var x = 0; x < length; x++){
        var module1 = modules[x][y];
        if (module1) {
            var px = x * xsize + options.padding * xsize;
            var py = y * ysize + options.padding * ysize;
            //Some users have had issues with the QR Code, thanks to @danioso for the solution
            if (swap) {
                var t = px;
                px = py;
                py = t;
            }
            if (join) {
                //Module as a part of svg path data, thanks to @danioso
                var w = xsize + px;
                var h = ysize + py;
                px = Number.isInteger(px) ? Number(px) : px.toFixed(2);
                py = Number.isInteger(py) ? Number(py) : py.toFixed(2);
                w = Number.isInteger(w) ? Number(w) : w.toFixed(2);
                h = Number.isInteger(h) ? Number(h) : h.toFixed(2);
                pathdata += "M" + px + "," + py + " V" + h + " H" + w + " V" + py + " H" + px + " Z ";
            } else if (predefined) //Module as a predefined shape, thanks to @kkocdko
            modrect += indent + '<use x="' + px.toString() + '" y="' + py.toString() + '" href="#qrmodule" />' + EOL;
            else //Module as rectangle element
            modrect += indent + '<rect x="' + px.toString() + '" y="' + py.toString() + '" width="' + xsize + '" height="' + ysize + '" style="fill:' + options.color + ';shape-rendering:crispEdges;"/>' + EOL;
        }
    }
    if (join) modrect = indent + '<path x="0" y="0" style="fill:' + options.color + ';shape-rendering:crispEdges;" d="' + pathdata + '" />';
    let imgSvg = "";
    if (this.options.image !== undefined && this.options.image.svg) {
        const imgWidth = width * this.options.image.width / 100;
        const imgHeight = height * this.options.image.height / 100;
        const imgX = width / 2 - imgWidth / 2;
        const imgY = height / 2 - imgHeight / 2;
        imgSvg += `<svg x="${imgX}" y="${imgY}" width="${imgWidth}" height="${imgHeight}" viewBox="0 0 100 100" preserveAspectRatio="xMinYMin meet">`;
        imgSvg += this.options.image.svg + EOL;
        imgSvg += "</svg>";
    }
    var svg = "";
    switch(opt.container){
        //Wrapped in SVG document
        case "svg":
            if (xmlDeclaration) svg += '<?xml version="1.0" standalone="yes"?>' + EOL;
            svg += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + width + '" height="' + height + '">' + EOL;
            svg += defs + bgrect + modrect;
            svg += imgSvg;
            svg += "</svg>";
            break;
        //Viewbox for responsive use in a browser, thanks to @danioso
        case "svg-viewbox":
            if (xmlDeclaration) svg += '<?xml version="1.0" standalone="yes"?>' + EOL;
            svg += '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + width + " " + height + '">' + EOL;
            svg += defs + bgrect + modrect;
            svg += imgSvg;
            svg += "</svg>";
            break;
        //Wrapped in group element
        case "g":
            svg += '<g width="' + width + '" height="' + height + '">' + EOL;
            svg += defs + bgrect + modrect;
            svg += imgSvg;
            svg += "</g>";
            break;
        //Without a container
        default:
            svg += (defs + bgrect + modrect + imgSvg).replace(/^\s+/, ""); //Clear indents on each line
            break;
    }
    return svg;
};
module.exports = $8f0000931ce1e56b$var$QRCode;

});


parcelRequire.register("8kxCd", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $610a44506095b309$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spinner = void 0;

var $1Hdcz = parcelRequire("1Hdcz");

const $610a44506095b309$var$Spinner_css_1 = $610a44506095b309$var$__importDefault((parcelRequire("1boiV")));
const $610a44506095b309$var$Spinner = (props)=>{
    var _a;
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 64;
    const color = props.color || "#000";
    return (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-spinner"
    }, (0, $1Hdcz.h)("style", null, $610a44506095b309$var$Spinner_css_1.default), (0, $1Hdcz.h)("svg", {
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            width: size,
            height: size
        }
    }, (0, $1Hdcz.h)("circle", {
        style: {
            cx: 50,
            cy: 50,
            r: 45,
            stroke: color
        }
    })));
};
module.exports.Spinner = $610a44506095b309$var$Spinner;

});
parcelRequire.register("1boiV", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = `.-cbwsdk-css-reset .-cbwsdk-spinner{display:inline-block}.-cbwsdk-css-reset .-cbwsdk-spinner svg{display:inline-block;animation:2s linear infinite -cbwsdk-spinner-svg}.-cbwsdk-css-reset .-cbwsdk-spinner svg circle{animation:1.9s ease-in-out infinite both -cbwsdk-spinner-circle;display:block;fill:rgba(0,0,0,0);stroke-dasharray:283;stroke-dashoffset:280;stroke-linecap:round;stroke-width:10px;transform-origin:50% 50%}@keyframes -cbwsdk-spinner-svg{0%{transform:rotateZ(0deg)}100%{transform:rotateZ(360deg)}}@keyframes -cbwsdk-spinner-circle{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}100%{stroke-dashoffset:280;transform:rotate(360deg)}}`;

});


parcelRequire.register("kWxjl", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = `.-cbwsdk-css-reset .-cbwsdk-connect-content{height:430px;width:700px;border-radius:12px;padding:30px}.-cbwsdk-css-reset .-cbwsdk-connect-content.light{background:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content.dark{background:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-content-header{display:flex;align-items:center;justify-content:space-between;margin:0 0 30px}.-cbwsdk-css-reset .-cbwsdk-connect-content-heading{font-style:normal;font-weight:500;font-size:28px;line-height:36px;margin:0}.-cbwsdk-css-reset .-cbwsdk-connect-content-heading.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-content-heading.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content-layout{display:flex;flex-direction:row}.-cbwsdk-css-reset .-cbwsdk-connect-content-column-left{margin-right:30px;display:flex;flex-direction:column;justify-content:space-between}.-cbwsdk-css-reset .-cbwsdk-connect-content-column-right{flex:25%;margin-right:34px}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-wrapper{width:220px;height:220px;border-radius:12px;display:flex;justify-content:center;align-items:center;background:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting{position:absolute;top:0;bottom:0;left:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.light{background-color:rgba(255,255,255,.95)}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.light>p{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.dark{background-color:rgba(10,11,13,.9)}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting.dark>p{color:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-content-qr-connecting>p{font-size:12px;font-weight:bold;margin-top:16px}.-cbwsdk-css-reset .-cbwsdk-connect-content-update-app{border-radius:8px;font-size:14px;line-height:20px;padding:12px;width:339px}.-cbwsdk-css-reset .-cbwsdk-connect-content-update-app.light{background:#eef0f3;color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-connect-content-update-app.dark{background:#1e2025;color:#8a919e}.-cbwsdk-css-reset .-cbwsdk-cancel-button{-webkit-appearance:none;border:none;background:none;cursor:pointer;padding:0;margin:0}.-cbwsdk-css-reset .-cbwsdk-cancel-button-x{position:relative;display:block;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-wallet-steps{padding:0 0 0 16px;margin:0;width:100%;list-style:decimal}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item{list-style-type:decimal;display:list-item;font-style:normal;font-weight:400;font-size:16px;line-height:24px;margin-top:20px}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-item-wrapper{display:flex;align-items:center}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-pad-left{margin-left:6px}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon{display:flex;border-radius:50%;height:24px;width:24px}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon svg{margin:auto;display:block}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon.light{background:#0052ff}.-cbwsdk-css-reset .-cbwsdk-wallet-steps-icon.dark{background:#588af5}.-cbwsdk-css-reset .-cbwsdk-connect-item{align-items:center;display:flex;flex-direction:row;padding:16px 24px;gap:12px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-connect-item.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-connect-item.light.selected{background:#f5f8ff;color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-connect-item.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-connect-item.dark.selected{background:#001033;color:#588af5}.-cbwsdk-css-reset .-cbwsdk-connect-item.selected{border-radius:100px;font-weight:600}.-cbwsdk-css-reset .-cbwsdk-connect-item-copy-wrapper{margin:0 4px 0 8px}.-cbwsdk-css-reset .-cbwsdk-connect-item-title{margin:0 0 0;font-size:16px;line-height:24px;font-weight:500}.-cbwsdk-css-reset .-cbwsdk-connect-item-description{font-weight:400;font-size:14px;line-height:20px;margin:0}`;

});


parcelRequire.register("2o0Sm", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $1bce8092ff3b1d7e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TryExtensionContent = void 0;

const $1bce8092ff3b1d7e$var$clsx_1 = $1bce8092ff3b1d7e$var$__importDefault((parcelRequire("1SA7b")));

var $1Hdcz = parcelRequire("1Hdcz");

var $2LSrt = parcelRequire("2LSrt");

var $jlo4N = parcelRequire("jlo4N");

var $dGXTh = parcelRequire("dGXTh");

var $1J4MT = parcelRequire("1J4MT");

const $1bce8092ff3b1d7e$var$TryExtensionContent_css_1 = $1bce8092ff3b1d7e$var$__importDefault((parcelRequire("5Tjat")));
function $1bce8092ff3b1d7e$var$TryExtensionContent({ theme: theme }) {
    const [clicked, setClicked] = (0, $2LSrt.useState)(false);
    const handleInstallClick = (0, $2LSrt.useCallback)(()=>{
        window.open("https://api.wallet.coinbase.com/rpc/v2/desktop/chrome", "_blank");
    }, []);
    const handleClick = (0, $2LSrt.useCallback)(()=>{
        if (clicked) window.location.reload();
        else {
            handleInstallClick();
            setClicked(true);
        }
    }, [
        handleInstallClick,
        clicked
    ]);
    return (0, $1Hdcz.h)("div", {
        class: (0, $1bce8092ff3b1d7e$var$clsx_1.default)("-cbwsdk-try-extension", theme)
    }, (0, $1Hdcz.h)("style", null, $1bce8092ff3b1d7e$var$TryExtensionContent_css_1.default), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-try-extension-column-half"
    }, (0, $1Hdcz.h)("h3", {
        class: (0, $1bce8092ff3b1d7e$var$clsx_1.default)("-cbwsdk-try-extension-heading", theme)
    }, "Or try the Coinbase Wallet browser extension"), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-try-extension-cta-wrapper"
    }, (0, $1Hdcz.h)("button", {
        class: (0, $1bce8092ff3b1d7e$var$clsx_1.default)("-cbwsdk-try-extension-cta", theme),
        onClick: handleClick
    }, clicked ? "Refresh" : "Install"), (0, $1Hdcz.h)("div", null, !clicked && (0, $1Hdcz.h)($jlo4N.ArrowLeftIcon, {
        class: "-cbwsdk-try-extension-cta-icon",
        fill: theme === "light" ? "#0052FF" : "#588AF5"
    })))), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-try-extension-column-half"
    }, (0, $1Hdcz.h)("ul", {
        class: "-cbwsdk-try-extension-list"
    }, (0, $1Hdcz.h)("li", {
        class: "-cbwsdk-try-extension-list-item"
    }, (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-try-extension-list-item-icon-wrapper"
    }, (0, $1Hdcz.h)("span", {
        class: (0, $1bce8092ff3b1d7e$var$clsx_1.default)("-cbwsdk-try-extension-list-item-icon", theme)
    }, (0, $1Hdcz.h)($dGXTh.LaptopIcon, {
        fill: theme === "light" ? "#0A0B0D" : "#FFFFFF"
    }))), (0, $1Hdcz.h)("div", {
        class: (0, $1bce8092ff3b1d7e$var$clsx_1.default)("-cbwsdk-try-extension-list-item-copy", theme)
    }, "Connect with dapps with just one click on your desktop browser")), (0, $1Hdcz.h)("li", {
        class: "-cbwsdk-try-extension-list-item"
    }, (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-try-extension-list-item-icon-wrapper"
    }, (0, $1Hdcz.h)("span", {
        class: (0, $1bce8092ff3b1d7e$var$clsx_1.default)("-cbwsdk-try-extension-list-item-icon", theme)
    }, (0, $1Hdcz.h)($1J4MT.SafeIcon, {
        fill: theme === "light" ? "#0A0B0D" : "#FFFFFF"
    }))), (0, $1Hdcz.h)("div", {
        class: (0, $1bce8092ff3b1d7e$var$clsx_1.default)("-cbwsdk-try-extension-list-item-copy", theme)
    }, "Add an additional layer of security by using a supported Ledger hardware wallet")))));
}
module.exports.TryExtensionContent = $1bce8092ff3b1d7e$var$TryExtensionContent;

});
parcelRequire.register("jlo4N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrowLeftIcon = void 0;

var $1Hdcz = parcelRequire("1Hdcz");
function $e152a78f145992a9$var$ArrowLeftIcon(props) {
    return (0, $1Hdcz.h)("svg", Object.assign({
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), (0, $1Hdcz.h)("path", {
        d: "M8.60675 0.155884L7.37816 1.28209L12.7723 7.16662H0V8.83328H12.6548L6.82149 14.6666L8 15.8451L15.8201 8.02501L8.60675 0.155884Z"
    }));
}
module.exports.ArrowLeftIcon = $e152a78f145992a9$var$ArrowLeftIcon;

});

parcelRequire.register("dGXTh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LaptopIcon = void 0;

var $1Hdcz = parcelRequire("1Hdcz");
function $9f7da7a5c0302360$var$LaptopIcon(props) {
    return (0, $1Hdcz.h)("svg", Object.assign({
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), (0, $1Hdcz.h)("path", {
        d: "M1.8001 2.2002H12.2001V9.40019H1.8001V2.2002ZM3.4001 3.8002V7.80019H10.6001V3.8002H3.4001Z"
    }), (0, $1Hdcz.h)("path", {
        d: "M13.4001 10.2002H0.600098C0.600098 11.0838 1.31644 11.8002 2.2001 11.8002H11.8001C12.6838 11.8002 13.4001 11.0838 13.4001 10.2002Z"
    }));
}
module.exports.LaptopIcon = $9f7da7a5c0302360$var$LaptopIcon;

});

parcelRequire.register("1J4MT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeIcon = void 0;

var $1Hdcz = parcelRequire("1Hdcz");
function $141db52569160f5e$var$SafeIcon(props) {
    return (0, $1Hdcz.h)("svg", Object.assign({
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), (0, $1Hdcz.h)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M0.600098 0.600098V11.8001H13.4001V0.600098H0.600098ZM7.0001 9.2001C5.3441 9.2001 4.0001 7.8561 4.0001 6.2001C4.0001 4.5441 5.3441 3.2001 7.0001 3.2001C8.6561 3.2001 10.0001 4.5441 10.0001 6.2001C10.0001 7.8561 8.6561 9.2001 7.0001 9.2001ZM0.600098 12.6001H3.8001V13.4001H0.600098V12.6001ZM10.2001 12.6001H13.4001V13.4001H10.2001V12.6001ZM8.8001 6.2001C8.8001 7.19421 7.99421 8.0001 7.0001 8.0001C6.00598 8.0001 5.2001 7.19421 5.2001 6.2001C5.2001 5.20598 6.00598 4.4001 7.0001 4.4001C7.99421 4.4001 8.8001 5.20598 8.8001 6.2001Z"
    }));
}
module.exports.SafeIcon = $141db52569160f5e$var$SafeIcon;

});

parcelRequire.register("5Tjat", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = `.-cbwsdk-css-reset .-cbwsdk-try-extension{display:flex;margin-top:12px;height:202px;width:700px;border-radius:12px;padding:30px}.-cbwsdk-css-reset .-cbwsdk-try-extension.light{background:#fff}.-cbwsdk-css-reset .-cbwsdk-try-extension.dark{background:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-try-extension-column-half{flex:50%}.-cbwsdk-css-reset .-cbwsdk-try-extension-heading{font-style:normal;font-weight:500;font-size:25px;line-height:32px;margin:0;max-width:204px}.-cbwsdk-css-reset .-cbwsdk-try-extension-heading.light{color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-try-extension-heading.dark{color:#fff}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta{appearance:none;border:none;background:none;color:#0052ff;cursor:pointer;padding:0;text-decoration:none;display:block;font-weight:600;font-size:16px;line-height:24px}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta.light{color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta.dark{color:#588af5}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta-wrapper{display:flex;align-items:center;margin-top:12px}.-cbwsdk-css-reset .-cbwsdk-try-extension-cta-icon{display:block;margin-left:4px;height:14px}.-cbwsdk-css-reset .-cbwsdk-try-extension-list{display:flex;flex-direction:column;justify-content:center;align-items:center;margin:0;padding:0;list-style:none;height:100%}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item{display:flex;align-items:center;flex-flow:nowrap;margin-top:24px}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item:first-of-type{margin-top:0}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon-wrapper{display:block}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon{display:flex;height:32px;width:32px;border-radius:50%}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon svg{margin:auto;display:block}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon.light{background:#eef0f3}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-icon.dark{background:#1e2025}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-copy{display:block;font-weight:400;font-size:14px;line-height:20px;padding-left:12px}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-copy.light{color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-try-extension-list-item-copy.dark{color:#8a919e}`;

});


parcelRequire.register("7xnP4", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = `.-cbwsdk-css-reset .-cbwsdk-connect-dialog{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop{z-index:2147483647;position:fixed;top:0;left:0;right:0;bottom:0;transition:opacity .25s}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop.light{background-color:rgba(0,0,0,.5)}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop.dark{background-color:rgba(50,53,61,.4)}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-backdrop-hidden{opacity:0}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-box{display:flex;position:relative;flex-direction:column;transform:scale(1);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-box-hidden{opacity:0;transform:scale(0.85)}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-container{display:block}.-cbwsdk-css-reset .-cbwsdk-connect-dialog-container-hidden{display:none}`;

});



parcelRequire.register("4tT4E", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $34349769f498506c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SnackbarInstance = module.exports.SnackbarContainer = module.exports.Snackbar = void 0;

const $34349769f498506c$var$clsx_1 = $34349769f498506c$var$__importDefault((parcelRequire("1SA7b")));

var $1Hdcz = parcelRequire("1Hdcz");

var $2LSrt = parcelRequire("2LSrt");

const $34349769f498506c$var$Snackbar_css_1 = $34349769f498506c$var$__importDefault((parcelRequire("dE5ul")));
const $34349769f498506c$var$gearIcon = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDYuNzV2LTEuNWwtMS43Mi0uNTdjLS4wOC0uMjctLjE5LS41Mi0uMzItLjc3bC44MS0xLjYyLTEuMDYtMS4wNi0xLjYyLjgxYy0uMjQtLjEzLS41LS4yNC0uNzctLjMyTDYuNzUgMGgtMS41bC0uNTcgMS43MmMtLjI3LjA4LS41My4xOS0uNzcuMzJsLTEuNjItLjgxLTEuMDYgMS4wNi44MSAxLjYyYy0uMTMuMjQtLjI0LjUtLjMyLjc3TDAgNS4yNXYxLjVsMS43Mi41N2MuMDguMjcuMTkuNTMuMzIuNzdsLS44MSAxLjYyIDEuMDYgMS4wNiAxLjYyLS44MWMuMjQuMTMuNS4yMy43Ny4zMkw1LjI1IDEyaDEuNWwuNTctMS43MmMuMjctLjA4LjUyLS4xOS43Ny0uMzJsMS42Mi44MSAxLjA2LTEuMDYtLjgxLTEuNjJjLjEzLS4yNC4yMy0uNS4zMi0uNzdMMTIgNi43NXpNNiA4LjVhMi41IDIuNSAwIDAxMC01IDIuNSAyLjUgMCAwMTAgNXoiIGZpbGw9IiMwNTBGMTkiLz48L3N2Zz4=`;
function $34349769f498506c$var$makeSnackbarIcon(appSrc) {
    switch(appSrc){
        case "coinbase-app":
            return `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0LjY3NCAxOC44NThjLTIuMDQ1IDAtMy42NDgtMS43MjItMy42NDgtMy44NDVzMS42NTktMy44NDUgMy42NDgtMy44NDVjMS44MjQgMCAzLjMxNyAxLjM3NyAzLjU5MyAzLjIxNGgzLjcwM2MtLjMzMS0zLjk2LTMuNDgyLTcuMDU5LTcuMjk2LTcuMDU5LTQuMDM0IDAtNy4zNSAzLjQ0My03LjM1IDcuNjkgMCA0LjI0NiAzLjI2IDcuNjkgNy4zNSA3LjY5IDMuODcgMCA2Ljk2NS0zLjEgNy4yOTYtNy4wNTloLTMuNzAzYy0uMjc2IDEuODM2LTEuNzY5IDMuMjE0LTMuNTkzIDMuMjE0WiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0wIDEwLjY3OGMwLTMuNzExIDAtNS41OTYuNzQyLTcuMDIzQTYuNTMyIDYuNTMyIDAgMCAxIDMuNjU1Ljc0MkM1LjA4MiAwIDYuOTY3IDAgMTAuNjc4IDBoNy45MzhjMy43MTEgMCA1LjU5NiAwIDcuMDIzLjc0MmE2LjUzMSA2LjUzMSAwIDAgMSAyLjkxMyAyLjkxM2MuNzQyIDEuNDI3Ljc0MiAzLjMxMi43NDIgNy4wMjN2Ny45MzhjMCAzLjcxMSAwIDUuNTk2LS43NDIgNy4wMjNhNi41MzEgNi41MzEgMCAwIDEtMi45MTMgMi45MTNjLTEuNDI3Ljc0Mi0zLjMxMi43NDItNy4wMjMuNzQyaC03LjkzOGMtMy43MTEgMC01LjU5NiAwLTcuMDIzLS43NDJhNi41MzEgNi41MzEgMCAwIDEtMi45MTMtMi45MTNDMCAyNC4yMTIgMCAyMi4zODQgMCAxOC42MTZ2LTcuOTM4WiIgZmlsbD0iIzAwNTJGRiIvPjxwYXRoIGQ9Ik0xNC42ODQgMTkuNzczYy0yLjcyNyAwLTQuODY0LTIuMjk1LTQuODY0LTUuMTI2IDAtMi44MzEgMi4yMS01LjEyNyA0Ljg2NC01LjEyNyAyLjQzMiAwIDQuNDIyIDEuODM3IDQuNzkgNC4yODVoNC45MzhjLS40NDItNS4yOC00LjY0My05LjQxMS05LjcyOC05LjQxMS01LjM4IDAtOS44MDIgNC41OS05LjgwMiAxMC4yNTMgMCA1LjY2MiA0LjM0OCAxMC4yNTMgOS44MDIgMTAuMjUzIDUuMTU5IDAgOS4yODYtNC4xMzIgOS43MjgtOS40MTFoLTQuOTM4Yy0uMzY4IDIuNDQ4LTIuMzU4IDQuMjg0LTQuNzkgNC4yODRaIiBmaWxsPSIjZmZmIi8+PC9zdmc+`;
        case "coinbase-wallet-app":
        default:
            return `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNDkyIDEwLjQxOWE4LjkzIDguOTMgMCAwMTguOTMtOC45M2gxMS4xNjNhOC45MyA4LjkzIDAgMDE4LjkzIDguOTN2MTEuMTYzYTguOTMgOC45MyAwIDAxLTguOTMgOC45M0gxMC40MjJhOC45MyA4LjkzIDAgMDEtOC45My04LjkzVjEwLjQxOXoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQxOSAwSDIxLjU4QzI3LjMzNSAwIDMyIDQuNjY1IDMyIDEwLjQxOVYyMS41OEMzMiAyNy4zMzUgMjcuMzM1IDMyIDIxLjU4MSAzMkgxMC40MkM0LjY2NSAzMiAwIDI3LjMzNSAwIDIxLjU4MVYxMC40MkMwIDQuNjY1IDQuNjY1IDAgMTAuNDE5IDB6bTAgMS40ODhhOC45MyA4LjkzIDAgMDAtOC45MyA4LjkzdjExLjE2M2E4LjkzIDguOTMgMCAwMDguOTMgOC45M0gyMS41OGE4LjkzIDguOTMgMCAwMDguOTMtOC45M1YxMC40MmE4LjkzIDguOTMgMCAwMC04LjkzLTguOTNIMTAuNDJ6IiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45OTggMjYuMDQ5Yy01LjU0OSAwLTEwLjA0Ny00LjQ5OC0xMC4wNDctMTAuMDQ3IDAtNS41NDggNC40OTgtMTAuMDQ2IDEwLjA0Ny0xMC4wNDYgNS41NDggMCAxMC4wNDYgNC40OTggMTAuMDQ2IDEwLjA0NiAwIDUuNTQ5LTQuNDk4IDEwLjA0Ny0xMC4wNDYgMTAuMDQ3eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0xMi43NjIgMTQuMjU0YzAtLjgyMi42NjctMS40ODkgMS40ODktMS40ODloMy40OTdjLjgyMiAwIDEuNDg4LjY2NiAxLjQ4OCAxLjQ4OXYzLjQ5N2MwIC44MjItLjY2NiAxLjQ4OC0xLjQ4OCAxLjQ4OGgtMy40OTdhMS40ODggMS40ODggMCAwMS0xLjQ4OS0xLjQ4OHYtMy40OTh6IiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+`;
    }
}
class $34349769f498506c$var$Snackbar {
    constructor(options){
        this.items = new Map();
        this.nextItemKey = 0;
        this.root = null;
        this.darkMode = options.darkMode;
    }
    attach(el) {
        this.root = document.createElement("div");
        this.root.className = "-cbwsdk-snackbar-root";
        el.appendChild(this.root);
        this.render();
    }
    presentItem(itemProps) {
        const key = this.nextItemKey++;
        this.items.set(key, itemProps);
        this.render();
        return ()=>{
            this.items.delete(key);
            this.render();
        };
    }
    clear() {
        this.items.clear();
        this.render();
    }
    render() {
        if (!this.root) return;
        (0, $1Hdcz.render)((0, $1Hdcz.h)("div", null, (0, $1Hdcz.h)(module.exports.SnackbarContainer, {
            darkMode: this.darkMode
        }, Array.from(this.items.entries()).map(([key, itemProps])=>(0, $1Hdcz.h)(module.exports.SnackbarInstance, Object.assign({}, itemProps, {
                key: key
            }))))), this.root);
    }
}
module.exports.Snackbar = $34349769f498506c$var$Snackbar;
const $34349769f498506c$var$SnackbarContainer = (props)=>(0, $1Hdcz.h)("div", {
        class: (0, $34349769f498506c$var$clsx_1.default)("-cbwsdk-snackbar-container")
    }, (0, $1Hdcz.h)("style", null, $34349769f498506c$var$Snackbar_css_1.default), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-snackbar"
    }, props.children));
module.exports.SnackbarContainer = $34349769f498506c$var$SnackbarContainer;
const $34349769f498506c$var$SnackbarInstance = ({ autoExpand: autoExpand, message: message, menuItems: menuItems, appSrc: appSrc })=>{
    const [hidden, setHidden] = (0, $2LSrt.useState)(true);
    const [expanded, setExpanded] = (0, $2LSrt.useState)(autoExpand !== null && autoExpand !== void 0 ? autoExpand : false);
    (0, $2LSrt.useEffect)(()=>{
        const timers = [
            window.setTimeout(()=>{
                setHidden(false);
            }, 1),
            window.setTimeout(()=>{
                setExpanded(true);
            }, 10000)
        ];
        return ()=>{
            timers.forEach(window.clearTimeout);
        };
    });
    const toggleExpanded = ()=>{
        setExpanded(!expanded);
    };
    return (0, $1Hdcz.h)("div", {
        class: (0, $34349769f498506c$var$clsx_1.default)("-cbwsdk-snackbar-instance", hidden && "-cbwsdk-snackbar-instance-hidden", expanded && "-cbwsdk-snackbar-instance-expanded")
    }, (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-snackbar-instance-header",
        onClick: toggleExpanded
    }, (0, $1Hdcz.h)("img", {
        src: $34349769f498506c$var$makeSnackbarIcon(appSrc),
        class: "-cbwsdk-snackbar-instance-header-cblogo"
    }), (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-snackbar-instance-header-message"
    }, message), (0, $1Hdcz.h)("div", {
        class: "-gear-container"
    }, !expanded && (0, $1Hdcz.h)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $1Hdcz.h)("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        fill: "#F5F7F8"
    })), (0, $1Hdcz.h)("img", {
        src: $34349769f498506c$var$gearIcon,
        class: "-gear-icon",
        title: "Expand"
    }))), menuItems && menuItems.length > 0 && (0, $1Hdcz.h)("div", {
        class: "-cbwsdk-snackbar-instance-menu"
    }, menuItems.map((action, i)=>(0, $1Hdcz.h)("div", {
            class: (0, $34349769f498506c$var$clsx_1.default)("-cbwsdk-snackbar-instance-menu-item", action.isRed && "-cbwsdk-snackbar-instance-menu-item-is-red"),
            onClick: action.onClick,
            key: i
        }, (0, $1Hdcz.h)("svg", {
            width: action.svgWidth,
            height: action.svgHeight,
            viewBox: "0 0 10 11",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, $1Hdcz.h)("path", {
            "fill-rule": action.defaultFillRule,
            "clip-rule": action.defaultClipRule,
            d: action.path,
            fill: "#AAAAAA"
        })), (0, $1Hdcz.h)("span", {
            class: (0, $34349769f498506c$var$clsx_1.default)("-cbwsdk-snackbar-instance-menu-item-info", action.isRed && "-cbwsdk-snackbar-instance-menu-item-info-is-red")
        }, action.info)))));
};
module.exports.SnackbarInstance = $34349769f498506c$var$SnackbarInstance;

});
parcelRequire.register("dE5ul", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = `.-cbwsdk-css-reset .-gear-container{margin-left:16px !important;margin-right:9px !important;display:flex;align-items:center;justify-content:center;width:24px;height:24px;transition:opacity .25s}.-cbwsdk-css-reset .-gear-container *{user-select:none}.-cbwsdk-css-reset .-gear-container svg{opacity:0;position:absolute}.-cbwsdk-css-reset .-gear-icon{height:12px;width:12px;z-index:10000}.-cbwsdk-css-reset .-cbwsdk-snackbar{align-items:flex-end;display:flex;flex-direction:column;position:fixed;right:0;top:0;z-index:2147483647}.-cbwsdk-css-reset .-cbwsdk-snackbar *{user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance{display:flex;flex-direction:column;margin:8px 16px 0 16px;overflow:visible;text-align:left;transform:translateX(0);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header:hover .-gear-container svg{opacity:1}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header{display:flex;align-items:center;background:#fff;overflow:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-cblogo{margin:8px 8px 8px 8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-message{color:#000;font-size:13px;line-height:1.5;user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu{background:#fff;transition:opacity .25s ease-in-out,transform .25s linear,visibility 0s;visibility:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;opacity:0;flex-direction:column;padding-left:8px;padding-right:8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:last-child{margin-bottom:8px !important}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover{background:#f5f7f8;border-radius:6px;transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover span{color:#050f19;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover svg path{fill:#000;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item{visibility:inherit;height:35px;margin-top:8px;margin-bottom:0;display:flex;flex-direction:row;align-items:center;padding:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item *{visibility:inherit;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover{background:rgba(223,95,103,.2);transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover svg path{fill:#df5f67;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover span{color:#df5f67;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-info{color:#aaa;font-size:13px;margin:0 8px 0 32px;position:absolute}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-hidden{opacity:0;text-align:left;transform:translateX(25%);transition:opacity .5s linear}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-expanded .-cbwsdk-snackbar-instance-menu{opacity:1;display:flex;transform:translateY(8px);visibility:visible}`;

});


parcelRequire.register("gscOu", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $bfa9334ed72da4cd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.injectCssReset = void 0;

const $bfa9334ed72da4cd$var$cssReset_css_1 = $bfa9334ed72da4cd$var$__importDefault((parcelRequire("ckY2m")));
function $bfa9334ed72da4cd$var$injectCssReset() {
    const styleEl = document.createElement("style");
    styleEl.type = "text/css";
    styleEl.appendChild(document.createTextNode($bfa9334ed72da4cd$var$cssReset_css_1.default));
    document.documentElement.appendChild(styleEl);
}
module.exports.injectCssReset = $bfa9334ed72da4cd$var$injectCssReset;

});
parcelRequire.register("ckY2m", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = `@namespace svg "http://www.w3.org/2000/svg";.-cbwsdk-css-reset,.-cbwsdk-css-reset *{animation:none;animation-delay:0;animation-direction:normal;animation-duration:0;animation-fill-mode:none;animation-iteration-count:1;animation-name:none;animation-play-state:running;animation-timing-function:ease;backface-visibility:visible;background:0;background-attachment:scroll;background-clip:border-box;background-color:rgba(0,0,0,0);background-image:none;background-origin:padding-box;background-position:0 0;background-position-x:0;background-position-y:0;background-repeat:repeat;background-size:auto auto;border:0;border-style:none;border-width:medium;border-color:inherit;border-bottom:0;border-bottom-color:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-style:none;border-bottom-width:medium;border-collapse:separate;border-image:none;border-left:0;border-left-color:inherit;border-left-style:none;border-left-width:medium;border-radius:0;border-right:0;border-right-color:inherit;border-right-style:none;border-right-width:medium;border-spacing:0;border-top:0;border-top-color:inherit;border-top-left-radius:0;border-top-right-radius:0;border-top-style:none;border-top-width:medium;box-shadow:none;box-sizing:border-box;caption-side:top;clear:none;clip:auto;color:inherit;columns:auto;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-rule-color:currentColor;column-rule-style:none;column-rule-width:none;column-span:1;column-width:auto;counter-increment:none;counter-reset:none;direction:ltr;empty-cells:show;float:none;font:normal;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;height:auto;hyphens:none;letter-spacing:normal;line-height:normal;list-style:none;list-style-image:none;list-style-position:outside;list-style-type:disc;margin:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;opacity:1;orphans:0;outline:0;outline-color:invert;outline-style:none;outline-width:medium;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;pointer-events:auto;position:static;quotes:"\\201C" "\\201D" "\\2018" "\\2019";tab-size:8;table-layout:auto;text-align:inherit;text-align-last:auto;text-decoration:none;text-decoration-color:inherit;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-shadow:none;text-transform:none;transform:none;transform-style:flat;transition:none;transition-delay:0s;transition-duration:0s;transition-property:none;transition-timing-function:ease;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:0;word-spacing:normal;z-index:auto}.-cbwsdk-css-reset strong{font-weight:bold}.-cbwsdk-css-reset *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;line-height:1}.-cbwsdk-css-reset [class*=container]{margin:0;padding:0}.-cbwsdk-css-reset style{display:none}`;

});



parcelRequire.register("kVwIQ", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
var $f3c28381e8f340c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f3c28381e8f340c8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f3c28381e8f340c8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $f3c28381e8f340c8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f3c28381e8f340c8$var$__createBinding(result, mod, k);
    }
    $f3c28381e8f340c8$var$__setModuleDefault(result, mod);
    return result;
};
var $f3c28381e8f340c8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletSDKRelay = void 0;

const $f3c28381e8f340c8$var$bind_decorator_1 = $f3c28381e8f340c8$var$__importDefault((parcelRequire("cMtVR")));

var $1j1JC = parcelRequire("1j1JC");
var $iFZjc = parcelRequire("iFZjc");
var $bFD5F = parcelRequire("bFD5F");
var $cGzXz = parcelRequire("cGzXz");
var $cnFOC = parcelRequire("cnFOC");
var $cDlsV = parcelRequire("cDlsV");

var $fZi5g = parcelRequire("fZi5g");
var $bQ5Pa = parcelRequire("bQ5Pa");
var $dkpsO = parcelRequire("dkpsO");
var $1cftY = parcelRequire("1cftY");
var $cgIaa = parcelRequire("cgIaa");
var $7jVzq = parcelRequire("7jVzq");
var $71y7H = parcelRequire("71y7H");
var $5N8Ow = parcelRequire("5N8Ow");

var $6W6hh = parcelRequire("6W6hh");

var $dMIwd = parcelRequire("dMIwd");

var $iGxB3 = parcelRequire("iGxB3");

var $iJH0e = parcelRequire("iJH0e");

var $1mY3j = parcelRequire("1mY3j");

const $f3c28381e8f340c8$var$aes256gcm = $f3c28381e8f340c8$var$__importStar((parcelRequire("kolOR")));

var $gPotL = parcelRequire("gPotL");

var $iF8HB = parcelRequire("iF8HB");

var $6Hvzc = parcelRequire("6Hvzc");

var $l0yO0 = parcelRequire("l0yO0");

var $dBRYn = parcelRequire("dBRYn");

var $7jLgc = parcelRequire("7jLgc");

var $fWZCq = parcelRequire("fWZCq");
class $f3c28381e8f340c8$var$WalletSDKRelay extends $iF8HB.WalletSDKRelayAbstract {
    constructor(options){
        var _a;
        super();
        this.accountsCallback = null;
        this.chainCallback = null;
        this.dappDefaultChainSubject = new $1j1JC.BehaviorSubject(1);
        this.dappDefaultChain = 1;
        this.appName = "";
        this.appLogoUrl = null;
        this.subscriptions = new $cnFOC.Subscription();
        this.linkAPIUrl = options.linkAPIUrl;
        this.storage = options.storage;
        this.options = options;
        const { session: session, ui: ui, connection: connection } = this.subscribe();
        this._session = session;
        this.connection = connection;
        this.relayEventManager = options.relayEventManager;
        if (options.diagnosticLogger && options.eventListener) throw new Error("Can't have both eventListener and diagnosticLogger options, use only diagnosticLogger");
        if (options.eventListener) this.diagnostic = {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            log: options.eventListener.onEvent
        };
        else this.diagnostic = options.diagnosticLogger;
        this._reloadOnDisconnect = (_a = options.reloadOnDisconnect) !== null && _a !== void 0 ? _a : true;
        this.ui = ui;
    }
    subscribe() {
        this.subscriptions.add(this.dappDefaultChainSubject.subscribe((chainId)=>{
            if (this.dappDefaultChain !== chainId) this.dappDefaultChain = chainId;
        }));
        const session = $gPotL.Session.load(this.storage) || new $gPotL.Session(this.storage).save();
        const connection = new $dMIwd.WalletSDKConnection(session.id, session.key, this.linkAPIUrl, this.diagnostic);
        this.subscriptions.add(connection.sessionConfig$.subscribe({
            next: (sessionConfig)=>{
                this.onSessionConfigChanged(sessionConfig);
            },
            error: ()=>{
                var _a;
                (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.GENERAL_ERROR, {
                    message: "error while invoking session config callback"
                });
            }
        }));
        this.subscriptions.add(connection.incomingEvent$.pipe((0, $dkpsO.filter)((m)=>m.event === "Web3Response")).subscribe({
            next: this.handleIncomingEvent
        }));
        this.subscriptions.add(connection.linked$.pipe((0, $7jVzq.skip)(1), (0, $71y7H.tap)((linked)=>{
            var _a;
            this.isLinked = linked;
            const cachedAddresses = this.storage.getItem($iF8HB.LOCAL_STORAGE_ADDRESSES_KEY);
            if (linked) // Only set linked session variable one way
            this.session.linked = linked;
            this.isUnlinkedErrorState = false;
            if (cachedAddresses) {
                const addresses = cachedAddresses.split(" ");
                const wasConnectedViaStandalone = this.storage.getItem("IsStandaloneSigning") === "true";
                if (addresses[0] !== "" && !linked && this.session.linked && !wasConnectedViaStandalone) {
                    this.isUnlinkedErrorState = true;
                    const sessionIdHash = this.getSessionIdHash();
                    (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.UNLINKED_ERROR_STATE, {
                        sessionIdHash: sessionIdHash
                    });
                }
            }
        })).subscribe());
        // if session is marked destroyed, reset and reload
        this.subscriptions.add(connection.sessionConfig$.pipe((0, $dkpsO.filter)((c)=>!!c.metadata && c.metadata.__destroyed === "1")).subscribe(()=>{
            var _a;
            const alreadyDestroyed = connection.isDestroyed;
            (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.METADATA_DESTROYED, {
                alreadyDestroyed: alreadyDestroyed,
                sessionIdHash: this.getSessionIdHash()
            });
            return this.resetAndReload();
        }));
        this.subscriptions.add(connection.sessionConfig$.pipe((0, $dkpsO.filter)((c)=>c.metadata && c.metadata.WalletUsername !== undefined)).pipe((0, $cgIaa.mergeMap)((c)=>$f3c28381e8f340c8$var$aes256gcm.decrypt(c.metadata.WalletUsername, session.secret))).subscribe({
            next: (walletUsername)=>{
                this.storage.setItem($iF8HB.WALLET_USER_NAME_KEY, walletUsername);
            },
            error: ()=>{
                var _a;
                (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.GENERAL_ERROR, {
                    message: "Had error decrypting",
                    value: "username"
                });
            }
        }));
        this.subscriptions.add(connection.sessionConfig$.pipe((0, $dkpsO.filter)((c)=>c.metadata && c.metadata.AppVersion !== undefined)).pipe((0, $cgIaa.mergeMap)((c)=>$f3c28381e8f340c8$var$aes256gcm.decrypt(c.metadata.AppVersion, session.secret))).subscribe({
            next: (appVersion)=>{
                this.storage.setItem($iF8HB.APP_VERSION_KEY, appVersion);
            },
            error: ()=>{
                var _a;
                (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.GENERAL_ERROR, {
                    message: "Had error decrypting",
                    value: "appversion"
                });
            }
        }));
        this.subscriptions.add(connection.sessionConfig$.pipe((0, $dkpsO.filter)((c)=>c.metadata && c.metadata.ChainId !== undefined && c.metadata.JsonRpcUrl !== undefined)).pipe((0, $cgIaa.mergeMap)((c)=>(0, $cDlsV.zip)($f3c28381e8f340c8$var$aes256gcm.decrypt(c.metadata.ChainId, session.secret), $f3c28381e8f340c8$var$aes256gcm.decrypt(c.metadata.JsonRpcUrl, session.secret)))).pipe((0, $bQ5Pa.distinctUntilChanged)()).subscribe({
            next: ([chainId, jsonRpcUrl])=>{
                if (this.chainCallback) this.chainCallback(chainId, jsonRpcUrl);
            },
            error: ()=>{
                var _a;
                (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.GENERAL_ERROR, {
                    message: "Had error decrypting",
                    value: "chainId|jsonRpcUrl"
                });
            }
        }));
        this.subscriptions.add(connection.sessionConfig$.pipe((0, $dkpsO.filter)((c)=>c.metadata && c.metadata.EthereumAddress !== undefined)).pipe((0, $cgIaa.mergeMap)((c)=>$f3c28381e8f340c8$var$aes256gcm.decrypt(c.metadata.EthereumAddress, session.secret))).subscribe({
            next: (selectedAddress)=>{
                if (this.accountsCallback) this.accountsCallback([
                    selectedAddress
                ]);
                if ($f3c28381e8f340c8$var$WalletSDKRelay.accountRequestCallbackIds.size > 0) {
                    // We get the ethereum address from the metadata.  If for whatever
                    // reason we don't get a response via an explicit web3 message
                    // we can still fulfill the eip1102 request.
                    Array.from($f3c28381e8f340c8$var$WalletSDKRelay.accountRequestCallbackIds.values()).forEach((id)=>{
                        const message = (0, $fWZCq.Web3ResponseMessage)({
                            id: id,
                            response: (0, $7jLgc.RequestEthereumAccountsResponse)([
                                selectedAddress
                            ])
                        });
                        this.invokeCallback(Object.assign(Object.assign({}, message), {
                            id: id
                        }));
                    });
                    $f3c28381e8f340c8$var$WalletSDKRelay.accountRequestCallbackIds.clear();
                }
            },
            error: ()=>{
                var _a;
                (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.GENERAL_ERROR, {
                    message: "Had error decrypting",
                    value: "selectedAddress"
                });
            }
        }));
        this.subscriptions.add(connection.sessionConfig$.pipe((0, $dkpsO.filter)((c)=>c.metadata && c.metadata.AppSrc !== undefined)).pipe((0, $cgIaa.mergeMap)((c)=>$f3c28381e8f340c8$var$aes256gcm.decrypt(c.metadata.AppSrc, session.secret))).subscribe({
            next: (appSrc)=>{
                this.ui.setAppSrc(appSrc);
            },
            error: ()=>{
                var _a;
                (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.GENERAL_ERROR, {
                    message: "Had error decrypting",
                    value: "appSrc"
                });
            }
        }));
        const ui = this.options.uiConstructor({
            linkAPIUrl: this.options.linkAPIUrl,
            version: this.options.version,
            darkMode: this.options.darkMode,
            session: session,
            connected$: connection.connected$,
            chainId$: this.dappDefaultChainSubject
        });
        connection.connect();
        return {
            session: session,
            ui: ui,
            connection: connection
        };
    }
    attachUI() {
        this.ui.attach();
    }
    resetAndReload() {
        this.connection.setSessionMetadata("__destroyed", "1").pipe((0, $5N8Ow.timeout)(1000), (0, $fZi5g.catchError)((_)=>(0, $cGzXz.of)(null))).subscribe((_)=>{
            var _a, _b, _c;
            const isStandalone = this.ui.isStandalone();
            try {
                this.subscriptions.unsubscribe();
            } catch (err) {
                (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.GENERAL_ERROR, {
                    message: "Had error unsubscribing"
                });
            }
            (_b = this.diagnostic) === null || _b === void 0 || _b.log($6W6hh.EVENTS.SESSION_STATE_CHANGE, {
                method: "relay::resetAndReload",
                sessionMetadataChange: "__destroyed, 1",
                sessionIdHash: this.getSessionIdHash()
            });
            this.connection.destroy();
            /**
             * Only clear storage if the session id we have in memory matches the one on disk
             * Otherwise, in the case where we have 2 tabs, another tab might have cleared
             * storage already.  In that case if we clear storage again, the user will be in
             * a state where the first tab allows the user to connect but the session that
             * was used isn't persisted.  This leaves the user in a state where they aren't
             * connected to the mobile app.
             */ const storedSession = $gPotL.Session.load(this.storage);
            if ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) === this._session.id) this.storage.clear();
            else if (storedSession) (_c = this.diagnostic) === null || _c === void 0 || _c.log($6W6hh.EVENTS.SKIPPED_CLEARING_SESSION, {
                sessionIdHash: this.getSessionIdHash(),
                storedSessionIdHash: $gPotL.Session.hash(storedSession.id)
            });
            if (this._reloadOnDisconnect) {
                this.ui.reloadUI();
                return;
            }
            if (this.accountsCallback) this.accountsCallback([], true);
            this.subscriptions = new $cnFOC.Subscription();
            const { session: session, ui: ui, connection: connection } = this.subscribe();
            this._session = session;
            this.connection = connection;
            this.ui = ui;
            if (isStandalone && this.ui.setStandalone) this.ui.setStandalone(true);
            this.attachUI();
        }, (err)=>{
            var _a;
            (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.FAILURE, {
                method: "relay::resetAndReload",
                message: `failed to reset and reload with ${err}`,
                sessionIdHash: this.getSessionIdHash()
            });
        });
    }
    setAppInfo(appName, appLogoUrl) {
        this.appName = appName;
        this.appLogoUrl = appLogoUrl;
    }
    getStorageItem(key) {
        return this.storage.getItem(key);
    }
    get session() {
        return this._session;
    }
    setStorageItem(key, value) {
        this.storage.setItem(key, value);
    }
    signEthereumMessage(message, address, addPrefix, typedDataJson) {
        return this.sendRequest({
            method: $6Hvzc.Web3Method.signEthereumMessage,
            params: {
                message: (0, $1mY3j.hexStringFromBuffer)(message, true),
                address: address,
                addPrefix: addPrefix,
                typedDataJson: typedDataJson || null
            }
        });
    }
    ethereumAddressFromSignedMessage(message, signature, addPrefix) {
        return this.sendRequest({
            method: $6Hvzc.Web3Method.ethereumAddressFromSignedMessage,
            params: {
                message: (0, $1mY3j.hexStringFromBuffer)(message, true),
                signature: (0, $1mY3j.hexStringFromBuffer)(signature, true),
                addPrefix: addPrefix
            }
        });
    }
    signEthereumTransaction(params) {
        return this.sendRequest({
            method: $6Hvzc.Web3Method.signEthereumTransaction,
            params: {
                fromAddress: params.fromAddress,
                toAddress: params.toAddress,
                weiValue: (0, $1mY3j.bigIntStringFromBN)(params.weiValue),
                data: (0, $1mY3j.hexStringFromBuffer)(params.data, true),
                nonce: params.nonce,
                gasPriceInWei: params.gasPriceInWei ? (0, $1mY3j.bigIntStringFromBN)(params.gasPriceInWei) : null,
                maxFeePerGas: params.gasPriceInWei ? (0, $1mY3j.bigIntStringFromBN)(params.gasPriceInWei) : null,
                maxPriorityFeePerGas: params.gasPriceInWei ? (0, $1mY3j.bigIntStringFromBN)(params.gasPriceInWei) : null,
                gasLimit: params.gasLimit ? (0, $1mY3j.bigIntStringFromBN)(params.gasLimit) : null,
                chainId: params.chainId,
                shouldSubmit: false
            }
        });
    }
    signAndSubmitEthereumTransaction(params) {
        return this.sendRequest({
            method: $6Hvzc.Web3Method.signEthereumTransaction,
            params: {
                fromAddress: params.fromAddress,
                toAddress: params.toAddress,
                weiValue: (0, $1mY3j.bigIntStringFromBN)(params.weiValue),
                data: (0, $1mY3j.hexStringFromBuffer)(params.data, true),
                nonce: params.nonce,
                gasPriceInWei: params.gasPriceInWei ? (0, $1mY3j.bigIntStringFromBN)(params.gasPriceInWei) : null,
                maxFeePerGas: params.maxFeePerGas ? (0, $1mY3j.bigIntStringFromBN)(params.maxFeePerGas) : null,
                maxPriorityFeePerGas: params.maxPriorityFeePerGas ? (0, $1mY3j.bigIntStringFromBN)(params.maxPriorityFeePerGas) : null,
                gasLimit: params.gasLimit ? (0, $1mY3j.bigIntStringFromBN)(params.gasLimit) : null,
                chainId: params.chainId,
                shouldSubmit: true
            }
        });
    }
    submitEthereumTransaction(signedTransaction, chainId) {
        return this.sendRequest({
            method: $6Hvzc.Web3Method.submitEthereumTransaction,
            params: {
                signedTransaction: (0, $1mY3j.hexStringFromBuffer)(signedTransaction, true),
                chainId: chainId
            }
        });
    }
    scanQRCode(regExp) {
        return this.sendRequest({
            method: $6Hvzc.Web3Method.scanQRCode,
            params: {
                regExp: regExp
            }
        });
    }
    getQRCodeUrl() {
        return (0, $1mY3j.createQrUrl)(this._session.id, this._session.secret, this.linkAPIUrl, false, this.options.version, this.dappDefaultChain);
    }
    genericRequest(data, action) {
        return this.sendRequest({
            method: $6Hvzc.Web3Method.generic,
            params: {
                action: action,
                data: data
            }
        });
    }
    sendGenericMessage(request) {
        return this.sendRequest(request);
    }
    sendRequest(request) {
        let hideSnackbarItem = null;
        const id = (0, $1mY3j.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        const promise = new Promise((resolve, reject)=>{
            if (!this.ui.isStandalone()) hideSnackbarItem = this.ui.showConnecting({
                isUnlinkedErrorState: this.isUnlinkedErrorState,
                onCancel: cancel,
                onResetConnection: this.resetAndReload
            });
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            if (this.ui.isStandalone()) this.sendRequestStandalone(id, request);
            else this.publishWeb3RequestEvent(id, request);
        });
        return {
            promise: promise,
            cancel: cancel
        };
    }
    setConnectDisabled(disabled) {
        this.ui.setConnectDisabled(disabled);
    }
    setAccountsCallback(accountsCallback) {
        this.accountsCallback = accountsCallback;
    }
    setChainCallback(chainCallback) {
        this.chainCallback = chainCallback;
    }
    setDappDefaultChainCallback(chainId) {
        this.dappDefaultChainSubject.next(chainId);
    }
    publishWeb3RequestEvent(id, request) {
        var _a;
        const message = (0, $dBRYn.Web3RequestMessage)({
            id: id,
            request: request
        });
        const storedSession = $gPotL.Session.load(this.storage);
        (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.WEB3_REQUEST, {
            eventId: message.id,
            method: `relay::${message.request.method}`,
            sessionIdHash: this.getSessionIdHash(),
            storedSessionIdHash: storedSession ? $gPotL.Session.hash(storedSession.id) : "",
            isSessionMismatched: ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) !== this._session.id).toString()
        });
        this.subscriptions.add(this.publishEvent("Web3Request", message, true).subscribe({
            next: (_)=>{
                var _a;
                (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.WEB3_REQUEST_PUBLISHED, {
                    eventId: message.id,
                    method: `relay::${message.request.method}`,
                    sessionIdHash: this.getSessionIdHash(),
                    storedSessionIdHash: storedSession ? $gPotL.Session.hash(storedSession.id) : "",
                    isSessionMismatched: ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) !== this._session.id).toString()
                });
            },
            error: (err)=>{
                this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                    id: message.id,
                    response: {
                        method: message.request.method,
                        errorMessage: err.message
                    }
                }));
            }
        }));
    }
    publishWeb3RequestCanceledEvent(id) {
        const message = (0, $l0yO0.Web3RequestCanceledMessage)(id);
        this.subscriptions.add(this.publishEvent("Web3RequestCanceled", message, false).subscribe());
    }
    publishEvent(event, message, callWebhook) {
        const secret = this.session.secret;
        return new $bFD5F.Observable((subscriber)=>{
            $f3c28381e8f340c8$var$aes256gcm.encrypt(JSON.stringify(Object.assign(Object.assign({}, message), {
                origin: location.origin
            })), secret).then((encrypted)=>{
                subscriber.next(encrypted);
                subscriber.complete();
            });
        }).pipe((0, $cgIaa.mergeMap)((encrypted)=>{
            return this.connection.publishEvent(event, encrypted, callWebhook);
        }));
    }
    handleIncomingEvent(event) {
        try {
            this.subscriptions.add((0, $iFZjc.from)($f3c28381e8f340c8$var$aes256gcm.decrypt(event.data, this.session.secret)).pipe((0, $1cftY.map)((c)=>JSON.parse(c))).subscribe({
                next: (json)=>{
                    const message = (0, $fWZCq.isWeb3ResponseMessage)(json) ? json : null;
                    if (!message) return;
                    this.handleWeb3ResponseMessage(message);
                },
                error: ()=>{
                    var _a;
                    (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.GENERAL_ERROR, {
                        message: "Had error decrypting",
                        value: "incomingEvent"
                    });
                }
            }));
        } catch (_a) {
            return;
        }
    }
    handleWeb3ResponseMessage(message) {
        var _a;
        const { response: response } = message;
        (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.WEB3_RESPONSE, {
            eventId: message.id,
            method: `relay::${response.method}`,
            sessionIdHash: this.getSessionIdHash()
        });
        if ((0, $7jLgc.isRequestEthereumAccountsResponse)(response)) {
            $f3c28381e8f340c8$var$WalletSDKRelay.accountRequestCallbackIds.forEach((id)=>this.invokeCallback(Object.assign(Object.assign({}, message), {
                    id: id
                })));
            $f3c28381e8f340c8$var$WalletSDKRelay.accountRequestCallbackIds.clear();
            return;
        }
        this.invokeCallback(message);
    }
    handleErrorResponse(id, method, error, errorCode) {
        var _a;
        const errorMessage = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : (0, $iGxB3.standardErrorMessage)(errorCode);
        this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
            id: id,
            response: {
                method: method,
                errorMessage: errorMessage,
                errorCode: errorCode
            }
        }));
    }
    invokeCallback(message) {
        const callback = this.relayEventManager.callbacks.get(message.id);
        if (callback) {
            callback(message.response);
            this.relayEventManager.callbacks.delete(message.id);
        }
    }
    requestEthereumAccounts() {
        const request = {
            method: $6Hvzc.Web3Method.requestEthereumAccounts,
            params: {
                appName: this.appName,
                appLogoUrl: this.appLogoUrl || null
            }
        };
        const hideSnackbarItem = null;
        const id = (0, $1mY3j.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        const promise = new Promise((resolve, reject)=>{
            var _a;
            this.relayEventManager.callbacks.set(id, (response)=>{
                this.ui.hideRequestEthereumAccounts();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            const userAgent = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || null;
            if (userAgent && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
                let location1;
                try {
                    if ((0, $1mY3j.isInIFrame)() && window.top) location1 = window.top.location;
                    else location1 = window.location;
                } catch (e) {
                    location1 = window.location;
                }
                location1.href = `https://www.coinbase.com/connect-dapp?uri=${encodeURIComponent(location1.href)}`;
                return;
            }
            if (this.ui.inlineAccountsResponse()) {
                const onAccounts = (accounts)=>{
                    this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                        id: id,
                        response: (0, $7jLgc.RequestEthereumAccountsResponse)(accounts)
                    }));
                };
                this.ui.requestEthereumAccounts({
                    onCancel: cancel,
                    onAccounts: onAccounts
                });
            } else {
                // Error if user closes TryExtensionLinkDialog without connecting
                const err = $iGxB3.standardErrors.provider.userRejectedRequest("User denied account authorization");
                this.ui.requestEthereumAccounts({
                    onCancel: ()=>cancel(err)
                });
            }
            $f3c28381e8f340c8$var$WalletSDKRelay.accountRequestCallbackIds.add(id);
            if (!this.ui.inlineAccountsResponse() && !this.ui.isStandalone()) this.publishWeb3RequestEvent(id, request);
        });
        return {
            promise: promise,
            cancel: cancel
        };
    }
    selectProvider(providerOptions) {
        const request = {
            method: $6Hvzc.Web3Method.selectProvider,
            params: {
                providerOptions: providerOptions
            }
        };
        const id = (0, $1mY3j.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
        };
        const promise = new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            const _cancel = (_error)=>{
                this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                    id: id,
                    response: (0, $7jLgc.SelectProviderResponse)($iJH0e.ProviderType.Unselected)
                }));
            };
            const approve = (selectedProviderKey)=>{
                this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                    id: id,
                    response: (0, $7jLgc.SelectProviderResponse)(selectedProviderKey)
                }));
            };
            if (this.ui.selectProvider) this.ui.selectProvider({
                onApprove: approve,
                onCancel: _cancel,
                providerOptions: providerOptions
            });
        });
        return {
            cancel: cancel,
            promise: promise
        };
    }
    watchAsset(type, address, symbol, decimals, image, chainId) {
        const request = {
            method: $6Hvzc.Web3Method.watchAsset,
            params: {
                type: type,
                options: {
                    address: address,
                    symbol: symbol,
                    decimals: decimals,
                    image: image
                },
                chainId: chainId
            }
        };
        let hideSnackbarItem = null;
        const id = (0, $1mY3j.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        if (!this.ui.inlineWatchAsset()) hideSnackbarItem = this.ui.showConnecting({
            isUnlinkedErrorState: this.isUnlinkedErrorState,
            onCancel: cancel,
            onResetConnection: this.resetAndReload
        });
        const promise = new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            const _cancel = (_error)=>{
                this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                    id: id,
                    response: (0, $7jLgc.WatchAssetReponse)(false)
                }));
            };
            const approve = ()=>{
                this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                    id: id,
                    response: (0, $7jLgc.WatchAssetReponse)(true)
                }));
            };
            if (this.ui.inlineWatchAsset()) this.ui.watchAsset({
                onApprove: approve,
                onCancel: _cancel,
                type: type,
                address: address,
                symbol: symbol,
                decimals: decimals,
                image: image,
                chainId: chainId
            });
            if (!this.ui.inlineWatchAsset() && !this.ui.isStandalone()) this.publishWeb3RequestEvent(id, request);
        });
        return {
            cancel: cancel,
            promise: promise
        };
    }
    addEthereumChain(chainId, rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency) {
        const request = {
            method: $6Hvzc.Web3Method.addEthereumChain,
            params: {
                chainId: chainId,
                rpcUrls: rpcUrls,
                blockExplorerUrls: blockExplorerUrls,
                chainName: chainName,
                iconUrls: iconUrls,
                nativeCurrency: nativeCurrency
            }
        };
        let hideSnackbarItem = null;
        const id = (0, $1mY3j.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
        };
        if (!this.ui.inlineAddEthereumChain(chainId)) hideSnackbarItem = this.ui.showConnecting({
            isUnlinkedErrorState: this.isUnlinkedErrorState,
            onCancel: cancel,
            onResetConnection: this.resetAndReload
        });
        const promise = new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                hideSnackbarItem === null || hideSnackbarItem === void 0 || hideSnackbarItem();
                if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            const _cancel = (_error)=>{
                this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                    id: id,
                    response: (0, $7jLgc.AddEthereumChainResponse)({
                        isApproved: false,
                        rpcUrl: ""
                    })
                }));
            };
            const approve = (rpcUrl)=>{
                this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                    id: id,
                    response: (0, $7jLgc.AddEthereumChainResponse)({
                        isApproved: true,
                        rpcUrl: rpcUrl
                    })
                }));
            };
            if (this.ui.inlineAddEthereumChain(chainId)) this.ui.addEthereumChain({
                onCancel: _cancel,
                onApprove: approve,
                chainId: request.params.chainId,
                rpcUrls: request.params.rpcUrls,
                blockExplorerUrls: request.params.blockExplorerUrls,
                chainName: request.params.chainName,
                iconUrls: request.params.iconUrls,
                nativeCurrency: request.params.nativeCurrency
            });
            if (!this.ui.inlineAddEthereumChain(chainId) && !this.ui.isStandalone()) this.publishWeb3RequestEvent(id, request);
        });
        return {
            promise: promise,
            cancel: cancel
        };
    }
    switchEthereumChain(chainId, address) {
        const request = {
            method: $6Hvzc.Web3Method.switchEthereumChain,
            params: Object.assign({
                chainId: chainId
            }, {
                address: address
            })
        };
        const id = (0, $1mY3j.randomBytesHex)(8);
        const cancel = (error)=>{
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
        };
        const promise = new Promise((resolve, reject)=>{
            this.relayEventManager.callbacks.set(id, (response)=>{
                if ((0, $7jLgc.isErrorResponse)(response) && response.errorCode) return reject($iGxB3.standardErrors.provider.custom({
                    code: response.errorCode,
                    message: `Unrecognized chain ID. Try adding the chain using addEthereumChain first.`
                }));
                else if (response.errorMessage) return reject(new Error(response.errorMessage));
                resolve(response);
            });
            const _cancel = (error)=>{
                var _a;
                if (error) {
                    // backward compatibility
                    const errorCode = (_a = (0, $iGxB3.getErrorCode)(error)) !== null && _a !== void 0 ? _a : $iGxB3.standardErrorCodes.provider.unsupportedChain;
                    this.handleErrorResponse(id, $6Hvzc.Web3Method.switchEthereumChain, error instanceof Error ? error : $iGxB3.standardErrors.provider.unsupportedChain(chainId), errorCode);
                } else this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                    id: id,
                    response: (0, $7jLgc.SwitchEthereumChainResponse)({
                        isApproved: false,
                        rpcUrl: ""
                    })
                }));
            };
            const approve = (rpcUrl)=>{
                this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                    id: id,
                    response: (0, $7jLgc.SwitchEthereumChainResponse)({
                        isApproved: true,
                        rpcUrl: rpcUrl
                    })
                }));
            };
            this.ui.switchEthereumChain({
                onCancel: _cancel,
                onApprove: approve,
                chainId: request.params.chainId,
                address: request.params.address
            });
            if (!this.ui.inlineSwitchEthereumChain() && !this.ui.isStandalone()) this.publishWeb3RequestEvent(id, request);
        });
        return {
            promise: promise,
            cancel: cancel
        };
    }
    inlineAddEthereumChain(chainId) {
        return this.ui.inlineAddEthereumChain(chainId);
    }
    getSessionIdHash() {
        return $gPotL.Session.hash(this._session.id);
    }
    sendRequestStandalone(id, request) {
        const _cancel = (error)=>{
            this.handleErrorResponse(id, request.method, error);
        };
        const onSuccess = (response)=>{
            this.handleWeb3ResponseMessage((0, $fWZCq.Web3ResponseMessage)({
                id: id,
                response: response
            }));
        };
        switch(request.method){
            case $6Hvzc.Web3Method.signEthereumMessage:
                this.ui.signEthereumMessage({
                    request: request,
                    onSuccess: onSuccess,
                    onCancel: _cancel
                });
                break;
            case $6Hvzc.Web3Method.signEthereumTransaction:
                this.ui.signEthereumTransaction({
                    request: request,
                    onSuccess: onSuccess,
                    onCancel: _cancel
                });
                break;
            case $6Hvzc.Web3Method.submitEthereumTransaction:
                this.ui.submitEthereumTransaction({
                    request: request,
                    onSuccess: onSuccess,
                    onCancel: _cancel
                });
                break;
            case $6Hvzc.Web3Method.ethereumAddressFromSignedMessage:
                this.ui.ethereumAddressFromSignedMessage({
                    request: request,
                    onSuccess: onSuccess
                });
                break;
            default:
                _cancel();
                break;
        }
    }
    onSessionConfigChanged(_nextSessionConfig) {}
}
$f3c28381e8f340c8$var$WalletSDKRelay.accountRequestCallbackIds = new Set();
$f3c28381e8f340c8$var$__decorate([
    $f3c28381e8f340c8$var$bind_decorator_1.default
], $f3c28381e8f340c8$var$WalletSDKRelay.prototype, "resetAndReload", null);
$f3c28381e8f340c8$var$__decorate([
    $f3c28381e8f340c8$var$bind_decorator_1.default
], $f3c28381e8f340c8$var$WalletSDKRelay.prototype, "handleIncomingEvent", null);
module.exports.WalletSDKRelay = $f3c28381e8f340c8$var$WalletSDKRelay;

});
parcelRequire.register("cMtVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e12fa1f9261b78$var$constants;
(function(constants) {
    constants.typeOfFunction = "function";
    constants.boolTrue = true;
})($94e12fa1f9261b78$var$constants || ($94e12fa1f9261b78$var$constants = {}));
function $94e12fa1f9261b78$var$bind(target, propertyKey, descriptor) {
    if (!descriptor || typeof descriptor.value !== $94e12fa1f9261b78$var$constants.typeOfFunction) throw new TypeError("Only methods can be decorated with @bind. <" + propertyKey + "> is not a method!");
    return {
        configurable: $94e12fa1f9261b78$var$constants.boolTrue,
        get: function() {
            var bound = descriptor.value.bind(this);
            // Credits to https://github.com/andreypopp/autobind-decorator for memoizing the result of bind against a symbol on the instance.
            Object.defineProperty(this, propertyKey, {
                value: bound,
                configurable: $94e12fa1f9261b78$var$constants.boolTrue,
                writable: $94e12fa1f9261b78$var$constants.boolTrue
            });
            return bound;
        }
    };
}
module.exports.bind = $94e12fa1f9261b78$var$bind;
module.exports.default = $94e12fa1f9261b78$var$bind;

});

parcelRequire.register("iFZjc", function(module, exports) {

$parcel$export(module.exports, "from", () => $d98b9cf92f0fc696$export$6788812c4e6611e6);
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");

var $2ZycD = parcelRequire("2ZycD");

var $8IoDV = parcelRequire("8IoDV");
function $d98b9cf92f0fc696$export$6788812c4e6611e6(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, $bFD5F.Observable)) return input;
        return new (0, $bFD5F.Observable)((0, $2ZycD.subscribeTo)(input));
    } else return (0, $8IoDV.scheduled)(input, scheduler);
}

});
parcelRequire.register("2ZycD", function(module, exports) {

$parcel$export(module.exports, "subscribeTo", () => $22dbcf3659b003f0$export$45e4095b0ba1d337);
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ 
var $1keVW = parcelRequire("1keVW");

var $cxuOV = parcelRequire("cxuOV");

var $k1Urb = parcelRequire("k1Urb");

var $bxWcp = parcelRequire("bxWcp");

var $1luRY = parcelRequire("1luRY");

var $fRIg1 = parcelRequire("fRIg1");

var $ciIuB = parcelRequire("ciIuB");

var $13SEs = parcelRequire("13SEs");

var $7lh9v = parcelRequire("7lh9v");
var $22dbcf3659b003f0$export$45e4095b0ba1d337 = function(result) {
    if (!!result && typeof result[0, $7lh9v.observable] === "function") return (0, $bxWcp.subscribeToObservable)(result);
    else if ((0, $1luRY.isArrayLike)(result)) return (0, $1keVW.subscribeToArray)(result);
    else if ((0, $fRIg1.isPromise)(result)) return (0, $cxuOV.subscribeToPromise)(result);
    else if (!!result && typeof result[0, $13SEs.iterator] === "function") return (0, $k1Urb.subscribeToIterable)(result);
    else {
        var value = (0, $ciIuB.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};

});
parcelRequire.register("1keVW", function(module, exports) {

$parcel$export(module.exports, "subscribeToArray", () => $0f733e2bdfe469ee$export$ab22aa77f372e159);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $0f733e2bdfe469ee$export$ab22aa77f372e159 = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

});

parcelRequire.register("cxuOV", function(module, exports) {

$parcel$export(module.exports, "subscribeToPromise", () => $92107966df70d874$export$3adcd774773826b8);
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ 
var $lcU8y = parcelRequire("lcU8y");
var $92107966df70d874$export$3adcd774773826b8 = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $lcU8y.hostReportError));
        return subscriber;
    };
};

});

parcelRequire.register("k1Urb", function(module, exports) {

$parcel$export(module.exports, "subscribeToIterable", () => $e94fadf285319eb2$export$176678a6ee07b575);
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ 
var $13SEs = parcelRequire("13SEs");
var $e94fadf285319eb2$export$176678a6ee07b575 = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, $13SEs.iterator]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};

});
parcelRequire.register("13SEs", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $0c6076e3e9fec9bd$export$6f58e2338da23f4d);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $0c6076e3e9fec9bd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $0c6076e3e9fec9bd$export$6f58e2338da23f4d = /*@__PURE__*/ $0c6076e3e9fec9bd$export$aa9956be4ae4fe8();
var $0c6076e3e9fec9bd$export$9785f547d3164dac = $0c6076e3e9fec9bd$export$6f58e2338da23f4d;

});


parcelRequire.register("bxWcp", function(module, exports) {

$parcel$export(module.exports, "subscribeToObservable", () => $867febe8bb84922d$export$253b2a6a99e75857);
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ 
var $7lh9v = parcelRequire("7lh9v");
var $867febe8bb84922d$export$253b2a6a99e75857 = function(obj) {
    return function(subscriber) {
        var obs = obj[0, $7lh9v.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};

});

parcelRequire.register("1luRY", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $0fafb2ab94116590$export$1e2f57719e155213);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $0fafb2ab94116590$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

});

parcelRequire.register("fRIg1", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $b8ce22dbbed07cc3$export$4369c812aac99591);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $b8ce22dbbed07cc3$export$4369c812aac99591(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

});


parcelRequire.register("8IoDV", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $65858c5917fe53ed$export$49c44dfc2bb21d70);
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ 
var $fzOvC = parcelRequire("fzOvC");

var $jeQmr = parcelRequire("jeQmr");

var $2DSY4 = parcelRequire("2DSY4");

var $bZ6q4 = parcelRequire("bZ6q4");

var $9Oqsy = parcelRequire("9Oqsy");

var $fRIg1 = parcelRequire("fRIg1");

var $1luRY = parcelRequire("1luRY");

var $h874t = parcelRequire("h874t");
function $65858c5917fe53ed$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $9Oqsy.isInteropObservable)(input)) return (0, $fzOvC.scheduleObservable)(input, scheduler);
        else if ((0, $fRIg1.isPromise)(input)) return (0, $jeQmr.schedulePromise)(input, scheduler);
        else if ((0, $1luRY.isArrayLike)(input)) return (0, $2DSY4.scheduleArray)(input, scheduler);
        else if ((0, $h874t.isIterable)(input) || typeof input === "string") return (0, $bZ6q4.scheduleIterable)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

});
parcelRequire.register("fzOvC", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $b5714df43994063f$export$ed8bd553a12b6a30);
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");

var $cnFOC = parcelRequire("cnFOC");

var $7lh9v = parcelRequire("7lh9v");
function $b5714df43994063f$export$ed8bd553a12b6a30(input, scheduler) {
    return new (0, $bFD5F.Observable)(function(subscriber) {
        var sub = new (0, $cnFOC.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, $7lh9v.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}

});

parcelRequire.register("jeQmr", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $e017f0ec21a75950$export$fc9afd948577f0a8);
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");

var $cnFOC = parcelRequire("cnFOC");
function $e017f0ec21a75950$export$fc9afd948577f0a8(input, scheduler) {
    return new (0, $bFD5F.Observable)(function(subscriber) {
        var sub = new (0, $cnFOC.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}

});

parcelRequire.register("2DSY4", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $1ec9dcbf7b7dc580$export$b34673931371729a);
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");

var $cnFOC = parcelRequire("cnFOC");
function $1ec9dcbf7b7dc580$export$b34673931371729a(input, scheduler) {
    return new (0, $bFD5F.Observable)(function(subscriber) {
        var sub = new (0, $cnFOC.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

});

parcelRequire.register("bZ6q4", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $8b9a5f00b74e9e57$export$2b75c58ab9b5b766);
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");

var $cnFOC = parcelRequire("cnFOC");

var $13SEs = parcelRequire("13SEs");
function $8b9a5f00b74e9e57$export$2b75c58ab9b5b766(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $bFD5F.Observable)(function(subscriber) {
        var sub = new (0, $cnFOC.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, $13SEs.iterator]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

});

parcelRequire.register("9Oqsy", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $724d4ee0e900f485$export$48c0cddbc99c45c2);
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ 
var $7lh9v = parcelRequire("7lh9v");
function $724d4ee0e900f485$export$48c0cddbc99c45c2(input) {
    return input && typeof input[0, $7lh9v.observable] === "function";
}

});

parcelRequire.register("h874t", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $c788ab326b1b133a$export$9652023d9040757);
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ 
var $13SEs = parcelRequire("13SEs");
function $c788ab326b1b133a$export$9652023d9040757(input) {
    return input && typeof input[0, $13SEs.iterator] === "function";
}

});



parcelRequire.register("cGzXz", function(module, exports) {

$parcel$export(module.exports, "of", () => $02622667f18df45a$export$ba255e9e49e00608);
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */ 
var $h5vv6 = parcelRequire("h5vv6");

var $8DZyD = parcelRequire("8DZyD");

var $2DSY4 = parcelRequire("2DSY4");
function $02622667f18df45a$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = args[args.length - 1];
    if ((0, $h5vv6.isScheduler)(scheduler)) {
        args.pop();
        return (0, $2DSY4.scheduleArray)(args, scheduler);
    } else return (0, $8DZyD.fromArray)(args);
}

});
parcelRequire.register("h5vv6", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $c70b56b236674ebc$export$187e35932e88c15c);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $c70b56b236674ebc$export$187e35932e88c15c(value) {
    return value && typeof value.schedule === "function";
}

});

parcelRequire.register("8DZyD", function(module, exports) {

$parcel$export(module.exports, "fromArray", () => $64b1b74ab7847db2$export$571d59b505e6bb4e);
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");

var $1keVW = parcelRequire("1keVW");

var $2DSY4 = parcelRequire("2DSY4");
function $64b1b74ab7847db2$export$571d59b505e6bb4e(input, scheduler) {
    if (!scheduler) return new (0, $bFD5F.Observable)((0, $1keVW.subscribeToArray)(input));
    else return (0, $2DSY4.scheduleArray)(input, scheduler);
}

});


parcelRequire.register("cDlsV", function(module, exports) {

$parcel$export(module.exports, "zip", () => $9329c72a8652d812$export$8901015135f2fb22);
/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_.._internal_symbol_iterator,_innerSubscribe PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $8DZyD = parcelRequire("8DZyD");

var $9WhX5 = parcelRequire("9WhX5");

var $13PY0 = parcelRequire("13PY0");

var $13SEs = parcelRequire("13SEs");

var $35c5k = parcelRequire("35c5k");
function $9329c72a8652d812$export$8901015135f2fb22() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === "function") observables.pop();
    return (0, $8DZyD.fromArray)(observables, undefined).lift(new $9329c72a8652d812$export$a488fab011740066(resultSelector));
}
var $9329c72a8652d812$export$a488fab011740066 = /*@__PURE__*/ function() {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9329c72a8652d812$export$7f72df0c8910d7c5(subscriber, this.resultSelector));
    };
    return ZipOperator;
}();
var $9329c72a8652d812$export$7f72df0c8910d7c5 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) values = Object.create(null);
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = typeof resultSelector === "function" ? resultSelector : undefined;
        return _this;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ((0, $9WhX5.isArray)(value)) iterators.push(new $9329c72a8652d812$var$StaticArrayIterator(value));
        else if (typeof value[0, $13SEs.iterator] === "function") iterators.push(new $9329c72a8652d812$var$StaticIterator(value[0, $13SEs.iterator]()));
        else iterators.push(new $9329c72a8652d812$var$ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe());
            } else this.active--;
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === "function" && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) this._tryresultSelector(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryresultSelector = function(args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}((0, $13PY0.Subscriber));
var $9329c72a8652d812$var$StaticIterator = /*@__PURE__*/ function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
    };
    return StaticIterator;
}();
var $9329c72a8652d812$var$StaticArrayIterator = /*@__PURE__*/ function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[0, $13SEs.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
var $9329c72a8652d812$var$ZipBufferIterator = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[0, $13SEs.iterator] = function() {
        return this;
    };
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function() {
        return (0, $35c5k.innerSubscribe)(this.observable, new (0, $35c5k.SimpleInnerSubscriber)(this));
    };
    return ZipBufferIterator;
}((0, $35c5k.SimpleOuterSubscriber));

});
parcelRequire.register("35c5k", function(module, exports) {

$parcel$export(module.exports, "SimpleInnerSubscriber", () => $23eb368cee048f82$export$20b3446cf1c359c0);
$parcel$export(module.exports, "SimpleOuterSubscriber", () => $23eb368cee048f82$export$b73f91a09e7d5376);
$parcel$export(module.exports, "innerSubscribe", () => $23eb368cee048f82$export$d34bac9c0f124cff);
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $13PY0 = parcelRequire("13PY0");

var $bFD5F = parcelRequire("bFD5F");

var $2ZycD = parcelRequire("2ZycD");
var $23eb368cee048f82$export$20b3446cf1c359c0 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, $13PY0.Subscriber));
var $23eb368cee048f82$export$319f8c60b2d80b53 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, $13PY0.Subscriber));
var $23eb368cee048f82$export$b73f91a09e7d5376 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, $13PY0.Subscriber));
var $23eb368cee048f82$export$9643bd8e0cc0c90a = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, $13PY0.Subscriber));
function $23eb368cee048f82$export$d34bac9c0f124cff(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, $bFD5F.Observable)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, $2ZycD.subscribeTo)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

});


parcelRequire.register("fZi5g", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $ba3a949fb0190b34$export$3dede90624df3ba9);
/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $35c5k = parcelRequire("35c5k");
function $ba3a949fb0190b34$export$3dede90624df3ba9(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $ba3a949fb0190b34$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
var $ba3a949fb0190b34$var$CatchOperator = /*@__PURE__*/ function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ba3a949fb0190b34$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
var $ba3a949fb0190b34$var$CatchSubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new (0, $35c5k.SimpleInnerSubscriber)(this);
            this.add(innerSubscriber);
            var innerSubscription = (0, $35c5k.innerSubscribe)(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) this.add(innerSubscription);
        }
    };
    return CatchSubscriber;
}((0, $35c5k.SimpleOuterSubscriber));

});

parcelRequire.register("bQ5Pa", function(module, exports) {

$parcel$export(module.exports, "distinctUntilChanged", () => $89e911a23ad872a9$export$779c5fb865a0172e);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $13PY0 = parcelRequire("13PY0");
function $89e911a23ad872a9$export$779c5fb865a0172e(compare, keySelector) {
    return function(source) {
        return source.lift(new $89e911a23ad872a9$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
var $89e911a23ad872a9$var$DistinctUntilChangedOperator = /*@__PURE__*/ function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $89e911a23ad872a9$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
var $89e911a23ad872a9$var$DistinctUntilChangedSubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === "function") _this.compare = compare;
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var key;
        try {
            var keySelector = this.keySelector;
            key = keySelector ? keySelector(value) : value;
        } catch (err) {
            return this.destination.error(err);
        }
        var result = false;
        if (this.hasKey) try {
            var compare = this.compare;
            result = compare(this.key, key);
        } catch (err) {
            return this.destination.error(err);
        }
        else this.hasKey = true;
        if (!result) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}((0, $13PY0.Subscriber));

});

parcelRequire.register("dkpsO", function(module, exports) {

$parcel$export(module.exports, "filter", () => $9b40e534aee37321$export$3dea766d36a8935f);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $13PY0 = parcelRequire("13PY0");
function $9b40e534aee37321$export$3dea766d36a8935f(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $9b40e534aee37321$var$FilterOperator(predicate, thisArg));
    };
}
var $9b40e534aee37321$var$FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9b40e534aee37321$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var $9b40e534aee37321$var$FilterSubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, $13PY0.Subscriber));

});

parcelRequire.register("1cftY", function(module, exports) {

$parcel$export(module.exports, "map", () => $0df2ebea4aa1249c$export$871de8747c9eaa88);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $13PY0 = parcelRequire("13PY0");
function $0df2ebea4aa1249c$export$871de8747c9eaa88(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new $0df2ebea4aa1249c$export$65d6be2d9a2ba8ee(project, thisArg));
    };
}
var $0df2ebea4aa1249c$export$65d6be2d9a2ba8ee = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0df2ebea4aa1249c$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var $0df2ebea4aa1249c$var$MapSubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, $13PY0.Subscriber));

});

parcelRequire.register("cgIaa", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $8ee93c856d38203a$export$6b9f6c0d32c093f9);
$parcel$export(module.exports, "flatMap", () => $8ee93c856d38203a$export$5b8affa63fc6df16);
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $1cftY = parcelRequire("1cftY");

var $iFZjc = parcelRequire("iFZjc");

var $35c5k = parcelRequire("35c5k");
function $8ee93c856d38203a$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe($8ee93c856d38203a$export$6b9f6c0d32c093f9(function(a, i) {
            return (0, $iFZjc.from)(project(a, i)).pipe((0, $1cftY.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new $8ee93c856d38203a$export$397d304a18305ca8(project, concurrent));
    };
}
var $8ee93c856d38203a$export$397d304a18305ca8 = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $8ee93c856d38203a$export$c13a9be6692e882(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var $8ee93c856d38203a$export$c13a9be6692e882 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, $35c5k.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, $35c5k.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, $35c5k.SimpleOuterSubscriber));
var $8ee93c856d38203a$export$5b8affa63fc6df16 = $8ee93c856d38203a$export$6b9f6c0d32c093f9;

});

parcelRequire.register("7jVzq", function(module, exports) {

$parcel$export(module.exports, "skip", () => $5546f70bb11749cb$export$955fc4a6c4be454d);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $13PY0 = parcelRequire("13PY0");
function $5546f70bb11749cb$export$955fc4a6c4be454d(count) {
    return function(source) {
        return source.lift(new $5546f70bb11749cb$var$SkipOperator(count));
    };
}
var $5546f70bb11749cb$var$SkipOperator = /*@__PURE__*/ function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5546f70bb11749cb$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
var $5546f70bb11749cb$var$SkipSubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}((0, $13PY0.Subscriber));

});

parcelRequire.register("71y7H", function(module, exports) {

$parcel$export(module.exports, "tap", () => $51d3188cb105db13$export$3f23594af5f37336);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $13PY0 = parcelRequire("13PY0");

var $lflai = parcelRequire("lflai");

var $3kPv7 = parcelRequire("3kPv7");
function $51d3188cb105db13$export$3f23594af5f37336(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $51d3188cb105db13$var$DoOperator(nextOrObserver, error, complete));
    };
}
var $51d3188cb105db13$var$DoOperator = /*@__PURE__*/ function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $51d3188cb105db13$var$TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
var $51d3188cb105db13$var$TapSubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = (0, $lflai.noop);
        _this._tapError = (0, $lflai.noop);
        _this._tapComplete = (0, $lflai.noop);
        _this._tapError = error || (0, $lflai.noop);
        _this._tapComplete = complete || (0, $lflai.noop);
        if ((0, $3kPv7.isFunction)(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        } else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || (0, $lflai.noop);
            _this._tapError = observerOrNext.error || (0, $lflai.noop);
            _this._tapComplete = observerOrNext.complete || (0, $lflai.noop);
        }
        return _this;
    }
    TapSubscriber.prototype._next = function(value) {
        try {
            this._tapNext.call(this._context, value);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function(err) {
        try {
            this._tapError.call(this._context, err);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function() {
        try {
            this._tapComplete.call(this._context);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}((0, $13PY0.Subscriber));

});
parcelRequire.register("lflai", function(module, exports) {

$parcel$export(module.exports, "noop", () => $f77b6a9daa3afd93$export$8793edee2d425525);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $f77b6a9daa3afd93$export$8793edee2d425525() {}

});


parcelRequire.register("5N8Ow", function(module, exports) {

$parcel$export(module.exports, "timeout", () => $43785d9a41ff7118$export$83e74882c5df8fe1);
/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */ 
var $bhK3E = parcelRequire("bhK3E");

var $Udt5h = parcelRequire("Udt5h");

var $dTVBl = parcelRequire("dTVBl");

var $bFgaT = parcelRequire("bFgaT");
function $43785d9a41ff7118$export$83e74882c5df8fe1(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, $bhK3E.async);
    return (0, $dTVBl.timeoutWith)(due, (0, $bFgaT.throwError)(new (0, $Udt5h.TimeoutError)()), scheduler);
}

});
parcelRequire.register("bhK3E", function(module, exports) {

$parcel$export(module.exports, "async", () => $837502669479b2f6$export$12af436354f1a4f7);
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */ 
var $exzKl = parcelRequire("exzKl");

var $7ZMIm = parcelRequire("7ZMIm");
var $837502669479b2f6$export$8d6b71a2b178fc32 = /*@__PURE__*/ new (0, $7ZMIm.AsyncScheduler)((0, $exzKl.AsyncAction));
var $837502669479b2f6$export$12af436354f1a4f7 = $837502669479b2f6$export$8d6b71a2b178fc32;

});
parcelRequire.register("exzKl", function(module, exports) {

$parcel$export(module.exports, "AsyncAction", () => $a95fe049686c7727$export$b5369ffd7cb2211b);
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $lbRMv = parcelRequire("lbRMv");
var $a95fe049686c7727$export$b5369ffd7cb2211b = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}((0, $lbRMv.Action));

});
parcelRequire.register("lbRMv", function(module, exports) {

$parcel$export(module.exports, "Action", () => $f6d457e70509fbcb$export$e19cd5f9376f8cee);
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $cnFOC = parcelRequire("cnFOC");
var $f6d457e70509fbcb$export$e19cd5f9376f8cee = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $cnFOC.Subscription));

});


parcelRequire.register("7ZMIm", function(module, exports) {

$parcel$export(module.exports, "AsyncScheduler", () => $5d24049566780726$export$4114a3ec92faa3c6);
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $1O0po = parcelRequire("1O0po");
var $5d24049566780726$export$4114a3ec92faa3c6 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $1O0po.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, function() {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) return AsyncScheduler.delegate.now();
            else return now();
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) return AsyncScheduler.delegate.schedule(work, delay, state);
        else return _super.prototype.schedule.call(this, work, delay, state);
    };
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $1O0po.Scheduler));

});
parcelRequire.register("1O0po", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $150ac7182b4d266e$export$d3e54bb8584cda7c);
var $150ac7182b4d266e$export$d3e54bb8584cda7c = /*@__PURE__*/ function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function() {
        return Date.now();
    };
    return Scheduler;
}();

});



parcelRequire.register("Udt5h", function(module, exports) {

$parcel$export(module.exports, "TimeoutError", () => $0a8fad8fcbb3c962$export$66d311bf29d5c89c);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $0a8fad8fcbb3c962$var$TimeoutErrorImpl = /*@__PURE__*/ function() {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = "Timeout has occurred";
        this.name = "TimeoutError";
        return this;
    }
    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return TimeoutErrorImpl;
}();
var $0a8fad8fcbb3c962$export$66d311bf29d5c89c = $0a8fad8fcbb3c962$var$TimeoutErrorImpl;

});

parcelRequire.register("dTVBl", function(module, exports) {

$parcel$export(module.exports, "timeoutWith", () => $a1ed17dd72e18ec0$export$86fe999fba7953f2);
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_innerSubscribe PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $bhK3E = parcelRequire("bhK3E");

var $kcb2y = parcelRequire("kcb2y");

var $35c5k = parcelRequire("35c5k");
function $a1ed17dd72e18ec0$export$86fe999fba7953f2(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = (0, $bhK3E.async);
    return function(source) {
        var absoluteTimeout = (0, $kcb2y.isDate)(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $a1ed17dd72e18ec0$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
var $a1ed17dd72e18ec0$var$TimeoutWithOperator = /*@__PURE__*/ function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a1ed17dd72e18ec0$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
var $a1ed17dd72e18ec0$var$TimeoutWithSubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.absoluteTimeout = absoluteTimeout;
        _this.waitFor = waitFor;
        _this.withObservable = withObservable;
        _this.scheduler = scheduler;
        _this.scheduleTimeout();
        return _this;
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add((0, $35c5k.innerSubscribe)(withObservable, new (0, $35c5k.SimpleInnerSubscriber)(subscriber)));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = undefined;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}((0, $35c5k.SimpleOuterSubscriber));

});
parcelRequire.register("kcb2y", function(module, exports) {

$parcel$export(module.exports, "isDate", () => $eb3d7df947d9108f$export$871608497c498473);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $eb3d7df947d9108f$export$871608497c498473(value) {
    return value instanceof Date && !isNaN(+value);
}

});


parcelRequire.register("bFgaT", function(module, exports) {

$parcel$export(module.exports, "throwError", () => $87e0120617403241$export$8bf7aba4a9e09055);
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");
function $87e0120617403241$export$8bf7aba4a9e09055(error, scheduler) {
    if (!scheduler) return new (0, $bFD5F.Observable)(function(subscriber) {
        return subscriber.error(error);
    });
    else return new (0, $bFD5F.Observable)(function(subscriber) {
        return scheduler.schedule($87e0120617403241$var$dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
    });
}
function $87e0120617403241$var$dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

});


parcelRequire.register("dMIwd", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletSDKConnection = void 0;

var $1j1JC = parcelRequire("1j1JC");
var $gbnEC = parcelRequire("gbnEC");
var $cGzXz = parcelRequire("cGzXz");
var $5q1z5 = parcelRequire("5q1z5");
var $cnFOC = parcelRequire("cnFOC");
var $bFgaT = parcelRequire("bFgaT");
var $c4xKi = parcelRequire("c4xKi");

var $fZi5g = parcelRequire("fZi5g");
var $7LrXa = parcelRequire("7LrXa");
var $bQ5Pa = parcelRequire("bQ5Pa");
var $dkpsO = parcelRequire("dkpsO");
var $cgIaa = parcelRequire("cgIaa");
var $1cftY = parcelRequire("1cftY");
var $ljKeM = parcelRequire("ljKeM");
var $7jVzq = parcelRequire("7jVzq");
var $9TTFa = parcelRequire("9TTFa");
var $qq9Z5 = parcelRequire("qq9Z5");
var $71y7H = parcelRequire("71y7H");
var $dTVBl = parcelRequire("dTVBl");

var $gPotL = parcelRequire("gPotL");

var $iJH0e = parcelRequire("iJH0e");

var $klSTV = parcelRequire("klSTV");

var $6W6hh = parcelRequire("6W6hh");

var $6JzG0 = parcelRequire("6JzG0");

var $fHM67 = parcelRequire("fHM67");
const $a0924a8c12204a4e$var$HEARTBEAT_INTERVAL = 10000;
const $a0924a8c12204a4e$var$REQUEST_TIMEOUT = 60000;
/**
 * Coinbase Wallet Connection
 */ class $a0924a8c12204a4e$var$WalletSDKConnection {
    /**
     * Constructor
     * @param sessionId Session ID
     * @param sessionKey Session Key
     * @param linkAPIUrl Coinbase Wallet link server URL
     * @param [WebSocketClass] Custom WebSocket implementation
     */ constructor(sessionId, sessionKey, linkAPIUrl, diagnostic, WebSocketClass = WebSocket){
        this.sessionId = sessionId;
        this.sessionKey = sessionKey;
        this.diagnostic = diagnostic;
        this.subscriptions = new $cnFOC.Subscription();
        this.destroyed = false;
        this.lastHeartbeatResponse = 0;
        this.nextReqId = (0, $iJH0e.IntNumber)(1);
        this.connectedSubject = new $1j1JC.BehaviorSubject(false);
        this.linkedSubject = new $1j1JC.BehaviorSubject(false);
        this.sessionConfigSubject = new $5q1z5.ReplaySubject(1);
        const ws = new $6JzG0.RxWebSocket(linkAPIUrl + "/rpc", WebSocketClass);
        this.ws = ws;
        // attempt to reconnect every 5 seconds when disconnected
        this.subscriptions.add(ws.connectionState$.pipe((0, $71y7H.tap)((state)=>{
            var _a;
            return (_a = this.diagnostic) === null || _a === void 0 ? void 0 : _a.log($6W6hh.EVENTS.CONNECTED_STATE_CHANGE, {
                state: state,
                sessionIdHash: $gPotL.Session.hash(sessionId)
            });
        }), // ignore initial DISCONNECTED state
        (0, $7jVzq.skip)(1), // if DISCONNECTED and not destroyed
        (0, $dkpsO.filter)((cs)=>cs === $6JzG0.ConnectionState.DISCONNECTED && !this.destroyed), // wait 5 seconds
        (0, $7LrXa.delay)(5000), // check whether it's destroyed again
        (0, $dkpsO.filter)((_)=>!this.destroyed), // reconnect
        (0, $cgIaa.flatMap)((_)=>ws.connect()), (0, $ljKeM.retry)()).subscribe());
        // perform authentication upon connection
        this.subscriptions.add(ws.connectionState$.pipe(// ignore initial DISCONNECTED and CONNECTING states
        (0, $7jVzq.skip)(2), (0, $9TTFa.switchMap)((cs)=>(0, $gbnEC.iif)(()=>cs === $6JzG0.ConnectionState.CONNECTED, // if CONNECTED, authenticate, and then check link status
            this.authenticate().pipe((0, $71y7H.tap)((_)=>this.sendIsLinked()), (0, $71y7H.tap)((_)=>this.sendGetSessionConfig()), (0, $1cftY.map)((_)=>true)), // if not CONNECTED, emit false immediately
            (0, $cGzXz.of)(false))), (0, $bQ5Pa.distinctUntilChanged)(), (0, $fZi5g.catchError)((_)=>(0, $cGzXz.of)(false))).subscribe((connected)=>this.connectedSubject.next(connected)));
        // send heartbeat every n seconds while connected
        this.subscriptions.add(ws.connectionState$.pipe(// ignore initial DISCONNECTED state
        (0, $7jVzq.skip)(1), (0, $9TTFa.switchMap)((cs)=>(0, $gbnEC.iif)(()=>cs === $6JzG0.ConnectionState.CONNECTED, // if CONNECTED, start the heartbeat timer
            (0, $c4xKi.timer)(0, $a0924a8c12204a4e$var$HEARTBEAT_INTERVAL)))).subscribe((i)=>// first timer event updates lastHeartbeat timestamp
            // subsequent calls send heartbeat message
            i === 0 ? this.updateLastHeartbeat() : this.heartbeat()));
        // handle server's heartbeat responses
        this.subscriptions.add(ws.incomingData$.pipe((0, $dkpsO.filter)((m)=>m === "h")).subscribe((_)=>this.updateLastHeartbeat()));
        // handle link status updates
        this.subscriptions.add(ws.incomingJSONData$.pipe((0, $dkpsO.filter)((m)=>[
                "IsLinkedOK",
                "Linked"
            ].includes(m.type))).subscribe((m)=>{
            var _a;
            const msg = m;
            (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.LINKED, {
                sessionIdHash: $gPotL.Session.hash(sessionId),
                linked: msg.linked,
                type: m.type,
                onlineGuests: msg.onlineGuests
            });
            this.linkedSubject.next(msg.linked || msg.onlineGuests > 0);
        }));
        // handle session config updates
        this.subscriptions.add(ws.incomingJSONData$.pipe((0, $dkpsO.filter)((m)=>[
                "GetSessionConfigOK",
                "SessionConfigUpdated"
            ].includes(m.type))).subscribe((m)=>{
            var _a;
            const msg = m;
            (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.SESSION_CONFIG_RECEIVED, {
                sessionIdHash: $gPotL.Session.hash(sessionId),
                metadata_keys: msg && msg.metadata ? Object.keys(msg.metadata) : undefined
            });
            this.sessionConfigSubject.next({
                webhookId: msg.webhookId,
                webhookUrl: msg.webhookUrl,
                metadata: msg.metadata
            });
        }));
    }
    /**
     * Make a connection to the server
     */ connect() {
        var _a;
        if (this.destroyed) throw new Error("instance is destroyed");
        (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.STARTED_CONNECTING, {
            sessionIdHash: $gPotL.Session.hash(this.sessionId)
        });
        this.ws.connect().subscribe();
    }
    /**
     * Terminate connection, and mark as destroyed. To reconnect, create a new
     * instance of WalletSDKConnection
     */ destroy() {
        var _a;
        this.subscriptions.unsubscribe();
        this.ws.disconnect();
        (_a = this.diagnostic) === null || _a === void 0 || _a.log($6W6hh.EVENTS.DISCONNECTED, {
            sessionIdHash: $gPotL.Session.hash(this.sessionId)
        });
        this.destroyed = true;
    }
    get isDestroyed() {
        return this.destroyed;
    }
    /**
     * Emit true if connected and authenticated, else false
     * @returns an Observable
     */ get connected$() {
        return this.connectedSubject.asObservable();
    }
    /**
     * Emit once connected
     * @returns an Observable
     */ get onceConnected$() {
        return this.connected$.pipe((0, $dkpsO.filter)((v)=>v), (0, $qq9Z5.take)(1), (0, $1cftY.map)(()=>void 0));
    }
    /**
     * Emit true if linked (a guest has joined before)
     * @returns an Observable
     */ get linked$() {
        return this.linkedSubject.asObservable();
    }
    /**
     * Emit once when linked
     * @returns an Observable
     */ get onceLinked$() {
        return this.linked$.pipe((0, $dkpsO.filter)((v)=>v), (0, $qq9Z5.take)(1), (0, $1cftY.map)(()=>void 0));
    }
    /**
     * Emit current session config if available, and subsequent updates
     * @returns an Observable for the session config
     */ get sessionConfig$() {
        return this.sessionConfigSubject.asObservable();
    }
    /**
     * Emit incoming Event messages
     * @returns an Observable for the messages
     */ get incomingEvent$() {
        return this.ws.incomingJSONData$.pipe((0, $dkpsO.filter)((m)=>{
            if (m.type !== "Event") return false;
            const sme = m;
            return typeof sme.sessionId === "string" && typeof sme.eventId === "string" && typeof sme.event === "string" && typeof sme.data === "string";
        }), (0, $1cftY.map)((m)=>m));
    }
    /**
     * Set session metadata in SessionConfig object
     * @param key
     * @param value
     * @returns an Observable that completes when successful
     */ setSessionMetadata(key, value) {
        const message = (0, $klSTV.ClientMessageSetSessionConfig)({
            id: (0, $iJH0e.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId,
            metadata: {
                [key]: value
            }
        });
        return this.onceConnected$.pipe((0, $cgIaa.flatMap)((_)=>this.makeRequest(message)), (0, $1cftY.map)((res)=>{
            if ((0, $fHM67.isServerMessageFail)(res)) throw new Error(res.error || "failed to set session metadata");
        }));
    }
    /**
     * Publish an event and emit event ID when successful
     * @param event event name
     * @param data event data
     * @param callWebhook whether the webhook should be invoked
     * @returns an Observable that emits event ID when successful
     */ publishEvent(event, data, callWebhook = false) {
        const message = (0, $klSTV.ClientMessagePublishEvent)({
            id: (0, $iJH0e.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId,
            event: event,
            data: data,
            callWebhook: callWebhook
        });
        return this.onceLinked$.pipe((0, $cgIaa.flatMap)((_)=>this.makeRequest(message)), (0, $1cftY.map)((res)=>{
            if ((0, $fHM67.isServerMessageFail)(res)) throw new Error(res.error || "failed to publish event");
            return res.eventId;
        }));
    }
    sendData(message) {
        this.ws.sendData(JSON.stringify(message));
    }
    updateLastHeartbeat() {
        this.lastHeartbeatResponse = Date.now();
    }
    heartbeat() {
        if (Date.now() - this.lastHeartbeatResponse > $a0924a8c12204a4e$var$HEARTBEAT_INTERVAL * 2) {
            this.ws.disconnect();
            return;
        }
        try {
            this.ws.sendData("h");
        } catch (_a) {}
    }
    makeRequest(message, timeout = $a0924a8c12204a4e$var$REQUEST_TIMEOUT) {
        const reqId = message.id;
        try {
            this.sendData(message);
        } catch (err) {
            return (0, $bFgaT.throwError)(err);
        }
        // await server message with corresponding id
        return this.ws.incomingJSONData$.pipe((0, $dTVBl.timeoutWith)(timeout, (0, $bFgaT.throwError)(new Error(`request ${reqId} timed out`))), (0, $dkpsO.filter)((m)=>m.id === reqId), (0, $qq9Z5.take)(1));
    }
    authenticate() {
        const msg = (0, $klSTV.ClientMessageHostSession)({
            id: (0, $iJH0e.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId,
            sessionKey: this.sessionKey
        });
        return this.makeRequest(msg).pipe((0, $1cftY.map)((res)=>{
            if ((0, $fHM67.isServerMessageFail)(res)) throw new Error(res.error || "failed to authentcate");
        }));
    }
    sendIsLinked() {
        const msg = (0, $klSTV.ClientMessageIsLinked)({
            id: (0, $iJH0e.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId
        });
        this.sendData(msg);
    }
    sendGetSessionConfig() {
        const msg = (0, $klSTV.ClientMessageGetSessionConfig)({
            id: (0, $iJH0e.IntNumber)(this.nextReqId++),
            sessionId: this.sessionId
        });
        this.sendData(msg);
    }
}
module.exports.WalletSDKConnection = $a0924a8c12204a4e$var$WalletSDKConnection;

});
parcelRequire.register("gbnEC", function(module, exports) {

$parcel$export(module.exports, "iif", () => $bc80059ee505dfb5$export$906815c308550252);
/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */ 
var $5gKLF = parcelRequire("5gKLF");

var $bQ7RD = parcelRequire("bQ7RD");
function $bc80059ee505dfb5$export$906815c308550252(condition, trueResult, falseResult) {
    if (trueResult === void 0) trueResult = (0, $bQ7RD.EMPTY);
    if (falseResult === void 0) falseResult = (0, $bQ7RD.EMPTY);
    return (0, $5gKLF.defer)(function() {
        return condition() ? trueResult : falseResult;
    });
}

});
parcelRequire.register("5gKLF", function(module, exports) {

$parcel$export(module.exports, "defer", () => $3d62b97f6fb13d16$export$260e5c0943f31606);
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");

var $iFZjc = parcelRequire("iFZjc");

var $bQ7RD = parcelRequire("bQ7RD");
function $3d62b97f6fb13d16$export$260e5c0943f31606(observableFactory) {
    return new (0, $bFD5F.Observable)(function(subscriber) {
        var input;
        try {
            input = observableFactory();
        } catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? (0, $iFZjc.from)(input) : (0, $bQ7RD.empty)();
        return source.subscribe(subscriber);
    });
}

});
parcelRequire.register("bQ7RD", function(module, exports) {

$parcel$export(module.exports, "EMPTY", () => $89eaa6b44cb073a6$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "empty", () => $89eaa6b44cb073a6$export$6e22c362a0406a2c);
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");
var $89eaa6b44cb073a6$export$ccb33e29d92c9a58 = /*@__PURE__*/ new (0, $bFD5F.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $89eaa6b44cb073a6$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $89eaa6b44cb073a6$var$emptyScheduled(scheduler) : $89eaa6b44cb073a6$export$ccb33e29d92c9a58;
}
function $89eaa6b44cb073a6$var$emptyScheduled(scheduler) {
    return new (0, $bFD5F.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});



parcelRequire.register("5q1z5", function(module, exports) {

$parcel$export(module.exports, "ReplaySubject", () => $3f20983ac4bfaf1f$export$915d2682b0aa0991);
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $atRt2 = parcelRequire("atRt2");

var $833mW = parcelRequire("833mW");

var $cnFOC = parcelRequire("cnFOC");

var $gSUCa = parcelRequire("gSUCa");

var $2sFVS = parcelRequire("2sFVS");

var $iR1mZ = parcelRequire("iR1mZ");
var $3f20983ac4bfaf1f$export$915d2682b0aa0991 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        } else _this.next = _this.nextTimeWindow;
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function(value) {
        if (!this.isStopped) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) _events.shift();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function(value) {
        if (!this.isStopped) {
            this._events.push(new $3f20983ac4bfaf1f$var$ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) throw new (0, $2sFVS.ObjectUnsubscribedError)();
        else if (this.isStopped || this.hasError) subscription = (0, $cnFOC.Subscription).EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new (0, $iR1mZ.SubjectSubscription)(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new (0, $gSUCa.ObserveOnSubscriber)(subscriber, scheduler));
        if (_infiniteTimeWindow) for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i]);
        else for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || (0, $833mW.queue)).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}((0, $atRt2.Subject));
var $3f20983ac4bfaf1f$var$ReplayEvent = /*@__PURE__*/ function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

});
parcelRequire.register("833mW", function(module, exports) {

$parcel$export(module.exports, "queue", () => $5dc13791984594d0$export$4f7fa46ff53e516f);
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */ 
var $isOUM = parcelRequire("isOUM");

var $jOseN = parcelRequire("jOseN");
var $5dc13791984594d0$export$69a3263547af8af8 = /*@__PURE__*/ new (0, $jOseN.QueueScheduler)((0, $isOUM.QueueAction));
var $5dc13791984594d0$export$4f7fa46ff53e516f = $5dc13791984594d0$export$69a3263547af8af8;

});
parcelRequire.register("isOUM", function(module, exports) {

$parcel$export(module.exports, "QueueAction", () => $d71256283e42e709$export$fec474e58f10935f);
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $exzKl = parcelRequire("exzKl");
var $d71256283e42e709$export$fec474e58f10935f = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        return scheduler.flush(this);
    };
    return QueueAction;
}((0, $exzKl.AsyncAction));

});

parcelRequire.register("jOseN", function(module, exports) {

$parcel$export(module.exports, "QueueScheduler", () => $e6c8973ee880f348$export$6a0c75a6abc7ad50);
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $7ZMIm = parcelRequire("7ZMIm");
var $e6c8973ee880f348$export$6a0c75a6abc7ad50 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, $7ZMIm.AsyncScheduler));

});


parcelRequire.register("gSUCa", function(module, exports) {

$parcel$export(module.exports, "ObserveOnSubscriber", () => $c4ad9afc7e05fdc9$export$2ccc19882708a0);
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $13PY0 = parcelRequire("13PY0");

var $cjKYA = parcelRequire("cjKYA");
function $c4ad9afc7e05fdc9$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $c4ad9afc7e05fdc9$export$b8e2e9b883c1952(scheduler, delay));
    };
}
var $c4ad9afc7e05fdc9$export$b8e2e9b883c1952 = /*@__PURE__*/ function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c4ad9afc7e05fdc9$export$2ccc19882708a0(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
var $c4ad9afc7e05fdc9$export$2ccc19882708a0 = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $c4ad9afc7e05fdc9$export$6358f3d000008d47(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage((0, $cjKYA.Notification).createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage((0, $cjKYA.Notification).createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage((0, $cjKYA.Notification).createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}((0, $13PY0.Subscriber));
var $c4ad9afc7e05fdc9$export$6358f3d000008d47 = /*@__PURE__*/ function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();

});
parcelRequire.register("cjKYA", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $8f7bb2e6bd2983b4$export$14834abbfce3b8cd);
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */ 
var $bQ7RD = parcelRequire("bQ7RD");

var $cGzXz = parcelRequire("cGzXz");

var $bFgaT = parcelRequire("bFgaT");
var $8f7bb2e6bd2983b4$export$f59c804e350a7a80;
/*@__PURE__*/ (function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})($8f7bb2e6bd2983b4$export$f59c804e350a7a80 || ($8f7bb2e6bd2983b4$export$f59c804e350a7a80 = {}));
var $8f7bb2e6bd2983b4$export$14834abbfce3b8cd = /*@__PURE__*/ function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case "N":
                return observer.next && observer.next(this.value);
            case "E":
                return observer.error && observer.error(this.error);
            case "C":
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case "N":
                return next && next(this.value);
            case "E":
                return error && error(this.error);
            case "C":
                return complete && complete();
        }
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case "N":
                return (0, $cGzXz.of)(this.value);
            case "E":
                return (0, $bFgaT.throwError)(this.error);
            case "C":
                return (0, $bQ7RD.empty)();
        }
        throw new Error("unexpected notification kind value");
    };
    Notification.createNext = function(value) {
        if (typeof value !== "undefined") return new Notification("N", value);
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    Notification.undefinedValueNotification = new Notification("N", undefined);
    return Notification;
}();

});



parcelRequire.register("c4xKi", function(module, exports) {

$parcel$export(module.exports, "timer", () => $8ca008ed6baaed69$export$9dc4ecf953986f04);
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */ 
var $bFD5F = parcelRequire("bFD5F");

var $bhK3E = parcelRequire("bhK3E");

var $eTbuc = parcelRequire("eTbuc");

var $h5vv6 = parcelRequire("h5vv6");
function $8ca008ed6baaed69$export$9dc4ecf953986f04(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    var period = -1;
    if ((0, $eTbuc.isNumeric)(periodOrScheduler)) period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    else if ((0, $h5vv6.isScheduler)(periodOrScheduler)) scheduler = periodOrScheduler;
    if (!(0, $h5vv6.isScheduler)(scheduler)) scheduler = (0, $bhK3E.async);
    return new (0, $bFD5F.Observable)(function(subscriber) {
        var due = (0, $eTbuc.isNumeric)(dueTime) ? dueTime : +dueTime - scheduler.now();
        return scheduler.schedule($8ca008ed6baaed69$var$dispatch, due, {
            index: 0,
            period: period,
            subscriber: subscriber
        });
    });
}
function $8ca008ed6baaed69$var$dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) return;
    else if (period === -1) return subscriber.complete();
    state.index = index + 1;
    this.schedule(state, period);
}

});
parcelRequire.register("eTbuc", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $ad6f1ca4aa2d78c9$export$e90fb89750dba83f);
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */ 
var $9WhX5 = parcelRequire("9WhX5");
function $ad6f1ca4aa2d78c9$export$e90fb89750dba83f(val) {
    return !(0, $9WhX5.isArray)(val) && val - parseFloat(val) + 1 >= 0;
}

});


parcelRequire.register("7LrXa", function(module, exports) {

$parcel$export(module.exports, "delay", () => $5a729b21852648a8$export$1391212d75b2ee65);
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $bhK3E = parcelRequire("bhK3E");

var $kcb2y = parcelRequire("kcb2y");

var $13PY0 = parcelRequire("13PY0");

var $cjKYA = parcelRequire("cjKYA");
function $5a729b21852648a8$export$1391212d75b2ee65(delay, scheduler) {
    if (scheduler === void 0) scheduler = (0, $bhK3E.async);
    var absoluteDelay = (0, $kcb2y.isDate)(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new $5a729b21852648a8$var$DelayOperator(delayFor, scheduler));
    };
}
var $5a729b21852648a8$var$DelayOperator = /*@__PURE__*/ function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5a729b21852648a8$var$DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
var $5a729b21852648a8$var$DelaySubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        var destination = this.destination;
        destination.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new $5a729b21852648a8$var$DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification((0, $cjKYA.Notification).createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
        this.unsubscribe();
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification((0, $cjKYA.Notification).createComplete());
        this.unsubscribe();
    };
    return DelaySubscriber;
}((0, $13PY0.Subscriber));
var $5a729b21852648a8$var$DelayMessage = /*@__PURE__*/ function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});

parcelRequire.register("ljKeM", function(module, exports) {

$parcel$export(module.exports, "retry", () => $f84f3d1718808d6a$export$9369b12211e1fce4);
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $13PY0 = parcelRequire("13PY0");
function $f84f3d1718808d6a$export$9369b12211e1fce4(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new $f84f3d1718808d6a$var$RetryOperator(count, source));
    };
}
var $f84f3d1718808d6a$var$RetryOperator = /*@__PURE__*/ function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f84f3d1718808d6a$var$RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
var $f84f3d1718808d6a$var$RetrySubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}((0, $13PY0.Subscriber));

});

parcelRequire.register("9TTFa", function(module, exports) {

$parcel$export(module.exports, "switchMap", () => $73546da28e450aaf$export$9f6ea8e48bc26eab);
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $1cftY = parcelRequire("1cftY");

var $iFZjc = parcelRequire("iFZjc");

var $35c5k = parcelRequire("35c5k");
function $73546da28e450aaf$export$9f6ea8e48bc26eab(project, resultSelector) {
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe($73546da28e450aaf$export$9f6ea8e48bc26eab(function(a, i) {
            return (0, $iFZjc.from)(project(a, i)).pipe((0, $1cftY.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return function(source) {
        return source.lift(new $73546da28e450aaf$var$SwitchMapOperator(project));
    };
}
var $73546da28e450aaf$var$SwitchMapOperator = /*@__PURE__*/ function() {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $73546da28e450aaf$var$SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}();
var $73546da28e450aaf$var$SwitchMapSubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        var innerSubscriber = new (0, $35c5k.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        this.innerSubscription = (0, $35c5k.innerSubscribe)(result, innerSubscriber);
        if (this.innerSubscription !== innerSubscriber) destination.add(this.innerSubscription);
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
        this.unsubscribe();
    };
    SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = undefined;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function() {
        this.innerSubscription = undefined;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}((0, $35c5k.SimpleOuterSubscriber));

});

parcelRequire.register("qq9Z5", function(module, exports) {

$parcel$export(module.exports, "take", () => $04f6b8a93cd8c861$export$b7df5d561049483a);
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ 
var $9D8rd = parcelRequire("9D8rd");

var $13PY0 = parcelRequire("13PY0");

var $4OrvZ = parcelRequire("4OrvZ");

var $bQ7RD = parcelRequire("bQ7RD");
function $04f6b8a93cd8c861$export$b7df5d561049483a(count) {
    return function(source) {
        if (count === 0) return (0, $bQ7RD.empty)();
        else return source.lift(new $04f6b8a93cd8c861$var$TakeOperator(count));
    };
}
var $04f6b8a93cd8c861$var$TakeOperator = /*@__PURE__*/ function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, $4OrvZ.ArgumentOutOfRangeError);
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $04f6b8a93cd8c861$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
var $04f6b8a93cd8c861$var$TakeSubscriber = /*@__PURE__*/ function(_super) {
    $9D8rd.__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}((0, $13PY0.Subscriber));

});
parcelRequire.register("4OrvZ", function(module, exports) {

$parcel$export(module.exports, "ArgumentOutOfRangeError", () => $38112cd17849b45d$export$630691c4a0cd4093);
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $38112cd17849b45d$var$ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ function() {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = "argument out of range";
        this.name = "ArgumentOutOfRangeError";
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
}();
var $38112cd17849b45d$export$630691c4a0cd4093 = $38112cd17849b45d$var$ArgumentOutOfRangeErrorImpl;

});


parcelRequire.register("klSTV", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientMessagePublishEvent = module.exports.ClientMessageSetSessionConfig = module.exports.ClientMessageGetSessionConfig = module.exports.ClientMessageIsLinked = module.exports.ClientMessageHostSession = void 0;
function $ed105b03e162d0d9$var$ClientMessageHostSession(params) {
    return Object.assign({
        type: "HostSession"
    }, params);
}
module.exports.ClientMessageHostSession = $ed105b03e162d0d9$var$ClientMessageHostSession;
function $ed105b03e162d0d9$var$ClientMessageIsLinked(params) {
    return Object.assign({
        type: "IsLinked"
    }, params);
}
module.exports.ClientMessageIsLinked = $ed105b03e162d0d9$var$ClientMessageIsLinked;
function $ed105b03e162d0d9$var$ClientMessageGetSessionConfig(params) {
    return Object.assign({
        type: "GetSessionConfig"
    }, params);
}
module.exports.ClientMessageGetSessionConfig = $ed105b03e162d0d9$var$ClientMessageGetSessionConfig;
function $ed105b03e162d0d9$var$ClientMessageSetSessionConfig(params) {
    return Object.assign({
        type: "SetSessionConfig"
    }, params);
}
module.exports.ClientMessageSetSessionConfig = $ed105b03e162d0d9$var$ClientMessageSetSessionConfig;
function $ed105b03e162d0d9$var$ClientMessagePublishEvent(params) {
    return Object.assign({
        type: "PublishEvent"
    }, params);
}
module.exports.ClientMessagePublishEvent = $ed105b03e162d0d9$var$ClientMessagePublishEvent;

});

parcelRequire.register("6JzG0", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RxWebSocket = module.exports.ConnectionState = void 0;

var $1j1JC = parcelRequire("1j1JC");
var $bQ7RD = parcelRequire("bQ7RD");
var $bFD5F = parcelRequire("bFD5F");
var $cGzXz = parcelRequire("cGzXz");
var $atRt2 = parcelRequire("atRt2");
var $bFgaT = parcelRequire("bFgaT");

var $cgIaa = parcelRequire("cgIaa");
var $qq9Z5 = parcelRequire("qq9Z5");
var $4e729ea90763844f$var$ConnectionState;
(function(ConnectionState) {
    ConnectionState[ConnectionState["DISCONNECTED"] = 0] = "DISCONNECTED";
    ConnectionState[ConnectionState["CONNECTING"] = 1] = "CONNECTING";
    ConnectionState[ConnectionState["CONNECTED"] = 2] = "CONNECTED";
})($4e729ea90763844f$var$ConnectionState = module.exports.ConnectionState || (module.exports.ConnectionState = {}));
/**
 * Rx-ified WebSocket
 */ class $4e729ea90763844f$var$RxWebSocket {
    /**
     * Constructor
     * @param url WebSocket server URL
     * @param [WebSocketClass] Custom WebSocket implementation
     */ constructor(url, WebSocketClass = WebSocket){
        this.WebSocketClass = WebSocketClass;
        this.webSocket = null;
        this.connectionStateSubject = new $1j1JC.BehaviorSubject($4e729ea90763844f$var$ConnectionState.DISCONNECTED);
        this.incomingDataSubject = new $atRt2.Subject();
        this.url = url.replace(/^http/, "ws");
    }
    /**
     * Make a websocket connection
     * @returns an Observable that completes when connected
     */ connect() {
        if (this.webSocket) return (0, $bFgaT.throwError)(new Error("webSocket object is not null"));
        return new $bFD5F.Observable((obs)=>{
            let webSocket;
            try {
                this.webSocket = webSocket = new this.WebSocketClass(this.url);
            } catch (err) {
                obs.error(err);
                return;
            }
            this.connectionStateSubject.next($4e729ea90763844f$var$ConnectionState.CONNECTING);
            webSocket.onclose = (evt)=>{
                this.clearWebSocket();
                obs.error(new Error(`websocket error ${evt.code}: ${evt.reason}`));
                this.connectionStateSubject.next($4e729ea90763844f$var$ConnectionState.DISCONNECTED);
            };
            webSocket.onopen = (_)=>{
                obs.next();
                obs.complete();
                this.connectionStateSubject.next($4e729ea90763844f$var$ConnectionState.CONNECTED);
            };
            webSocket.onmessage = (evt)=>{
                this.incomingDataSubject.next(evt.data);
            };
        }).pipe((0, $qq9Z5.take)(1));
    }
    /**
     * Disconnect from server
     */ disconnect() {
        const { webSocket: webSocket } = this;
        if (!webSocket) return;
        this.clearWebSocket();
        this.connectionStateSubject.next($4e729ea90763844f$var$ConnectionState.DISCONNECTED);
        try {
            webSocket.close();
        } catch (_a) {}
    }
    /**
     * Emit current connection state and subsequent changes
     * @returns an Observable for the connection state
     */ get connectionState$() {
        return this.connectionStateSubject.asObservable();
    }
    /**
     * Emit incoming data from server
     * @returns an Observable for the data received
     */ get incomingData$() {
        return this.incomingDataSubject.asObservable();
    }
    /**
     * Emit incoming JSON data from server. non-JSON data are ignored
     * @returns an Observable for parsed JSON data
     */ get incomingJSONData$() {
        return this.incomingData$.pipe((0, $cgIaa.flatMap)((m)=>{
            let j;
            try {
                j = JSON.parse(m);
            } catch (err) {
                return (0, $bQ7RD.empty)();
            }
            return (0, $cGzXz.of)(j);
        }));
    }
    /**
     * Send data to server
     * @param data text to send
     */ sendData(data) {
        const { webSocket: webSocket } = this;
        if (!webSocket) throw new Error("websocket is not connected");
        webSocket.send(data);
    }
    clearWebSocket() {
        const { webSocket: webSocket } = this;
        if (!webSocket) return;
        this.webSocket = null;
        webSocket.onclose = null;
        webSocket.onerror = null;
        webSocket.onmessage = null;
        webSocket.onopen = null;
    }
}
module.exports.RxWebSocket = $4e729ea90763844f$var$RxWebSocket;

});

parcelRequire.register("fHM67", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isServerMessageFail = void 0;
function $b6f02e639297740f$var$isServerMessageFail(msg) {
    return msg && msg.type === "Fail" && typeof msg.id === "number" && typeof msg.sessionId === "string" && typeof msg.error === "string";
}
module.exports.isServerMessageFail = $b6f02e639297740f$var$isServerMessageFail;

});


parcelRequire.register("kolOR", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decrypt = module.exports.encrypt = void 0;

var $1mY3j = parcelRequire("1mY3j");
/**
 *
 * @param plainText string to be encrypted
 * @param secret hex representation of 32-byte secret
 * returns hex string representation of bytes in the order: initialization vector (iv),
 * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes. Remaining bytes are the
 * encrypted plainText.
 */ async function $ed86f96217a642f5$var$encrypt(plainText, secret) {
    if (secret.length !== 64) throw Error(`secret must be 256 bits`);
    const ivBytes = crypto.getRandomValues(new Uint8Array(12));
    const secretKey = await crypto.subtle.importKey("raw", (0, $1mY3j.hexStringToUint8Array)(secret), {
        name: "aes-gcm"
    }, false, [
        "encrypt",
        "decrypt"
    ]);
    const enc = new TextEncoder();
    // Will return encrypted plainText with auth tag (ie MAC or checksum) appended at the end
    const encryptedResult = await window.crypto.subtle.encrypt({
        name: "AES-GCM",
        iv: ivBytes
    }, secretKey, enc.encode(plainText));
    const tagLength = 16;
    const authTag = encryptedResult.slice(encryptedResult.byteLength - tagLength);
    const encryptedPlaintext = encryptedResult.slice(0, encryptedResult.byteLength - tagLength);
    const authTagBytes = new Uint8Array(authTag);
    const encryptedPlaintextBytes = new Uint8Array(encryptedPlaintext);
    const concatted = new Uint8Array([
        ...ivBytes,
        ...authTagBytes,
        ...encryptedPlaintextBytes
    ]);
    return (0, $1mY3j.uint8ArrayToHex)(concatted);
}
module.exports.encrypt = $ed86f96217a642f5$var$encrypt;
/**
 *
 * @param cipherText hex string representation of bytes in the order: initialization vector (iv),
 * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes.
 * @param secret hex string representation of 32-byte secret
 */ function $ed86f96217a642f5$var$decrypt(cipherText, secret) {
    if (secret.length !== 64) throw Error(`secret must be 256 bits`);
    return new Promise((resolve, reject)=>{
        (async function() {
            const secretKey = await crypto.subtle.importKey("raw", (0, $1mY3j.hexStringToUint8Array)(secret), {
                name: "aes-gcm"
            }, false, [
                "encrypt",
                "decrypt"
            ]);
            const encrypted = (0, $1mY3j.hexStringToUint8Array)(cipherText);
            const ivBytes = encrypted.slice(0, 12);
            const authTagBytes = encrypted.slice(12, 28);
            const encryptedPlaintextBytes = encrypted.slice(28);
            const concattedBytes = new Uint8Array([
                ...encryptedPlaintextBytes,
                ...authTagBytes
            ]);
            const algo = {
                name: "AES-GCM",
                iv: new Uint8Array(ivBytes)
            };
            try {
                const decrypted = await window.crypto.subtle.decrypt(algo, secretKey, concattedBytes);
                const decoder = new TextDecoder();
                resolve(decoder.decode(decrypted));
            } catch (err) {
                reject(err);
            }
        })();
    });
}
module.exports.decrypt = $ed86f96217a642f5$var$decrypt;

});

parcelRequire.register("l0yO0", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Web3RequestCanceledMessage = void 0;

var $4nfGX = parcelRequire("4nfGX");
function $f4b498bc274652dc$var$Web3RequestCanceledMessage(id) {
    return {
        type: $4nfGX.RelayMessageType.WEB3_REQUEST_CANCELED,
        id: id
    };
}
module.exports.Web3RequestCanceledMessage = $f4b498bc274652dc$var$Web3RequestCanceledMessage;

});
parcelRequire.register("4nfGX", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RelayMessageType = void 0;
var $32f57b759118407a$var$RelayMessageType;
(function(RelayMessageType) {
    RelayMessageType["SESSION_ID_REQUEST"] = "SESSION_ID_REQUEST";
    RelayMessageType["SESSION_ID_RESPONSE"] = "SESSION_ID_RESPONSE";
    RelayMessageType["LINKED"] = "LINKED";
    RelayMessageType["UNLINKED"] = "UNLINKED";
    RelayMessageType["WEB3_REQUEST"] = "WEB3_REQUEST";
    RelayMessageType["WEB3_REQUEST_CANCELED"] = "WEB3_REQUEST_CANCELED";
    RelayMessageType["WEB3_RESPONSE"] = "WEB3_RESPONSE";
})($32f57b759118407a$var$RelayMessageType = module.exports.RelayMessageType || (module.exports.RelayMessageType = {}));

});


parcelRequire.register("dBRYn", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Web3RequestMessage = void 0;

var $4nfGX = parcelRequire("4nfGX");
function $9e8898ecd301f027$var$Web3RequestMessage(params) {
    return Object.assign({
        type: $4nfGX.RelayMessageType.WEB3_REQUEST
    }, params);
}
module.exports.Web3RequestMessage = $9e8898ecd301f027$var$Web3RequestMessage;

});

parcelRequire.register("fWZCq", function(module, exports) {
"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isWeb3ResponseMessage = module.exports.Web3ResponseMessage = void 0;

var $4nfGX = parcelRequire("4nfGX");
function $b9cc12031ce36f22$var$Web3ResponseMessage(params) {
    return Object.assign({
        type: $4nfGX.RelayMessageType.WEB3_RESPONSE
    }, params);
}
module.exports.Web3ResponseMessage = $b9cc12031ce36f22$var$Web3ResponseMessage;
function $b9cc12031ce36f22$var$isWeb3ResponseMessage(msg) {
    return msg && msg.type === $4nfGX.RelayMessageType.WEB3_RESPONSE;
}
module.exports.isWeb3ResponseMessage = $b9cc12031ce36f22$var$isWeb3ResponseMessage;

});


parcelRequire.register("frxtt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletSDKRelayEventManager = void 0;

var $1mY3j = parcelRequire("1mY3j");
class $b3e357f685997226$var$WalletSDKRelayEventManager {
    constructor(){
        this._nextRequestId = 0;
        this.callbacks = new Map();
    }
    makeRequestId() {
        // max nextId == max int32 for compatibility with mobile
        this._nextRequestId = (this._nextRequestId + 1) % 0x7fffffff;
        const id = this._nextRequestId;
        const idStr = (0, $1mY3j.prepend0x)(id.toString(16));
        // unlikely that this will ever be an issue, but just to be safe
        const callback = this.callbacks.get(idStr);
        if (callback) this.callbacks.delete(idStr);
        return id;
    }
}
module.exports.WalletSDKRelayEventManager = $b3e357f685997226$var$WalletSDKRelayEventManager;

});




//# sourceMappingURL=dist.838d26f2.js.map
